import * as i0 from '@angular/core';
import { Directive, EventEmitter, Component, Input, Output, NgModule, ViewChild, HostBinding, HostListener, Injectable, InjectionToken, Optional, Inject, SkipSelf, ViewChildren, ChangeDetectionStrategy, ViewContainerRef, TemplateRef, ViewEncapsulation, CUSTOM_ELEMENTS_SCHEMA, Pipe, SecurityContext } from '@angular/core';
import * as i1$3 from '@angular/common';
import { CommonModule, NgClass, NgIf, NgStyle, NgFor, NgTemplateOutlet, formatNumber, DecimalPipe, DOCUMENT, AsyncPipe, SlicePipe, I18nPluralPipe } from '@angular/common';
import * as i1 from '@angular/forms';
import { FormsModule, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { trigger, state, style, transition, animate, sequence, query, group } from '@angular/animations';
import { of, iif, ReplaySubject, interval, Subject, fromEvent } from 'rxjs';
import { filter, tap, debounceTime, switchMap, take, catchError, first, map, timeout, distinctUntilChanged, startWith, shareReplay, takeUntil } from 'rxjs/operators';
import * as i1$1 from '@angular/platform-browser';
import { __decorate } from 'tslib';
import { defineCustomElements } from '@header-footer/bahf-header-footer-fallback/loader';
import * as i1$2 from '@angular/router';
import { NavigationEnd, RouterLink, RouterModule, DefaultTitleStrategy } from '@angular/router';
import * as i1$4 from 'ngx-cookie-service';
import { CookieService } from 'ngx-cookie-service';
import * as i2 from '@angular/common/http';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import * as esri from 'esri-loader';
import { loadCss, loadModules } from 'esri-loader';

/**
 * Initialisiert DPL-3-Tooltips
 *
 * Code der DPL:
 *  - Globale Verankerung https://bitbucket.webapp.sdst.sbaintern.de/projects/BAPF/repos/bapf-dpl3/browse/source/js/app.js#124
 *  - BaPopover-Klasse https://bitbucket.webapp.sdst.sbaintern.de/projects/BAPF/repos/bapf-dpl3/browse/source/js/_popover.js
 */
const _c0 = ["*"];
const _c1 = ["collapse"];
const _c2 = a0 => ({
  collapsed: a0
});
const _c3 = a0 => ({
  show: a0
});
const _c4 = ["button"];
const _c5 = (a0, a1) => ({
  "ba-icon-information": a0,
  "ba-icon-help": a1
});
const _c6 = (a0, a1, a2) => ({
  "ba-icon-info": a0,
  "ba-icon-help": a1,
  "ba-accent-icon": a2
});
function HilfeInfoCollapseComponent_button_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function HilfeInfoCollapseComponent_button_9_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.toggleCollapse());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r2._collapseId + "-toggle-btn");
    i0.ɵɵattribute("aria-label", ctx_r2.tooltipForClose)("data-bs-target", "#" + ctx_r2._collapseId)("aria-controls", ctx_r2._collapseId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.closingButtonText, " ");
  }
}
const _c7 = a0 => ({
  "ba-prompt": a0
});
function ModalPopupComponent_h1_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("modal-title ", ctx_r0.iconClasses(), "");
    i0.ɵɵpropertyInterpolate1("id", "modal-title-", ctx_r0.modalId, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.modalTitle, " ");
  }
}
function ModalPopupComponent_h2_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.modalSubtitle);
  }
}
function ModalPopupComponent_div_9_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function ModalPopupComponent_div_9_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.primaryButtonClick.emit(true));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-label", ctx_r0.primaryButtonText);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.primaryButtonText, " ");
  }
}
function ModalPopupComponent_div_9_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function ModalPopupComponent_div_9_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.secondaryButtonClick.emit(true));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-label", ctx_r0.secondaryButtonText);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.secondaryButtonText, " ");
  }
}
function ModalPopupComponent_div_9_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function ModalPopupComponent_div_9_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.primaryButtonClick.emit(true));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-label", ctx_r0.primaryButtonText);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.primaryButtonText, " ");
  }
}
function ModalPopupComponent_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, ModalPopupComponent_div_9_button_1_Template, 2, 2, "button", 11)(2, ModalPopupComponent_div_9_button_2_Template, 2, 2, "button", 12)(3, ModalPopupComponent_div_9_button_3_Template, 2, 2, "button", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.primaryButtonText && ctx_r0.primaryBeforeSecondary);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.secondaryButtonText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.primaryButtonText && !ctx_r0.primaryBeforeSecondary);
  }
}
const _c8 = ["labelRef"];
const _c9 = a0 => ({
  "height.px": a0
});
function FlyoutComponent_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8, 0);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function FlyoutComponent_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 9);
  }
}
const _c10 = ["suggestionsUl"];
const _c11 = ["inputField"];
const _c12 = ["option"];
const _c13 = a0 => ({
  focused: a0
});
function TypeaheadComponent_i_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 12);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.iconClass);
    i0.ɵɵclassProp("disabled", ctx_r1.disable);
  }
}
function TypeaheadComponent_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function TypeaheadComponent_button_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.cleanAndClose());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r1.id + "_clear");
    i0.ɵɵattribute("aria-label", ctx_r1.label + " l\xF6schen");
  }
}
function TypeaheadComponent_li_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 14, 2);
    i0.ɵɵlistener("click", function TypeaheadComponent_li_11_Template_li_click_0_listener() {
      const idx_r5 = i0.ɵɵrestoreView(_r4).index;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClickSuggestion(idx_r5));
    })("focus", function TypeaheadComponent_li_11_Template_li_focus_0_listener() {
      const idx_r5 = i0.ɵɵrestoreView(_r4).index;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setActive(idx_r5));
    });
    i0.ɵɵelementStart(2, "a", 15);
    i0.ɵɵelement(3, "div", 16);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const suggestion_r6 = ctx.$implicit;
    const idx_r5 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("id", "selectedOption-" + ctx_r1.id + "-" + idx_r5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c13, idx_r5 === ctx_r1.activeSuggestionIndex));
    i0.ɵɵattribute("aria-selected", idx_r5 === ctx_r1.activeSuggestionIndex ? "true" : "false");
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(suggestion_r6.cssClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r1.render(suggestion_r6), i0.ɵɵsanitizeHtml);
  }
}
function AccordionComponent_i_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.iconClasses);
  }
}
function AccordionComponent_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DropdownComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DropdownComponent_li_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 8);
    i0.ɵɵlistener("click", function DropdownComponent_li_8_Template_a_click_1_listener() {
      const value_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onChange(value_r2));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const value_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("active", ctx_r2.optionCompareFunction(ctx_r2.selectedValue, value_r2));
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-value", ctx_r2.optionLabelFunction(value_r2));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.optionLabelFunction(value_r2));
  }
}
function FilterChipComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "span", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 3);
    i0.ɵɵelementStart(4, "button", 4);
    i0.ɵɵlistener("click", function FilterChipComponent_div_0_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.removeChip());
    });
    i0.ɵɵelement(5, "i", 5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("id", ctx_r1.id ? ctx_r1.id : null)("aria-hidden", ctx_r1.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.aktiverFilter.name + " " + ctx_r1.aktiverFilter.text);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r1.aktiverFilter.text, i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("data-bs-content", ctx_r1.aktiverFilter.name)("aria-hidden", true);
    i0.ɵɵadvance();
    i0.ɵɵattribute("id", ctx_r1.id ? ctx_r1.id + "_delete" : null)("disabled", ctx_r1.disabled ? true : null)("aria-label", ctx_r1.aktiverFilter.text + " Filter entfernen");
  }
}
const _c14 = ["sliderViewContainer"];
const _c15 = ["sliderTemplate"];
function BildSliderComponent_ng_template_2_section_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8)(2, "div")(3, "img", 9);
    i0.ɵɵlistener("click", function BildSliderComponent_ng_template_2_section_0_div_2_Template_img_click_3_listener() {
      const i_r2 = i0.ɵɵrestoreView(_r1).index;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.sendIndex(i_r2));
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(4, "div", 10);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const bild_r4 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("src", bild_r4.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("alt", bild_r4.unterschrift);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(bild_r4.unterschrift);
  }
}
function BildSliderComponent_ng_template_2_section_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "section", 4)(1, "div", 5);
    i0.ɵɵtemplate(2, BildSliderComponent_ng_template_2_section_0_div_2_Template, 6, 3, "div", 6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("ba-4by3", ctx_r2.is4by3);
    i0.ɵɵproperty("id", ctx_r2.id)("ngClass", ctx_r2.bilder.length === 1 ? "ba-slider nglib-no-slider" : "ba-slider");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.bilder);
  }
}
function BildSliderComponent_ng_template_2_p_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.alternativText, " ");
  }
}
function BildSliderComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, BildSliderComponent_ng_template_2_section_0_Template, 3, 5, "section", 2)(1, BildSliderComponent_ng_template_2_p_1_Template, 2, 1, "p", 3);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.bilder.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.bilder.length === 0);
  }
}
const _c16 = a0 => ({
  "py-4 px-2": a0
});
const _c17 = a0 => ({
  "reserve-space": a0
});
function CheckboxListeComponent_ng_container_0_div_1_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 12);
    i0.ɵɵpipe(1, "truncate");
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind4(1, 1, item_r2.label, 2, " \u2026", true), i0.ɵɵsanitizeHtml);
  }
}
function CheckboxListeComponent_ng_container_0_div_1_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 12);
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("innerHTML", item_r2.label, i0.ɵɵsanitizeHtml);
  }
}
function CheckboxListeComponent_ng_container_0_div_1_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 13);
    i0.ɵɵtext(2, " (");
    i0.ɵɵelementStart(3, "span", 14);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6, ") ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-bs-content", ctx_r2.createTitle(item_r2));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("+", i0.ɵɵpipeBind1(5, 2, item_r2.treffer), "");
  }
}
function CheckboxListeComponent_ng_container_0_div_1_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " (");
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, ") ");
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, item_r2.treffer));
  }
}
function CheckboxListeComponent_ng_container_0_div_1_button_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "button", 15);
  }
  if (rf & 2) {
    const modal_r4 = ctx.ngIf;
    i0.ɵɵproperty("id", modal_r4.id + "_infobutton");
    i0.ɵɵattribute("data-bs-target", "#" + modal_r4.id)("aria-label", modal_r4.ariaLabel);
  }
}
function CheckboxListeComponent_ng_container_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "input", 7);
    i0.ɵɵlistener("change", function CheckboxListeComponent_ng_container_0_div_1_Template_input_change_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const item_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clicked(item_r2));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 8);
    i0.ɵɵtemplate(4, CheckboxListeComponent_ng_container_0_div_1_span_4_Template, 2, 6, "span", 9)(5, CheckboxListeComponent_ng_container_0_div_1_span_5_Template, 1, 1, "span", 9)(6, CheckboxListeComponent_ng_container_0_div_1_ng_container_6_Template, 7, 4, "ng-container", 10)(7, CheckboxListeComponent_ng_container_0_div_1_ng_template_7_Template, 5, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(9, CheckboxListeComponent_ng_container_0_div_1_button_9_Template, 1, 3, "button", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const default_r5 = i0.ɵɵreference(8);
    const item_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c17, !!item_r2.modal));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r2.id, "_checkbox_", item_r2.key, "");
    i0.ɵɵproperty("checked", item_r2.selected)("indeterminate", item_r2.indeterminate)("disabled", !item_r2.selected && ctx_r2.disabled);
    i0.ɵɵattribute("aria-label", ctx_r2.createAriaLabel(item_r2));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r2.id, "_checkbox_", item_r2.key, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.truncate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.truncate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isAdditional(item_r2))("ngIfElse", default_r5);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", item_r2.modal);
  }
}
function CheckboxListeComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 3);
    i0.ɵɵtemplate(1, CheckboxListeComponent_ng_container_0_div_1_Template, 10, 18, "div", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r2.active);
  }
}
function CheckboxListeComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 16);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "_keineErgebnisse");
    i0.ɵɵproperty("innerHTML", "keine Ergebnisse", i0.ɵɵsanitizeHtml);
  }
}
function AuswahlBuchstabenComponent_div_1_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1, " (aktuelle Auswahl) ");
    i0.ɵɵelementEnd();
  }
}
function AuswahlBuchstabenComponent_div_1_span_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1, " (aktuelle Auswahl) ");
    i0.ɵɵelementEnd();
  }
}
function AuswahlBuchstabenComponent_div_1_span_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1, " (aktuelle Auswahl) ");
    i0.ɵɵelementEnd();
  }
}
function AuswahlBuchstabenComponent_div_1_span_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1, " (aktuelle Auswahl) ");
    i0.ɵɵelementEnd();
  }
}
function AuswahlBuchstabenComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4)(3, "input", 5);
    i0.ɵɵlistener("focus", function AuswahlBuchstabenComponent_div_1_Template_input_focus_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFocus());
    })("focusout", function AuswahlBuchstabenComponent_div_1_Template_input_focusout_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFocusOut());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "label", 6);
    i0.ɵɵtext(5, "A - F ");
    i0.ɵɵtemplate(6, AuswahlBuchstabenComponent_div_1_span_6_Template, 2, 0, "span", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 4)(8, "input", 8);
    i0.ɵɵlistener("focus", function AuswahlBuchstabenComponent_div_1_Template_input_focus_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFocus());
    })("focusout", function AuswahlBuchstabenComponent_div_1_Template_input_focusout_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFocusOut());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "label", 9);
    i0.ɵɵtext(10, "G - L ");
    i0.ɵɵtemplate(11, AuswahlBuchstabenComponent_div_1_span_11_Template, 2, 0, "span", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 4)(13, "input", 10);
    i0.ɵɵlistener("focus", function AuswahlBuchstabenComponent_div_1_Template_input_focus_13_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFocus());
    })("focusout", function AuswahlBuchstabenComponent_div_1_Template_input_focusout_13_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFocusOut());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "label", 11);
    i0.ɵɵtext(15, "M - R ");
    i0.ɵɵtemplate(16, AuswahlBuchstabenComponent_div_1_span_16_Template, 2, 0, "span", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "div", 4)(18, "input", 12);
    i0.ɵɵlistener("focus", function AuswahlBuchstabenComponent_div_1_Template_input_focus_18_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFocus());
    })("focusout", function AuswahlBuchstabenComponent_div_1_Template_input_focusout_18_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFocusOut());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "label", 13);
    i0.ɵɵtext(20, "S - Z ");
    i0.ɵɵtemplate(21, AuswahlBuchstabenComponent_div_1_span_21_Template, 2, 0, "span", 7);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r1.komponentenId, "-radioAbisF");
    i0.ɵɵattribute("name", "buchstabenAuswahl")("aria-checked", ctx_r1.aktuelleBuchstabenReichweite === "aBisF")("disabled", ctx_r1.anbieterlisten.aBisF.length === 0 ? true : null);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("for", "", ctx_r1.komponentenId, "-radioAbisF");
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r1.komponentenId, "-radioAbisFLabel");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.aktuelleBuchstabenReichweite === "aBisF");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r1.komponentenId, "-radioGbisL");
    i0.ɵɵattribute("name", "buchstabenAuswahl")("aria-checked", ctx_r1.aktuelleBuchstabenReichweite === "gBisL")("disabled", ctx_r1.anbieterlisten.gBisL.length === 0 ? true : null);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("for", "", ctx_r1.komponentenId, "-radioGbisL");
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r1.komponentenId, "-radioGbisLLabel");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.aktuelleBuchstabenReichweite === "gBisL");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r1.komponentenId, "-radioMbisR");
    i0.ɵɵattribute("name", "buchstabenAuswahl")("aria-checked", ctx_r1.aktuelleBuchstabenReichweite === "mBisR")("disabled", ctx_r1.anbieterlisten.mBisR.length === 0 ? true : null);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("for", "", ctx_r1.komponentenId, "-radioMbisR");
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r1.komponentenId, "-radioMbisRLabel");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.aktuelleBuchstabenReichweite === "mBisR");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r1.komponentenId, "-radioSbisZ");
    i0.ɵɵattribute("name", "buchstabenAuswahl")("aria-checked", ctx_r1.aktuelleBuchstabenReichweite === "sBisZ")("disabled", ctx_r1.anbieterlisten.sBisZ.length === 0 ? true : null);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("for", "", ctx_r1.komponentenId, "-radioSbisZ");
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r1.komponentenId, "-radioSbisZLabel");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.aktuelleBuchstabenReichweite === "sBisZ");
  }
}
function AnbieterFilterComponent_div_1_ba_bub_auswahl_buchstaben_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ba-bub-auswahl-buchstaben", 6);
    i0.ɵɵlistener("buchstabenSelected", function AnbieterFilterComponent_div_1_ba_bub_auswahl_buchstaben_1_Template_ba_bub_auswahl_buchstaben_buchstabenSelected_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.setzteBuchstabenKategorie($event));
    })("hasFocus", function AnbieterFilterComponent_div_1_ba_bub_auswahl_buchstaben_1_Template_ba_bub_auswahl_buchstaben_hasFocus_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.hasFocus.next($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r1.komponentenId, "_auswahlBuchstaben");
    i0.ɵɵproperty("komponentenId", ctx_r1.komponentenId)("aktuelleBuchstabenReichweite", ctx_r1.aktiveBuchstabenKategorie)("anbieterlisten", ctx_r1.anbieterNachBuchstabenKategorie);
  }
}
function AnbieterFilterComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AnbieterFilterComponent_div_1_ba_bub_auswahl_buchstaben_1_Template, 1, 5, "ba-bub-auswahl-buchstaben", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.anbieterNachBuchstabenKategorie.alle.length > 5);
  }
}
function AnbieterFilterComponent_div_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "ba-bub-checkbox-liste", 10);
    i0.ɵɵlistener("checkboxClicked", function AnbieterFilterComponent_div_2_div_1_Template_ba_bub_checkbox_liste_checkboxClicked_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onCheckboxAuswaehlen($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const anbieterInBuchstabenKategorie_r4 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("filterList", anbieterInBuchstabenKategorie_r4)("id", ctx_r1.komponentenId + "_aktuelleAnbieter")("truncate", true)("forcePlus", ctx_r1.istEinAnbieterAusgewaehlt)("disabled", ctx_r1.istMaximaleAnzahlErreicht);
  }
}
function AnbieterFilterComponent_div_2_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ba-bub-zuviele-anbieter", 11);
  }
  if (rf & 2) {
    const anbieterInBuchstabenKategorie_r4 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("komponentenId", ctx_r1.komponentenId)("anzahlAnbieter", anbieterInBuchstabenKategorie_r4.length)("focus", ctx_r1.hasFocus);
  }
}
function AnbieterFilterComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, AnbieterFilterComponent_div_2_div_1_Template, 2, 5, "div", 8)(2, AnbieterFilterComponent_div_2_ng_template_2_Template, 1, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const anbieterInBuchstabenKategorie_r4 = ctx.ngIf;
    const zuvieleAnbieter_r5 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", anbieterInBuchstabenKategorie_r4.length <= 15 && ctx_r1.anbieterListe.length < 500)("ngIfElse", zuvieleAnbieter_r5);
  }
}
function AnbieterFilterComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtext(1, " keine Ergebnisse ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r1.komponentenId, "_keineErgebnisse");
  }
}
const _c18 = a0 => ({
  "mw-100 rounded border-0": a0
});
function TaglisteComponent_li_1_button_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "button", 10);
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r2.getTeaserTooltip(item_r2.teaser));
    i0.ɵɵattribute("data-bs-target", "#modal-teaser-" + item_r2.id)("aria-label", ctx_r2.getTeaserAriaLabel(item_r2.teaser))("aria-expanded", item_r2.teaser.open);
  }
}
function TaglisteComponent_li_1_i_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 11);
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMapInterpolate1("ba-icon ", item_r2.icon, "-after");
  }
}
function TaglisteComponent_li_1_ba_bub_tagteaser_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ba-bub-tagteaser", 12);
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate1("id", "ba-bub-tag-teaser-", item_r2.id, "");
    i0.ɵɵproperty("id", item_r2.id)("teaser", item_r2.teaser);
  }
}
function TaglisteComponent_li_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "div", 2);
    i0.ɵɵtemplate(2, TaglisteComponent_li_1_button_2_Template, 1, 4, "button", 3);
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵtemplate(4, TaglisteComponent_li_1_i_4_Template, 1, 3, "i", 5);
    i0.ɵɵelementStart(5, "div", 6);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "p", 7);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 8);
    i0.ɵɵlistener("click", function TaglisteComponent_li_1_Template_button_click_9_listener() {
      const item_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onRemove(item_r2));
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(10, TaglisteComponent_li_1_ba_bub_tagteaser_10_Template, 1, 4, "ba-bub-tagteaser", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", "tagCloudElement_" + item_r2.id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r2.teaser);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c18, !item_r2.teaser));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r2.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", item_r2.angezeigterText);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r2.angezeigterText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r2.angezeigterText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", ctx_r2.getRemoveTooltip(item_r2));
    i0.ɵɵattribute("aria-label", ctx_r2.getRemoveTooltip(item_r2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r2.teaser);
  }
}
function TagcloudComponent_div_0_a_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 6);
    i0.ɵɵlistener("click", function TagcloudComponent_div_0_a_3_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.tagcloudListeRemoveAll.emit());
    });
    i0.ɵɵtext(1, " Alle L\xF6schen ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r1.id, "_delete-all-link");
    i0.ɵɵproperty("title", ctx_r1.removeAllTooltip);
  }
}
function TagcloudComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "p", 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, TagcloudComponent_div_0_a_3_Template, 2, 3, "a", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r1.id, "_headline");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.headline);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.tagcloudListeRemoveAll.observers.length > 0);
  }
}
function TagcloudComponent_ba_bub_collapse_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ba-bub-collapse", 7)(1, "ba-bub-tagliste", 8);
    i0.ɵɵpipe(2, "slice");
    i0.ɵɵlistener("tagClicked", function TagcloudComponent_ba_bub_collapse_3_Template_ba_bub_tagliste_tagClicked_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClick($event));
    })("tagRemoved", function TagcloudComponent_ba_bub_collapse_3_Template_ba_bub_tagliste_tagRemoved_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onRemove($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("ariaLabel", ctx_r1.ariaLabel);
    i0.ɵɵpropertyInterpolate("ariaLabelContent", ctx_r1.ariaLabelContent);
    i0.ɵɵpropertyInterpolate2("labelForOpen", "", ctx_r1.labelForOpen, " (", ctx_r1.tagcloudListe.length - ctx_r1.maxTagsVisible, ")");
    i0.ɵɵpropertyInterpolate("labelForClose", ctx_r1.labelForClose);
    i0.ɵɵproperty("collapseId", ctx_r1.collapseId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("taglisteAriaLabel", ctx_r1.tagListeAriaLabel)("tagcloudListe", i0.ɵɵpipeBind2(2, 10, ctx_r1.tagcloudListe, ctx_r1.maxTagsVisible))("startId", ctx_r1.maxTagsVisible);
  }
}
const _c19 = a0 => ({
  disabled: a0
});
const _c20 = (a0, a1, a2) => ({
  disabled: a0,
  "position-absolute invisible": a1,
  "ms-auto": a2
});
function SuchUmkreisSliderComponent_span_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵlistener("click", function SuchUmkreisSliderComponent_span_8_Template_span_click_0_listener() {
      const i_r2 = i0.ɵɵrestoreView(_r1).index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onChange(i_r2));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const wert_r4 = ctx.$implicit;
    const i_r2 = ctx.index;
    const isFirst_r5 = ctx.first;
    const isLast_r6 = ctx.last;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(5, _c20, ctx_r2.disabled, !isFirst_r5 && !isLast_r6, isLast_r6));
    i0.ɵɵattribute("value", i_r2)("label", isFirst_r5 || isLast_r6 ? ctx_r2.modifikatorFuerBeschreibung(wert_r4, i_r2) : undefined)("disabled", ctx_r2.disabled ? "" : undefined);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.modifikatorFuerBeschreibung(wert_r4, i_r2), " ");
  }
}
function FacetteComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9);
    i0.ɵɵelement(2, "i");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div")(4, "span", 10);
    i0.ɵɵtext(5, "Facette");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "legende_", ctx_r0.id, "");
    i0.ɵɵattribute("aria-level", ctx_r0.headingLevel);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("facette-icon ba-icon ", ctx_r0.icon, "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.facettenName, " ");
  }
}
function FacetteComponent_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function FacetteComponent_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.resetClicked.emit());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattributeInterpolate1("aria-label", "Auswahl der Facette ", ctx_r0.facettenName, " zur\xFCcksetzen");
    i0.ɵɵattributeInterpolate1("data-bs-content", "Auswahl der Facette ", ctx_r0.facettenName, " zur\xFCcksetzen");
    i0.ɵɵpropertyInterpolate1("id", "reset_", ctx_r0.id, "");
  }
}
function FacetteComponent_hr_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hr", 9);
  }
}
function FacetteComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FacetteComponent_fieldset_7_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FacetteComponent_fieldset_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "fieldset", 12)(1, "legend", 13)(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtemplate(5, FacetteComponent_fieldset_7_ng_container_5_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "legende_print_", ctx_r0.id, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.facettenName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.druckansicht);
  }
}
function FeedbackComponent_ba_feedback_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FeedbackComponent_ba_feedback_0_h2_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 3);
    i0.ɵɵtext(1, " Wie gef\xE4llt Ihnen unsere Webseite? ");
    i0.ɵɵelementEnd();
  }
}
function FeedbackComponent_ba_feedback_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ba-feedback");
    i0.ɵɵtemplate(1, FeedbackComponent_ba_feedback_0_ng_container_1_Template, 1, 0, "ng-container", 1)(2, FeedbackComponent_ba_feedback_0_h2_2_Template, 2, 0, "h2", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("client-id", ctx_r0.clientId)("subject", ctx_r0.subject);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.customHeader);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.customHeader);
  }
}
function FeedbackComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, " Die Feedback-Komponente steht aktuell leider nicht zur Verf\xFCgung.\n");
    i0.ɵɵelementEnd();
  }
}
const _c21 = a0 => ({
  "background-image": a0
});
const _c22 = a0 => ({
  action: "click",
  category: "kachel",
  name: a0
});
const _c23 = ["svg_germany"];
const _c24 = ["svg_europe"];
function KarteComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 69)(1, "div", 70)(2, "div", 71)(3, "input", 72);
    i0.ɵɵlistener("click", function KarteComponent_div_1_Template_input_click_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onNationalClicked());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "label", 73);
    i0.ɵɵtext(5, "National");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 71)(7, "input", 74);
    i0.ɵɵlistener("click", function KarteComponent_div_1_Template_input_click_7_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onInternationalClicked());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "label", 73);
    i0.ɵɵtext(9, "International");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("aria-controls", "", ctx_r2.id, "-cb");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "National");
    i0.ɵɵpropertyInterpolate("name", ctx_r2.id);
    i0.ɵɵproperty("checked", ctx_r2.zoomLevel === "national");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("for", "", ctx_r2.id, "National");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "International");
    i0.ɵɵpropertyInterpolate("name", ctx_r2.id);
    i0.ɵɵproperty("checked", ctx_r2.zoomLevel === "international");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("for", "", ctx_r2.id, "International");
  }
}
function KarteComponent_div_160__svg_svg_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 78, 1);
    i0.ɵɵelement(2, "path", 79);
    i0.ɵɵelementStart(3, "g", 80);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_3_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz.iN));
    });
    i0.ɵɵelement(4, "path", 81)(5, "rect", 82);
    i0.ɵɵelementStart(6, "text", 83);
    i0.ɵɵtext(7, "N");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "text", 84);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "text", 85);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "g", 86);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_12_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz.iIRL));
    });
    i0.ɵɵelement(13, "path", 87)(14, "rect", 88);
    i0.ɵɵelementStart(15, "text", 89);
    i0.ɵɵtext(16, "IRL");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "text", 84);
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "text", 85);
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(21, "g", 86);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_21_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz.iGB));
    });
    i0.ɵɵelement(22, "path", 90)(23, "rect", 91);
    i0.ɵɵelementStart(24, "text", 92);
    i0.ɵɵtext(25, "GB");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "text", 84);
    i0.ɵɵtext(27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "text", 85);
    i0.ɵɵtext(29);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(30, "g", 86);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_30_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz.iNL));
    });
    i0.ɵɵelement(31, "path", 93)(32, "rect", 94);
    i0.ɵɵelementStart(33, "text", 95);
    i0.ɵɵtext(34, "NL");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "text", 84);
    i0.ɵɵtext(36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "text", 85);
    i0.ɵɵtext(38);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(39, "g", 86);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_39_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz.iB));
    });
    i0.ɵɵelement(40, "path", 96)(41, "rect", 97);
    i0.ɵɵelementStart(42, "text", 98);
    i0.ɵɵtext(43, "B");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(44, "text", 84);
    i0.ɵɵtext(45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(46, "text", 85);
    i0.ɵɵtext(47);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(48, "g", 86);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_48_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz.iLU));
    });
    i0.ɵɵelement(49, "path", 99)(50, "rect", 100);
    i0.ɵɵelementStart(51, "text", 101);
    i0.ɵɵtext(52, "LU");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(53, "text", 84);
    i0.ɵɵtext(54);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(55, "text", 85);
    i0.ɵɵtext(56);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(57, "g", 86);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_57_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz.iF));
    });
    i0.ɵɵelement(58, "path", 102)(59, "rect", 103);
    i0.ɵɵelementStart(60, "text", 104);
    i0.ɵɵtext(61, "F");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(62, "text", 84);
    i0.ɵɵtext(63);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(64, "text", 85);
    i0.ɵɵtext(65);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(66, "g", 86);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_66_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz.iE));
    });
    i0.ɵɵelement(67, "path", 105)(68, "rect", 106);
    i0.ɵɵelementStart(69, "text", 107);
    i0.ɵɵtext(70, "E");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(71, "text", 84);
    i0.ɵɵtext(72);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(73, "text", 85);
    i0.ɵɵtext(74);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(75, "g", 86);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_75_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz.iI));
    });
    i0.ɵɵelement(76, "path", 108)(77, "rect", 109);
    i0.ɵɵelementStart(78, "text", 110);
    i0.ɵɵtext(79, "I");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(80, "text", 84);
    i0.ɵɵtext(81);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(82, "text", 85);
    i0.ɵɵtext(83);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(84, "g", 86);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_84_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz.iP));
    });
    i0.ɵɵelement(85, "path", 111)(86, "rect", 112);
    i0.ɵɵelementStart(87, "text", 113);
    i0.ɵɵtext(88, "P");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(89, "text", 84);
    i0.ɵɵtext(90);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(91, "text", 85);
    i0.ɵɵtext(92);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(93, "g", 86);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_93_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz.iS));
    });
    i0.ɵɵelement(94, "path", 114)(95, "rect", 115);
    i0.ɵɵelementStart(96, "text", 116);
    i0.ɵɵtext(97, "S");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(98, "text", 84);
    i0.ɵɵtext(99);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(100, "text", 85);
    i0.ɵɵtext(101);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(102, "g", 86);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_102_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz.iDK));
    });
    i0.ɵɵelement(103, "path", 117)(104, "rect", 118);
    i0.ɵɵelementStart(105, "text", 119);
    i0.ɵɵtext(106, "DK");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(107, "text", 84);
    i0.ɵɵtext(108);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(109, "text", 85);
    i0.ɵɵtext(110);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(111, "g", 86);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_111_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz.iFIN));
    });
    i0.ɵɵelement(112, "path", 120)(113, "rect", 121);
    i0.ɵɵelementStart(114, "text", 122);
    i0.ɵɵtext(115, "FIN");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(116, "text", 84);
    i0.ɵɵtext(117);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(118, "text", 85);
    i0.ɵɵtext(119);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(120, "g", 86);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_120_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz.iPL));
    });
    i0.ɵɵelement(121, "path", 123)(122, "rect", 124);
    i0.ɵɵelementStart(123, "text", 125);
    i0.ɵɵtext(124, "PL");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(125, "text", 84);
    i0.ɵɵtext(126);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(127, "text", 85);
    i0.ɵɵtext(128);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(129, "g", 86);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_129_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz.iCZ));
    });
    i0.ɵɵelement(130, "path", 126)(131, "rect", 127);
    i0.ɵɵelementStart(132, "text", 128);
    i0.ɵɵtext(133, "CZ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(134, "text", 84);
    i0.ɵɵtext(135);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(136, "text", 85);
    i0.ɵɵtext(137);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(138, "g", 86);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_138_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz.iSK));
    });
    i0.ɵɵelement(139, "path", 129)(140, "rect", 130);
    i0.ɵɵelementStart(141, "text", 131);
    i0.ɵɵtext(142, "SK");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(143, "text", 84);
    i0.ɵɵtext(144);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(145, "text", 85);
    i0.ɵɵtext(146);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(147, "g", 86);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_147_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz.iH));
    });
    i0.ɵɵelement(148, "path", 132)(149, "rect", 133);
    i0.ɵɵelementStart(150, "text", 134);
    i0.ɵɵtext(151, "H");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(152, "text", 84);
    i0.ɵɵtext(153);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(154, "text", 85);
    i0.ɵɵtext(155);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(156, "g", 86);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_156_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz.iA));
    });
    i0.ɵɵelement(157, "path", 135)(158, "rect", 136);
    i0.ɵɵelementStart(159, "text", 137);
    i0.ɵɵtext(160, "A");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(161, "text", 84);
    i0.ɵɵtext(162);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(163, "text", 85);
    i0.ɵɵtext(164);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(165, "g", 86);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_165_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz.iCH));
    });
    i0.ɵɵelement(166, "path", 138)(167, "rect", 139);
    i0.ɵɵelementStart(168, "text", 140);
    i0.ɵɵtext(169, "CH");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(170, "text", 84);
    i0.ɵɵtext(171);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(172, "text", 85);
    i0.ɵɵtext(173);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(174, "g", 86);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_174_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz.iSLO));
    });
    i0.ɵɵelement(175, "path", 141)(176, "rect", 142);
    i0.ɵɵelementStart(177, "text", 143);
    i0.ɵɵtext(178, "SLO");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(179, "text", 84);
    i0.ɵɵtext(180);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(181, "text", 85);
    i0.ɵɵtext(182);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(183, "g", 144);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_183_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onNationalClicked());
    });
    i0.ɵɵelement(184, "path", 145)(185, "rect", 146);
    i0.ɵɵelementStart(186, "text", 147);
    i0.ɵɵtext(187, "D");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(188, "text", 84);
    i0.ɵɵtext(189);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(190, "text", 85);
    i0.ɵɵtext(191);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(192, "g", 86);
    i0.ɵɵlistener("click", function KarteComponent_div_160__svg_svg_2_Template_g_click_192_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz.iWORLD));
    });
    i0.ɵɵelement(193, "rect", 148);
    i0.ɵɵelementStart(194, "text", 149);
    i0.ɵɵtext(195, "...");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(196, "text", 84);
    i0.ɵɵtext(197);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(198, "text", 85);
    i0.ɵɵtext(199);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-svg-map-europe");
    i0.ɵɵattribute("class", ctx_r2.focusedRegion !== null ? "checkbox-focus svg-map-europe" : "svg-map-europe");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-other");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-N");
    i0.ɵɵattribute("class", ctx_r2.getClassnameForRegion(ctx_r2.regionenKurz.iN));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iN, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iN, 2), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-IRL");
    i0.ɵɵattribute("class", ctx_r2.getClassnameForRegion(ctx_r2.regionenKurz.iIRL));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iIRL, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iIRL, 2), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-GB");
    i0.ɵɵattribute("class", ctx_r2.getClassnameForRegion(ctx_r2.regionenKurz.iGB));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iGB, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iGB, 2), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-NL");
    i0.ɵɵattribute("class", ctx_r2.getClassnameForRegion(ctx_r2.regionenKurz.iNL));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iNL, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iNL, 2), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-B");
    i0.ɵɵattribute("class", ctx_r2.getClassnameForRegion(ctx_r2.regionenKurz.iB));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iB, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iB, 2), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-LU");
    i0.ɵɵattribute("class", ctx_r2.getClassnameForRegion(ctx_r2.regionenKurz.iLU));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iLU, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iLU, 2), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-F");
    i0.ɵɵattribute("class", ctx_r2.getClassnameForRegion(ctx_r2.regionenKurz.iF));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iF, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iF, 2), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-E");
    i0.ɵɵattribute("class", ctx_r2.getClassnameForRegion(ctx_r2.regionenKurz.iE));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iE, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iE, 2), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-I");
    i0.ɵɵattribute("class", ctx_r2.getClassnameForRegion(ctx_r2.regionenKurz.iI));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iI, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iI, 2), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-P");
    i0.ɵɵattribute("class", ctx_r2.getClassnameForRegion(ctx_r2.regionenKurz.iP));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iP, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iP, 2), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-S");
    i0.ɵɵattribute("class", ctx_r2.getClassnameForRegion(ctx_r2.regionenKurz.iS));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iS, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iS, 2), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-DK");
    i0.ɵɵattribute("class", ctx_r2.getClassnameForRegion(ctx_r2.regionenKurz.iDK));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iDK, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iDK, 2), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-FIN");
    i0.ɵɵattribute("class", ctx_r2.getClassnameForRegion(ctx_r2.regionenKurz.iFIN));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iFIN, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iFIN, 2), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-PL");
    i0.ɵɵattribute("class", ctx_r2.getClassnameForRegion(ctx_r2.regionenKurz.iPL));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iPL, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iPL, 2), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-CZ");
    i0.ɵɵattribute("class", ctx_r2.getClassnameForRegion(ctx_r2.regionenKurz.iCZ));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iCZ, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iCZ, 2), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-SK");
    i0.ɵɵattribute("class", ctx_r2.getClassnameForRegion(ctx_r2.regionenKurz.iSK));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iSK, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iSK, 2), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-H");
    i0.ɵɵattribute("class", ctx_r2.getClassnameForRegion(ctx_r2.regionenKurz.iH));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iH, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iH, 2), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-A");
    i0.ɵɵattribute("class", ctx_r2.getClassnameForRegion(ctx_r2.regionenKurz.iA));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iA, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iA, 2), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-CH");
    i0.ɵɵattribute("class", ctx_r2.getClassnameForRegion(ctx_r2.regionenKurz.iCH));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iCH, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iCH, 2), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-SLO");
    i0.ɵɵattribute("class", ctx_r2.getClassnameForRegion(ctx_r2.regionenKurz.iSLO));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iSLO, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iSLO, 2), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-D");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iD, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getAnzahlDeutschland(), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-country-WORLD");
    i0.ɵɵattribute("class", ctx_r2.getClassnameForRegion(ctx_r2.regionenKurz.iWORLD));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iWORLD, 1), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getCommentLine(ctx_r2.regionenKurz.iWORLD, 2), " ");
  }
}
function KarteComponent_div_160_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 75);
    i0.ɵɵelement(1, "canvas", 76);
    i0.ɵɵtemplate(2, KarteComponent_div_160__svg_svg_2_Template, 200, 114, "svg", 77);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r2.moeglicheLaender == null ? null : ctx_r2.moeglicheLaender.length) > 0);
  }
}
function KarteComponent_input_162_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 150);
    i0.ɵɵlistener("change", function KarteComponent_input_162_Template_input_change_0_listener() {
      const item_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.toggleRegion(ctx_r2.regionenKurz[item_r6.key]));
    })("focus", function KarteComponent_input_162_Template_input_focus_0_listener() {
      const item_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.focusCheckbox(ctx_r2.regionenKurz[item_r6.key]));
    })("blur", function KarteComponent_input_162_Template_input_blur_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.blurCheckbox());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r2.id, "-cb-", item_r6.key, "");
    i0.ɵɵpropertyInterpolate1("name", "bundesland-cb-", item_r6.key, "");
    i0.ɵɵproperty("checked", item_r6.selected);
    i0.ɵɵattribute("aria-label", item_r6.ariaLabel);
  }
}
function KarteComponent_div_163_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 151);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "_keineErgebnisse");
    i0.ɵɵproperty("innerHTML", ctx_r2.keineErgebnisse, i0.ɵɵsanitizeHtml);
  }
}
const _c25 = a0 => ({
  "small-header": a0
});
const _c26 = a0 => ({
  action: "click",
  category: "breadcrumb",
  name: a0
});
function KontextinfoHeaderComponent_nav_3_li_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "a", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const breadcrumb_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", breadcrumb_r1.name);
    i0.ɵɵproperty("routerLink", breadcrumb_r1.path)("queryParams", breadcrumb_r1.queryParams)("trackEvent", i0.ɵɵpureFunction1(5, _c26, breadcrumb_r1.name));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", breadcrumb_r1.name, "");
  }
}
function KontextinfoHeaderComponent_nav_3_li_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span", 12);
    i0.ɵɵtext(3, "(aktuelle Seite)");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r1.breadcrumb, " ");
  }
}
function KontextinfoHeaderComponent_nav_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "nav", 8)(1, "ol");
    i0.ɵɵtemplate(2, KontextinfoHeaderComponent_nav_3_li_2_Template, 3, 7, "li", 9)(3, KontextinfoHeaderComponent_nav_3_li_3_Template, 4, 1, "li", 10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.breadcrumbUrls);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.breadcrumb);
  }
}
function KontextinfoHeaderComponent_ng_template_4_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 14);
  }
}
function KontextinfoHeaderComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, KontextinfoHeaderComponent_ng_template_4_div_0_Template, 1, 0, "div", 13);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r1.smallHeader);
  }
}
function PaginierungComponent_nav_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nav", 1)(1, "ul", 2)(2, "li", 3)(3, "a", 4);
    i0.ɵɵlistener("click", function PaginierungComponent_nav_1_Template_a_click_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.pageFirstClicked());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "li", 5)(5, "a", 6);
    i0.ɵɵlistener("click", function PaginierungComponent_nav_1_Template_a_click_5_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.pagePrevClicked());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "li", 7)(7, "span", 8);
    i0.ɵɵtext(8, "Seite");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 9)(10, "span", 10);
    i0.ɵɵtext(11, "Seite ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "span", 8);
    i0.ɵɵtext(14, "(aktuelle Seite)");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "li", 11)(16, "a", 6);
    i0.ɵɵlistener("click", function PaginierungComponent_nav_1_Template_a_click_16_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.pageNextClicked());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "li", 12)(18, "a", 6);
    i0.ɵɵlistener("click", function PaginierungComponent_nav_1_Template_a_click_18_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.pageLastClicked());
    });
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattributeInterpolate1("aria-label", "Pagination Ergebnisliste (", ctx_r1.position, ")");
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("disabled", ctx_r1.isFirstPage);
    i0.ɵɵpropertyInterpolate1("id", "page-first-", ctx_r1.position, "");
    i0.ɵɵattribute("aria-disabled", ctx_r1.isFirstPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabindex", ctx_r1.isFirstPage ? -1 : 0);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("disabled", ctx_r1.isFirstPage);
    i0.ɵɵpropertyInterpolate1("id", "page-previous-", ctx_r1.position, "");
    i0.ɵɵattribute("aria-disabled", ctx_r1.isFirstPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabindex", ctx_r1.isFirstPage ? -1 : 0)("title", ctx_r1.labelVorherigeSeite);
    i0.ɵɵattribute("aria-label", ctx_r1.labelVorherigeSeite);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "page-active-", ctx_r1.position, "");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate2("", ctx_r1.aktuelleSeite, " von ", ctx_r1.anzahlSeiten, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("disabled", ctx_r1.isLastPage);
    i0.ɵɵpropertyInterpolate1("id", "page-next-", ctx_r1.position, "");
    i0.ɵɵattribute("aria-disabled", ctx_r1.isLastPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabindex", ctx_r1.isLastPage ? -1 : 0)("title", ctx_r1.labelNaechsteSeite);
    i0.ɵɵattribute("aria-label", ctx_r1.labelNaechsteSeite);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("disabled", ctx_r1.isLastPage);
    i0.ɵɵpropertyInterpolate1("id", "page-last-", ctx_r1.position, "");
    i0.ɵɵattribute("aria-disabled", ctx_r1.isLastPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabindex", ctx_r1.isLastPage ? -1 : 0)("title", ctx_r1.labelLetzteSeite);
    i0.ɵɵattribute("aria-label", ctx_r1.labelLetzteSeite);
  }
}
const _c27 = (a0, a1, a2) => ({
  affix: a0,
  unfix: a1,
  small: a2
});
const _c28 = () => ["/"];
function DetailNavigationComponent_ng_container_3_span_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "span", 13);
    i0.ɵɵtext(2, "0 vorherige");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 7);
    i0.ɵɵtext(4, "keine vorherigen Angebote");
    i0.ɵɵelementEnd()();
  }
}
function DetailNavigationComponent_ng_container_3_span_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "span", 13)(2, "span", 14);
    i0.ɵɵtext(3, "1");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, " vorheriges");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 7);
    i0.ɵɵtext(6, "ein vorheriges Angebot");
    i0.ɵɵelementEnd()();
  }
}
function DetailNavigationComponent_ng_container_3_span_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "span", 13)(2, "span", 14);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, " vorherige ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 7);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.anzahlVorherigeSeiten);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r1.anzahlVorherigeSeiten, " vorherige Angebote");
  }
}
function DetailNavigationComponent_ng_container_3_span_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "span", 13);
    i0.ɵɵtext(2, "0 weitere");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 7);
    i0.ɵɵtext(4, "keine weiteren Angebote");
    i0.ɵɵelementEnd()();
  }
}
function DetailNavigationComponent_ng_container_3_span_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "span", 13)(2, "span", 14);
    i0.ɵɵtext(3, "1");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, " weiteres");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 7);
    i0.ɵɵtext(6, "ein weiteres Angebot");
    i0.ɵɵelementEnd()();
  }
}
function DetailNavigationComponent_ng_container_3_span_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "span", 13)(2, "span", 14);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, " weitere");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 7);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.anzahlFolgendeSeiten);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r1.anzahlFolgendeSeiten, " weitere Angebote");
  }
}
function DetailNavigationComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 5);
    i0.ɵɵlistener("click", function DetailNavigationComponent_ng_container_3_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onZurueckZurErgebnisseite());
    });
    i0.ɵɵelement(2, "i", 6);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, "zur\xFCck");
    i0.ɵɵelementStart(5, "span", 7);
    i0.ɵɵtext(6, " zur Suche");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "button", 8);
    i0.ɵɵlistener("click", function DetailNavigationComponent_ng_container_3_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onNaechstesErgebnis());
    });
    i0.ɵɵelement(8, "i", 9);
    i0.ɵɵelementStart(9, "span");
    i0.ɵɵtemplate(10, DetailNavigationComponent_ng_container_3_span_10_Template, 5, 0, "span", 10)(11, DetailNavigationComponent_ng_container_3_span_11_Template, 7, 0, "span", 10)(12, DetailNavigationComponent_ng_container_3_span_12_Template, 7, 2, "span", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "button", 11);
    i0.ɵɵlistener("click", function DetailNavigationComponent_ng_container_3_Template_button_click_13_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onVorherigesErgebnis());
    });
    i0.ɵɵelementStart(14, "span");
    i0.ɵɵtemplate(15, DetailNavigationComponent_ng_container_3_span_15_Template, 5, 0, "span", 10)(16, DetailNavigationComponent_ng_container_3_span_16_Template, 7, 0, "span", 10)(17, DetailNavigationComponent_ng_container_3_span_17_Template, 7, 2, "span", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(18, "i", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("disabled", (ctx_r1.naechstesElement == null ? null : ctx_r1.naechstesElement.observers.length) === 0 || ctx_r1.anzahlVorherigeSeiten <= 0)("title", (ctx_r1.naechstesElement == null ? null : ctx_r1.naechstesElement.observers.length) === 0 || ctx_r1.anzahlVorherigeSeiten <= 0 ? "Keine vorherigen Ergebnisse" : "Zum vorherigen Ergebnis");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.anzahlVorherigeSeiten <= 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.anzahlVorherigeSeiten === 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.anzahlVorherigeSeiten > 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", (ctx_r1.vorherigesElement == null ? null : ctx_r1.vorherigesElement.observers.length) === 0 || ctx_r1.anzahlFolgendeSeiten <= 0)("title", (ctx_r1.vorherigesElement == null ? null : ctx_r1.vorherigesElement.observers.length) === 0 || ctx_r1.anzahlFolgendeSeiten <= 0 ? "Keine weiteren Ergebnisse" : "Zum n\xE4chsten Ergebnis");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.anzahlFolgendeSeiten <= 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.anzahlFolgendeSeiten === 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.anzahlFolgendeSeiten > 1);
  }
}
function DetailNavigationComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵelement(1, "i", 6);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, "zur\xFCck");
    i0.ɵɵelementStart(4, "span", 7);
    i0.ɵɵtext(5, " zur Startseite");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(1, _c28));
  }
}
function PaginierungDplComponent_nav_1_li_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 11)(1, "a", 12);
    i0.ɵɵlistener("click", function PaginierungDplComponent_nav_1_li_4_Template_a_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.pageFirstClicked());
    });
    i0.ɵɵtext(2, "1");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "page-first-", ctx_r1.position, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabindex", ctx_r1.isFirstPage ? -1 : 0);
  }
}
function PaginierungDplComponent_nav_1_li_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 13)(1, "a", 14);
    i0.ɵɵlistener("click", function PaginierungDplComponent_nav_1_li_5_Template_a_click_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.pageThreePagesPreviousClicked($event));
    });
    i0.ɵɵtext(2, "...");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "page-previous-three-", ctx_r1.position, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabindex", ctx_r1.isFirstPage ? -1 : 0);
  }
}
function PaginierungDplComponent_nav_1_li_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 11)(1, "a", 3);
    i0.ɵɵlistener("click", function PaginierungDplComponent_nav_1_li_6_Template_a_click_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.pagePrevClicked($event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "page-previous-", ctx_r1.position, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabindex", ctx_r1.isFirstPage ? -1 : 0)("title", ctx_r1.labelVorherigeSeite);
    i0.ɵɵattribute("aria-label", ctx_r1.labelVorherigeSeite);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.aktuelleSeite - 1);
  }
}
function PaginierungDplComponent_nav_1_li_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 11)(1, "a", 15);
    i0.ɵɵlistener("click", function PaginierungDplComponent_nav_1_li_14_Template_a_click_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.pageNextClicked($event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "page-next-", ctx_r1.position, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", ctx_r1.labelNaechsteSeite);
    i0.ɵɵattribute("aria-label", ctx_r1.labelNaechsteSeite);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.aktuelleSeite + 1);
  }
}
function PaginierungDplComponent_nav_1_li_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 16)(1, "a", 17);
    i0.ɵɵlistener("click", function PaginierungDplComponent_nav_1_li_15_Template_a_click_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.pageThreePagesNextClicked($event));
    });
    i0.ɵɵtext(2, "...");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "page-next-three-", ctx_r1.position, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabindex", ctx_r1.isFirstPage ? -1 : 0);
  }
}
function PaginierungDplComponent_nav_1_li_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 11)(1, "a", 3);
    i0.ɵɵlistener("click", function PaginierungDplComponent_nav_1_li_16_Template_a_click_1_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.pageLastClicked());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "page-last-", ctx_r1.position, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabindex", ctx_r1.isLastPage ? -1 : 0)("title", ctx_r1.labelLetzteSeite);
    i0.ɵɵattribute("aria-label", ctx_r1.labelLetzteSeite);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.anzahlSeiten);
  }
}
function PaginierungDplComponent_nav_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nav", 1)(1, "ul")(2, "li", 2)(3, "a", 3);
    i0.ɵɵlistener("click", function PaginierungDplComponent_nav_1_Template_a_click_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.pagePrevClicked($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, PaginierungDplComponent_nav_1_li_4_Template, 3, 3, "li", 4)(5, PaginierungDplComponent_nav_1_li_5_Template, 3, 3, "li", 5)(6, PaginierungDplComponent_nav_1_li_6_Template, 3, 6, "li", 4);
    i0.ɵɵelementStart(7, "li", 6)(8, "span", 7);
    i0.ɵɵtext(9, "Seite");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "span", 8);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "span", 7);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(14, PaginierungDplComponent_nav_1_li_14_Template, 3, 5, "li", 4)(15, PaginierungDplComponent_nav_1_li_15_Template, 3, 3, "li", 9)(16, PaginierungDplComponent_nav_1_li_16_Template, 3, 6, "li", 4);
    i0.ɵɵelementStart(17, "li", 10)(18, "a", 3);
    i0.ɵɵlistener("click", function PaginierungDplComponent_nav_1_Template_a_click_18_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.pageNextClicked($event));
    });
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattributeInterpolate1("aria-label", "Pagination Ergebnisliste (", ctx_r1.position, ")");
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("disabled", ctx_r1.isFirstPage);
    i0.ɵɵpropertyInterpolate1("id", "page-previous-arrow-", ctx_r1.position, "");
    i0.ɵɵattribute("aria-disabled", ctx_r1.isFirstPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabindex", ctx_r1.isFirstPage ? -1 : 0)("title", ctx_r1.labelVorherigeSeite);
    i0.ɵɵattribute("aria-label", ctx_r1.labelVorherigeSeite);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isFirstPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isThreePagesPrevious);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isSecondPage && !ctx_r1.isFirstPage);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "page-active-", ctx_r1.position, "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.aktuelleSeite, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" von ", ctx_r1.anzahlSeiten, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isSecondLastPage && !ctx_r1.isLastPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isThreePagesNext);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isLastPage);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("disabled", ctx_r1.isLastPage);
    i0.ɵɵpropertyInterpolate1("id", "page-next-arrow-", ctx_r1.position, "");
    i0.ɵɵattribute("aria-disabled", ctx_r1.isLastPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabindex", ctx_r1.isLastPage ? -1 : 0)("title", ctx_r1.labelNaechsteSeite);
    i0.ɵɵattribute("aria-label", ctx_r1.labelNaechsteSeite);
  }
}
const _c29 = a0 => ({
  "d-lg-inline": a0
});
const _c30 = a0 => ({
  open: a0
});
function FilterChipListeComponent_div_0_ba_bub_filter_chip_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ba-bub-filter-chip", 7);
    i0.ɵɵlistener("filterEntfernt", function FilterChipListeComponent_div_0_ba_bub_filter_chip_6_Template_ba_bub_filter_chip_filterEntfernt_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.filterEntfernen($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const filter_r4 = ctx.$implicit;
    i0.ɵɵproperty("aktiverFilter", filter_r4);
  }
}
function FilterChipListeComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵtext(2, " Aktive Filter");
    i0.ɵɵelementStart(3, "span", 4);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5, ": ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, FilterChipListeComponent_div_0_ba_bub_filter_chip_6_Template, 1, 1, "ba-bub-filter-chip", 5);
    i0.ɵɵelementStart(7, "a", 6);
    i0.ɵɵlistener("click", function FilterChipListeComponent_div_0_Template_a_click_7_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.alleFilterEntfernen($event));
    });
    i0.ɵɵtext(8, "Alle l\xF6schen");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c29, ctx_r2.showAnzahlOnlyOnDesktop));
    i0.ɵɵattribute("id", ctx_r2.idPrefix + "anzahl_aktive_filter");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" (", ctx_r2.aktiveFilter.length, ")");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.aktiveFilter)("ngForTrackBy", ctx_r2.trackByItemKey);
    i0.ɵɵadvance();
    i0.ɵɵattribute("id", ctx_r2.idPrefix + "delete_all_filters");
  }
}
function FilterChipListeComponent_div_1_a_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 16);
    i0.ɵɵlistener("click", function FilterChipListeComponent_div_1_a_7_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.alleFilterEntfernen($event));
    });
    i0.ɵɵtext(1, "Alle l\xF6schen");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("id", ctx_r2.idPrefix + "delete_all_filters_mobile print");
  }
}
function FilterChipListeComponent_div_1_ba_bub_filter_chip_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ba-bub-filter-chip", 17);
    i0.ɵɵlistener("filterEntfernt", function FilterChipListeComponent_div_1_ba_bub_filter_chip_10_Template_ba_bub_filter_chip_filterEntfernt_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.filterEntfernen($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const filter_r7 = ctx.$implicit;
    const i_r8 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", ctx_r2.idPrefix + "filter_chip_" + i_r8)("aktiverFilter", filter_r7)("disabled", !ctx_r2.chipVisibility.get(ctx_r2.idPrefix + "filter_chip_" + i_r8));
  }
}
function FilterChipListeComponent_div_1_a_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 18);
    i0.ɵɵlistener("click", function FilterChipListeComponent_div_1_a_11_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(2);
      $event.preventDefault();
      return i0.ɵɵresetView(ctx_r2.collapsed = !ctx_r2.collapsed);
    });
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("id", ctx_r2.idPrefix + "collapse_filter_chips_mobile")("aria-expanded", ctx_r2.collapsed);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.collapsed ? "+ " + ctx_r2.numberHiddenElements + " " : "Ausblenden ", " ");
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("ba-icon ", ctx_r2.collapsed ? "ba-icon-chevron-down-after" : "ba-icon-chevron-up-after", "");
  }
}
function FilterChipListeComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9)(2, "div", 10);
    i0.ɵɵtext(3, " Aktive Filter");
    i0.ɵɵelementStart(4, "span", 4);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6, ": ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, FilterChipListeComponent_div_1_a_7_Template, 2, 1, "a", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 12)(9, "div", 13);
    i0.ɵɵtemplate(10, FilterChipListeComponent_div_1_ba_bub_filter_chip_10_Template, 1, 3, "ba-bub-filter-chip", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, FilterChipListeComponent_div_1_a_11_Template, 3, 6, "a", 15);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c29, ctx_r2.showAnzahlOnlyOnDesktop));
    i0.ɵɵattribute("id", ctx_r2.idPrefix + "anzahl_aktive_filter_mobile");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" (", ctx_r2.aktiveFilter.length, ")");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r2.aktiveFilter == null ? null : ctx_r2.aktiveFilter.length) > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c30, !ctx_r2.collapsed));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.aktiveFilter);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.collapsed || ctx_r2.numberHiddenElements > 0);
  }
}
function CollapsibleFacetteComponent_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("ba-icon ", ctx_r0.icon, "");
  }
}
function CollapsibleFacetteComponent_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.anzahlSelektierterFilter);
  }
}
const _c31 = ["geoisMap"];
function KontaktSliderKachelComponent_div_10_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const rolle_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(rolle_r1.bezeichnung);
  }
}
function KontaktSliderKachelComponent_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "dt");
    i0.ɵɵtext(2, "Funktion");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "dd");
    i0.ɵɵtemplate(4, KontaktSliderKachelComponent_div_10_span_4_Template, 2, 1, "span", 10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r1.person.rollen);
  }
}
function KontaktSliderKachelComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "dt");
    i0.ɵɵtext(2, "Telefon");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "dd");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2(" ", ctx_r1.person.telefonVorwahl, " / ", ctx_r1.person.telefonDurchwahl, " ");
  }
}
function KontaktSliderKachelComponent_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "dt");
    i0.ɵɵtext(2, "E-Mail");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "dd");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const email_r3 = ctx.ngIf;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(email_r3);
  }
}
function KontaktSliderComponent_ng_template_2_section_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "ba-bub-kontakt-slider-kachel", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const person_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("person", person_r1);
  }
}
function KontaktSliderComponent_ng_template_2_section_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "section", 5)(1, "div", 6);
    i0.ɵɵtemplate(2, KontaktSliderComponent_ng_template_2_section_0_div_2_Template, 2, 1, "div", 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.ansprechpartner);
  }
}
function KontaktSliderComponent_ng_template_2_ba_bub_kontakt_slider_kachel_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ba-bub-kontakt-slider-kachel", 9);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("person", ctx_r1.ansprechpartner[0]);
  }
}
function KontaktSliderComponent_ng_template_2_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 10);
    i0.ɵɵtext(1, " Aktuell sind keine Informationen zu einzelnen Kontaktpersonen bekannt. ");
    i0.ɵɵelement(2, "br");
    i0.ɵɵtext(3, " Bei Fragen zur Veranstaltung bitte direkt an den Bildungsanbieter wenden. ");
    i0.ɵɵelementEnd();
  }
}
function KontaktSliderComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, KontaktSliderComponent_ng_template_2_section_0_Template, 3, 1, "section", 2)(1, KontaktSliderComponent_ng_template_2_ba_bub_kontakt_slider_kachel_1_Template, 1, 1, "ba-bub-kontakt-slider-kachel", 3)(2, KontaktSliderComponent_ng_template_2_p_2_Template, 4, 0, "p", 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.ansprechpartner.length > 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.ansprechpartner.length === 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.ansprechpartner.length === 0);
  }
}
const _c32 = ["modal"];
const _c33 = () => ({
  "=1": "Ergebnis",
  other: "Ergebnisse"
});
const _c34 = a0 => ({
  "ba-with-addon": a0
});
function ResponsiveKontextinfoHeaderComponent_source_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "source");
  }
  if (rf & 2) {
    const source_r1 = ctx.$implicit;
    i0.ɵɵattribute("media", source_r1.media)("srcset", source_r1.src)("type", source_r1.type);
  }
}
function ResponsiveKontextinfoHeaderComponent_nav_6_ng_container_2_li_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "a", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const breadcrumb_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", breadcrumb_r2.path)("queryParams", breadcrumb_r2.queryParams)("trackEvent", i0.ɵɵpureFunction1(4, _c26, breadcrumb_r2.name));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", breadcrumb_r2.name, "");
  }
}
function ResponsiveKontextinfoHeaderComponent_nav_6_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ResponsiveKontextinfoHeaderComponent_nav_6_ng_container_2_li_1_Template, 3, 6, "li", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.breadcrumbs.parents);
  }
}
function ResponsiveKontextinfoHeaderComponent_nav_6_li_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span", 13);
    i0.ɵɵtext(3, "(aktuelle Seite)");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.breadcrumbs.current, " ");
  }
}
function ResponsiveKontextinfoHeaderComponent_nav_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "nav", 10)(1, "ol");
    i0.ɵɵtemplate(2, ResponsiveKontextinfoHeaderComponent_nav_6_ng_container_2_Template, 2, 1, "ng-container", 11)(3, ResponsiveKontextinfoHeaderComponent_nav_6_li_3_Template, 4, 1, "li", 11);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r2.breadcrumbs.parents == null ? null : ctx_r2.breadcrumbs.parents.length) > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.breadcrumbs.current);
  }
}
function ResponsiveKontextinfoHeaderComponent_p_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p", 14);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r2.headline.subtitle, i0.ɵɵsanitizeHtml);
  }
}
function MapComponent_Conditional_5_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, " ");
  }
}
function MapComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementStart(3, "div", 6);
    i0.ɵɵelement(4, "img", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, MapComponent_Conditional_5_Conditional_5_Template, 2, 1, "div", 8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("height", ctx_r0.errorMessage ? 200 : 400, "px");
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("height", i0.ɵɵpipeBind1(2, 9, ctx_r0.isPhablet$) ? 300 : 400, "px");
    i0.ɵɵclassProp("placeholder-small-img", !!ctx_r0.errorMessage);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("map-loading", !ctx_r0.errorMessage);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!!ctx_r0.errorMessage ? 5 : -1);
  }
}
let TooltipDirective = /*#__PURE__*/(() => {
  class TooltipDirective {
    constructor(elementRef, zone) {
      this.elementRef = elementRef;
      this.zone = zone;
      this.triggerTooltipUpdate = entries => entries.forEach(entry => {
        if (entry.attributeName == 'data-bs-content') {
          this.removeTooltip();
          this.initTooltip();
        }
      });
    }
    ngOnInit() {
      this.initTooltip();
      this.mutationObserver = new MutationObserver(this.triggerTooltipUpdate);
      this.mutationObserver.observe(this.elementRef.nativeElement, {
        attributes: true,
        childList: false,
        characterData: false
      });
    }
    removeTooltip() {
      try {
        this.zone.runOutsideAngular(() => {
          this.elementRef.nativeElement?.bsPopover.dispose();
          this.elementRef.nativeElement.removeAttribute('data-initialized');
        });
      } catch (ex) {
        // Irrelevant, falls beim Löschen der Tooltips Fehler auftreten.
      }
    }
    initTooltip() {
      const id = this.elementRef.nativeElement.id;
      // Änderungen am DOM durch das JS der DPL sollen die ChangeDetection von Angular nicht auslösen
      this.zone.runOutsideAngular(() => {
        // Setzen des Events zum Öffnen des Tooltips (DPL-Default ist "click")
        this.elementRef.nativeElement.setAttribute('data-bs-trigger', 'hover');
        // Vgl. DPL-3 Datei: https://bitbucket.webapp.sdst.sbaintern.de/projects/BAPF/repos/bapf-dpl3/browse/source/js/app.js#138
        // @ts-ignore
        window.dpl.popover.init(id ? `#${id}` : null);
      });
    }
    /**
     * Schließt den Tooltip, auch wenn auf das Element mit dem Tooltip geklickt wird und dadurch
     * das auslösende Element aus dem DOM entfernt wird z. B. weil eine Seitennavigation durch
     * dadurch ausgelöst wird.
     *
     * Referenz entnommen aus der Klasse BaPopover der DPL-3.
     */
    ngOnDestroy() {
      this.elementRef.nativeElement?.popover?.domEl?.bsPopover.hide();
      this.mutationObserver.disconnect();
    }
    static {
      this.ɵfac = function TooltipDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TooltipDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TooltipDirective,
        selectors: [["", "data-bs-toggle", "popover"]]
      });
    }
  }
  return TooltipDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CheckboxComponent = /*#__PURE__*/(() => {
  class CheckboxComponent {
    constructor() {
      /*
        Autor  MJU 23.03.20
        Review PJO 12.08.20
      */
      //    Property wird ueber getter setter verdeckt (setter zum emitieren von value change)
      //    der input rename ist hier gewünscht => checked und checkedChange sind wichtig für
      //    TwoWay Binding Funktionalitaet auf diese Property
      // eslint-disable-next-line @angular-eslint/no-input-rename
      this._checked = true;
      //    ermoeglicht TwoWayBinding auf model Property
      this.checkedChange = new EventEmitter();
      this.id = 'cb';
      this.title = '';
      this.label = '';
      this.arialabel = '';
      this.disabled = false;
    }
    set checked(value) {
      if (value !== this._checked) {
        this._checked = value;
        this.checkedChange.emit(this._checked);
      }
    }
    get checked() {
      return this._checked;
    }
    static {
      this.ɵfac = function CheckboxComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckboxComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckboxComponent,
        selectors: [["ba-bub-checkbox"]],
        inputs: {
          _checked: [0, "checked", "_checked"],
          id: "id",
          title: "title",
          label: "label",
          arialabel: "arialabel",
          disabled: "disabled"
        },
        outputs: {
          checkedChange: "checkedChange"
        },
        ngContentSelectors: _c0,
        decls: 5,
        vars: 7,
        consts: [["role", "presentation", 1, "form-group", "ba-bub-checkbox", 3, "click"], ["type", "checkbox", 3, "ngModelChange", "id", "ngModel", "disabled"], ["aria-hidden", "true", "data-bs-toggle", "popover", "data-bs-placement", "right", 3, "for"], [3, "outerHTML"]],
        template: function CheckboxComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("click", function CheckboxComponent_Template_div_click_0_listener($event) {
              return $event.stopPropagation();
            });
            i0.ɵɵelementStart(1, "input", 1);
            i0.ɵɵtwoWayListener("ngModelChange", function CheckboxComponent_Template_input_ngModelChange_1_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.checked, $event) || (ctx.checked = $event);
              return $event;
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "label", 2);
            i0.ɵɵelement(3, "span", 3);
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("id", ctx.id);
            i0.ɵɵtwoWayProperty("ngModel", ctx.checked);
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵattribute("aria-label", ctx.arialabel);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("for", ctx.id);
            i0.ɵɵattribute("data-bs-content", ctx.title ? ctx.title : null);
            i0.ɵɵadvance();
            i0.ɵɵproperty("outerHTML", ctx.label, i0.ɵɵsanitizeHtml);
          }
        },
        dependencies: [FormsModule, i1.CheckboxControlValueAccessor, i1.NgControlStatus, i1.NgModel, TooltipDirective],
        styles: ["[_nghost-%COMP%]{display:block}.ba-bub-checkbox[_ngcontent-%COMP%]{margin-bottom:0}.ba-bub-checkbox[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{padding-right:0}"]
      });
    }
  }
  return CheckboxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TooltipModule = /*#__PURE__*/(() => {
  class TooltipModule {
    static {
      this.ɵfac = function TooltipModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TooltipModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TooltipModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return TooltipModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CheckboxModule = /*#__PURE__*/(() => {
  class CheckboxModule {
    static {
      this.ɵfac = function CheckboxModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckboxModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckboxModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, TooltipModule, CheckboxComponent]
      });
    }
  }
  return CheckboxModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CollapseComponent = /*#__PURE__*/(() => {
  class CollapseComponent {
    constructor() {
      /*
        Autor  PJO 26.03.20
        Review CKU 12.08.20
        Abweichung von Naming Pattern, um den Setter als Hook zu nutzen
        https://angular.io/guide/component-interaction#intercept-input-property-changes-with-a-setter
      */
      this._collapseId = 'collapsable';
      this.closed = true;
      this.labelForOpen = 'Mehr anzeigen';
      this.labelForClose = 'Weniger anzeigen';
    }
    set collapseId(id) {
      if (id === undefined || id.length === 0) {
        this._collapseId = 'collapsable';
      } else {
        this._collapseId = id;
      }
    }
    set closedByDefault(closedByDefault) {
      this.closed = !!closedByDefault;
    }
    ngAfterViewInit() {
      this.listenCollapseEvents();
    }
    createDefaultAriaLabel() {
      if (this.closed) {
        return this.ariaLabel + ' - ausklappen';
      } else {
        return this.ariaLabel + ' - einklappen';
      }
    }
    listenCollapseEvents() {
      // https://getbootstrap.com/docs/5.0/components/collapse/#events
      this.collapse.nativeElement.addEventListener('shown.bs.collapse', () => {
        this.closed = false;
      });
      this.collapse.nativeElement.addEventListener('hidden.bs.collapse', () => {
        this.closed = true;
      });
    }
    static {
      this.ɵfac = function CollapseComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CollapseComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CollapseComponent,
        selectors: [["ba-bub-collapse"]],
        viewQuery: function CollapseComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c1, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.collapse = _t.first);
          }
        },
        inputs: {
          collapseId: "collapseId",
          closedByDefault: "closedByDefault",
          ariaLabel: "ariaLabel",
          ariaDescription: "ariaDescription",
          ariaLabelContent: "ariaLabelContent",
          labelForOpen: "labelForOpen",
          labelForClose: "labelForClose"
        },
        ngContentSelectors: _c0,
        decls: 10,
        vars: 17,
        consts: [["collapse", ""], [1, "ba-collapsible"], ["role", "button", "data-bs-toggle", "collapse", "data-label-collapsed", "ausklappen", "data-label-expanded", "einklappen", 1, "ba-collapse-control", "collapsed", 3, "id", "ngClass", "href"], [1, "ba-collapse-open"], [1, "ba-collapse-close"], ["role", "tabpanel", 1, "collapse", 3, "ngClass", "id"]],
        template: function CollapseComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1)(1, "a", 2)(2, "span", 3);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "span", 4);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "div", 5, 0)(8, "div");
            i0.ɵɵprojection(9);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("id", ctx._collapseId + "Trigger")("ngClass", i0.ɵɵpureFunction1(13, _c2, ctx.closed))("href", "#" + ctx._collapseId, i0.ɵɵsanitizeUrl);
            i0.ɵɵattribute("aria-controls", ctx._collapseId)("aria-expanded", !ctx.closed)("aria-label", ctx.createDefaultAriaLabel())("data-aria-label", ctx.ariaLabel)("aria-description", ctx.ariaDescription);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.labelForOpen);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.labelForClose);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c3, !ctx.closed))("id", ctx._collapseId);
            i0.ɵɵattribute("aria-label", ctx.ariaLabelContent);
          }
        },
        dependencies: [NgClass],
        encapsulation: 2
      });
    }
  }
  return CollapseComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HilfeInfoCollapseComponent = /*#__PURE__*/(() => {
  class HilfeInfoCollapseComponent {
    set collapseId(id) {
      if (id === undefined || id.length === 0) {
        this._collapseId = 'collapse';
      } else {
        this._collapseId = id;
      }
    }
    constructor() {
      this._collapseId = 'collapse';
      this.collapseChanged = new EventEmitter();
      this.collapsed = true;
      this.icon = 'info';
      this.showIcon = true;
      this.showBorder = true;
      this.showClosingButton = false;
      this.closingButtonText = 'Schliessen';
      // Tooltip + Aria-Label für Öffnen  des Collapse
      this.tooltipForOpen = 'Hinweistext einblenden';
      // Tooltip + Aria-Label für Schließen des Collapse
      this.tooltipForClose = 'Hinweistext ausblenden';
      this.disabled = false;
      this.ariaLabel = this.tooltipForOpen;
    }
    createTooltipAria() {
      if (this.button.nativeElement.getAttribute('class').includes('collapsed')) {
        this.ariaLabel = this.tooltipForOpen;
      } else {
        this.ariaLabel = this.tooltipForClose;
      }
    }
    click() {
      this.button.nativeElement.click();
    }
    toggleCollapse() {
      this.createTooltipAria();
      this.collapsed = !this.collapsed;
      this.collapseChanged.emit({
        collapseId: this._collapseId,
        isCollapsed: this.collapsed
      });
    }
    static {
      this.ɵfac = function HilfeInfoCollapseComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HilfeInfoCollapseComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HilfeInfoCollapseComponent,
        selectors: [["ba-bub-hilfe-info-collapse"]],
        viewQuery: function HilfeInfoCollapseComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c4, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.button = _t.first);
          }
        },
        inputs: {
          collapsed: "collapsed",
          collapseId: "collapseId",
          title: "title",
          content: "content",
          icon: "icon",
          showIcon: "showIcon",
          showBorder: "showBorder",
          showClosingButton: "showClosingButton",
          closingButtonText: "closingButtonText",
          tooltipForOpen: "tooltipForOpen",
          tooltipForClose: "tooltipForClose",
          disabled: "disabled"
        },
        outputs: {
          collapseChanged: "collapseChanged"
        },
        ngContentSelectors: _c0,
        decls: 10,
        vars: 19,
        consts: [["button", ""], [1, "ba-bub-hilfe", "ba-copytext"], [1, "ba-bub-hilfe-title-bar"], [1, "ba-bub-hilfe-title", 3, "id"], ["aria-expanded", "false", "data-bs-toggle", "collapse", 1, "ba-bub-hilfe-toggle", "ba-round-icon-btn", 3, "click", "id", "ngClass", "title", "disabled"], [1, "ba-bub-hilfe-content", "collapse", 3, "id"], [3, "ngClass"], ["class", "ba-btn ba-btn-primary", "data-bs-toggle", "collapse", 3, "id", "click", 4, "ngIf"], ["data-bs-toggle", "collapse", 1, "ba-btn", "ba-btn-primary", 3, "click", "id"]],
        template: function HilfeInfoCollapseComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "button", 4, 0);
            i0.ɵɵlistener("click", function HilfeInfoCollapseComponent_Template_button_click_4_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleCollapse());
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "div", 5)(7, "div", 6);
            i0.ɵɵprojection(8);
            i0.ɵɵtemplate(9, HilfeInfoCollapseComponent_button_9_Template, 2, 5, "button", 7);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("id", ctx._collapseId + "-title");
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.title);
            i0.ɵɵadvance();
            i0.ɵɵproperty("id", ctx._collapseId + "Trigger")("ngClass", i0.ɵɵpureFunction2(12, _c5, ctx.icon === "info", ctx.icon === "hilfe"))("title", ctx.ariaLabel)("disabled", ctx.disabled);
            i0.ɵɵattribute("aria-label", ctx.ariaLabel)("data-bs-target", "#" + ctx._collapseId)("aria-controls", ctx._collapseId);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("id", ctx._collapseId);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(15, _c6, ctx.showIcon && ctx.icon === "info", ctx.showIcon && ctx.icon === "hilfe", ctx.showBorder));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.showClosingButton);
          }
        },
        dependencies: [NgClass, NgIf],
        styles: [".ba-bub-hilfe[_ngcontent-%COMP%]   .ba-bub-hilfe-title-bar[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{display:inline-block}.ba-bub-hilfe[_ngcontent-%COMP%]   .ba-bub-hilfe-title-bar[_ngcontent-%COMP%]   .ba-bub-hilfe-title[_ngcontent-%COMP%]{margin-bottom:.8666666667rem;font-size:1.5333333333rem}.ba-bub-hilfe[_ngcontent-%COMP%]   .ba-bub-hilfe-title-bar[_ngcontent-%COMP%]   .ba-bub-hilfe-toggle[_ngcontent-%COMP%]:before{margin:-2px -2px 2px -3px}.ba-bub-hilfe[_ngcontent-%COMP%]   .ba-bub-hilfe-content[_ngcontent-%COMP%]{background-color:#fff}.ba-bub-hilfe[_ngcontent-%COMP%]   .ba-bub-hilfe-content[_ngcontent-%COMP%]   .ba-accent-icon[_ngcontent-%COMP%]:not([class*=ba-icon-]){padding:35px 40px 35px 35px}.ba-bub-hilfe[_ngcontent-%COMP%]   .ba-bub-hilfe-content[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{overflow:auto}.ba-bub-hilfe[_ngcontent-%COMP%]   .ba-bub-hilfe-content[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{display:block;float:right;margin-top:30px}\n\n\n\n\n\n\n\n\n\n"]
      });
    }
  }
  return HilfeInfoCollapseComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CollapseModule = /*#__PURE__*/(() => {
  class CollapseModule {
    static {
      this.ɵfac = function CollapseModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CollapseModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CollapseModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return CollapseModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputrangeComponent = /*#__PURE__*/(() => {
  class InputrangeComponent {
    constructor() {
      this.min = 1;
      this.max = 100;
      this.step = 1;
      this.disabled = false;
      this.ariaValueText = '';
      this.onchange = new EventEmitter();
    }
    onChange(value) {
      this.value = value;
      this.onchange.emit(this.value);
    }
    static {
      this.ɵfac = function InputrangeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputrangeComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InputrangeComponent,
        selectors: [["ba-bub-inputrange"]],
        inputs: {
          name: "name",
          id: "id",
          min: "min",
          max: "max",
          step: "step",
          value: "value",
          disabled: "disabled",
          ariaValueText: "ariaValueText"
        },
        outputs: {
          onchange: "onchange"
        },
        decls: 1,
        vars: 9,
        consts: [["type", "range", 3, "change", "name", "disabled", "min", "max", "step", "value"]],
        template: function InputrangeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "input", 0);
            i0.ɵɵlistener("change", function InputrangeComponent_Template_input_change_0_listener($event) {
              return ctx.onChange($event.target.value);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("name", ctx.name)("disabled", ctx.disabled)("min", ctx.min)("max", ctx.max)("step", ctx.step)("value", ctx.value);
            i0.ɵɵattribute("id", ctx.id)("aria-valuenow", ctx.value)("aria-valuetext", ctx.ariaValueText);
          }
        },
        styles: ["input[type=range][_ngcontent-%COMP%]:disabled{opacity:.5}input[type=range][_ngcontent-%COMP%]::-ms-tooltip{display:none}"]
      });
    }
  }
  return InputrangeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputrangeModule = /*#__PURE__*/(() => {
  class InputrangeModule {
    static {
      this.ɵfac = function InputrangeModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputrangeModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: InputrangeModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return InputrangeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalPopupComponent = /*#__PURE__*/(() => {
  class ModalPopupComponent {
    constructor() {
      this.primaryButtonClick = new EventEmitter();
      this.secondaryButtonClick = new EventEmitter();
      this.errorModal = false;
      this.infoModal = false;
      this.primaryButtonText = 'Akzeptieren';
      this.secondaryButtonText = 'Abbrechen';
      this.additionalModalClasses = '';
      this.additionalHeaderClasses = '';
      this.center = false;
      this.primaryBeforeSecondary = true;
      this.prompt = true;
    }
    ngOnInit() {
      if (!this.modalId) {
        throw new TypeError('parameter modalId is required for component ba-bub-modal-popup');
      }
      if (this.icon == null) {
        if (this.infoModal) {
          this.icon = 'info';
        } else if (this.errorModal) {
          this.icon = 'error';
        }
      }
    }
    iconClasses() {
      if (this.center || this.icon == null) {
        return '';
      }
      return 'ba-icon ba-icon-' + this.icon;
    }
    /**
     * Schließt das Modal, falls es noch geöffnet wird,
     * bevor alle Angular-Referenzen darauf zerstört werden.
     */
    ngOnDestroy() {
      this.closeFacettenSlideOut();
    }
    // Ruft Bootstrap auf, um das Slide-In der Facetten zu schließen.
    closeFacettenSlideOut() {
      // @ts-ignore
      const bootstrap = window.dpl.bs;
      const modalElement = document.getElementById(this.modalId);
      // https://getbootstrap.com/docs/5.0/components/modal/#via-javascript
      const modal = bootstrap.Modal.getInstance(modalElement);
      modal?.hide();
    }
    openModal() {
      // @ts-ignore
      const bootstrap = window.dpl.bs;
      // https://getbootstrap.com/docs/5.1/components/modal/#via-javascript
      const modalElement = document.getElementById(this.modalId);
      const modal = bootstrap.Modal.getOrCreateInstance(modalElement);
      modal?.show();
    }
    static {
      this.ɵfac = function ModalPopupComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModalPopupComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ModalPopupComponent,
        selectors: [["ba-bub-modal-popup"]],
        inputs: {
          errorModal: "errorModal",
          infoModal: "infoModal",
          modalId: "modalId",
          modalTitle: "modalTitle",
          modalSubtitle: "modalSubtitle",
          modalText: "modalText",
          primaryButtonText: "primaryButtonText",
          secondaryButtonText: "secondaryButtonText",
          additionalModalClasses: "additionalModalClasses",
          additionalHeaderClasses: "additionalHeaderClasses",
          center: "center",
          icon: "icon",
          primaryBeforeSecondary: "primaryBeforeSecondary",
          ariaLabel: "ariaLabel",
          prompt: "prompt"
        },
        outputs: {
          primaryButtonClick: "primaryButtonClick",
          secondaryButtonClick: "secondaryButtonClick"
        },
        ngContentSelectors: _c0,
        decls: 10,
        vars: 17,
        consts: [["tabindex", "-1", "role", "dialog", 3, "id"], [1, "modal-dialog", "modal-dialog-centered", 3, "ngClass"], [1, "modal-content"], ["type", "button", "data-bs-dismiss", "modal", "aria-label", "Schlie\xDFen", 1, "close", "ba-modal-close"], [3, "id", "class", 4, "ngIf"], ["class", "modal-subtitle", 4, "ngIf"], [1, "modal-body"], ["class", "modal-footer", 4, "ngIf"], [3, "id"], [1, "modal-subtitle"], [1, "modal-footer"], ["class", "ba-btn ba-btn-primary", "type", "button", "data-bs-dismiss", "modal", 3, "click", 4, "ngIf"], ["class", "ba-btn ba-btn-tertiary", "type", "button", "data-bs-dismiss", "modal", 3, "click", 4, "ngIf"], ["type", "button", "data-bs-dismiss", "modal", 1, "ba-btn", "ba-btn-primary", 3, "click"], ["type", "button", "data-bs-dismiss", "modal", 1, "ba-btn", "ba-btn-tertiary", 3, "click"]],
        template: function ModalPopupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div");
            i0.ɵɵelement(4, "button", 3);
            i0.ɵɵtemplate(5, ModalPopupComponent_h1_5_Template, 2, 6, "h1", 4)(6, ModalPopupComponent_h2_6_Template, 2, 1, "h2", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 6);
            i0.ɵɵprojection(8);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, ModalPopupComponent_div_9_Template, 4, 3, "div", 7);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("modal fade ", ctx.additionalModalClasses, "");
            i0.ɵɵpropertyInterpolate("id", ctx.modalId);
            i0.ɵɵattribute("aria-label", ctx.ariaLabel)("aria-labelledby", "modal-title-" + ctx.modalId);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c7, ctx.prompt));
            i0.ɵɵadvance(2);
            i0.ɵɵclassMapInterpolate1("modal-header ", ctx.additionalHeaderClasses, "");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.modalTitle);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.modalSubtitle);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("text-center", ctx.center);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.secondaryButtonText || ctx.primaryButtonText);
          }
        },
        dependencies: [NgClass, NgIf],
        encapsulation: 2
      });
    }
  }
  return ModalPopupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SlideInComponent = /*#__PURE__*/(() => {
  class SlideInComponent {
    ngOnInit() {
      if (!this.slideInId) {
        throw new TypeError('parameter slideInId is required for component ba-bub-slide-in');
      }
    }
    static {
      this.ɵfac = function SlideInComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SlideInComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SlideInComponent,
        selectors: [["ba-bub-slide-in"]],
        inputs: {
          slideInId: "slideInId",
          fromLeft: "fromLeft",
          ariaLabel: "ariaLabel"
        },
        ngContentSelectors: _c0,
        decls: 2,
        vars: 4,
        consts: [["modalTitle", "", "primaryButtonText", "", "secondaryButtonText", "", "additionalHeaderClasses", "ba-headless", 3, "modalId", "ariaLabel", "additionalModalClasses", "prompt"]],
        template: function SlideInComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "ba-bub-modal-popup", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("modalId", ctx.slideInId)("ariaLabel", ctx.ariaLabel)("additionalModalClasses", ctx.fromLeft === true || ctx.fromLeft === "true" ? "ba-left" : "ba-right")("prompt", false);
          }
        },
        dependencies: [ModalPopupComponent],
        encapsulation: 2
      });
    }
  }
  return SlideInComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FlyoutComponent = /*#__PURE__*/(() => {
  class FlyoutComponent {
    constructor(eRef, cdr) {
      this.eRef = eRef;
      this.cdr = cdr;
      this.tooltipOffen = null;
      this.tooltipGeschlossen = null;
      this.isOpen = false;
      this.fadein = 'yes';
      this.maxHeight = 'auto';
    }
    // binds the animation to the host component
    get getHost() {
      return this.isOpen ? 'open' : 'closed';
    }
    clickout(event) {
      this.isOpen = false;
    }
    clickin(event) {
      event.stopPropagation();
    }
    onResize(event) {
      this.labelHeight = this.labelRef.nativeElement.clientWidth;
      this.maxHeight = window.innerHeight - this.eRef.nativeElement.firstChild.offsetTop - 40 + 'px';
    }
    get ariaLabel() {
      return `Formular ${this.label}`;
    }
    toggle() {
      this.fadein = 'no';
      this.isOpen = !this.isOpen;
    }
    ngAfterViewInit() {
      this.onResize(null);
      this.cdr.detectChanges();
    }
    static {
      this.ɵfac = function FlyoutComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FlyoutComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FlyoutComponent,
        selectors: [["ba-bub-flyout"]],
        viewQuery: function FlyoutComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c8, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.labelRef = _t.first);
          }
        },
        hostVars: 1,
        hostBindings: function FlyoutComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function FlyoutComponent_click_HostBindingHandler($event) {
              return ctx.clickout($event);
            }, false, i0.ɵɵresolveDocument)("resize", function FlyoutComponent_resize_HostBindingHandler($event) {
              return ctx.onResize($event);
            }, false, i0.ɵɵresolveWindow);
          }
          if (rf & 2) {
            i0.ɵɵsyntheticHostProperty("@openClose", ctx.getHost);
          }
        },
        inputs: {
          label: "label",
          tooltipOffen: "tooltipOffen",
          tooltipGeschlossen: "tooltipGeschlossen"
        },
        ngContentSelectors: _c0,
        decls: 8,
        vars: 14,
        consts: [["labelRef", ""], ["id", "flyout", 1, "d-print-none", 3, "click", "className"], [1, "flyout-icons"], ["id", "flyout2-icon", "href", "javascript:void(0);", "flow", "left", "role", "button", 1, "flyout-icon", 3, "click", "ngStyle"], ["class", "flyout-label", "aria-hidden", "true", 4, "ngIf"], ["class", "ba-icon ba-icon-chevron-right", "aria-hidden", "true", 4, "ngIf"], [1, "flyout-content"], [1, "scrollBox"], ["aria-hidden", "true", 1, "flyout-label"], ["aria-hidden", "true", 1, "ba-icon", "ba-icon-chevron-right"]],
        template: function FlyoutComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵlistener("click", function FlyoutComponent_Template_div_click_0_listener($event) {
              return ctx.clickin($event);
            });
            i0.ɵɵelementStart(1, "div", 2)(2, "a", 3);
            i0.ɵɵlistener("click", function FlyoutComponent_Template_a_click_2_listener() {
              return ctx.toggle();
            });
            i0.ɵɵtemplate(3, FlyoutComponent_span_3_Template, 3, 1, "span", 4)(4, FlyoutComponent_span_4_Template, 1, 0, "span", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 6)(6, "div", 7);
            i0.ɵɵprojection(7);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("className", "flyout d-print-none");
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("active", ctx.isOpen);
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(12, _c9, !ctx.isOpen ? ctx.labelHeight : null))("@fadein", ctx.fadein);
            i0.ɵɵattribute("title", ctx.isOpen ? ctx.tooltipOffen : ctx.tooltipGeschlossen)("aria-label", ctx.ariaLabel)("aria-expanded", ctx.isOpen);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.isOpen);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isOpen);
            i0.ɵɵadvance();
            i0.ɵɵproperty("@content", ctx.isOpen ? "open" : "closed");
            i0.ɵɵattribute("aria-hidden", !ctx.isOpen);
          }
        },
        dependencies: [NgStyle, NgIf],
        styles: ["[_nghost-%COMP%]{position:fixed;right:0;z-index:504}@media (max-width: 575.98px){[_nghost-%COMP%]{top:120px}}@media (min-width: 576px){[_nghost-%COMP%]{top:250px}}@media (orientation: landscape) and (max-width: 575.98px){[_nghost-%COMP%]{top:120px}}.flyout[_ngcontent-%COMP%]   .flyout-label[_ngcontent-%COMP%]{display:inline-block;position:absolute;font-size:18px;text-transform:uppercase;transform:translate(-50%) translateY(-50%) rotate(-90deg);left:50%;top:50%;padding-left:20%;padding-right:20%}@media (max-width: 575.98px){.flyout[_ngcontent-%COMP%]   .flyout-label[_ngcontent-%COMP%]{font-size:13.4px}}@media (min-width: 576px) and (max-width: 767.98px){.flyout[_ngcontent-%COMP%]   .flyout-label[_ngcontent-%COMP%]{font-size:15.5px}}.flyout[_ngcontent-%COMP%]   .flyout-icons[_ngcontent-%COMP%]{float:left;width:45px;position:absolute;left:-45px;top:17px}@media (max-width: 575.98px){.flyout[_ngcontent-%COMP%]   .flyout-icons[_ngcontent-%COMP%]{padding-left:15px}}@media (min-width: 576px) and (max-width: 767.98px){.flyout[_ngcontent-%COMP%]   .flyout-icons[_ngcontent-%COMP%]{padding-left:10px}}.flyout[_ngcontent-%COMP%]   .flyout-icon[_ngcontent-%COMP%]{position:relative;display:block;float:left;width:45px;height:45px;background-color:#b30920;cursor:pointer;text-align:center;vertical-align:middle;color:#fff;text-decoration:none}@media (max-width: 575.98px){.flyout[_ngcontent-%COMP%]   .flyout-icon[_ngcontent-%COMP%]{width:30px}}@media (min-width: 576px) and (max-width: 767.98px){.flyout[_ngcontent-%COMP%]   .flyout-icon[_ngcontent-%COMP%]{width:35px}}.flyout[_ngcontent-%COMP%]   .flyout-icon[_ngcontent-%COMP%]   .ba-icon[_ngcontent-%COMP%]{display:block;font-size:31px}.flyout[_ngcontent-%COMP%]   .flyout-icon[_ngcontent-%COMP%]   .ba-icon-chevron-right[_ngcontent-%COMP%]{font-size:15px;margin-top:11px;display:block}.flyout[_ngcontent-%COMP%]   .flyout-icon[_ngcontent-%COMP%]:first-child{border-top-left-radius:4px}.flyout[_ngcontent-%COMP%]   .flyout-icon[_ngcontent-%COMP%]:last-child{border-bottom-left-radius:4px}.flyout[_ngcontent-%COMP%]   .flyout-icon[_ngcontent-%COMP%]:hover, .flyout[_ngcontent-%COMP%]   .flyout-icon[_ngcontent-%COMP%]:focus, .flyout[_ngcontent-%COMP%]   .flyout-icon.active[_ngcontent-%COMP%]{background-color:#601}.flyout[_ngcontent-%COMP%]   .flyout-icon[_ngcontent-%COMP%]:focus-visible{border:2px solid #020E25;outline:2px dotted #F9FBFC}.flyout[_ngcontent-%COMP%]   .flyout-icon[_ngcontent-%COMP%]:-moz-focusring{border:2px solid #020E25;outline:2px dotted #F9FBFC}.flyout[_ngcontent-%COMP%]   .divider[_ngcontent-%COMP%]{display:block;float:left;width:46px;background-color:#b30920}.flyout[_ngcontent-%COMP%]   .divider[_ngcontent-%COMP%]:after{content:\"\";height:1px;width:75%;display:block;margin-left:auto;margin-right:auto;border-top:1px solid white}.flyout[_ngcontent-%COMP%]   .flyout-content[_ngcontent-%COMP%]{display:block;float:left;width:300px;height:auto;background-color:#fff;padding:15px 0;box-shadow:-1px 3px 12px #000000bf}@media (max-width: 575.98px){.flyout[_ngcontent-%COMP%]   .flyout-content[_ngcontent-%COMP%]{width:270px}}.flyout[_ngcontent-%COMP%]   .flyout-content[_ngcontent-%COMP%]   .scrollBox[_ngcontent-%COMP%]{position:relative;overflow:auto;height:100%;min-height:100px;max-height:350px;max-width:100%;outline:none;padding:0 25px;text-align:center}.flyout[_ngcontent-%COMP%]   .flyout-content[_ngcontent-%COMP%]   .flyout-content-image[_ngcontent-%COMP%]{height:100px;margin-top:0;margin-bottom:0}.flyout[_ngcontent-%COMP%]   .flyout-content[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{margin-top:0;margin-bottom:15px;border:3px solid #020E25}.flyout[_ngcontent-%COMP%]   .flyout-content[_ngcontent-%COMP%]   .flyout-content-header[_ngcontent-%COMP%]{font-weight:700;font-size:large;margin-top:0;margin-bottom:10px;text-align:left}.flyout[_ngcontent-%COMP%]   .flyout-content[_ngcontent-%COMP%]   .flyout-content-text[_ngcontent-%COMP%]{margin-top:0;margin-bottom:15px;text-align:left}.flyout[_ngcontent-%COMP%]   .flyout-content[_ngcontent-%COMP%]   .flyout-content-button[_ngcontent-%COMP%]{padding-top:5px;padding-bottom:3px;min-width:auto}.flyout[_ngcontent-%COMP%]   .flyout-content[_ngcontent-%COMP%]   .flyout-content-button[_ngcontent-%COMP%]:before{padding-bottom:2px;padding-left:4px;padding-right:10px}\n\n\n\n\n\n\n\n\n\n"],
        data: {
          animation: [trigger('openClose', [
          // ...
          state('open', style({
            transform: 'translatex(0)'
          })), state('closed', style({
            transform: 'translatex(100%) translatex(0px)'
          })), transition('open => closed', [animate('240ms ease-out')]), transition('closed => open', [animate('240ms ease-in')])]), trigger('content', [state('closed', style({
            display: 'none'
          })), transition('open => closed', [animate('240ms ease-out')])]), trigger('fadein', [transition('* => yes', [sequence([style({
            opacity: 0
          }), animate('240ms 2s ease-out', style({
            opacity: 1
          }))])])])]
        }
      });
    }
  }
  return FlyoutComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalModule = /*#__PURE__*/(() => {
  class ModalModule {
    static {
      this.ɵfac = function ModalModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModalModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ModalModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return ModalModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// Whether the current platform supports the V8 Break Iterator. The V8 check
// is necessary to detect all Blink based browsers.
const hasV8BreakIterator = typeof Intl !== 'undefined' && Intl.v8BreakIterator;
/**
 * Service to detect the current platform by comparing the userAgent strings and
 * checking browser-specific global properties.
 * @inputDocs-private
 */
let Platform = /*#__PURE__*/(() => {
  class Platform {
    constructor() {
      this.isBrowser = typeof document === 'object' && !!document;
      /** Layout Engines */
      this.EDGE = this.isBrowser && /(edge)/i.test(navigator.userAgent);
      this.TRIDENT = this.isBrowser && /(msie|trident)/i.test(navigator.userAgent);
      // EdgeHTML and Trident mock Blink specific things and need to be excluded from this check.
      this.BLINK = this.isBrowser && !!(window.chrome || hasV8BreakIterator) && !!CSS && !this.EDGE && !this.TRIDENT;
      // Webkit is part of the userAgent in EdgeHTML, Blink and Trident. Therefore we need to
      // ensure that Webkit runs standalone and is not used as another engine's base.
      this.WEBKIT = this.isBrowser && /AppleWebKit/i.test(navigator.userAgent) && !this.BLINK && !this.EDGE && !this.TRIDENT;
      /** Browsers and Platform Types */
      this.IOS = this.isBrowser && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      // It's difficult to detect the plain Gecko engine, because most of the browsers identify
      // them self as Gecko-like browsers and modify the userAgent's according to that.
      // Since we only cover one explicit Firefox case, we can simply check for Firefox
      // instead of having an unstable check for Gecko.
      this.FIREFOX = this.isBrowser && /(firefox|minefield)/i.test(navigator.userAgent);
      // Trident on mobile adds the android platform to the userAgent to trick detections.
      this.ANDROID = this.isBrowser && /android/i.test(navigator.userAgent) && !this.TRIDENT;
      // Safari browsers will include the Safari keyword in their userAgent. Some browsers may fake
      // this and just place the Safari keyword in the userAgent. To be more safe about Safari every
      // Safari browser should also use Webkit as its layout engine.
      this.SAFARI = this.isBrowser && /safari/i.test(navigator.userAgent) && this.WEBKIT;
    }
    static {
      this.ɵfac = function Platform_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Platform)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: Platform,
        factory: Platform.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return Platform;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
const LIVE_ANNOUNCER_ELEMENT_TOKEN = new InjectionToken('liveAnnouncerElement');
let LiveAnnouncer = /*#__PURE__*/(() => {
  class LiveAnnouncer {
    constructor(elementToken, platform) {
      // Only do anything if we're on the browser platform.
      if (platform.isBrowser) {
        // We inject the live element as `any` because the constructor signature cannot reference
        // browser globals (HTMLElement) on non-browser environments, since having a class decorator
        // causes TypeScript to preserve the constructor signature types.
        this._liveElement = elementToken || this._createLiveElement();
      }
    }
    /**
     * Announces a message to screenreaders.
     * @param message Message to be announced to the screenreader
     * @param politeness The politeness of the announcer element
     */
    announce(message, politeness = 'polite') {
      this._liveElement.textContent = '';
      // TODO: ensure changing the politeness works on all environments we support.
      this._liveElement.setAttribute('aria-live', politeness);
      // This 100ms timeout is necessary for some browser + screen-reader combinations:
      // - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
      // - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
      //   second time without clearing and then using a non-zero delay.
      // (using JAWS 17 at time of this writing).
      setTimeout(() => this._liveElement.textContent = message, 100);
    }
    /** Removes the aria-live element from the DOM. */
    _removeLiveElement() {
      if (this._liveElement && this._liveElement.parentNode) {
        this._liveElement.parentNode.removeChild(this._liveElement);
      }
    }
    _createLiveElement() {
      const liveEl = document.createElement('div');
      liveEl.classList.add('sr-only');
      liveEl.setAttribute('aria-atomic', 'true');
      liveEl.setAttribute('aria-live', 'polite');
      liveEl.setAttribute('role', 'alert');
      document.body.appendChild(liveEl);
      return liveEl;
    }
    static {
      this.ɵfac = function LiveAnnouncer_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LiveAnnouncer)(i0.ɵɵinject(LIVE_ANNOUNCER_ELEMENT_TOKEN, 8), i0.ɵɵinject(Platform));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: LiveAnnouncer,
        factory: LiveAnnouncer.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return LiveAnnouncer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function LIVE_ANNOUNCER_PROVIDER_FACTORY(parentDispatcher, liveElement, platform) {
  return parentDispatcher || new LiveAnnouncer(liveElement, platform);
}
const LIVE_ANNOUNCER_PROVIDER = {
  // If there is already a LiveAnnouncer available, use that. Otherwise, provide a new one.
  provide: LiveAnnouncer,
  deps: [[new Optional(), new SkipSelf(), LiveAnnouncer], [new Optional(), new Inject(LIVE_ANNOUNCER_ELEMENT_TOKEN)], Platform],
  useFactory: LIVE_ANNOUNCER_PROVIDER_FACTORY
};
const KEY_ENTER = 'Enter';
const KEY_ARROW_UP = 'ArrowUp';
const KEY_ARROW_DOWN = 'ArrowDown';
const KEY_ESC = 'Escape';
const KEY_ALT = 'Alt';
/**
 * Ein Typeahead-Vorschlag.
 * Die cssClass bezieht sich auf das class des A-Tags innerhalb des LI.
 * Damit können für die Vorschläge Icons eingebunden werden (z.B.: cssClass: 'ba-icon ba-icon-info').
 * isReadOnly bedeutet, dass der Vorschlag nicht ausgewählt werden können soll (z.B. für Error-Texten).
 */
class Suggestion {
  constructor(label, value, cssClass, isReadOnly, extra) {
    this.label = label;
    this.value = value;
    this.cssClass = cssClass;
    this.isReadOnly = isReadOnly;
    this.extra = extra;
  }
  // Erzeugt einen (auswählbaren) Vorschlag
  static of(label, value, cssClass, extra, isReadOnly) {
    return new Suggestion(label, value, cssClass, isReadOnly ?? false, extra);
  }
  // Erzeugt einen (nicht-auswählbaren) Info-'Vorschlag'
  static info(label) {
    return new Suggestion(label, null, 'info ba-link-icon ba-icon-info', true);
  }
  // Erzeugt einen (nicht-auswählbaren) Error-'Vorschlag'
  static error(label) {
    return new Suggestion(label, null, 'error ba-link-icon ba-icon-error-o', true);
  }
}
/**
 * Der vom User gewählte Vorschlag.
 * isAutoSelected ist true, wenn keinen Vorschlag direkt gewählt, sondern im Eingabefeld einfach Enter gedrückt wurde.
 */
class SelectedSuggestion {
  constructor(input, value, isAutoSelected, extra) {
    this.input = input;
    this.value = value;
    this.isAutoSelected = isAutoSelected;
    this.extra = extra;
  }
}
let TypeaheadComponent = /*#__PURE__*/(() => {
  class TypeaheadComponent {
    constructor(announcer, sanitizer, elRef) {
      this.announcer = announcer;
      this.sanitizer = sanitizer;
      this.elRef = elRef;
      this.suggestionSelected = new EventEmitter();
      this.placeholder = '';
      this.resetOnSubmit = true;
      this.activeSuggestionIndex = -1;
      this.showSuggestions = false;
      this.loadSuggestionsInProgress = false;
      this.inputFieldHasFocus = false;
      // Hilfs-Flag zur Markierung eines ausstehenden Submits, während eine Autocomplete-Liste gerade geladen wird.
      this.submitPending = false;
      // Hilfs-Flag zur Markierung einer Textänderung, die nicht durch eine direkte User-Eingabe verursacht wurde.
      this.nonUserTextChange = false;
      this.disabled = false;
      // befindet sich der focus außerhalb der komponente?
      this.outside = true;
      // könnte sein, dass wir uns außerhalb der komponente befinden
      this.outsideMaybe = false;
      /**
       * Möglichkeit den Default-Renderer zu überschreiben.
       * Dies kann z.B. genutzt werden, um in den Vorschlägen rechts noch die Trefferanzahl anzuzeigen.
       * Der Default-Renderer zeigt einfach die Labels (ge-highlight-et) an.
       */
      this.suggestionRenderer = (suggestion, searchInput, highlighter) => {
        return this.sanitizer.bypassSecurityTrustHtml(highlighter(suggestion.label, searchInput));
      };
      /**
       * Observable, das den aktuellen Inhalt des Input-Feldes wiedergibt
       */
      this.inputContent$ = of('');
      /**
       * Markiert Vorkommen von Substring in Text fett.
       */
      this.highlighter = (word, substring) => {
        let result = word;
        const searchWord = substring.toLowerCase();
        const searchPos = word.toLowerCase().indexOf(searchWord);
        if (searchPos > -1) {
          const searchLen = searchWord.length;
          const prefix = searchPos <= 0 ? '' : word.substr(0, searchPos);
          const postfix = searchPos + searchLen === word.length ? '' : word.substr(searchPos + searchLen);
          result = prefix + '<b>' + word.substr(searchPos, searchLen) + '</b>' + postfix;
        }
        return result;
      };
    }
    set disable(disabled) {
      this.disabled = disabled;
      if (disabled) {
        this.inputControl?.disable();
      } else {
        this.inputControl?.enable();
      }
    }
    ngOnInit() {
      if (!this.id) {
        throw Error('id is required');
      }
      if (!this.label) {
        throw Error('label is required');
      }
      if (!this.loadSuggestions) {
        throw Error('suggestionsLoader is required');
      }
      this.elRef.nativeElement.addEventListener('focusin', () => this.focusin());
      this.elRef.nativeElement.addEventListener('focusout', () => this.focusout());
      this.inputControl = new FormControl({
        value: '',
        disabled: this.disabled
      });
      this.form = new FormGroup({
        typeahead: this.inputControl
      });
      this.subscription = this.inputControl.valueChanges.pipe(filter(() => !this.nonUserTextChange), tap(() => this.loadSuggestionsInProgress = true),
      // Vor debounceTime!
      tap(() => this.originalInput = this.inputControl.value),
      // Vor debounceTime!
      debounceTime(200),
      // distinctUntilChanged(), Nicht nötig und auch falsch (da es mache Events verschluckt und dann oraclePending nicht resetet wird!
      switchMap(query => {
        return this.load(query);
      })).subscribe(suggestions => {
        this.loadSuggestionsInProgress = false;
        this.activeSuggestionIndex = -1;
        if (suggestions == null) {
          // null heißt: keine Vorschläge anzeigen
          this.suggestions = [];
          this.showSuggestions = false;
        } else {
          this.suggestions = suggestions;
          if (this.submitPending) {
            this.submitSelection();
          }
          this.showSuggestions = suggestions.length > 0 && !this.outside;
        }
        if (this.showSuggestions) {
          if (this.suggestions.length === 1 && this.suggestions[0].isReadOnly) {
            this.announcer.announce(this.suggestions[0].label);
          } else {
            this.announcer.announce(`${suggestions.length} Ergebnisse stehen zur Verfügung. Nutzen Sie die Hoch- und Runter-Pfeiltasten zum Navigieren und die Enter-Taste zum Selektieren.`);
          }
        }
      });
      this.inputContent$ = this.inputControl.valueChanges;
    }
    // von clients aufrufbar
    setText(text) {
      this.nonUserTextChange = true;
      this.inputControl.setValue(text);
      this.nonUserTextChange = false;
    }
    // von clients aufrufbar
    reload() {
      this.loadSuggestionsInProgress = true;
      this.load(this.inputControl.value).pipe(take(1)).subscribe(suggestions => {
        this.loadSuggestionsInProgress = false;
        this.activeSuggestionIndex = -1;
        this.suggestions = suggestions;
        if (this.submitPending) {
          this.submitSelection();
        }
      });
    }
    onKeyUp(event) {
      this.submitPending = false;
      switch (event.key) {
        case KEY_ENTER:
          event.preventDefault();
          this.submitPending = true; // vor dem Test auf Oracle pending, damit das Submit keinesfalls verloren geht!
          if (!this.loadSuggestionsInProgress) {
            if (this.activeSuggestionIndex > -1 || this.inputControl.value === this.originalInput) {
              this.submitSelection();
            }
          }
          this.inputFieldHasFocus = event.key === KEY_ENTER; // keep focus for enter only.
          break;
        case KEY_ARROW_UP:
        case 'Up':
          // IE
          if (this.showSuggestions) {
            this.handleItemChange(event, -1);
            return false;
          }
          return true;
        case KEY_ARROW_DOWN:
        case 'Down':
          // IE
          if (this.showSuggestions) {
            this.handleItemChange(event, +1);
            return false;
          }
          return true;
        case KEY_ESC:
        case KEY_ALT:
          // bei aktiviertem JAWS wird ALT statt ESC erkannt
          this.showSuggestions = false;
          this.activeSuggestionIndex = -1;
          this.nonUserTextChange = true;
          this.inputControl.setValue(this.originalInput);
          this.nonUserTextChange = false;
          break;
      }
    }
    ngOnDestroy() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
    onClickSuggestion(idx) {
      const item = this.suggestions[idx];
      if (!item.isReadOnly) {
        this.activeSuggestionIndex = idx;
        this.nonUserTextChange = true;
        this.inputControl.setValue(item.label);
        this.nonUserTextChange = false;
        this.submitSelection();
        this.showSuggestions = false;
      }
    }
    render(suggestion) {
      if (!suggestion.value && suggestion.isReadOnly) {
        return suggestion.label;
      }
      return this.suggestionRenderer(suggestion, this.originalInput, this.highlighter);
    }
    setActive(idx) {
      this.activeSuggestionIndex = idx;
    }
    // von clients aufrufbar
    focus() {
      this.inputField.nativeElement.focus();
    }
    /**
     * Löscht die Eingabe und schließt (erst mal) das Popup, fokussiert das Eingabeelement
     */
    cleanAndClose() {
      this.inputField.nativeElement.value = '';
      this.inputControl.setValue('');
      this.suggestions = [];
      this.showSuggestions = false;
      this.inputField.nativeElement.focus();
    }
    load(query) {
      const enteredValue = query.trim();
      return iif(() => !enteredValue, of([]), this.loadSuggestions(enteredValue).pipe(catchError(() => {
        return of([Suggestion.error('Technischer Fehler')]);
      })));
    }
    /**
     * Submits the currently selected value
     */
    submitSelection() {
      const firstNonReadonlySuggestion = this.suggestions.find(suggestion => !suggestion.isReadOnly);
      if (!this.inputControl.value || this.inputControl.value.length === 0 || this.suggestions.length === 0 || !firstNonReadonlySuggestion) {
        this.submitPending = false;
        return false;
      }
      const suchwort = this.inputControl.value;
      let selected;
      if (this.activeSuggestionIndex < 0) {
        // erstes nehmen
        selected = firstNonReadonlySuggestion || this.suggestions[0];
      } else {
        selected = this.suggestions[this.activeSuggestionIndex];
      }
      this.suggestionSelected.emit(new SelectedSuggestion(suchwort, selected.value, this.activeSuggestionIndex < 0, selected.extra));
      this.submitPending = false;
      this.showSuggestions = false;
      this.originalInput = '';
      if (this.resetOnSubmit) {
        this.suggestions = [];
        this.inputControl.setValue('');
      }
      return true;
    }
    /**
     * Handles change of the currently selected element according to the given index offset.
     *
     * Also prevents the default function for the event in order to not change cursor position within the input field.
     */
    handleItemChange(event, offset) {
      // Verhindert Cursor-Bewegungen innerhalb des Eingabefeldes.
      event.preventDefault();
      const nextIndex = this.nextIndex(this.activeSuggestionIndex, offset);
      if (this.activeSuggestionIndex !== nextIndex) {
        if (nextIndex === -1) {
          this.activeSuggestionIndex = -1;
          this.nonUserTextChange = true;
          this.inputControl.setValue(this.originalInput);
          this.nonUserTextChange = false;
          return;
        } else {
          this.activeSuggestionIndex = nextIndex;
          // Dropdown ggf. so scrollen, dass das aktuelle Item sichtbar wird.
          this.scrollToView(this.activeSuggestionIndex);
          this.nonUserTextChange = true;
          this.inputControl.setValue(this.suggestions[this.activeSuggestionIndex].label || '');
          this.nonUserTextChange = false;
        }
      }
      /*
      // Abbruchbedingung: Falls das gewaehlte Element die Fehlermeldung der Validierung ist,
      // wird der Wert (natürlich) nicht in das Autocomplete uebernommen
      if (
        this.suggestions.length === 0 ||
        (nextIndex > -1 && nextIndex <= maxIndex && this.suggestions[nextIndex].isReadOnly)
      ) {
        return;
      }
           // Wenn der Benutzer durch KeyUp/PgUp! über das 1. Element hinweg geht, dann wird der ursprünglich
      // eingegebene Text angezeigt (wie bei Google).
      if (
        this.activeSuggestionIndex > -1 &&
        (nextIndex < 0 || nextIndex > maxIndex || (this.activeSuggestionIndex === maxIndex && offset > 0))
      ) {
        this.activeSuggestionIndex = -1;
        this.nonUserTextChange = true;
        this.inputControl.setValue(this.originalInput);
        this.nonUserTextChange = false;
             return;
      }
           if (this.activeSuggestionIndex === -1 && offset < 0) {
        this.activeSuggestionIndex = maxIndex;
      } else {
        this.activeSuggestionIndex = Math.max(0, Math.min(maxIndex, nextIndex));
      }
      */
    }
    nextIndex(currentIndex, offset) {
      const max = this.suggestions.length - 1;
      let next = currentIndex + offset;
      if (next < -1) {
        next = max;
      } else if (next > max) {
        next = -1;
      }
      if (next === -1) {
        return next;
      }
      if (this.suggestions[next].isReadOnly) {
        return this.nextIndex(next, offset);
      }
      return next;
    }
    /**
     * Scrollt zu dem Eintrag mit dem index in der Autocomplete-Liste index; dieser wird bei keydown/key events berechnet
     * @param index Index des zu scrollenden Elenets in der Autocomplete-Box
     */
    scrollToView(index) {
      const ul = this.suggestionsUl.nativeElement;
      const li = ul.querySelector('li'); // just sample the first li to get height
      const liHeight = li.offsetHeight;
      const scrollTop = ul.scrollTop;
      const viewport = scrollTop + ul.offsetHeight;
      const scrollOffset = liHeight * index;
      if (scrollOffset < scrollTop || scrollOffset + liHeight > viewport) {
        ul.scrollTop = scrollOffset;
      }
    }
    focusin() {
      if (this.outside) {
        this.showSuggestions = this.suggestions && this.suggestions.length > 0;
        this.outside = false;
      }
      this.outsideMaybe = false;
    }
    focusout() {
      this.outsideMaybe = true;
      setTimeout(() => {
        if (this.outsideMaybe) {
          this.showSuggestions = false;
          this.outside = true;
        }
      }, 100);
    }
    static {
      this.ɵfac = function TypeaheadComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TypeaheadComponent)(i0.ɵɵdirectiveInject(LiveAnnouncer), i0.ɵɵdirectiveInject(i1$1.DomSanitizer), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TypeaheadComponent,
        selectors: [["ba-bub-typeahead"]],
        viewQuery: function TypeaheadComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c10, 5);
            i0.ɵɵviewQuery(_c11, 5);
            i0.ɵɵviewQuery(_c12, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.suggestionsUl = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputField = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.options = _t);
          }
        },
        inputs: {
          id: "id",
          placeholder: "placeholder",
          label: "label",
          resetOnSubmit: "resetOnSubmit",
          maxlength: "maxlength",
          disable: "disable",
          iconClass: "iconClass",
          loadSuggestions: "loadSuggestions",
          suggestionRenderer: "suggestionRenderer"
        },
        outputs: {
          suggestionSelected: "suggestionSelected"
        },
        decls: 12,
        vars: 24,
        consts: [["inputField", ""], ["suggestionsUl", ""], ["option", ""], [3, "formGroup"], [1, "form-group"], [3, "id", "for"], [1, "dropdown", "form-typeahead"], ["aria-hidden", "true", 3, "class", "disabled", 4, "ngIf"], ["type", "text", "title", "Wenn Vorschl\xE4ge verf\xFCgbar sind, k\xF6nnen die Hoch- und Runter-Pfeiltasten zum Navigieren und die Enter-Taste zum Selektieren verwendet werden.", "role", "combobox", "autocomplete", "off", "aria-autocomplete", "both", 1, "form-control", "darker-placeholder", 3, "keyup", "focus", "id", "formControl", "maxlength", "placeholder"], ["type", "button", "class", "clean-and-close ba-icon ba-icon-close-after", 3, "id", "click", 4, "ngIf"], ["tabindex", "-1", "role", "listbox", 1, "dropdown-menu", 3, "keyup", "id"], ["tabindex", "-1", "role", "option", 3, "id", "ngClass", "click", "focus", 4, "ngFor", "ngForOf"], ["aria-hidden", "true"], ["type", "button", 1, "clean-and-close", "ba-icon", "ba-icon-close-after", 3, "click", "id"], ["tabindex", "-1", "role", "option", 3, "click", "focus", "id", "ngClass"], ["tabindex", "-1"], [3, "innerHTML"]],
        template: function TypeaheadComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "form", 3)(1, "div", 4)(2, "label", 5);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 6);
            i0.ɵɵtemplate(5, TypeaheadComponent_i_5_Template, 1, 4, "i", 7);
            i0.ɵɵelementStart(6, "input", 8, 0);
            i0.ɵɵlistener("keyup", function TypeaheadComponent_Template_input_keyup_6_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onKeyUp($event));
            })("focus", function TypeaheadComponent_Template_input_focus_6_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.setActive(-1));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, TypeaheadComponent_button_8_Template, 1, 2, "button", 9);
            i0.ɵɵelementStart(9, "ul", 10, 1);
            i0.ɵɵlistener("keyup", function TypeaheadComponent_Template_ul_keyup_9_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onKeyUp($event));
            });
            i0.ɵɵtemplate(11, TypeaheadComponent_li_11_Template, 4, 9, "li", 11);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            const inputField_r7 = i0.ɵɵreference(7);
            i0.ɵɵproperty("formGroup", ctx.form);
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate1("id", "typeahead-", ctx.id, "-label");
            i0.ɵɵpropertyInterpolate1("for", "typeahead-", ctx.id, "");
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.label);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.iconClass);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("extra-padding", ctx.iconClass);
            i0.ɵɵpropertyInterpolate1("id", "typeahead-", ctx.id, "");
            i0.ɵɵproperty("formControl", ctx.inputControl)("maxlength", ctx.maxlength)("placeholder", ctx.placeholder);
            i0.ɵɵattribute("aria-expanded", ctx.showSuggestions)("aria-controls", "typeahead-menu-" + ctx.id)("aria-activedescendant", ctx.activeSuggestionIndex >= 0 ? "selectedOption-" + ctx.id + "-" + ctx.activeSuggestionIndex : null);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", inputField_r7.value !== "");
            i0.ɵɵadvance();
            i0.ɵɵclassProp("d-none", !ctx.showSuggestions);
            i0.ɵɵpropertyInterpolate1("id", "typeahead-menu-", ctx.id, "");
            i0.ɵɵattribute("aria-label", "Auswahlvorschl\xE4ge f\xFCr " + ctx.label);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.suggestions);
          }
        },
        dependencies: [FormsModule, i1.ɵNgNoValidate, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgControlStatusGroup, i1.MaxLengthValidator, ReactiveFormsModule, i1.FormControlDirective, i1.FormGroupDirective, NgIf, NgFor, NgClass],
        styles: ["i.ba-icon[_ngcontent-%COMP%]{text-align:left}i.ba-icon[_ngcontent-%COMP%]:before{position:absolute;font-size:1.5rem;z-index:1;margin-left:.4rem;margin-top:.4rem}input.extra-padding[_ngcontent-%COMP%]{padding-left:2.8rem}input[_ngcontent-%COMP%]{padding-right:35px}.clean-and-close[_ngcontent-%COMP%]{position:absolute;top:5px;border:none;background:none;color:#020e25;right:5px}.clean-and-close[_ngcontent-%COMP%]:hover, .clean-and-close[_ngcontent-%COMP%]:focus{color:#601}input[_ngcontent-%COMP%], input[_ngcontent-%COMP%]::placeholder{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.dropdown-menu[_ngcontent-%COMP%]{z-index:500;display:block;width:100%}.dropdown-menu[_ngcontent-%COMP%]   .focused[_ngcontent-%COMP%]{border-left:4px solid #020E25;background-color:#020e2514;color:#020e25;box-shadow:1px 1px 0 1px #f7f7f7,1px -1px 0 1px #f7f7f7,-1px 1px 0 1px #f7f7f7,-1px -1px 0 1px #f7f7f7,0 0 0 2px #f7f7f7,0 0 0 4px #020e25}.dropdown-menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,Arial,sans-serif;text-align:left;width:stretch}.dropdown-menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{box-shadow:none}.dropdown-menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a.ba-link-icon[_ngcontent-%COMP%]:before{top:9px}.dropdown-menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a.ba-link-icon[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:flex}.dropdown-menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{pointer-events:none}\n\n\n\n\n\n\n\n\n\n"]
      });
    }
  }
  return TypeaheadComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TypeaheadModule = /*#__PURE__*/(() => {
  class TypeaheadModule {
    static {
      this.ɵfac = function TypeaheadModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TypeaheadModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TypeaheadModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, ReactiveFormsModule, TypeaheadComponent]
      });
    }
  }
  return TypeaheadModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccordionComponent = /*#__PURE__*/(() => {
  class AccordionComponent {
    constructor() {
      this.isExpanded = false;
      this.linkclicked = new EventEmitter();
    }
    linkClicked() {
      this.linkclicked.emit();
    }
    static {
      this.ɵfac = function AccordionComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AccordionComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AccordionComponent,
        selectors: [["ba-bub-accordion"]],
        inputs: {
          id: "id",
          titleText: "titleText",
          iconClasses: "iconClasses",
          isExpanded: "isExpanded",
          ariaLabel: "ariaLabel",
          accordionContent: "accordionContent"
        },
        outputs: {
          linkclicked: "linkclicked"
        },
        decls: 8,
        vars: 20,
        consts: [[1, "accordion-item"], [1, "accordion-header", 3, "id"], ["type", "button", "data-bs-toggle", "collapse", 1, "accordion-button", "d-flex", "gap-2", "align-items-center", 3, "click", "id", "ngClass"], ["aria-hidden", "true", 3, "ngClass", 4, "ngIf"], [3, "id"], [1, "accordion-body"], [4, "ngTemplateOutlet"], ["aria-hidden", "true", 3, "ngClass"]],
        template: function AccordionComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "button", 2);
            i0.ɵɵlistener("click", function AccordionComponent_Template_button_click_2_listener() {
              return ctx.linkClicked();
            });
            i0.ɵɵtemplate(3, AccordionComponent_i_3_Template, 1, 1, "i", 3);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 4)(6, "div", 5);
            i0.ɵɵtemplate(7, AccordionComponent_ng_container_7_Template, 1, 0, "ng-container", 6);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate1("id", "accordion-", ctx.id, "-heading");
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate1("id", "accordion_", ctx.id, "_Link");
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c2, !ctx.isExpanded));
            i0.ɵɵattribute("data-bs-target", "#accordion-" + ctx.id + "-panel")("aria-controls", "accordion-" + ctx.id + "-panel")("aria-expanded", ctx.isExpanded)("aria-label", ctx.ariaLabel);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.iconClasses);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.titleText, " ");
            i0.ɵɵadvance();
            i0.ɵɵclassMapInterpolate1("accordion-collapse collapse ", ctx.isExpanded ? "show" : "", "");
            i0.ɵɵpropertyInterpolate1("id", "accordion-", ctx.id, "-panel");
            i0.ɵɵattribute("aria-labelledby", "accordion-" + ctx.id + "-heading");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.accordionContent);
          }
        },
        dependencies: [NgClass, NgIf, NgTemplateOutlet],
        styles: [".accordion-body[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]:last-child, .accordion-body[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:last-child, p[_ngcontent-%COMP%]:last-child{margin-bottom:0}.accordion-header[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]:before{font-size:30px}@media (max-width: 575.98px){.accordion-header[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:28px}}@media print{.accordion-header[_ngcontent-%COMP%]{border:1px solid black!important;-webkit-print-color-adjust:exact;print-color-adjust:exact}}\n\n\n\n\n\n\n\n\n\n"]
      });
    }
  }
  return AccordionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccordionModule = /*#__PURE__*/(() => {
  class AccordionModule {
    static {
      this.ɵfac = function AccordionModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AccordionModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AccordionModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return AccordionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DropdownComponent = /*#__PURE__*/(() => {
  class DropdownComponent {
    constructor() {
      this.label = 'Auswahlmenü';
      this.disabled = false;
      this.optionLabelFunction = value => value;
      this.optionCompareFunction = (active, fromList) => active === fromList;
      /*
        Autor  PJO 10.02.20
        Review CKU 12.08.20
                 Der Linting-Hinweis ist richtig, ABER
          Konsumenten müssten bei Umbenennung angepasst werden, welches einen
          unverhältnismäßigen Aufwand bedeuten würde.
      */
      // eslint-disable-next-line @angular-eslint/no-output-on-prefix
      this.onSelectionChanged = new EventEmitter();
    }
    ngAfterViewInit() {
      window.dpl.dropdownSelect.init(`#${this.id}-dropdown-select`);
    }
    // wird für Navigation über unterschiedliche Seiten benötigt, damit das DPL-Skript initialisiert wird
    ngAfterViewChecked() {
      let element = document.querySelector(`#${this.id}-dropdown-select`);
      let hasActiveAnchor = !!element.querySelector('ul.dropdown-menu li.active > a');
      if (hasActiveAnchor) {
        // @ts-ignore
        element.baDropdownSelect.updateStates(element);
      }
    }
    onChange(value) {
      if (this.selectedValue !== value) {
        this.onSelectionChanged.emit(value);
      }
      // return false verhindert Weiterleitung & Ausfuehrung von href
      return false;
    }
    static {
      this.ɵfac = function DropdownComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DropdownComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DropdownComponent,
        selectors: [["ba-bub-dropdown"]],
        inputs: {
          id: "id",
          label: "label",
          disabled: "disabled",
          possibleValues: "possibleValues",
          selectedValue: "selectedValue",
          title: "title",
          optionLabelFunction: "optionLabelFunction",
          optionCompareFunction: "optionCompareFunction",
          afterLabelTemplate: "afterLabelTemplate"
        },
        outputs: {
          onSelectionChanged: "onSelectionChanged"
        },
        decls: 9,
        vars: 9,
        consts: [["data-default-aria-label", "Auswahlmen\xFC", 1, "dropdown", "ba-dropdown-select"], [3, "for"], [4, "ngTemplateOutlet"], ["type", "button", "data-bs-toggle", "dropdown", "data-bs-offset", "0,4", "aria-expanded", "false", 1, "dropdown-toggle", "w-100", "d-flex", "justify-content-between", 3, "id", "disabled"], [1, "ba-selected-text"], ["type", "hidden", "name", "form-field-name", "value", "", 1, "ba-selected-value"], [1, "dropdown-menu", 3, "id"], [3, "active", 4, "ngFor", "ngForOf"], ["href", "#", 1, "dropdown-item", 3, "click"]],
        template: function DropdownComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "label", 1);
            i0.ɵɵtext(2);
            i0.ɵɵtemplate(3, DropdownComponent_ng_container_3_Template, 1, 0, "ng-container", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "button", 3);
            i0.ɵɵelement(5, "span", 4)(6, "input", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "ul", 6);
            i0.ɵɵtemplate(8, DropdownComponent_li_8_Template, 3, 4, "li", 7);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id + "-dropdown-select");
            i0.ɵɵadvance();
            i0.ɵɵproperty("for", ctx.id + "-button");
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.afterLabelTemplate);
            i0.ɵɵadvance();
            i0.ɵɵproperty("id", ctx.id + "-button")("disabled", ctx.disabled);
            i0.ɵɵattribute("aria-controls", ctx.id + "-liste");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("id", ctx.id + "-liste");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.possibleValues);
          }
        },
        dependencies: [NgTemplateOutlet, NgFor],
        styles: [".ba-selected-text[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block}@media (max-width: 575.98px){.dropdown[_ngcontent-%COMP%]:not(.select-only)   .dropdown-toggle[aria-expanded=true][_ngcontent-%COMP%]:after{transform:rotateX(180deg)!important}}\n\n\n\n\n\n\n\n\n\n"],
        changeDetection: 0
      });
    }
  }
  return DropdownComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DropdownModule = /*#__PURE__*/(() => {
  class DropdownModule {
    static {
      this.ɵfac = function DropdownModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DropdownModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: DropdownModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return DropdownModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LoadSpinnerComponent = /*#__PURE__*/(() => {
  class LoadSpinnerComponent {
    constructor() {
      this.size = 33;
      this.class = '';
    }
    static {
      this.ɵfac = function LoadSpinnerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LoadSpinnerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LoadSpinnerComponent,
        selectors: [["ba-bub-load-spinner"]],
        inputs: {
          size: "size",
          class: "class"
        },
        decls: 8,
        vars: 4,
        consts: [["role", "progressbar"], ["id", "ie-rotor"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 100 100", 1, "load-spinner"], ["attributeName", "transform", "type", "rotate", "values", "0 50 50; 275 50 50", "begin", "0s", "dur", "1.5s", "fill", "freeze", "repeatCount", "indefinite"], ["fill", "none", "stroke", "black", "stroke-width", "10", "stroke-linecap", "square", "cx", "50", "cy", "50", "r", "44", "stroke-dasharray", "274", "stroke-dashoffset", "610"], ["attributeName", "transform", "type", "rotate", "values", "0 50 50; 135 50 50; 450 50 50", "begin", "0s", "dur", "1.5s", "fill", "freeze", "repeatCount", "indefinite"], ["attributeName", "stroke-dashoffset", "values", "274; 68.57; 274", "begin", "0s", "dur", "1.5s", "fill", "freeze", "repeatCount", "indefinite"]],
        template: function LoadSpinnerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(2, "svg", 2)(3, "g");
            i0.ɵɵelement(4, "animateTransform", 3);
            i0.ɵɵelementStart(5, "circle", 4);
            i0.ɵɵelement(6, "animateTransform", 5)(7, "animate", 6);
            i0.ɵɵelementEnd()()()()();
          }
          if (rf & 2) {
            i0.ɵɵclassMap("load-spinner-box " + ctx.class);
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("width", ctx.size + "px")("height", ctx.size + "px");
          }
        },
        styles: [".load-spinner-box[_ngcontent-%COMP%]{width:100%;text-align:center;padding:10px;background:#fff;border:1px solid #DDE3E8;border-radius:2px}.load-spinner-box[_ngcontent-%COMP%]   .load-spinner[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{stroke:#b30920}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){#ie-rotor[_ngcontent-%COMP%]{animation-duration:1s;animation-iteration-count:infinite;animation-name:_ngcontent-%COMP%_load-spinning;animation-timing-function:linear;transform-origin:50% 46%}.studisu-content-studienfeldinfo[_ngcontent-%COMP%]   #ie-rotor[_ngcontent-%COMP%]{transform-origin:50% 43.5%}}@keyframes _ngcontent-%COMP%_load-spinning{0%{transform:rotate(0)}to{transform:rotate(360deg)}}\n\n\n\n\n\n\n\n\n\n"]
      });
    }
  }
  return LoadSpinnerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LoadSpinnerModule = /*#__PURE__*/(() => {
  class LoadSpinnerModule {
    static {
      this.ɵfac = function LoadSpinnerModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LoadSpinnerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: LoadSpinnerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return LoadSpinnerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SwitchComponent = /*#__PURE__*/(() => {
  class SwitchComponent {
    constructor() {
      this.switchedOnChange = new EventEmitter();
    }
    set switchedOn(value) {
      if (value !== this._switchedOn) {
        this._switchedOn = value;
        this.switchedOnChange.emit(this._switchedOn);
      }
    }
    get switchedOn() {
      return this._switchedOn;
    }
    static {
      this.ɵfac = function SwitchComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SwitchComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SwitchComponent,
        selectors: [["ba-bub-switch"]],
        inputs: {
          _switchedOn: [0, "switchedOn", "_switchedOn"],
          id: "id"
        },
        outputs: {
          switchedOnChange: "switchedOnChange"
        },
        decls: 18,
        vars: 28,
        consts: [["role", "presentation", 1, "d-inline-block"], ["aria-hidden", "true", "role", "presentation", 1, "radio-buttons"], ["type", "radio", "value", "ja", "tabindex", "-1", 3, "change", "id", "name", "checked"], [1, "yes", 3, "for"], ["type", "radio", "value", "nein", "tabindex", "-1", 3, "change", "id", "name", "checked"], [1, "no", 3, "for"], ["role", "presentation", 1, "form-group", "button-group"], ["role", "presentation", 1, "ba-btn-group"], [1, "form-check"], ["type", "radio", "value", "true", 3, "change", "id", "name", "checked"], ["type", "radio", "value", "false", 3, "change", "id", "name", "checked"]],
        template: function SwitchComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div")(3, "input", 2);
            i0.ɵɵlistener("change", function SwitchComponent_Template_input_change_3_listener() {
              return ctx.switchedOn = true;
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(4, "label", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div")(6, "input", 4);
            i0.ɵɵlistener("change", function SwitchComponent_Template_input_change_6_listener() {
              return ctx.switchedOn = false;
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(7, "label", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 6)(9, "div", 7)(10, "div", 8)(11, "input", 9);
            i0.ɵɵlistener("change", function SwitchComponent_Template_input_change_11_listener() {
              return ctx.switchedOn = true;
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "label", 3);
            i0.ɵɵtext(13, "Ja");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "div", 8)(15, "input", 10);
            i0.ɵɵlistener("change", function SwitchComponent_Template_input_change_15_listener() {
              return ctx.switchedOn = false;
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "label", 5);
            i0.ɵɵtext(17, "Nein");
            i0.ɵɵelementEnd()()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-radio-yes");
            i0.ɵɵpropertyInterpolate1("name", "", ctx.id, "-radio");
            i0.ɵɵproperty("checked", ctx.switchedOn);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate1("for", "", ctx.id, "-radio-yes");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-radio-no");
            i0.ɵɵpropertyInterpolate1("name", "", ctx.id, "-radio");
            i0.ɵɵproperty("checked", !ctx.switchedOn);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate1("for", "", ctx.id, "-radio-no");
            i0.ɵɵadvance(4);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-switch-yes");
            i0.ɵɵpropertyInterpolate1("name", "", ctx.id, "-switch");
            i0.ɵɵproperty("checked", ctx.switchedOn);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate1("for", "", ctx.id, "-switch-yes");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-switch-no");
            i0.ɵɵpropertyInterpolate1("name", "", ctx.id, "-switch");
            i0.ɵɵproperty("checked", !ctx.switchedOn);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate1("for", "", ctx.id, "-switch-no");
          }
        },
        styles: [".radio-buttons[_ngcontent-%COMP%]{position:absolute;display:flex}.radio-buttons[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{z-index:10;width:90px!important;height:0}.radio-buttons[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:before{top:1.5px;left:13px}.ba-btn-group[_ngcontent-%COMP%]{margin:0!important;display:inline-flex;flex-direction:row}.ba-btn-group[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]{border-top-width:1px;border-left-width:0;border-radius:0}.ba-btn-group[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]:before{inset:auto 0 0;width:100%;height:4px}.ba-keyboard-mode[_ngcontent-%COMP%]   .ba-btn-group[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]:focus + label[_ngcontent-%COMP%]{margin-top:0;margin-left:-1px;border-left-width:1px;border-color:#020e25}.ba-btn-group[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:first-child   input[type=radio][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]{border-left-width:1px;border-top-left-radius:5px;border-bottom-left-radius:5px}.ba-keyboard-mode[_ngcontent-%COMP%]   .ba-btn-group[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:first-child   input[type=radio][_ngcontent-%COMP%]:focus + label[_ngcontent-%COMP%]{margin-left:0}.ba-btn-group[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:last-child   input[type=radio][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]{border-top-right-radius:5px;border-bottom-right-radius:5px}.ba-btn-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{width:91px!important;padding-left:30px!important;padding-top:8px!important;height:39px!important}.ba-btn-group[_ngcontent-%COMP%]   .yes[_ngcontent-%COMP%]{padding-left:30px!important;border-radius:5px 0 0 5px!important}.ba-btn-group[_ngcontent-%COMP%]   .no[_ngcontent-%COMP%]{padding-left:40px!important;border-radius:0 5px 5px 0!important}\n\n\n\n\n\n\n\n\n\n"]
      });
    }
  }
  return SwitchComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SwitchModule = /*#__PURE__*/(() => {
  class SwitchModule {
    static {
      this.ɵfac = function SwitchModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SwitchModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: SwitchModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return SwitchModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChipComponent = /*#__PURE__*/(() => {
  class ChipComponent {
    constructor() {
      /**
       * Einzeln stehender Chip sollen nicht die Rolle List-Item erhalten.
       */
      this.single = false;
    }
    static {
      this.ɵfac = function ChipComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ChipComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ChipComponent,
        selectors: [["ba-bub-chip"]],
        inputs: {
          name: "name",
          icon: "icon",
          single: "single"
        },
        ngContentSelectors: _c0,
        decls: 8,
        vars: 5,
        consts: [[1, "simple-chip"], ["aria-hidden", "true"], [1, "sr-only"], [1, "content"]],
        template: function ChipComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div")(2, "span", 1);
            i0.ɵɵelement(3, "i");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "span", 2);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "div", 3);
            i0.ɵɵprojection(7);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵattribute("role", ctx.single ? null : "listitem");
            i0.ɵɵadvance(3);
            i0.ɵɵclassMapInterpolate1("ba-icon ", ctx.icon, "");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.name);
          }
        },
        styles: [".simple-chip[_ngcontent-%COMP%]{border:2px solid #DDE3E8;border-radius:3px;background-color:#dde3e8;max-width:100%;padding:.2666rem .5333rem .2rem;line-height:1.15rem;display:inline-grid;grid-template-columns:18px 1fr}.simple-chip[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-left:.2rem}.ba-icon[_ngcontent-%COMP%]:before{line-height:1rem;margin-top:.05rem;display:block}\n\n\n\n\n\n\n\n\n\n"]
      });
    }
  }
  return ChipComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DistanzIconComponent = /*#__PURE__*/(() => {
  class DistanzIconComponent {
    static {
      this.ɵfac = function DistanzIconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DistanzIconComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DistanzIconComponent,
        selectors: [["ba-bub-icon-distanz"]],
        decls: 2,
        vars: 0,
        consts: [["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 100 100", 2, "width", "fit-content"], ["d", "M22,44c-2,0-19.56.45-20,18.85S22,96,22,96,42.42,81.25,42,62.85,23.85,44,22,44Zm0,26.81a7.32,7.32,0,1,1,7.5-7.32A7.41,7.41,0,0,1,22,70.81ZM82,44S98.34,32.09,98,17.23,83.48,2,82,2s-15.65.36-16,15.23S82,44,82,44Zm0-32.17a5.92,5.92,0,1,1-6,5.91A6,6,0,0,1,82,11.83ZM98,81.5A16.52,16.52,0,0,1,81.5,98H35a3,3,0,0,1,0-6H81.5a10.5,10.5,0,0,0,0-21H62a14,14,0,0,1,0-28H74a3,3,0,0,1,0,6H62a8,8,0,0,0,0,16H81.5A16.52,16.52,0,0,1,98,81.5Z"]],
        template: function DistanzIconComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(0, "svg", 0);
            i0.ɵɵelement(1, "path", 1);
            i0.ɵɵelementEnd();
          }
        },
        encapsulation: 2
      });
    }
  }
  return DistanzIconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DistanzChipComponent = /*#__PURE__*/(() => {
  class DistanzChipComponent {
    get beschreibungKurz() {
      return `${formatNumber(this.distanz, 'de', '1.1-1')} km vom Suchort ${this.ort} entfernt.`;
    }
    static {
      this.ɵfac = function DistanzChipComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DistanzChipComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DistanzChipComponent,
        selectors: [["ba-bub-distanz-chip"]],
        inputs: {
          ort: "ort",
          plz: "plz",
          distanz: "distanz"
        },
        decls: 8,
        vars: 8,
        consts: [["role", "listitem"], ["data-bs-toggle", "popover", "data-bs-placement", "bottom", 1, "distanz-chip"], ["aria-hidden", "true", 1, "icon"], [1, "distanz"], [1, "ortsname"]],
        template: function DistanzChipComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵelement(2, "ba-bub-icon-distanz", 2);
            i0.ɵɵelementStart(3, "span", 3);
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "number");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "span", 4);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵattribute("aria-label", ctx.beschreibungKurz);
            i0.ɵɵadvance();
            i0.ɵɵattribute("data-bs-content", ctx.beschreibungKurz);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(5, 5, ctx.distanz, "1.1-1"), " km");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate2("", ctx.plz, " ", ctx.ort, "");
          }
        },
        dependencies: [TooltipDirective, DistanzIconComponent, DecimalPipe],
        styles: [".distanz-chip[_ngcontent-%COMP%]{border-radius:3px;background-color:#dde3e8;max-width:100%;padding:.15625rem .625rem;display:inline-grid;grid-template-columns:1rem max-content auto;grid-gap:.5rem;white-space:nowrap}@media print{.distanz-chip[_ngcontent-%COMP%]{border:2px solid #DDE3E8}}span.ortsname[_ngcontent-%COMP%]{text-overflow:ellipsis;overflow:hidden}.icon[_ngcontent-%COMP%]{display:flex;align-items:center;color:#838383}span.distanz[_ngcontent-%COMP%]{border-right:1px solid #B3B3B3;padding-right:.5rem}\n\n\n\n\n\n\n\n\n\n"]
      });
    }
  }
  return DistanzChipComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FilterChipComponent = /*#__PURE__*/(() => {
  class FilterChipComponent {
    constructor() {
      this.disabled = false;
      this.filterEntfernt = new EventEmitter();
    }
    removeChip() {
      this.filterEntfernt.emit(this.aktiverFilter);
    }
    static {
      this.ɵfac = function FilterChipComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FilterChipComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FilterChipComponent,
        selectors: [["ba-bub-filter-chip"]],
        inputs: {
          id: "id",
          disabled: "disabled",
          aktiverFilter: "aktiverFilter"
        },
        outputs: {
          filterEntfernt: "filterEntfernt"
        },
        decls: 1,
        vars: 1,
        consts: [["class", "filter-chip", 4, "ngIf"], [1, "filter-chip"], [1, "sr-only"], ["data-bs-toggle", "popover", "data-bs-placement", "bottom", 1, "content", 3, "innerHTML"], [1, "d-print-none", 3, "click"], [1, "ba-icon", "ba-icon-close"]],
        template: function FilterChipComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, FilterChipComponent_div_0_Template, 6, 9, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.aktiverFilter);
          }
        },
        dependencies: [NgIf, TooltipDirective],
        styles: [".filter-chip[_ngcontent-%COMP%]{border-radius:3px;background-color:#dde3e8;max-width:100%;padding:4px 8px;display:inline-grid;grid-template-columns:1fr 25px;align-items:center;justify-items:center}.filter-chip[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-right:.2rem}button[_ngcontent-%COMP%]{border:none;background-color:#dde3e8;vertical-align:middle;font-size:.8rem;padding:5px}button[_ngcontent-%COMP%]:disabled{color:#838383}button[_ngcontent-%COMP%]:focus:not(:disabled){outline:2px solid #660011;color:#601}button[_ngcontent-%COMP%]:hover:not(:disabled){color:#601;cursor:pointer}.ba-icon[_ngcontent-%COMP%]:before{display:block}@media print{.filter-chip[_ngcontent-%COMP%]{border:2px solid #DDE3E8;grid-template-columns:1fr}}\n\n\n\n\n\n\n\n\n\n"]
      });
    }
  }
  return FilterChipComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CheckChipComponent = /*#__PURE__*/(() => {
  class CheckChipComponent {
    static {
      this.ɵfac = function CheckChipComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckChipComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckChipComponent,
        selectors: [["ba-bub-check-chip"]],
        ngContentSelectors: _c0,
        decls: 6,
        vars: 0,
        consts: [[1, "text-nowrap", "d-flex", "gap-1", "align-items-center"], ["aria-hidden", "true", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 100 100", "height", "19", "width", "19"], ["d", "M70.94,32.626a2.1374,2.1374,0,0,0-3.0224,0L43.738,56.7988l-9.0672-9.0649a2.1374,2.1374,0,0,0-3.0224,0L28.626,50.7554a2.1359,2.1359,0,0,0,0,3.0215L42.2268,67.374a2.1375,2.1375,0,0,0,3.0225,0l.7556-.7553,3.7781-3.7769L73.9623,38.6689a2.136,2.136,0,0,0,0-3.0214Z", 1, "check-line"], ["d", "M50,2A48,48,0,1,0,98,50,48.055,48.055,0,0,0,50,2Zm0,89A41,41,0,1,1,91,50,41.0465,41.0465,0,0,1,50,91Z", 1, "check-line"]],
        template: function CheckChipComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(1, "svg", 1);
            i0.ɵɵelement(2, "path", 2)(3, "path", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(4, "div");
            i0.ɵɵprojection(5);
            i0.ɵɵelementEnd()();
          }
        },
        styles: [".check-line[_ngcontent-%COMP%]{fill:#1f8904}\n\n"]
      });
    }
  }
  return CheckChipComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChipsModule = /*#__PURE__*/(() => {
  class ChipsModule {
    static {
      this.ɵfac = function ChipsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ChipsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ChipsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TooltipModule]
      });
    }
  }
  return ChipsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Error404ImageComponent = /*#__PURE__*/(() => {
  class Error404ImageComponent {
    static {
      this.ɵfac = function Error404ImageComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Error404ImageComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Error404ImageComponent,
        selectors: [["ba-bub-error-404-image"]],
        decls: 51,
        vars: 0,
        consts: [["id", "Layer_1", "data-name", "Layer 1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "viewBox", "0 0 774.44 380.59"], ["id", "linear-gradient", "x1", "5202.34", "y1", "-610.58", "x2", "5315.89", "y2", "-610.58", "gradientTransform", "translate(5359 3330.09) rotate(-141.59)", "gradientUnits", "userSpaceOnUse"], ["offset", "0", "stop-color", "#e24c4b"], ["offset", "1", "stop-color", "#f08985", "stop-opacity", "0"], ["id", "linear-gradient-2", "x1", "5280.22", "y1", "-704.12", "x2", "5364.68", "y2", "-704.12", "gradientTransform", "translate(5359 3330.09) rotate(-141.59)", "gradientUnits", "userSpaceOnUse"], ["offset", "0", "stop-color", "#83a4d6"], ["offset", "1", "stop-color", "#97b7e1", "stop-opacity", "0"], ["id", "linear-gradient-3", "x1", "5160.3", "y1", "-542.71", "x2", "5229.39", "y2", "-542.71", 0, "xlink", "href", "#linear-gradient-2"], ["id", "linear-gradient-4", "x1", "4927.21", "y1", "-267.02", "x2", "4996.3", "y2", "-267.02", "gradientTransform", "translate(5359 3330.09) rotate(-141.59)", "gradientUnits", "userSpaceOnUse"], ["offset", "0", "stop-color", "#e14a12"], ["offset", "1", "stop-color", "#f08552", "stop-opacity", "0"], ["d", "M773.39,617.12h32.88v35.41H773.39v58.85H729.26V652.53H615l-1.27-26.88L727.81,446.94h45.58Zm-113.33,0h69.2V506.69L726,512.5Z", "transform", "translate(-613.75 -429.41)", 1, "cls-1"], ["d", "M1355.31,617.12h32.88v35.41h-32.88v58.85h-44.13V652.53H1196.94l-1.27-26.88,114-178.71h45.59Zm-113.33,0h69.2V506.69l-3.27,5.81Z", "transform", "translate(-613.75 -429.41)", 1, "cls-1"], ["cx", "386.06", "cy", "149.65", "r", "138.56", 1, "cls-1"], ["width", "160", "height", "159", "transform", "translate(395.25 221.59)", 0, "xlink", "href", "data:image/png;base64,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"], ["d", "M1055.3,632.82s17.67-7.44,38.13,27.9l15.65,25a10.14,10.14,0,0,1-3.07,13.87l-1.55,1a11.66,11.66,0,0,1-15.32-2.34l-42.67-51.53Z", "transform", "translate(-613.75 -429.41)", 1, "cls-2"], ["d", "M1104.66,690.17l-15.64-25c-16.46-28.43-31.11-29.18-36.21-28.38l2.49-3.94s17.67-7.44,38.13,27.9l15.65,25a10.14,10.14,0,0,1-3.07,13.87l-1,.63A10.13,10.13,0,0,0,1104.66,690.17Z", "transform", "translate(-613.75 -429.41)", 1, "cls-3"], ["cx", "389.8", "cy", "184.19", "r", "56.92", 1, "cls-4"], ["d", "M968.81,568.53h0a9,9,0,0,0,2.32,6l31.46,34.69a12,12,0,0,1,3,6.42l2,14.7a10.79,10.79,0,0,1-1.19,6.57l-14.26,26.43a8,8,0,0,0-.69,5.88h0a56.91,56.91,0,0,1-22.68-100.7Z", "transform", "translate(-613.75 -429.41)", 1, "cls-3"], ["d", "M964.16,622a30.72,30.72,0,0,1,23-29.73l16.7,18.42a5.76,5.76,0,0,1,1.44,3.07l2.52,18.23a5.82,5.82,0,0,1-.64,3.54l-9.18,17a30.36,30.36,0,0,1-3.18.16A30.69,30.69,0,0,1,964.16,622Z", "transform", "translate(-613.75 -429.41)", 1, "cls-2"], ["d", "M1010.64,667.09h0s-6,22.79,8.37,40,34.88,41.38,67.43,38.13h0s7.44,11.62,25.11,2.79h0l-11.16-26.32a5.08,5.08,0,0,0-5.84-3c-5.67,1.36-16.15,1.59-23-12.08h0s17.86,5.49,20.52-6.24a11.88,11.88,0,0,0-2.75-10.35l-39.62-45.72h0Z", "transform", "translate(-613.75 -429.41)", 1, "cls-4"], ["d", "M1071.56,706.62l-25.09-29.06s8.35,39.28,32.07,38C1078.54,715.57,1075.09,713.28,1071.56,706.62Z", "transform", "translate(-613.75 -429.41)", 1, "cls-5"], ["d", "M972.86,568l32.72,36.1a19.26,19.26,0,0,1,4.73,9.79l2.57,15.58c.67,4.07,0,8.25-3.86,15.8L997.51,668", "transform", "translate(-613.75 -429.41)", 1, "cls-6"], ["d", "M1086,736s-1.76,6.81.45,9.19c0,0-8.28.61-12.7-.12Z", "transform", "translate(-613.75 -429.41)", 1, "cls-5"], ["d", "M1009.54,682.69l8.39-3a10.34,10.34,0,0,1,13.82,9.18,102.86,102.86,0,0,0,1.6,13.86,11,11,0,0,1-4.66,11.31l-2.39,1.58S1010.75,706.42,1009.54,682.69Z", "transform", "translate(-613.75 -429.41)", 1, "cls-3"], ["d", "M1016.74,685.17h0a8,8,0,0,1,10.72,7.12,78,78,0,0,0,1.26,10.86,8.41,8.41,0,0,1-3.63,8.66h0a3.22,3.22,0,0,1-3.83-.23,31.26,31.26,0,0,1-9.86-16.24A8.52,8.52,0,0,1,1016.74,685.17Z", "transform", "translate(-613.75 -429.41)", 1, "cls-2"], ["d", "M1010,670.15s8.43-1.28,12.31-2.81c0,0-4.34,7.3-12.87,8.06A39.72,39.72,0,0,1,1010,670.15Z", "transform", "translate(-613.75 -429.41)", 1, "cls-5"], [1, "cls-7"], ["cx", "331.18", "cy", "24.9", "r", "16.87", 1, "cls-8"], ["d", "M928.06,454.31a16.87,16.87,0,0,0,16.87,16.87,17.5,17.5,0,0,0,2.82-.23L928.3,451.49A16.43,16.43,0,0,0,928.06,454.31Z", "transform", "translate(-613.75 -429.41)", 1, "cls-8"], ["d", "M930.59,445.42l23.23,23.23a16.69,16.69,0,0,0,1.87-1.34l-23.76-23.75A18,18,0,0,0,930.59,445.42Z", "transform", "translate(-613.75 -429.41)", 1, "cls-4"], ["cx", "943.43", "cy", "455.29", "rx", "3.35", "ry", "36.43", "transform", "translate(-659.36 371.04) rotate(-45)", 1, "cls-9"], ["cx", "942.29", "cy", "455.68", "rx", "2.51", "ry", "29.8", "transform", "translate(-659.97 370.35) rotate(-45)", 1, "cls-10"], ["cx", "942.14", "cy", "456.25", "rx", "2.29", "ry", "24.83", "transform", "translate(-660.42 370.41) rotate(-45)", 1, "cls-11"], ["d", "M928.94,448.93l21.37,21.38a16.85,16.85,0,0,0,3.51-1.66l-23.23-23.23A16.33,16.33,0,0,0,928.94,448.93Z", "transform", "translate(-613.75 -429.41)", 1, "cls-8"], ["d", "M903.32,576.17a4,4,0,0,0-.87-5.73l-90.56-61.71h0l85.87,68.08a4,4,0,0,0,5.56-.64Z", "transform", "translate(-613.75 -429.41)", 1, "cls-12"], ["d", "M784.18,601.08a3,3,0,0,0-.65-4.27l-67.36-45.9h0L780,601.56a3,3,0,0,0,4.14-.48Z", "transform", "translate(-613.75 -429.41)", 1, "cls-13"], ["d", "M978.43,549.12a2.42,2.42,0,0,0-.53-3.49l-55.1-37.55h0L975,549.51a2.42,2.42,0,0,0,3.39-.39Z", "transform", "translate(-613.75 -429.41)", 1, "cls-14"], ["d", "M1332.36,477.92a2.4,2.4,0,0,0-.53-3.48l-55.1-37.55h0L1329,478.32a2.42,2.42,0,0,0,3.39-.4Z", "transform", "translate(-613.75 -429.41)", 1, "cls-15"], ["cx", "441.52", "cy", "83.25", "r", "4.36", 1, "cls-16"], ["cx", "132.39", "cy", "34.88", "r", "4.36", 1, "cls-16"], ["cx", "154.02", "cy", "111.61", "r", "2.18", 1, "cls-16"], ["cx", "486.99", "cy", "185.99", "r", "8.71", 1, "cls-17"], ["cx", "30.47", "cy", "198.01", "r", "3.97", 1, "cls-17"], ["cx", "727.84", "cy", "202.75", "r", "8.71", 1, "cls-17"], ["cx", "596.22", "cy", "194.7", "r", "4.36", 1, "cls-18"]],
        template: function Error404ImageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(0, "svg", 0)(1, "defs")(2, "style");
            i0.ɵɵtext(3, ".cls-1{fill:#222d41;}.cls-2{fill:#ffce1f;}.cls-3{fill:#efae00;}.cls-4{fill:#fff;}.cls-5{fill:#ededee;}.cls-6{fill:none;stroke:#d9d9d9;stroke-linecap:round;stroke-miterlimit:10;stroke-width:5px;}.cls-7{opacity:0.85;}.cls-8{fill:#9ec0cf;}.cls-9{fill:#f7cb8a;}.cls-10{fill:#e4915b;}.cls-11{fill:#2a2f41;}.cls-12,.cls-13,.cls-14,.cls-15,.cls-18{opacity:0.52;}.cls-12{fill:url(#linear-gradient);}.cls-13{fill:url(#linear-gradient-2);}.cls-14{fill:url(#linear-gradient-3);}.cls-15{fill:url(#linear-gradient-4);}.cls-16{fill:#e99250;}.cls-16,.cls-17{opacity:0.59;}.cls-17{fill:#9ebdc9;}.cls-18{fill:#bdb6cd;}");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "linearGradient", 1);
            i0.ɵɵelement(5, "stop", 2)(6, "stop", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "linearGradient", 4);
            i0.ɵɵelement(8, "stop", 5)(9, "stop", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(10, "linearGradient", 7);
            i0.ɵɵelementStart(11, "linearGradient", 8);
            i0.ɵɵelement(12, "stop", 9)(13, "stop", 10);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "title");
            i0.ɵɵtext(15, "Seite nicht gefunden. Fehler 404.");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(16, "path", 11)(17, "path", 12)(18, "circle", 13)(19, "image", 14)(20, "path", 15)(21, "path", 16)(22, "circle", 17)(23, "path", 18)(24, "path", 19)(25, "path", 20)(26, "path", 21)(27, "path", 22)(28, "path", 23)(29, "path", 24)(30, "path", 25)(31, "path", 26);
            i0.ɵɵelementStart(32, "g", 27);
            i0.ɵɵelement(33, "circle", 28)(34, "path", 29)(35, "path", 30)(36, "ellipse", 31)(37, "ellipse", 32)(38, "ellipse", 33)(39, "path", 34);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(40, "path", 35)(41, "path", 36)(42, "path", 37)(43, "path", 38)(44, "circle", 39)(45, "circle", 40)(46, "circle", 41)(47, "circle", 42)(48, "circle", 43)(49, "circle", 44)(50, "circle", 45);
            i0.ɵɵelementEnd();
          }
        },
        encapsulation: 2
      });
    }
  }
  return Error404ImageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Error404Component = /*#__PURE__*/(() => {
  class Error404Component {
    constructor() {
      this.buttonText = 'Zurück zur Startseite';
      this.buttonClicked = new EventEmitter();
    }
    static {
      this.ɵfac = function Error404Component_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Error404Component)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Error404Component,
        selectors: [["ba-bub-error404"]],
        inputs: {
          buttonText: "buttonText"
        },
        outputs: {
          buttonClicked: "buttonClicked"
        },
        decls: 18,
        vars: 1,
        consts: [[1, "error-404"], [1, "ba-content-header", "ba-with-overlay", "ba-with-image"], [1, "ba-header-image"], ["title", "Fehler 404: Seite nicht gefunden", 1, "img404"], [1, "ba-content-wrap"], [1, "ba-overlay"], [1, "container-fluid", "ba-copytext"], [1, "ba-btn", "ba-btn-primary", 3, "click"]],
        template: function Error404Component_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "header", 1)(2, "div", 2);
            i0.ɵɵelement(3, "ba-bub-error-404-image", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 4)(5, "div", 5)(6, "h1");
            i0.ɵɵtext(7, "Die angeforderte Webseite ist leider nicht vorhanden");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(8, "div", 6)(9, "h2");
            i0.ɵɵtext(10, "M\xF6gliche Gr\xFCnde");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "ul")(12, "li");
            i0.ɵɵtext(13, "Die Adresse (URL) der angeforderten Seite hat sich ge\xE4ndert.");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "li");
            i0.ɵɵtext(15, "Die angeforderte Seite wurde gel\xF6scht.");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(16, "button", 7);
            i0.ɵɵlistener("click", function Error404Component_Template_button_click_16_listener() {
              return ctx.buttonClicked.emit();
            });
            i0.ɵɵtext(17);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(17);
            i0.ɵɵtextInterpolate1(" ", ctx.buttonText, " ");
          }
        },
        dependencies: [Error404ImageComponent],
        styles: [".ba-content-header[_ngcontent-%COMP%]{max-width:var(--container-max-width)}"]
      });
    }
  }
  return Error404Component;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Error404Module = /*#__PURE__*/(() => {
  class Error404Module {
    static {
      this.ɵfac = function Error404Module_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Error404Module)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Error404Module
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return Error404Module;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BildSliderComponent = /*#__PURE__*/(() => {
  class BildSliderComponent {
    constructor(changeDetectorRef) {
      this.changeDetectorRef = changeDetectorRef;
      this.label = 'Bild-Slider';
      this.id = 'bild-slider';
      this.is4by3 = false;
      /* Event, welches den Index des angeklickten Bildes sendet */
      this.index = new EventEmitter();
    }
    ngOnChanges() {
      // Falls bereits initialisiert, stoße Reinitialisierung an.
      if (this.sliderViewContainer) {
        this.resetSlider();
      }
    }
    /**
     * Entfernt Slider komplett, da das dynamische Austauschen der Slides
     * vom BaSlider nicht unterstützt wird. Danach wird der Slider wieder
     * eingefügt und initialisiert.
     */
    resetSlider() {
      this.removeSlider();
      this.initSlider();
    }
    removeSlider() {
      this.sliderViewContainer.clear();
    }
    ngAfterViewInit() {
      // sliderViewContainer ist er in diesem Lifecycle verfügbar.
      this.initSlider();
    }
    initSlider() {
      this.sliderViewContainer.createEmbeddedView(this.sliderTemplate);
      // Notwendig ansonsten Fehler NG0100 ExpressionChangedAfterItHasBeenCheckedError
      this.changeDetectorRef.detectChanges();
      // @ts-ignore
      window.dpl.imageSlider.init();
    }
    sendIndex(index) {
      // Index des angeklickten Bildes senden
      this.index.emit(index);
    }
    static {
      this.ɵfac = function BildSliderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BildSliderComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BildSliderComponent,
        selectors: [["ba-bub-bild-slider"]],
        viewQuery: function BildSliderComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c14, 5, ViewContainerRef);
            i0.ɵɵviewQuery(_c15, 5, TemplateRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sliderViewContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sliderTemplate = _t.first);
          }
        },
        inputs: {
          bilder: "bilder",
          label: "label",
          id: "id",
          alternativText: "alternativText",
          is4by3: "is4by3"
        },
        outputs: {
          index: "index"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 4,
        vars: 0,
        consts: [["sliderViewContainer", ""], ["sliderTemplate", ""], ["aria-label", "Slider mit Bildern", "role", "application", "data-prev-text", "vorheriges Bild", "data-next-text", "n\xE4chstes Bild", "data-index-text", "Bild {1} von {2}", "data-current-text", "aktiv", 3, "id", "ngClass", "ba-4by3", 4, "ngIf"], ["id", "keine-bilder-hinweise", 4, "ngIf"], ["aria-label", "Slider mit Bildern", "role", "application", "data-prev-text", "vorheriges Bild", "data-next-text", "n\xE4chstes Bild", "data-index-text", "Bild {1} von {2}", "data-current-text", "aktiv", 3, "id", "ngClass"], [1, "ba-slide-track"], ["class", "ba-slide", 4, "ngFor", "ngForOf"], [1, "ba-slide"], [1, "ba-image"], ["loading", "lazy", 3, "click", "src", "alt"], ["aria-hidden", "true", 1, "ba-caption"], ["id", "keine-bilder-hinweise"]],
        template: function BildSliderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementContainer(0, null, 0);
            i0.ɵɵtemplate(2, BildSliderComponent_ng_template_2_Template, 2, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
        },
        dependencies: [NgIf, NgClass, NgFor],
        styles: [".nglib-no-slider .ba-slide-next,.nglib-no-slider .ba-slider-dots,.nglib-no-slider .ba-slide-prev{display:none}\n"],
        encapsulation: 2
      });
    }
  }
  return BildSliderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BildSliderModule = /*#__PURE__*/(() => {
  class BildSliderModule {
    static {
      this.ɵfac = function BildSliderModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BildSliderModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: BildSliderModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return BildSliderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BookmarkIconComponent = /*#__PURE__*/(() => {
  class BookmarkIconComponent {
    static {
      this.ɵfac = function BookmarkIconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BookmarkIconComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BookmarkIconComponent,
        selectors: [["ba-bub-icon-bookmark"]],
        decls: 3,
        vars: 0,
        consts: [["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 100 100"], ["d", "M82.59,95.91,51.41,64.8a2,2,0,0,0-2.82,0L17.41,95.91A2,2,0,0,1,14,94.5v-85a6,6,0,0,1,6-6H80a6,6,0,0,1,6,6v85A2,2,0,0,1,82.59,95.91Z", 1, "cls-1"], ["d", "M16,98a3.51,3.51,0,0,1-3.5-3.5v-85A7.5,7.5,0,0,1,20,2H80a7.5,7.5,0,0,1,7.5,7.49v85a3.5,3.5,0,0,1-6,2.47L50.35,65.86a.5.5,0,0,0-.7,0L18.47,97A3.49,3.49,0,0,1,16,98ZM50,62.71a3.48,3.48,0,0,1,2.47,1L83.65,94.85a.5.5,0,0,0,.85-.35v-85A4.5,4.5,0,0,0,80,5H20a4.5,4.5,0,0,0-4.5,4.49v85a.48.48,0,0,0,.31.46.46.46,0,0,0,.54-.11L47.53,63.74A3.48,3.48,0,0,1,50,62.71Z", 1, "cls-2"]],
        template: function BookmarkIconComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(0, "svg", 0);
            i0.ɵɵelement(1, "path", 1)(2, "path", 2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["svg[_ngcontent-%COMP%]{width:var(--bookmark-icon-width, 18px);height:var(--bookmark-icon-width, 18px);transition:all .08s ease-in-out}svg[_ngcontent-%COMP%]   .cls-1[_ngcontent-%COMP%]{fill-opacity:1;fill:var(--bookmark-icon-background, currentColor)}svg[_ngcontent-%COMP%]   .cls-2[_ngcontent-%COMP%]{fill:var(--bookmark-icon-outline-color, currentColor)}\n\n\n\n\n\n"]
      });
    }
  }
  return BookmarkIconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BookmarkIconModule = /*#__PURE__*/(() => {
  class BookmarkIconModule {
    static {
      this.ɵfac = function BookmarkIconModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BookmarkIconModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: BookmarkIconModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return BookmarkIconModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @experimental seit 0.2.89
 *
 * Testweise Alternative für Angulars ngOnChanges
 *
 * Kann als Decorator über @Input() geschrieben werden
 *
 * Beispielhaft in der AnbieterFacetteComponent genutzt
 *
 * Es können auch Methoden der nutzende KomponentenKlasse übergeben werden, allerdings
 * muss deren Name als string übergeben werden. Das liegt daran, dass der Decorator intern
 * target nutzt um auf das entsprechende member der ParentKlasse zuzugreifen.
 *
 */
function OnChange(callback) {
  const cachedValueKey = Symbol();
  const isFirstChangeKey = Symbol();
  return (target, key) => {
    const callBackFn = typeof callback === 'string' ? target[callback] : callback;
    if (!callBackFn) {
      throw new Error(`Methode ${callback} kann in Klasse ${target.constructor.name} nicht gefunden werden`);
    }
    Object.defineProperty(target, key, {
      set(value) {
        // change status of "isFirstChange"
        this[isFirstChangeKey] = this[isFirstChangeKey] === undefined;
        // No operation if new value is same as old value
        if (!this[isFirstChangeKey] && this[cachedValueKey] === value) {
          return;
        }
        const oldValue = this[cachedValueKey];
        this[cachedValueKey] = value;
        const simpleChange = {
          firstChange: this[isFirstChangeKey],
          previousValue: oldValue,
          currentValue: this[cachedValueKey],
          isFirstChange: () => this[isFirstChangeKey]
        };
        callBackFn.call(this, this[cachedValueKey], simpleChange);
      },
      get() {
        return this[cachedValueKey];
      }
    });
  };
}
let BookmarkComponent = /*#__PURE__*/(() => {
  class BookmarkComponent {
    constructor() {
      this.large = false;
      this.gemerkteIds = [];
      this.vonMerklisteEntfernen = new EventEmitter();
      this.aufMerklisteHinzufuegen = new EventEmitter();
      this.isOnMerkliste = false;
      this.ariaEntfernenTextDefault = 'Löschen aus der Merkliste';
      this.ariaHinzufuegenTextDefault = 'Hinzufügen zur Merkliste';
      this.ariaEntfernenText = ' aus der Merkliste löschen';
      this.ariaHinzufuegenText = ' zur Merkliste hinzufügen';
      this.dataBsEntfernenText = ' von der Merkliste löschen';
      this.dataBsHinzufuegenText = ' zur Merkliste hinzufügen';
      this.preTitleDefault = 'Angebot';
    }
    checkOnListe(merkliste) {
      this.isOnMerkliste = merkliste.includes(String(this.id));
    }
    toggleMerklistEntity($event) {
      $event.stopPropagation();
      if (this.isOnMerkliste) {
        this.vonMerklisteEntfernen.emit(this.id);
      } else {
        this.aufMerklisteHinzufuegen.emit(this.id);
      }
    }
    get buttonId() {
      return this.htmlId || this.id?.toString();
    }
    getAriaText() {
      return this.isOnMerkliste ? this.ariaEntfernenText : this.ariaHinzufuegenText;
    }
    getAriaTextDefault() {
      return this.isOnMerkliste ? this.ariaEntfernenTextDefault : this.ariaHinzufuegenTextDefault;
    }
    ariaLabel() {
      let preTitleOderTitle = this.preTitle || this.title;
      let titleVorhanden = !!preTitleOderTitle;
      let merklisteText = titleVorhanden ? this.getAriaText() : this.getAriaTextDefault();
      return titleVorhanden ? preTitleOderTitle + merklisteText : merklisteText;
    }
    dataBsContent() {
      return (this.preTitle || this.preTitleDefault) + (this.isOnMerkliste ? this.dataBsEntfernenText : this.dataBsHinzufuegenText);
    }
    static {
      this.ɵfac = function BookmarkComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BookmarkComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BookmarkComponent,
        selectors: [["ba-bub-bookmark"]],
        inputs: {
          id: "id",
          htmlId: "htmlId",
          title: "title",
          preTitle: "preTitle",
          large: "large",
          gemerkteIds: "gemerkteIds"
        },
        outputs: {
          vonMerklisteEntfernen: "vonMerklisteEntfernen",
          aufMerklisteHinzufuegen: "aufMerklisteHinzufuegen"
        },
        decls: 2,
        vars: 9,
        consts: [["role", "switch", "data-bs-toggle", "popover", "data-bs-placement", "top", 1, "ba-btn", "ba-btn-ghost", "ba-btn-icon-only", "ba-btn-red-ghost", "d-grid", "align-content-center", 3, "click", "id", "ngClass"], ["aria-hidden", "true", 1, "icon", 3, "ngClass"]],
        template: function BookmarkComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("click", function BookmarkComponent_Template_button_click_0_listener($event) {
              return ctx.toggleMerklistEntity($event);
            });
            i0.ɵɵelement(1, "ba-bub-icon-bookmark", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵpropertyInterpolate1("id", "merk-button-", ctx.buttonId, "");
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c16, ctx.large));
            i0.ɵɵattribute("aria-label", ctx.ariaLabel())("data-bs-content", ctx.dataBsContent())("aria-checked", ctx.isOnMerkliste);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.isOnMerkliste && "active");
          }
        },
        dependencies: [TooltipDirective, NgClass, BookmarkIconComponent],
        styles: [".ba-btn.ba-btn-ghost.ba-btn-red-ghost[_ngcontent-%COMP%]:not(:disabled){color:#b30920;background:transparent}.ba-btn.ba-btn-ghost.ba-btn-red-ghost[_ngcontent-%COMP%]:not(:disabled):not(.ba-btn-right):not(.dropdown-toggle):not(.ba-btn-block):not(.ba-loading):not(.ba-btn-next):after{background-image:linear-gradient(to bottom,transparent,transparent 2px,#660011)}.ba-btn.ba-btn-ghost.ba-btn-red-ghost[_ngcontent-%COMP%]:not(:disabled):not(.ba-btn-right):not(.dropdown-toggle):not(.ba-btn-block):not(.ba-loading):not(.ba-btn-next):hover, .ba-btn.ba-btn-ghost.ba-btn-red-ghost[_ngcontent-%COMP%]:not(:disabled):not(.ba-btn-right):not(.dropdown-toggle):not(.ba-btn-block):not(.ba-loading):not(.ba-btn-next):focus{color:#601}.ba-btn.ba-btn-ghost.ba-btn-red-ghost.ba-btn-block[_ngcontent-%COMP%]:not(:disabled)   span[_ngcontent-%COMP%]:after{background-image:linear-gradient(to bottom,transparent,transparent 2px,#660011)}.ba-btn.ba-btn-ghost.ba-btn-red-ghost.ba-btn-block[_ngcontent-%COMP%]:hover, .ba-btn.ba-btn-ghost.ba-btn-red-ghost.ba-btn-block[_ngcontent-%COMP%]:focus{color:#601}.ba-btn-icon-only[_ngcontent-%COMP%]:before{font-size:1.25em}ba-bub-icon-bookmark[_ngcontent-%COMP%]{--bookmark-icon-background: transparent;--bookmark-icon-outline-color: #B30920;--bookmark-icon-width: 25px}ba-bub-icon-bookmark.active[_ngcontent-%COMP%]{--bookmark-icon-background: #B30920}[_ngcontent-%COMP%]:hover   ba-bub-icon-bookmark[_ngcontent-%COMP%]:not(.active){--bookmark-icon-background: #FDC4C4}[_ngcontent-%COMP%]:hover   ba-bub-icon-bookmark.active[_ngcontent-%COMP%]{--bookmark-icon-background: #660011;--bookmark-icon-outline-color: #660011}\n\n"]
      });
    }
  }
  __decorate([OnChange('checkOnListe')], BookmarkComponent.prototype, "gemerkteIds", void 0);
  return BookmarkComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BookmarkModule = /*#__PURE__*/(() => {
  class BookmarkModule {
    static {
      this.ɵfac = function BookmarkModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BookmarkModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: BookmarkModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TooltipModule, BookmarkIconModule]
      });
    }
  }
  return BookmarkModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EmptyStateImageComponent = /*#__PURE__*/(() => {
  class EmptyStateImageComponent {
    static {
      this.ɵfac = function EmptyStateImageComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EmptyStateImageComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EmptyStateImageComponent,
        selectors: [["ba-bub-empty-state-image"]],
        decls: 12,
        vars: 0,
        consts: [["id", "Layer_1", "data-name", "Layer 1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "viewBox", "0 0 505 505", 2, "max-height", "120px", "width", "100%"], ["id", "linear-gradient", "x1", "134.42", "y1", "363.9", "x2", "319.17", "y2", "195.64", "gradientTransform", "matrix(1, 0, 0, -1, 0, 506)", "gradientUnits", "userSpaceOnUse"], ["offset", "0", "stop-color", "#fff"], ["offset", "1", "stop-color", "#e9f3fc"], ["d", "M500,250c0,138.07-111.93,250-250,250S0,388.07,0,250,111.93,0,250,0,500,111.93,500,250Z", 1, "cls-1"], ["d", "M128.58,128.41a131.9,131.9,0,1,1,0,186.57A131.9,131.9,0,0,1,128.58,128.41Z", 1, "cls-2"], ["d", "M355.49,270.5l-85,85s30.22-9.44,73.66,5.67c7.31,2.54,19.54-9.69,17-17C346.05,300.72,355.49,270.5,355.49,270.5ZM337.54,388.44a36,36,0,0,1,50.9-50.9L504.38,453.48c3.11,3.12-5.75,17.06-19.8,31.1s-28,22.91-31.1,19.8ZM212.14,179.49c-4.42,3.26-7.29,8.84-7.11,16.47a8,8,0,0,1-16,.38c-.33-13.92,5.55-23.79,13.62-29.75,13.47-9.93,33.54-8.6,44.46,3.7,4.68,5.27,7.83,12.55,7.91,22,.13,16.05-6.67,25.74-14,35.45l-.78,1c-5.28,6.92-10.72,14.07-11.36,25.94a8,8,0,0,1-16-.88c.89-16.39,8.13-26.21,15.37-35.76l.49-.66c5.22-6.86,10.38-13.64,10.29-25,0-4.89-1.44-8.75-3.86-11.48C229.48,174.58,219.09,174.36,212.14,179.49Zm17.8,102.66a9.86,9.86,0,1,1-9.86-9.85A9.86,9.86,0,0,1,229.94,282.15ZM340.33,60.79l16.28-43.68a8,8,0,1,0-15-5.59L325.35,55.2a8,8,0,0,0,15,5.59Zm42.34,36.59L465.3,26.73a8,8,0,0,0-10.38-12.16L372.28,85.22a8,8,0,0,0,10.39,12.16Zm92,27.32-63.93,16a8,8,0,0,1-3.88-15.51l63.93-16a8,8,0,1,1,3.88,15.52Z", 1, "cls-3"], ["d", "M117.33,117.33a148,148,0,1,1,0,209.34A148.09,148.09,0,0,1,117.33,117.33Zm17,17a124,124,0,1,1,0,175.4A124.09,124.09,0,0,1,134.3,134.3Z", 1, "cls-4"], ["d", "M89.38,287.82a148.06,148.06,0,0,1,188.19-203q.58,7.35.59,14.89,0,5.81-.35,11.54a124.06,124.06,0,0,0-162,174.86A190.7,190.7,0,0,1,90,287.82ZM337.54,388.44a36,36,0,0,1,50.9-50.9L493.37,442.47c3.12,3.12-5.75,17.06-19.79,31.1s-28,22.92-31.11,19.8Z", 1, "cls-5"]],
        template: function EmptyStateImageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(0, "svg", 0)(1, "defs")(2, "style");
            i0.ɵɵtext(3, ".cls-1{fill:#020e25;fill-opacity:0.04;}.cls-2,.cls-3,.cls-4,.cls-5{fill-rule:evenodd;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#305c73;}.cls-4{fill:#95acbc;}.cls-5{fill:#d9e1ed;}");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "linearGradient", 1);
            i0.ɵɵelement(5, "stop", 2)(6, "stop", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(7, "path", 4)(8, "path", 5)(9, "path", 6)(10, "path", 7)(11, "path", 8);
            i0.ɵɵelementEnd();
          }
        },
        encapsulation: 2
      });
    }
  }
  return EmptyStateImageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SuchergebnisEmptyStateComponent = /*#__PURE__*/(() => {
  class SuchergebnisEmptyStateComponent {
    constructor() {}
    static {
      this.ɵfac = function SuchergebnisEmptyStateComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SuchergebnisEmptyStateComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SuchergebnisEmptyStateComponent,
        selectors: [["ba-bub-suchergebnis-empty-state"]],
        decls: 16,
        vars: 0,
        consts: [[1, "ba-layout-tile", "d-flex", "flex-column", "align-items-center", "gap-2"], ["aria-live", "polite", 1, "h3", "mt-3", "text-center"], [1, "d-flex", "flex-column", "gap-2"], [1, "d-flex"], [1, "text-center"]],
        template: function SuchergebnisEmptyStateComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "article", 0);
            i0.ɵɵelement(1, "ba-bub-empty-state-image");
            i0.ɵɵelementStart(2, "h2", 1);
            i0.ɵɵtext(3, "Keine Ergebnisse f\xFCr die Suche");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "ul", 2)(5, "li", 3)(6, "ba-bub-check-chip");
            i0.ɵɵtext(7, "Sucheingaben \xFCberpr\xFCfen");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "li", 3)(9, "ba-bub-check-chip");
            i0.ɵɵtext(10, "Gesetzte Filter \xFCberpr\xFCfen");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(11, "li", 3)(12, "ba-bub-check-chip");
            i0.ɵɵtext(13, "Bei Ortseingabe Umkreis anpassen");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(14, "p", 4);
            i0.ɵɵtext(15, " Es kann immer vorkommen, dass aktuell keine betreffenden Angebote in der Datenbank vorliegen. ");
            i0.ɵɵelementEnd()();
          }
        },
        dependencies: [EmptyStateImageComponent, CheckChipComponent],
        encapsulation: 2
      });
    }
  }
  return SuchergebnisEmptyStateComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SuchergebnisEmptyStateModule = /*#__PURE__*/(() => {
  class SuchergebnisEmptyStateModule {
    static {
      this.ɵfac = function SuchergebnisEmptyStateModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SuchergebnisEmptyStateModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: SuchergebnisEmptyStateModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, ChipsModule]
      });
    }
  }
  return SuchergebnisEmptyStateModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UiComponentsModule = /*#__PURE__*/(() => {
  class UiComponentsModule {
    static {
      this.ɵfac = function UiComponentsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiComponentsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: UiComponentsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [AccordionModule, CommonModule, CheckboxModule, ChipsModule, CollapseModule, DropdownModule, Error404Module, SuchergebnisEmptyStateModule, InputrangeModule, LoadSpinnerModule, ModalModule, SwitchModule, TypeaheadModule, BildSliderModule, BookmarkIconModule, BookmarkModule, AccordionModule, CheckboxModule, ChipsModule, CollapseModule, DropdownModule, Error404Module, SuchergebnisEmptyStateModule, InputrangeModule, LoadSpinnerModule, ModalModule, SwitchModule, TypeaheadModule, BildSliderModule, BookmarkIconModule, BookmarkModule]
      });
    }
  }
  return UiComponentsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HeaderComponent = /*#__PURE__*/(() => {
  class HeaderComponent {
    constructor() {
      /**
       * Steuert die Anzeige des Sprachselektors im Portalheader über das
       * Attribut with-lang-switch der Webcomponent
       * @see https://bitbucket.webapp.sdst.sbaintern.de/projects/HEADER-FOOTER/repos/webcomponent/browse/src/components/bahf-header-v5
       */
      this.langSwitchEnabled = true;
    }
    static {
      this.ɵfac = function HeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HeaderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HeaderComponent,
        selectors: [["ba-bub-header"]],
        inputs: {
          langSwitchEnabled: "langSwitchEnabled"
        },
        decls: 2,
        vars: 1,
        consts: [["with-cookie-disclaimer", "true"]],
        template: function HeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "bahf-header", 0)(1, "bahf-fallback-header");
          }
          if (rf & 2) {
            i0.ɵɵattribute("with-lang-switch", ctx.langSwitchEnabled);
          }
        },
        encapsulation: 2
      });
    }
  }
  return HeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FooterComponent = /*#__PURE__*/(() => {
  class FooterComponent {
    static {
      this.ɵfac = function FooterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FooterComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FooterComponent,
        selectors: [["ba-bub-footer"]],
        decls: 2,
        vars: 0,
        template: function FooterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "bahf-footer")(1, "bahf-fallback-footer");
          }
        },
        encapsulation: 2
      });
    }
  }
  return FooterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// Quelle: http://bitbucket.webapp.sdst.sbaintern.de/projects/SET/repos/set-client2/browse/src/app/shared/dom/script-injector.service.ts
let ScriptInjectorService = /*#__PURE__*/(() => {
  class ScriptInjectorService {
    /**
     * Konstruktor - sollte jedoch injected werden
     */
    constructor(htmlDocument) {
      this.htmlDocument = htmlDocument;
    }
    /**
     * Injiziert das Script in das DOM.
     *
     * Der Service soll in einer Komponente verwendet werden. Wenn vom finalizer "next()" aufgerufen wird,
     * dann wird das Script wieder aus dem DOM entfernt. Eine Komponente muss ein Subject anlegen und im
     * ngOnDestroy dieses Subject mit next() und complete() aufrufen um das Script wieder zu entfernen.
     *
     * @param pathToScript das JS script so wie es vom Browser zur Ausführung geladen werden kann.
     * @param scriptIdentifier muss im Script-Pfad beinhaltet sein, jedoch unveränderlich sein um das script
     * wieder auffinden zu können. Beispielsweise wird ggf. der Port entfernt, wenn es einer der Standards ist. Der
     * Identifier muss in dem Fall geeignet sein das Script trotzdem wieder aufzufinden.
     * @param finalizer Entfernt das Script aus dem DOM wenn dieses Observable completed.
     * @returns liefert true wenn das Script erfolgreich eingebettet werden konnte, sonst false.
     */
    inject(pathToScript, scriptIdentifier, module, finalizer) {
      // script einbetten
      const isEmbedded = this.injectScript(pathToScript, module);
      // beim Beenden wieder entfernen
      if (!!finalizer) {
        finalizer.pipe(take(1)).subscribe(() => this.removeScript(scriptIdentifier));
      }
      return isEmbedded;
    }
    /**
     * Findet das eingebettete, zugehörige JS script element oder returniert "null"
     */
    queryScriptElement(scriptIdentifier) {
      if (this.htmlDocument) {
        const scripts = this.htmlDocument.getElementsByTagName('script');
        if (scripts) {
          // finde das richtige Script Element
          for (let i = 0; i < scripts.length; i++) {
            const script = scripts.item(i);
            if (script && script.src && script.src.indexOf(scriptIdentifier) > -1) {
              return script;
            }
          }
        }
      }
      return null;
    }
    /**
     * Script im DOM einbetten
     */
    injectScript(pathToScript, module) {
      const bodyElement = this.queryBodyElement();
      if (this.htmlDocument) {
        const scriptElement = this.htmlDocument.createElement('script');
        if (module) {
          scriptElement.type = 'module';
        } else {
          scriptElement.noModule = true;
          scriptElement.type = 'text/javascript';
        }
        scriptElement.async = true;
        scriptElement.defer = true;
        scriptElement.src = pathToScript;
        bodyElement.appendChild(scriptElement);
        return true;
      }
      return false;
    }
    /**
     * Script aus dem DOM entfernen
     */
    removeScript(scriptId) {
      const bodyElement = this.queryBodyElement();
      const script = this.queryScriptElement(scriptId);
      if (script && bodyElement) {
        bodyElement.removeChild(script);
      }
    }
    /**
     * Suche das Element mit sem <body> Tag im HTML Document
     */
    queryBodyElement() {
      if (this.htmlDocument) {
        const body = this.htmlDocument.getElementsByTagName('body');
        if (body) {
          return body[0];
        }
      }
      return null;
    }
    static {
      this.ɵfac = function ScriptInjectorService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ScriptInjectorService)(i0.ɵɵinject(DOCUMENT));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ScriptInjectorService,
        factory: ScriptInjectorService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ScriptInjectorService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OiamComponent = /*#__PURE__*/(() => {
  class OiamComponent {
    constructor(document, router, scriptInjectorService) {
      this.document = document;
      this.router = router;
      this.scriptInjectorService = scriptInjectorService;
      this.conf = window.infosysbubLibConfig;
      this.oauthConfig = {
        clientid: this.conf?.clientId,
        redirecturi: this.conf?.redirecturi,
        logouturi: this.conf?.logouturi,
        customstate: ''
      };
      // dynamically load oiam-oauth-wc from path given in app-config
      const oiamOauthWcUrl = this.conf?.oiamOauthWcUrl ?? 'https://web.dev.ocp.webapp.idst.ibaintern.de/websso-master/oiam-oauth-wc/v1';
      this.addComponentScript(oiamOauthWcUrl, '/oiam-oauth-wc.esm.js', '/oiam-oauth-wc.js');
      this.document.defaultView.addEventListener('oiamLoadedEvent', () => {
        //Set initially the config
        return this.setConfig();
      }, {
        once: true
      });
      this.document.defaultView.addEventListener('oiamCustomStateEvent', e =>
      // Redirect after a login event to the content of the customstate
      this.processCustomState(e));
      router.events.subscribe(urlChangeEvent => {
        //Observe url changes and store the url in the customstate
        if (urlChangeEvent instanceof NavigationEnd) {
          this.oauthConfig.customstate = urlChangeEvent.url;
          this.setConfig();
        }
      });
    }
    /**
     * Die Methode schickt ein oiamSetConfigEvent, dass von der oiam Komponente verstanden wird.
     * Manche parameter, wie die redirect url werden nur beim ersten mal gesetzt. Andere Parameter, wie der customstate werden überschrieben.
     */
    setConfig() {
      return this.document.defaultView.dispatchEvent(new CustomEvent('oiamSetConfigEvent', {
        detail: this.oauthConfig
      }));
    }
    /**
     * Redirect after a login event to the content of the customstate
     * @param e
     * @private
     */
    processCustomState(e) {
      const target = e.detail.customstate;
      this.router.navigateByUrl(target);
    }
    /**
     * Add a web component dynamically to the head of the html document
     *
     * @param base
     * @param module
     * @param nomodule
     * @private
     */
    addComponentScript(base, module, nomodule) {
      this.scriptInjectorService.inject(base + module, 'oiam-oauth-wc-module', true);
      this.scriptInjectorService.inject(base + nomodule, 'oiam-oauth-wc-nomodule', false);
    }
    static {
      this.ɵfac = function OiamComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OiamComponent)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1$2.Router), i0.ɵɵdirectiveInject(ScriptInjectorService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OiamComponent,
        selectors: [["ba-bub-oiam"]],
        decls: 1,
        vars: 0,
        template: function OiamComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "oiam-oauth-component");
          }
        },
        encapsulation: 2
      });
    }
  }
  return OiamComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MainLayoutComponent = /*#__PURE__*/(() => {
  class MainLayoutComponent {
    constructor(scriptInjectorService, zone) {
      this.scriptInjectorService = scriptInjectorService;
      this.zone = zone;
      /**
       * Optionaler Parameter, der es ermöglicht, im APOK-Header,
       * das Language-Dropdown-Menü zu entfernen.
       *
       * Default: Menü wird angezeigt.
       */
      this.showLanguageDropdown = true;
      this.headerFooterBaseUrl = window.infosysbubLibConfig.headerFooterBaseUrl;
    }
    /**
     * Sprunglink zur Verbesserung der Barrierefreiheit.
     */
    goTo(location) {
      // Zurücksetzen der Location, da sonst bei der Einsprung nur einmal ausgeführt werden kann.
      window.location.hash = '';
      window.location.hash = location;
    }
    ngOnInit() {
      // Manipuliere DOM-Objekte, die keine Angular-Komponenten sind,
      // daher zur Performance-Verbesserung, außerhalb der NgZone ausführen.
      this.zone.runOutsideAngular(() => {
        this.initializeApokHeaderFooter();
        this.fixHeaderCss();
        MainLayoutComponent.initializeDpl3();
      });
    }
    initializeApokHeaderFooter() {
      defineCustomElements();
      this.scriptInjectorService.inject(this.headerFooterBaseUrl + '/hf/releases/v6.x/bahf-webcomponents/bahf-webcomponents.esm.js', 'header-footer-script-module', true);
      this.scriptInjectorService.inject(this.headerFooterBaseUrl + '/hf/releases/v6.x/bahf-webcomponents/bahf-webcomponents.js', 'header-footer-script', false);
    }
    static initializeDpl3() {
      // https://bitbucket.webapp.sdst.sbaintern.de/projects/BAPF/repos/bapf-dpl3/browse/source/js/app.js#177
      // @ts-ignore
      window.dpl.global.init();
    }
    /**
     * Passe APOK-Header an die Breite bei InfoSysBub an
     *
     * Übernommen von Jobbörse:
     * https://bitbucket.webapp.sdst.sbaintern.de/projects/VAMAPOK/repos/jobboerse-jobsuche-ui
     * /browse/src/app/browser-shared/components/header/header.component.ts#20-43
     */
    fixHeaderCss() {
      // der header liegt im shadow dom und muss deshalb via js manipuliert werden
      const interval = setInterval(() => {
        const shadowRootHeader = document.querySelector('bahf-header')?.shadowRoot;
        const shadowRootFooter = document.querySelector('bahf-footer')?.shadowRoot;
        if (shadowRootHeader && shadowRootFooter) {
          this.addStyleToApokHeader(shadowRootHeader);
          this.addStyleToApokFooter(shadowRootFooter);
          clearInterval(interval);
        }
      }, 150);
    }
    addStyleToApokFooter(shadowRootFooter) {
      const styleFooter = document.createElement('style');
      styleFooter.innerHTML = '.container-fluid { max-width: var(--container-max-width) !important; } ';
      shadowRootFooter.appendChild(styleFooter);
    }
    addStyleToApokHeader(shadowRootHeader) {
      const styleHeader = document.createElement('style');
      styleHeader.innerHTML = '.container-fluid, .ba-flyout-container { max-width: var(--container-max-width) !important; } ';
      shadowRootHeader.appendChild(styleHeader);
    }
    static {
      this.ɵfac = function MainLayoutComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MainLayoutComponent)(i0.ɵɵdirectiveInject(ScriptInjectorService), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MainLayoutComponent,
        selectors: [["ba-bub-main-layout"]],
        inputs: {
          showLanguageDropdown: "showLanguageDropdown"
        },
        ngContentSelectors: _c0,
        decls: 9,
        vars: 1,
        consts: [["role", "navigation", "aria-label", "Sprunglinks", 1, "ba-jumpnav"], ["href", "javascript:void(0);", "tabindex", "0", 3, "click"], [1, "d-print-none", 3, "langSwitchEnabled"], ["id", "main"], [1, "d-print-none"], ["tabindex", "-1", "href", "#", "title", "nach oben", "aria-hidden", "true", 1, "ba-scroll-to-top"]],
        template: function MainLayoutComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "nav", 0)(1, "a", 1);
            i0.ɵɵlistener("click", function MainLayoutComponent_Template_a_click_1_listener() {
              return ctx.goTo("main");
            });
            i0.ɵɵtext(2, "zu den Hauptinhalten springen");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(3, "ba-bub-header", 2);
            i0.ɵɵelementStart(4, "main", 3);
            i0.ɵɵprojection(5);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(6, "ba-bub-footer", 4)(7, "a", 5)(8, "ba-bub-oiam");
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("langSwitchEnabled", ctx.showLanguageDropdown);
          }
        },
        dependencies: [HeaderComponent, FooterComponent, OiamComponent],
        styles: ["@charset \"UTF-8\";:root{--container-max-width: 1600px}.container-fluid,.ba-contact-infobox{max-width:var(--container-max-width)}.ba-content-header .ba-content-wrap{max-width:calc(var(--container-max-width) - 48px)}.ba-scroll-to-top.visible{opacity:.45;z-index:100}.ba-scroll-to-top:focus,.ba-scroll-to-top:hover{text-decoration:none;opacity:1}@media print{a.ba-scroll-to-top.visible{display:none}.ba-unhide-for-measure{display:none!important;visibility:hidden!important}}\n", "@media print{:root{font-size:12px;--bs-body-font-size: 12px;--bs-body-bg: white;background-color:var(--bs-body-bg)}*{-webkit-print-color-adjust:exact!important;print-color-adjust:exact!important}.ba-breadcrumb{display:none}.container-fluid{padding-inline:0}h2{font-size:1.75rem}dl>div{break-inside:avoid-page}.text-truncate{overflow:auto;white-space:normal;overflow-wrap:break-word}.ba-layout-tile,.ba-tile{box-shadow:none;border:solid 1px white;padding:0;padding-right:2rem;margin-bottom:1rem;break-inside:avoid;-webkit-box-decoration-break:clone;box-decoration-break:clone}h2,h3,h4,h5,h6,.h2,.h3,.h4,.h5,.h6{break-after:avoid;margin-bottom:4px;margin-top:8px}hr{break-after:avoid;column-span:all}.page-break-before-always{page-break-before:always}.column-count-2{column-count:2}.column-count-3{column-count:3}.column-count-4{column-count:4}}@media print and (min-width: 7cm) and (max-width: 12cm){.col-md-1{flex:0 0 auto;width:calc(8.3333333333% * 1)}.col-md-2{flex:0 0 auto;width:calc(8.3333333333% * 2)}.col-md-3{flex:0 0 auto;width:calc(8.3333333333% * 3)}.col-md-4{flex:0 0 auto;width:calc(8.3333333333% * 4)}.col-md-5{flex:0 0 auto;width:calc(8.3333333333% * 5)}.col-md-6{flex:0 0 auto;width:calc(8.3333333333% * 6)}.col-md-7{flex:0 0 auto;width:calc(8.3333333333% * 7)}.col-md-8{flex:0 0 auto;width:calc(8.3333333333% * 8)}.col-md-9{flex:0 0 auto;width:calc(8.3333333333% * 9)}.col-md-10{flex:0 0 auto;width:calc(8.3333333333% * 10)}.col-md-11{flex:0 0 auto;width:calc(8.3333333333% * 11)}.col-md-12{flex:0 0 auto;width:calc(8.3333333333% * 12)}}@media print and (min-width: 12cm){.col-lg-1{flex:0 0 auto;width:calc(8.3333333333% * 1)}.col-lg-2{flex:0 0 auto;width:calc(8.3333333333% * 2)}.col-lg-3{flex:0 0 auto;width:calc(8.3333333333% * 3)}.col-lg-4{flex:0 0 auto;width:calc(8.3333333333% * 4)}.col-lg-5{flex:0 0 auto;width:calc(8.3333333333% * 5)}.col-lg-6{flex:0 0 auto;width:calc(8.3333333333% * 6)}.col-lg-7{flex:0 0 auto;width:calc(8.3333333333% * 7)}.col-lg-8{flex:0 0 auto;width:calc(8.3333333333% * 8)}.col-lg-9{flex:0 0 auto;width:calc(8.3333333333% * 9)}.col-lg-10{flex:0 0 auto;width:calc(8.3333333333% * 10)}.col-lg-11{flex:0 0 auto;width:calc(8.3333333333% * 11)}.col-lg-12{flex:0 0 auto;width:calc(8.3333333333% * 12)}}@media print{.col-print-1{flex:0 0 auto;width:calc(8.3333333333% * 1)}.col-print-2{flex:0 0 auto;width:calc(8.3333333333% * 2)}.col-print-3{flex:0 0 auto;width:calc(8.3333333333% * 3)}.col-print-4{flex:0 0 auto;width:calc(8.3333333333% * 4)}.col-print-5{flex:0 0 auto;width:calc(8.3333333333% * 5)}.col-print-6{flex:0 0 auto;width:calc(8.3333333333% * 6)}.col-print-7{flex:0 0 auto;width:calc(8.3333333333% * 7)}.col-print-8{flex:0 0 auto;width:calc(8.3333333333% * 8)}.col-print-9{flex:0 0 auto;width:calc(8.3333333333% * 9)}.col-print-10{flex:0 0 auto;width:calc(8.3333333333% * 10)}.col-print-11{flex:0 0 auto;width:calc(8.3333333333% * 11)}.col-print-12{flex:0 0 auto;width:calc(8.3333333333% * 12)}}\n"],
        encapsulation: 2
      });
    }
  }
  return MainLayoutComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OiamModule = /*#__PURE__*/(() => {
  class OiamModule {
    static {
      this.ɵfac = function OiamModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OiamModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OiamModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return OiamModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MainLayoutModule = /*#__PURE__*/(() => {
  class MainLayoutModule {
    static {
      this.ɵfac = function MainLayoutModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MainLayoutModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MainLayoutModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [ScriptInjectorService],
        imports: [CommonModule, OiamModule]
      });
    }
  }
  return MainLayoutModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generalisierte Umsetzung der Sicherheitsmaßnahme M-118
 * Direktive zum Setzen von rel="noreferrer", wenn das HTML-Attribut target="_blank" gesetzt ist.
 * Beim Öffnen eines neuen Tabs per target="_blank" darf kein Referrer gesetzt sein. Diese Direktive wird überall aktiv,
 * wo die ng-lib eingebunden ist und gilt damit automatisch.
 */
let NoReferrerDirective = /*#__PURE__*/(() => {
  class NoReferrerDirective {
    constructor(el, renderer) {
      this.el = el;
      this.renderer = renderer;
      const target = this.el.nativeElement.getAttribute('target');
      if (target === '_blank') {
        this.renderer.setAttribute(this.el.nativeElement, 'rel', 'noreferrer');
      }
    }
    static {
      this.ɵfac = function NoReferrerDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NoReferrerDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NoReferrerDirective,
        selectors: [["", "target", ""]]
      });
    }
  }
  return NoReferrerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MinimalCoreModule = /*#__PURE__*/(() => {
  class MinimalCoreModule {
    static {
      this.ɵfac = function MinimalCoreModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MinimalCoreModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MinimalCoreModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [CookieService],
        imports: [CommonModule, TooltipModule, TooltipModule]
      });
    }
  }
  return MinimalCoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Diese Komponente händelt die Authentifizierung am OAG.
 * Sie soll nach der Umstellung auf OIDC die @websso/ba-oauthlib ersetzten.
 **/
let XapikeyInterceptor = /*#__PURE__*/(() => {
  class XapikeyInterceptor {
    intercept(request, next) {
      const clientId = window.infosysbubLibConfig.clientId;
      const reqWithXapiKey = request.clone({
        setHeaders: {
          'X-API-Key': clientId
        }
      });
      return next.handle(reqWithXapiKey);
    }
    static {
      this.ɵfac = function XapikeyInterceptor_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || XapikeyInterceptor)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: XapikeyInterceptor,
        factory: XapikeyInterceptor.ɵfac
      });
    }
  }
  return XapikeyInterceptor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Funktion zur Rückgabe des Providers für den XapikeyInterceptor.
 *
 * Diese wird für die Applikationen ab Angular 17 ohne Module verwende, die mit
 * der Moduleeinbildung nichts anfangen können.
 *
 * @return Array mit den Provider-Angaben für den XapikeyInterceptor.
 */
function provideXapikeyInterceptor() {
  return [{
    provide: HTTP_INTERCEPTORS,
    useClass: XapikeyInterceptor,
    multi: true
  }];
}
/**
 * Enthält einen Http-Interceptor fürs Setzen des Xapikey Headers zur Authentifizierung am OAG.
 */
let XapikeyModule = /*#__PURE__*/(() => {
  class XapikeyModule {
    static {
      this.ɵfac = function XapikeyModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || XapikeyModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: XapikeyModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: provideXapikeyInterceptor()
      });
    }
  }
  return XapikeyModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CoreModule = /*#__PURE__*/(() => {
  class CoreModule {
    static {
      this.ɵfac = function CoreModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoreModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CoreModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MinimalCoreModule, XapikeyModule, MinimalCoreModule]
      });
    }
  }
  return CoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function ersetzeUmlauteUndScharfS(s) {
  s = s.toLowerCase();
  s = s.replace('ä', 'a');
  s = s.replace('ö', 'o');
  s = s.replace('ü', 'u');
  s = s.replace('ß', 'ss');
  return s;
}
function istABisFKlein(charCode) {
  return charCode >= 97 && charCode <= 102;
}
function istGBisLKlein(charCode) {
  return charCode >= 103 && charCode <= 108;
}
function istMBisRKlein(charCode) {
  return charCode >= 109 && charCode <= 114;
}
function istSBisZKlein(charCode) {
  return charCode >= 115 && charCode <= 122;
}
function istABisFGross(charCode) {
  return charCode >= 65 && charCode <= 70;
}
function istGBisLGross(charCode) {
  return charCode >= 71 && charCode <= 76;
}
function istMBisRGross(charCode) {
  return charCode >= 77 && charCode <= 82;
}
function istSBisZGross(charCode) {
  return charCode >= 83 && charCode <= 90;
}
function istSonderzeichen(charCode) {
  return charCode <= 64 || charCode >= 123 || charCode >= 91 && charCode <= 96;
}
function istInABisFOderSonderzeichen(charCode) {
  return istABisFKlein(charCode) || istABisFGross(charCode) || istSonderzeichen(charCode);
}
function istInGBisL(charCode) {
  return istGBisLKlein(charCode) || istGBisLGross(charCode);
}
function istInMBisR(charCode) {
  return istMBisRKlein(charCode) || istMBisRGross(charCode);
}
function istInSBisZ(charCode) {
  return istSBisZKlein(charCode) || istSBisZGross(charCode);
}
const vergleicheErstenBuchstaben = (a, b) => {
  if (a.ausgewaehlt && !b.ausgewaehlt) {
    return -1;
  }
  if (!a.ausgewaehlt && b.ausgewaehlt) {
    return 1;
  }
  const aNormalisiert = ersetzeUmlauteUndScharfS(a.name);
  const bNormalisiert = ersetzeUmlauteUndScharfS(b.name);
  // Sonderzeichen werden an den Anfang sortiert
  if (aNormalisiert.charCodeAt(0) < 48 || aNormalisiert.charCodeAt(0) > 57 && aNormalisiert.charCodeAt(0) < 97 || aNormalisiert.charCodeAt(0) > 122) {
    return -1;
  } else if (bNormalisiert.charCodeAt(0) < 48 || bNormalisiert.charCodeAt(0) > 57 && bNormalisiert.charCodeAt(0) < 97 || bNormalisiert.charCodeAt(0) > 122) {
    return 1;
  }
  if (aNormalisiert > bNormalisiert) {
    return 1;
  }
  if (aNormalisiert < bNormalisiert) {
    return -1;
  }
  return 0;
};
function hatValideAnzahlAnEintraegen(buchstabenKategorie, anbieterNachBuchstabenKategorie) {
  return anbieterNachBuchstabenKategorie[buchstabenKategorie].length > 0 && anbieterNachBuchstabenKategorie[buchstabenKategorie].length < 16;
}
function ersteKategorieMitValiderAnzahlAnEintraegen(anbieterNachBuchstabenKategorie) {
  return Object.keys(anbieterNachBuchstabenKategorie).filter(buchstabenKategorie => buchstabenKategorie !== 'alle').find(buchstabenKategorie => hatValideAnzahlAnEintraegen(buchstabenKategorie, anbieterNachBuchstabenKategorie)) || 'aBisF';
}

// kürzt ein html ohne dessen struktur zu zerstören
function kuerzeHtml(html, maxZeichen, maxZeilen) {
  return new ContentClipHelper().clipContent(html, maxZeichen, maxZeilen);
}
// Adaption des ContentClipHelper von AVGS-Server
class ContentClipHelper {
  constructor() {
    /**
     * Menge von Tags, die als "neue Zeile" gezählt werden.
     */
    this.linebreaks = new Set(['h4', 'br', 'p', 'li']);
    /**
     * Stringbuilder für die Speicherung des Ergebnistextes.
     */
    this.sb = '';
    /**
     * Stringbuilder, in den das aktuelle Tag eingelesen wird.
     */
    this.tag = '';
    /**
     * Stack mit den aktuell geöffneten Tags.
     */
    this.stack = [];
  }
  /**
   * Kürzt den übergebenen HTML-Text bei Bedarf auf die angegebene Anzahl Zeichen + Zeilen.
   *
   * Tags werden nicht als Zeichen gezählt. Als Zeile zählt jedes "p", "br", "h4" oder "li" Element.
   *
   * Etwaige geöffnete Tags werden ordnungsgemäß geschlossen, um einen validen gekürzten Text zu erhalten.
   *
   * @param inhalt
   *            Der ggf. zu kürzende Textinhalt.
   * @param maxZeichen
   *            Die maximale Zeichenzahl im Textinhalt.
   * @param maxZeilen
   *            Die maximale Zeilenzahl im Textinhalt.
   * @return Der ggf. gekürzte HTML-Text.
   */
  clipContent(inhalt, maxZeichen, maxZeilen) {
    this.resetState();
    if (inhalt != null) {
      for (let i = 0; i < inhalt.length; i++) {
        const currentChar = inhalt.charAt(i);
        if (currentChar === '<') {
          this.isInTag = true;
        } else if (this.isInTag) {
          this.parseTag(currentChar);
        } else {
          this.textLength++;
        }
        if (this.textLength > maxZeichen || this.lines > maxZeilen) {
          if (this.lines > maxZeilen) {
            this.sb += currentChar;
          }
          this.sb += '&hellip;';
          this.writeClosingTags();
          break;
        }
        this.sb += currentChar;
        this.previousChar = currentChar;
      }
    }
    return this.sb.toString();
  }
  /**
   * Initialisiert das Objekt für einen neuen Durchgang.
   */
  resetState() {
    this.sb = '';
    this.tag = '';
    this.stack = [];
    this.isInTag = false;
    this.isClosingTag = false;
    this.isSelfclosingTag = false;
    this.textLength = 0;
    this.previousChar = '0';
    this.lines = 0;
  }
  /**
   * Führt das Parsen des Textes innerhalb eines HTML-Tags durch.
   *
   * @param currentChar
   *            Das aktuelle Zeichen im Akzeptor.
   */
  parseTag(currentChar) {
    if (currentChar === '>') {
      this.finalizeParsedTag();
    } else if (currentChar === '/') {
      this.isClosingTag = this.previousChar === '<';
    } else {
      this.tag += currentChar;
    }
  }
  /**
   * Schließt das Parsen eines HTML-Tags ab (letztes Zeichen ">" im Tag).
   */
  finalizeParsedTag() {
    // wenn <br> statt <br/> geliefert wird, soll kein schließendes </br> eingefügt werden, da das im Browser
    // als zusätzliches <br> interpretiert wird
    this.isSelfclosingTag = this.previousChar === '/' || this.tag === 'br';
    const tagName = this.tag;
    if (this.isClosingTag) {
      this.handleClosingTag(tagName);
    } else {
      this.handleOpeningOrSelfClosingTag(tagName);
    }
    this.tag = '';
    this.isSelfclosingTag = false;
    this.isClosingTag = false;
    this.isInTag = false;
  }
  /**
   * Behandelt ein schließendes HTML-Tag.
   *
   * @param tagName
   *            Name des zu schließenden Tags.
   */
  handleClosingTag(tagName) {
    const pop = this.stack.pop();
    if (tagName !== pop) {
      // console.log('closing tag "' + tagName + '" while tag "' + pop + '" was open');
    }
  }
  /**
   * Behandelt ein öffnendes HTML-Tag oder eines, das für sich alleine steht ("self-closing").
   *
   * @param tagName
   *            Name des zu öffnenden Tags.
   */
  handleOpeningOrSelfClosingTag(tagName) {
    if (!this.isSelfclosingTag) {
      // opening tag
      this.stack.push(tagName);
    }
    if (this.linebreaks.has(tagName)) {
      this.lines++;
    }
  }
  /**
   * Fügt alle derzeit noch offenen Tags als Strings an den Ausgabepuffer an.
   */
  writeClosingTags() {
    while (this.stack.length > 0) {
      this.sb += '</' + this.stack.pop() + '>';
    }
  }
}
function ordneStringInBuchstabenKategorie(label, ordneBuchstabenEin) {
  return ordneBuchstabenEin(ersetzeUmlauteUndScharfS(label).charCodeAt(0));
}
const trackByItemKey = (_, {
  key
}) => key;

/**
 * Schneidet zu langen Text ab und punktet das Ende dabei aus.
 *
 * Diese Pipe ist impure, da sie nicht nur abhängig von ihren direkten Eingabeparametern ist,
 * sondern auch von der Breite des Eltern-Containers.
 */
class TruncatePipe {
  static {
    this.canvasRenderingContext2D = document.createElement('canvas').getContext('2d');
  }
  constructor(ref, changeDetection) {
    this.ref = ref;
    this.changeDetection = changeDetection;
    this.resizeObserver = new ResizeObserver(() => {
      // Falls sich die Größe des Target-Elements verändert, müssen wir neu berechnen.
      this.changeDetection.detectChanges();
    });
    this.resizeObserver.observe(this.ref.nativeElement);
    this.intersectionObserver = new IntersectionObserver(() => {
      // Falls sich das Element außerhalb des Viewports nicht gerendert wird,
      // z. B. in einem Slide-In, wollen wir erkennen, wenn es eingeblendet wird.
      this.changeDetection.detectChanges();
    });
    this.intersectionObserver.observe(this.ref.nativeElement);
  }
  ngOnDestroy() {
    this.resizeObserver.disconnect();
    this.intersectionObserver.disconnect();
  }
  /**
   * Schneidet zu langen Text ab und punktet das Ende dabei aus.
   * @param text Text, der ggf. gekürzt werden soll.
   * @param numberOfLines Anzahl der Linien, die maximal angezeigt werden soll.
   * @param endCharacter Schlusszeichen, welches zur Auspunktung verwendet wird.
   * @param showTitel Toggle, um das Titel-Attribut hinzuzufügen, wenn ausgepunktet wurde.
   * @param minWidth Falls die Breite des Elements nicht bestimmt werden kann, wird dieser Wert als Fallback in Pixeln genommen
   */
  transform(text, numberOfLines = 3, endCharacter = '…', showTitel = false, minWidth = 250) {
    const parentWidth = this.calculateParentWidth(minWidth);
    const fontSize = getComputedStyle(this.ref.nativeElement).fontSize;
    return TruncatePipe.truncateWithEllipses(text, numberOfLines, endCharacter, showTitel, parentWidth, fontSize);
  }
  calculateParentWidth(minWidth) {
    const parentElement = this.ref.nativeElement.parentElement;
    const computedStyleParent = getComputedStyle(parentElement);
    const parentPadding = parseFloat(computedStyleParent.paddingLeft ?? '0') + parseFloat(computedStyleParent.paddingRight ?? '0');
    return (parentElement.clientWidth || minWidth) - parentPadding;
  }
  static truncateWithEllipses(text, numberOfLines, endCharacter, showTitel = false, parentWidth, fontSize) {
    const {
      isTruncated,
      truncatedText
    } = this.addAllFittingWords(text, numberOfLines, endCharacter, parentWidth, fontSize);
    const textWithFinalCharacter = isTruncated ? TruncatePipe.addFinalCharacter(truncatedText, endCharacter) : truncatedText;
    return showTitel && isTruncated ? `<span aria-hidden="true" title="${text}">${textWithFinalCharacter}</span><span class="sr-only">${text}</span>` : textWithFinalCharacter;
  }
  /**
   * Misst die Länge eines gerenderten Strings in Pixeln
   */
  static getTextWidth(text, fontSize) {
    this.canvasRenderingContext2D.font = fontSize + ' Roboto';
    const metrics = this.canvasRenderingContext2D.measureText(text);
    return metrics.width;
  }
  /**
   * Fügt die Auspunktung an den Text an.
   */
  static addFinalCharacter(text, endCharacter) {
    // Entferne Satzendzeichen, die Vierfachpunkte verursachen würde
    if (text.endsWith('.') || text.endsWith('!') || text.endsWith('?')) {
      text = text.substr(0, text.length - 1);
    }
    return text + endCharacter;
  }
  /**
   * Füllt die Zeilen wortweise auf, sodass sie die Breite des Containers nicht überschreiten.
   */
  static addAllFittingWords(text, numberOfLines, endCharacter, parentWidth, fontSize) {
    let truncatedText = '';
    const words = text.split(' ');
    let wordIndex = 0;
    for (let line = 0; line < numberOfLines; line++) {
      let truncatedLine = '';
      const lineStillFits = () => {
        let candidate = truncatedLine + ' ' + words[wordIndex];
        const isLastLine = line + 1 === numberOfLines;
        const isLastWord = wordIndex + 1 === words.length;
        // In der letzte Zeile muss noch das Schlusszeichen angefügt werden.
        // Ausnahme, das letzte Wort, denn danach muss nicht mehr ausgepunktet werden.
        if (isLastLine && !isLastWord) {
          candidate = TruncatePipe.addFinalCharacter(candidate, endCharacter + '(XX)');
        }
        return TruncatePipe.getTextWidth(candidate, fontSize) < parentWidth;
      };
      // Füge ganze Wörter in die Zeile, solange noch Platz ist.
      while (wordIndex < words.length && lineStillFits()) {
        truncatedLine += ' ' + words[wordIndex];
        wordIndex++;
      }
      truncatedText += truncatedLine;
    }
    truncatedText = truncatedText.trim();
    return {
      truncatedText,
      isTruncated: wordIndex < words.length
    };
  }
  static {
    this.ɵfac = function TruncatePipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TruncatePipe)(i0.ɵɵdirectiveInject(i0.ElementRef, 16), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef, 16));
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "truncate",
      type: TruncatePipe,
      pure: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CheckboxListeComponent = /*#__PURE__*/(() => {
  class CheckboxListeComponent {
    constructor(decimalPipe) {
      this.decimalPipe = decimalPipe;
      this.disabled = false;
      this.forcePlus = false;
      this.truncate = false;
      this.checkboxClicked = new EventEmitter();
      this.trackByItemKey = trackByItemKey;
    }
    createAriaLabel(item) {
      if (1 === item.treffer) {
        return `${item.label} (Ein${this.isAdditional(item) ? ' weiteres' : ''} Suchergebnis)`;
      } else {
        return `${item.label} (${item.treffer}${this.isAdditional(item) ? ' weitere' : ''} Suchergebnisse)`;
      }
    }
    createTitle(item) {
      if (!this.isAdditional(item)) {
        return '';
      } else if (1 === item.treffer) {
        return 'Ein weiteres Suchergebnis aufrufen';
      }
      return `Weitere ${this.decimalPipe.transform(item.treffer)} Suchergebnisse aufrufen`;
    }
    isAdditional(element) {
      return !element.selected && (this.filterList?.some(box => box.selected) || this.forcePlus);
    }
    clicked(item) {
      this.checkboxClicked.emit(item);
    }
    static {
      this.ɵfac = function CheckboxListeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckboxListeComponent)(i0.ɵɵdirectiveInject(i1$3.DecimalPipe));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckboxListeComponent,
        selectors: [["ba-bub-checkbox-liste"]],
        inputs: {
          filterList: "filterList",
          id: "id",
          disabled: "disabled",
          forcePlus: "forcePlus",
          truncate: "truncate"
        },
        outputs: {
          checkboxClicked: "checkboxClicked"
        },
        decls: 2,
        vars: 3,
        consts: [["default", ""], ["role", "presentation", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "id", "innerHTML", 4, "ngIf"], ["role", "presentation"], ["class", "ba-check-group checkbox-wrapper", 4, "ngIf"], [1, "ba-check-group", "checkbox-wrapper"], [1, "form-check", 3, "ngClass"], ["type", "checkbox", 3, "change", "id", "checked", "indeterminate", "disabled"], [2, "width", "100%", 3, "for"], [3, "innerHTML", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["data-bs-toggle", "modal", "class", "ba-round-icon-btn ba-icon-information", 3, "id", 4, "ngIf"], [3, "innerHTML"], ["aria-hidden", "true", "data-bs-toggle", "popover", "data-bs-placement", "right"], [1, "red"], ["data-bs-toggle", "modal", 1, "ba-round-icon-btn", "ba-icon-information", 3, "id"], [3, "id", "innerHTML"]],
        template: function CheckboxListeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CheckboxListeComponent_ng_container_0_Template, 2, 1, "ng-container", 1)(1, CheckboxListeComponent_div_1_Template, 1, 3, "div", 2);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngForOf", ctx.filterList)("ngForTrackBy", ctx.trackByItemKey);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.filterList || ctx.filterList.length === 0);
          }
        },
        dependencies: [NgFor, NgIf, NgClass, TooltipDirective, DecimalPipe, TruncatePipe],
        styles: ["[_nghost-%COMP%]{display:grid;gap:.5rem}.red[_ngcontent-%COMP%]{color:#b30920}.checkbox-wrapper[_ngcontent-%COMP%]{position:relative}.checkbox-wrapper[_ngcontent-%COMP%]   .reserve-space[_ngcontent-%COMP%]{margin-right:35px}.checkbox-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{position:absolute;right:var(--checkbox-liste-info-i-right, 0);margin-inline:var(--checkbox-liste-info-i-margin-inline, 6px);top:0}\n\n\n\n\n\n\n\n\n\n"]
      });
    }
  }
  return CheckboxListeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var Severity = /*#__PURE__*/function (Severity) {
  Severity[Severity["error"] = 0] = "error";
  Severity[Severity["warning"] = 1] = "warning";
  Severity[Severity["info"] = 2] = "info";
  Severity[Severity["debug"] = 3] = "debug";
  Severity[Severity["trace"] = 4] = "trace";
  return Severity;
}(Severity || {});
class LogMessage {
  toString() {
    let callerText = '';
    if (this.caller) {
      callerText = this.caller + ': ';
    }
    return '[' + this.timestamp + ']\t ' + callerText + this.text;
  }
}
/**
 * Erweiterung und Wrapper,
 * um in die Entwicklung zu unterstützen mit logging-Code, der im Artefakt verweilt (statt console.log).

 * Kann auch spätere (Bug-)Analysen unterstützen, wenn dann Logging aktiviert und LogLevel eingestellt wird.
 * Ferner wäre eine Einbindung in den Konsumenten eine gute Vorarbeit,
 * wenn man später die Client-Logs auch an einen Server-Endpunkt schicken wollte.
 *
 * TODO nachdokumentieren in demo-app
 */
let LoggingService = /*#__PURE__*/(() => {
  class LoggingService {
    constructor() {
      this.logLevel = window.infosysbubLibConfig?.logLevel ?? 'off';
    }
    // as we designed this to potentially log to console this is intentionally
    // tslint disabled by CKU, service implemented by TWE
    /* eslint-disable no-console */
    trace(text, caller) {
      const message = this.newLogMessage(text, Severity.trace, caller);
      if (['trace'].includes(this.logLevel.toLocaleLowerCase())) {
        this.handleLogMessage(message);
      }
    }
    debug(text, caller) {
      const message = this.newLogMessage(text, Severity.debug, caller);
      if (['trace', 'debug'].includes(this.logLevel.toLocaleLowerCase())) {
        this.handleLogMessage(message);
      }
    }
    info(text, caller) {
      const message = this.newLogMessage(text, Severity.info, caller);
      if (['trace', 'debug', 'info'].includes(this.logLevel.toLocaleLowerCase())) {
        this.handleLogMessage(message);
      }
    }
    warn(text, caller) {
      const message = this.newLogMessage(text, Severity.warning, caller);
      if (['trace', 'debug', 'info', 'warn'].includes(this.logLevel.toLocaleLowerCase())) {
        this.handleLogMessage(message);
      }
    }
    error(text, caller) {
      const message = this.newLogMessage(text, Severity.error, caller);
      if (['trace', 'debug', 'info', 'warn', 'error'].includes(this.logLevel.toLocaleLowerCase())) {
        this.handleLogMessage(message);
      }
    }
    newLogMessage(text, severity, caller) {
      const message = new LogMessage();
      message.timestamp = new Date().toLocaleString();
      message.text = JSON.stringify(text);
      message.severity = severity;
      if (caller) {
        message.caller = caller.constructor.name;
      }
      return message;
    }
    handleLogMessage(message) {
      if (this.logLevel.toLocaleLowerCase() !== 'off') {
        if (this.detectIE()) {
          this.printToConsole(message);
        } else {
          this.printToConsoleColored(message);
        }
      }
    }
    printToConsoleColored(message) {
      const log = message.toString();
      if (message.severity === Severity.trace) {
        console.info('[trace]\t' + '%c' + log, 'color: darkgray');
      } else if (message.severity === Severity.debug) {
        console.info('[debug]\t' + '%c' + log, 'color: gray');
      } else if (message.severity === Severity.info) {
        console.info('[info]\t' + '%c' + log, 'color: blue');
      } else if (message.severity === Severity.warning) {
        console.info('[warn]\t' + '%c' + log, 'color: orange; background-color: lightgray');
      } else if (message.severity === Severity.error) {
        console.info('[error]\t' + '%c' + log, 'color: red; background-color: lightgray');
      }
    }
    printToConsole(message) {
      const log = message.toString();
      if (message.severity === Severity.trace) {
        console.info('[trace]\t' + log);
      } else if (message.severity === Severity.debug) {
        console.info('[debug]\t' + log);
      } else if (message.severity === Severity.info) {
        console.info('[info]\t' + log);
      } else if (message.severity === Severity.warning) {
        console.info('[warn]\t' + log);
      } else if (message.severity === Severity.error) {
        console.info('[error]\t' + log);
      }
    }
    detectIE() {
      const ua = window.navigator.userAgent;
      return ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0;
    }
    static {
      this.ɵfac = function LoggingService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LoggingService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: LoggingService,
        factory: LoggingService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return LoggingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const CONSENT_COOKIE = 'cookie_consent';
const CONSENT_COOKIE_ACCEPTED = 'accepted';
/**
 * Abstraktion zum fachlichen User Tracking beispielsweise über Piwik/Matomo
 *
 * Kann zentral auf Testbetrieb mit Logging geschaltet werden z.B. auf niederer Umgebung
 * zentralisiert ferner die Matomo spezifischen Aufrufe, um z.B. bei API-Änderungen leichter anpassbar zu sein
 * jedoch ist die piwik API NICHT AKTUELL GEPFLEGT (09.08.22, CKU), TODO für die Teams
 * https://developer.matomo.org/api-reference/tracking-javascript
 *
 * Eine Verbesserungsoption wäre auch der Einsatz der vom Hersteller beworbenen Angular-Umsetzung ngx-matomo
 * https://github.com/EmmanuelRoux/ngx-matomo#tracking-page-views-with-angular-router
 * Dies ist in aelterer Version auch in anderen BA-Teams schon im Einsatz (kusos, verlauf)
 * https://bitbucket.webapp.sdst.sbaintern.de/plugins/servlet/search?q=%22ngx-matomo%22%20path%3Apackage.json
 */
let TrackingService = /*#__PURE__*/(() => {
  class TrackingService {
    constructor(cookieService, loggingService) {
      this.cookieService = cookieService;
      this.loggingService = loggingService;
      this.piwikEnabled = false;
      this.conf = window.infosysbubLibConfig;
      this.piwikUrl = this.conf?.piwikUrl ?? '';
      this.piwikId = this.conf?.piwikId ?? '';
      this.initialize();
    }
    /**
     * trackEvent(category, action, [name], [value])
     * Log an event with
     * an event category (Videos, Music, Games...),
     * an event action (Play, Pause, Duration, Add Playlist, Downloaded, Clicked...),
     * and an optional event name
     * and optional numeric value.
     */
    trackEvent(action, category, name = '', value = 0) {
      if (this.isTrackingAllowed()) {
        if (this.piwikEnabled) {
          window._paq.push(['trackEvent', category, action, name, value]);
        } else {
          this.loggingService.info(`mocked tracking of event ${action} (category: ${category}, name: ${name}, value: ${value})`);
        }
      }
    }
    /**
     * trackSiteSearch(keyword, [category], [resultsCount])
     * Log an internal site search for a specific keyword,
     * in an optional category,
     * specifying the optional count of search results in the page.
     */
    trackSearch(keyword, category, results) {
      if (this.isTrackingAllowed()) {
        if (this.piwikEnabled) {
          window._paq.push(['trackSiteSearch', keyword, category, results]);
        } else {
          this.loggingService.info(`mocked tracking of siteSearch ${keyword} (category: ${category}, results: ${results})`);
        }
      }
    }
    /**
     * trackLink( url, linkType )
     * Log a click from your own code.
     * url is the full URL which is to be tracked as a click.
     * linkType can either be 'link' for an outlink or 'download' for a download.
     */
    trackOutlink(url) {
      if (this.isTrackingAllowed()) {
        if (this.piwikEnabled) {
          window._paq.push(['trackLink', url, 'link']);
        } else {
          this.loggingService.info(`mocked tracking of outlink ${url}`);
        }
      }
    }
    /**
     * trackPageView([customTitle]) - Log a page view
     *
     * Tracks an SPA page visit according to https://matomo.org/blog/2017/02/how-to-track-single-page-websites-using-piwik-analytics/
     *
     * used by berufetv, studisu, avgs, absuche, berufetv, ega, spraf, wbsuche, bnet
     *      only TSO uses Matomo TagManager as an alternative approach
     *      https://bitbucket.webapp.sdst.sbaintern.de/projects/INFOSYSBUB/repos/infosysbub-tso/pull-requests/117/overview
     */
    trackPageVisit(fromUrl, toUrl, toTitle) {
      if (this.isTrackingAllowed()) {
        if (this.piwikEnabled) {
          // setReferrerUrl( string ) - Override the detected Http-Referer. We recommend you call this method early
          // in your tracking code before you call trackPageView if it should be applied to all tracking requests.
          window._paq.push(['setReferrerUrl', fromUrl]);
          // setCustomUrl( string ) - Override the page's reported URL
          window._paq.push(['setCustomUrl', toUrl]);
          // setDocumentTitle( string ) - Override document.title
          window._paq.push(['setDocumentTitle', toTitle]);
          window._paq.push(['trackPageView']);
          //enableLinkTracking( enable ) - Install link tracking on all applicable link elements.
          // Set the enable parameter to true to use pseudo click-handler (treat middle click and open contextmenu
          // as left click). A right click (or any click that opens the context menu) on a link will be tracked
          // as clicked even if "Open in new tab" is not selected. If "false" (default),
          // nothing will be tracked on open context menu or middle click.
          window._paq.push(['enableLinkTracking']);
          //setDomains( array ) - Set array of hostnames or domains to be treated as local.
          // For wildcard subdomains, you can use: setDomains('.example.com'); or setDomains('*.example.com');.
          // You can also specify a path along a domain: setDomains('*.example.com/subsite1');
          window._paq.push(['setDomains', ['arbeitsagentur.de', '*.arbeitsagentur.de']]);
        } else {
          this.loggingService.info(`mocked tracking of pageview ${toTitle} (${fromUrl} to ${toUrl})`);
        }
      }
    }
    initialize() {
      if (this.isPiwikEnabled() && this.isTrackingAllowed()) {
        this.initializePiwik();
      }
    }
    initializePiwik() {
      const piwik = window._paq || [];
      this.configurePiwik(piwik);
      try {
        const piwikScriptElement = this.createPiwikScriptElement();
        this.insertAtFirst(piwikScriptElement);
      } catch (error) {
        const m = `Error initializing Piwik. The url ${this.piwikUrl} might be wrongly configured. ` + `Please check protocol and trailing slashes`;
        this.loggingService.error(m, error);
      }
      window._paq = piwik;
      this.piwikEnabled = true;
    }
    configurePiwik(piwik) {
      piwik.push(['setCookieDomain', this.getCookieDomain(location.hostname)]);
      piwik.push(['setTrackerUrl', this.piwikUrl + '/piwik.php']);
      piwik.push(['setSiteId', this.piwikId]);
      piwik.push(['trackPageView']);
      piwik.push(['enableHeartBeatTimer']);
      piwik.push(['enableCrossDomainLinking']);
    }
    getCookieDomain(hostname) {
      const segments = hostname.split('.').reverse();
      const l = segments.length;
      if (l < 2) {
        return hostname;
      }
      return `.${segments[1]}.${segments[0]}`;
    }
    insertAtFirst(piwikScriptElement) {
      const firstScriptElement = document.getElementsByTagName('script')[0];
      if (firstScriptElement && firstScriptElement.parentNode) {
        firstScriptElement.parentNode.insertBefore(piwikScriptElement, firstScriptElement);
      }
    }
    createPiwikScriptElement() {
      const piwikScriptElement = document.createElement('script');
      piwikScriptElement.type = 'text/javascript';
      piwikScriptElement.async = true;
      piwikScriptElement.defer = true;
      piwikScriptElement.src = this.piwikUrl + '/piwik.js';
      return piwikScriptElement;
    }
    /**
     * You can control this feature toggle by configuring the environment property for piwik url.
     */
    isPiwikEnabled() {
      return this.piwikUrl !== undefined && this.piwikUrl !== null && this.piwikUrl !== '' && this.piwikUrl !== '{{piwikUrl}}';
    }
    isTrackingAllowed() {
      const cookieExists = this.cookieService.check(CONSENT_COOKIE);
      if (!cookieExists) {
        return true;
      }
      const value = this.cookieService.get(CONSENT_COOKIE);
      return CONSENT_COOKIE_ACCEPTED === value;
    }
    static {
      this.ɵfac = function TrackingService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrackingService)(i0.ɵɵinject(i1$4.CookieService), i0.ɵɵinject(LoggingService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TrackingService,
        factory: TrackingService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return TrackingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AuswahlBuchstabenComponent = /*#__PURE__*/(() => {
  class AuswahlBuchstabenComponent {
    constructor(fb, trackingService) {
      this.fb = fb;
      this.trackingService = trackingService;
      this.komponentenId = '';
      this.buchstabenSelected = new EventEmitter();
      this.hasFocus = new EventEmitter();
    }
    ngOnInit() {
      this.buchstabenAuswahlForm = this.fb.group({
        buchstabenAuswahl: new FormControl(this.aktuelleBuchstabenReichweite)
      });
      this.buchstabenAuswahlFormSubscription = this.buchstabenAuswahlForm.valueChanges.pipe().subscribe({
        next: ({
          buchstabenAuswahl
        }) => {
          if (this.anbieterlisten[buchstabenAuswahl].length > 0) {
            this.trackingService.trackEvent('click', 'anbieter-facette-tab', buchstabenAuswahl);
            this.buchstabenSelected.emit(buchstabenAuswahl);
          }
          this.setDisabled();
        }
      });
    }
    ngAfterViewInit() {
      this.setDisabled();
    }
    setDisabled() {
      /* Holt die Input Elemente anhand der IDs. Sofern die dazugehörige Kategorie leer ist wird ein disabled flag gesetzt
           Wird benötigt, da nach der Umstellung auf Angular 15 [attr.disabled] nicht mehr funktioniert hat. Da die Patchnotes
      nicht davon beinhalten ist unklar ob es sich um einen Bug handelt oder gewollt ist.
      Workaround bis geklärt ist ob Angular einen fix dafür bereitet.
      Andernfalls muss die Component überarbeitet werden, da ein disabled nurnoch über die Formcontrol möglich wäre.
      * */
      const idKategorieMap = [{
        identifier: 'AbisF',
        kategorie: 'aBisF'
      }, {
        identifier: 'GbisL',
        kategorie: 'gBisL'
      }, {
        identifier: 'MbisR',
        kategorie: 'mBisR'
      }, {
        identifier: 'SbisZ',
        kategorie: 'sBisZ'
      }];
      idKategorieMap.filter(({
        kategorie
      }) => this.anbieterlisten && this.anbieterlisten[kategorie]?.length == 0).map(({
        identifier
      }) => document.getElementById(`${this.komponentenId}-radio${identifier}`)).filter(element => !!element).forEach((element // @ts-ignore
      ) => element.disabled = 'true');
    }
    ngOnChanges(changes) {
      if (changes.aktuelleBuchstabenReichweite && this.buchstabenAuswahlForm) {
        this.buchstabenAuswahlForm.patchValue({
          buchstabenAuswahl: changes.aktuelleBuchstabenReichweite.currentValue
        });
      }
    }
    ngOnDestroy() {
      this.buchstabenAuswahlFormSubscription.unsubscribe();
    }
    onFocus() {
      this.hasFocus.emit(true);
    }
    onFocusOut() {
      this.hasFocus.emit(false);
    }
    static {
      this.ɵfac = function AuswahlBuchstabenComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AuswahlBuchstabenComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(TrackingService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AuswahlBuchstabenComponent,
        selectors: [["ba-bub-auswahl-buchstaben"]],
        inputs: {
          komponentenId: "komponentenId",
          anbieterlisten: "anbieterlisten",
          aktuelleBuchstabenReichweite: "aktuelleBuchstabenReichweite"
        },
        outputs: {
          buchstabenSelected: "buchstabenSelected",
          hasFocus: "hasFocus"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 2,
        vars: 2,
        consts: [[3, "formGroup"], ["class", "form-group", 4, "ngIf"], [1, "form-group"], ["role", "radiogroup", "aria-label", "Auswahl der Buchstabenkategorie", 1, "ba-btn-group", "ba-tablet-fullwidth"], [1, "form-check"], ["type", "radio", "formControlName", "buchstabenAuswahl", "value", "aBisF", 3, "focus", "focusout", "id"], ["title", "Anbieter von A - F inkl. Sonderzeichen anzeigen", 3, "for", "id"], ["class", "sr-only", 4, "ngIf"], ["type", "radio", "formControlName", "buchstabenAuswahl", "value", "gBisL", 3, "focus", "focusout", "id"], ["title", "Anbieter von G - L", 3, "for", "id"], ["type", "radio", "formControlName", "buchstabenAuswahl", "value", "mBisR", 3, "focus", "focusout", "id"], ["title", "Anbieter von M - R", 3, "for", "id"], ["type", "radio", "formControlName", "buchstabenAuswahl", "value", "sBisZ", 3, "focus", "focusout", "id"], ["title", "Anbieter von S - Z", 3, "for", "id"], [1, "sr-only"]],
        template: function AuswahlBuchstabenComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "form", 0);
            i0.ɵɵtemplate(1, AuswahlBuchstabenComponent_div_1_Template, 22, 40, "div", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.buchstabenAuswahlForm);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.anbieterlisten);
          }
        },
        dependencies: [FormsModule, i1.ɵNgNoValidate, i1.DefaultValueAccessor, i1.RadioControlValueAccessor, i1.NgControlStatus, i1.NgControlStatusGroup, ReactiveFormsModule, i1.FormGroupDirective, i1.FormControlName, NgIf],
        styles: [".ba-btn-group[_ngcontent-%COMP%]{width:100%;margin:0;display:flex;display:inline-flex;flex-direction:row}.ba-btn-group[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]{border-top-width:1px;border-left-width:0;border-radius:0}.ba-btn-group[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]:before{inset:auto 0 0;width:100%;height:4px}.ba-keyboard-mode[_ngcontent-%COMP%]   .ba-btn-group[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]:focus + label[_ngcontent-%COMP%]{margin-top:0;margin-left:-1px;border-left-width:1px;border-color:#020e25}.ba-btn-group[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:first-child   input[type=radio][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]{border-left-width:1px;border-top-left-radius:5px;border-bottom-left-radius:5px}.ba-keyboard-mode[_ngcontent-%COMP%]   .ba-btn-group[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:first-child   input[type=radio][_ngcontent-%COMP%]:focus + label[_ngcontent-%COMP%]{margin-left:0}.ba-btn-group[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:last-child   input[type=radio][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]{border-top-right-radius:5px;border-bottom-right-radius:5px}.ba-btn-group[_ngcontent-%COMP%]   div.form-check[_ngcontent-%COMP%]{width:25%;height:50px;min-width:3em;position:relative}.ba-btn-group[_ngcontent-%COMP%]   div.form-check[_ngcontent-%COMP%]:not(:first-of-type):before{position:absolute;z-index:10;left:0;top:10px;width:1px;background-color:#838383;content:\"\";border-radius:0;border:none;height:30px}.ba-btn-group[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]{border-style:none;display:flex;position:relative;flex-direction:column;justify-content:center;padding:10px 3px;font-size:1.0666666667rem;text-align:center;border-radius:0;height:50px}.form-group[_ngcontent-%COMP%]{margin-bottom:1.5rem}\n\n\n\n\n\n\n\n\n\n"]
      });
    }
  }
  return AuswahlBuchstabenComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZuvieleAnbieterComponent = /*#__PURE__*/(() => {
  class ZuvieleAnbieterComponent {
    constructor() {
      this.focus = new EventEmitter();
    }
    static {
      this.ɵfac = function ZuvieleAnbieterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ZuvieleAnbieterComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ZuvieleAnbieterComponent,
        selectors: [["ba-bub-zuviele-anbieter"]],
        inputs: {
          komponentenId: "komponentenId",
          anzahlAnbieter: "anzahlAnbieter",
          focus: "focus"
        },
        decls: 5,
        vars: 6,
        consts: [["aria-live", "polite", 1, "alert", "alert-info", 3, "id"], [1, "ba-heading"]],
        template: function ZuvieleAnbieterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵelementStart(2, "h3", 1);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtext(4, " Bei gr\xF6\xDFeren Treffermengen ist f\xFCr die Verwendung des Filters nach Anbietern eine Einschr\xE4nkung auf Ort, Suchbegriff oder Umkreis erforderlich.\n");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵpropertyInterpolate1("id", "", ctx.komponentenId, "_zuvieleAnbieter");
            i0.ɵɵattribute("role", i0.ɵɵpipeBind1(1, 4, ctx.focus) === true ? "alert" : "");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1("Sehr viele Anbieter (", ctx.anzahlAnbieter, ")");
          }
        },
        dependencies: [AsyncPipe],
        styles: [".h5[_ngcontent-%COMP%]{margin-top:0}"]
      });
    }
  }
  return ZuvieleAnbieterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class AnbieterFilterConfiguration {}
/**
 * Service kann in der einbindenden Komponente überschrieben werden
 *
 * Dazu muss eine Klasse definiert werden, die AnbieterFacetteConfiguration
 * implementiert
 *
 * Diese Klasse muss in der Komponente/Modul, die den AnbieterFacettenFilter nutzt
 * als provider für AnbieterFacetteConfigurationService eingesetzt werden.
 *
 */
let AnbieterFilterConfigurationService = /*#__PURE__*/(() => {
  class AnbieterFilterConfigurationService {
    constructor() {
      this.maximalAuswaehlbareAnbieter = 20;
    }
    static {
      this.ɵfac = function AnbieterFilterConfigurationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AnbieterFilterConfigurationService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AnbieterFilterConfigurationService,
        factory: AnbieterFilterConfigurationService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AnbieterFilterConfigurationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function istAnzahlAnbieterAnders(change) {
  return change.previousValue?.length !== change.currentValue?.length;
}
function findeBuchstabenkategorieMitAnbietern(anbieterNachBuchstabenKategorie, aktiveBuchstabenKategorie) {
  if (anbieterNachBuchstabenKategorie.alle?.length > 0 && anbieterNachBuchstabenKategorie.alle?.length <= 5) {
    return 'alle';
  }
  if (aktiveBuchstabenKategorie !== 'alle' && anbieterNachBuchstabenKategorie[aktiveBuchstabenKategorie]?.length > 0 && anbieterNachBuchstabenKategorie[aktiveBuchstabenKategorie]?.length <= 15) {
    return aktiveBuchstabenKategorie;
  }
  return ersteKategorieMitValiderAnzahlAnEintraegen(anbieterNachBuchstabenKategorie);
}
let AnbieterFilterComponent = /*#__PURE__*/(() => {
  class AnbieterFilterComponent {
    constructor(anbieterFilterConfigurationService) {
      this.anbieterFilterConfigurationService = anbieterFilterConfigurationService;
      this.sortierungsFunktion = vergleicheErstenBuchstaben;
      this.anbieterAusgewaehlt = new EventEmitter();
      this.aktiveBuchstabenKategorie = 'aBisF';
      this.istEinAnbieterAusgewaehlt = false;
      this.istMaximaleAnzahlErreicht = false;
      this.hasFocus = new ReplaySubject(1);
    }
    ordneAnbieterInBuchstabenKategorien(anbieterListe, change) {
      if (!anbieterListe) {
        return;
      }
      this.berechneMaximaleAnzahlErreicht(anbieterListe);
      this.gruppiereAnbieterNachKategorie(anbieterListe);
      this.aktualisiereAktiveKategorie(change);
      this.pruefeObEinAnbieterAusgewaehlt(anbieterListe);
    }
    aktualisiereAktiveKategorie(change) {
      if (istAnzahlAnbieterAnders(change)) {
        this.aktiveBuchstabenKategorie = findeBuchstabenkategorieMitAnbietern(this.anbieterNachBuchstabenKategorie, this.aktiveBuchstabenKategorie);
      }
    }
    gruppiereAnbieterNachKategorie(anbieterListe) {
      this.anbieterNachBuchstabenKategorie = this.ordneAnbieterNachBuchstabenKategorie(anbieterListe.sort(this.sortierungsFunktion).map(AnbieterFilterComponent.transformAnbieterToSelectItem));
    }
    berechneMaximaleAnzahlErreicht(anbieterListe) {
      this.istMaximaleAnzahlErreicht = anbieterListe.filter(a => a.ausgewaehlt).length >= this.anbieterFilterConfigurationService.maximalAuswaehlbareAnbieter;
    }
    ordneAnbieterNachBuchstabenKategorie(anbieterListe) {
      return {
        alle: anbieterListe,
        aBisF: anbieterListe.filter(({
          label
        }) => ordneStringInBuchstabenKategorie(label.toString().charAt(0), istInABisFOderSonderzeichen)),
        gBisL: anbieterListe.filter(({
          label
        }) => ordneStringInBuchstabenKategorie(label.toString().charAt(0), istInGBisL)),
        mBisR: anbieterListe.filter(({
          label
        }) => ordneStringInBuchstabenKategorie(label.toString().charAt(0), istInMBisR)),
        sBisZ: anbieterListe.filter(({
          label
        }) => ordneStringInBuchstabenKategorie(label.toString().charAt(0), istInSBisZ))
      };
    }
    pruefeObEinAnbieterAusgewaehlt(anbieterListe) {
      this.istEinAnbieterAusgewaehlt = anbieterListe.some(({
        ausgewaehlt
      }) => ausgewaehlt === true);
    }
    setzteBuchstabenKategorie(ausgewaehlteBuchstabenKategorie) {
      if (this.anbieterNachBuchstabenKategorie.alle.length > 5) {
        this.aktiveBuchstabenKategorie = ausgewaehlteBuchstabenKategorie;
      } else {
        this.aktiveBuchstabenKategorie = 'alle';
      }
    }
    onCheckboxAuswaehlen({
      label,
      key,
      treffer,
      selected
    }) {
      this.onAnbieterAuswaehlen({
        name: label.toString(),
        id: key,
        ausgewaehlt: selected,
        anzahlAngebote: treffer
      });
    }
    onAnbieterAuswaehlen(auswahl) {
      const activeAnbieterIds = this.anbieterListe.map(anbieter => {
        if (anbieter.id === auswahl.id) {
          return {
            ...anbieter,
            ausgewaehlt: !anbieter.ausgewaehlt
          };
        }
        return anbieter;
      }).filter(({
        ausgewaehlt
      }) => ausgewaehlt === true).map(({
        id
      }) => id);
      this.anbieterAusgewaehlt.emit(activeAnbieterIds);
    }
    static transformAnbieterToSelectItem({
      id,
      name,
      anzahlAngebote,
      ausgewaehlt
    }) {
      return {
        key: id,
        active: true,
        label: name,
        treffer: anzahlAngebote,
        selected: ausgewaehlt
      };
    }
    static {
      this.ɵfac = function AnbieterFilterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AnbieterFilterComponent)(i0.ɵɵdirectiveInject(AnbieterFilterConfigurationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AnbieterFilterComponent,
        selectors: [["ba-bub-anbieter-filter"]],
        inputs: {
          anbieterListe: "anbieterListe",
          komponentenId: "komponentenId",
          sortierungsFunktion: "sortierungsFunktion"
        },
        outputs: {
          anbieterAusgewaehlt: "anbieterAusgewaehlt"
        },
        decls: 4,
        vars: 4,
        consts: [["zuvieleAnbieter", ""], [3, "id"], [4, "ngIf"], ["class", "anbieter-auswahl-liste-eintrag__inhalt", 4, "ngIf"], [3, "id", 4, "ngIf"], [3, "id", "komponentenId", "aktuelleBuchstabenReichweite", "anbieterlisten", "buchstabenSelected", "hasFocus", 4, "ngIf"], [3, "buchstabenSelected", "hasFocus", "id", "komponentenId", "aktuelleBuchstabenReichweite", "anbieterlisten"], [1, "anbieter-auswahl-liste-eintrag__inhalt"], ["id", "anbieterContent", 4, "ngIf", "ngIfElse"], ["id", "anbieterContent"], [3, "checkboxClicked", "filterList", "id", "truncate", "forcePlus", "disabled"], [3, "komponentenId", "anzahlAnbieter", "focus"]],
        template: function AnbieterFilterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, AnbieterFilterComponent_div_1_Template, 2, 1, "div", 2)(2, AnbieterFilterComponent_div_2_Template, 4, 2, "div", 3)(3, AnbieterFilterComponent_div_3_Template, 2, 2, "div", 4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵpropertyInterpolate("id", ctx.komponentenId);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.anbieterNachBuchstabenKategorie);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.anbieterNachBuchstabenKategorie && ctx.anbieterNachBuchstabenKategorie[ctx.aktiveBuchstabenKategorie].length > 0 && ctx.anbieterNachBuchstabenKategorie[ctx.aktiveBuchstabenKategorie]);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.anbieterNachBuchstabenKategorie && (ctx.anbieterNachBuchstabenKategorie[ctx.aktiveBuchstabenKategorie] == null ? null : ctx.anbieterNachBuchstabenKategorie[ctx.aktiveBuchstabenKategorie].length) === 0);
          }
        },
        dependencies: [NgIf, AuswahlBuchstabenComponent, CheckboxListeComponent, ZuvieleAnbieterComponent],
        styles: [".anbieter-auswahl-liste-eintrag__inhalt{text-align:left}#anbieterContent input[type=checkbox]+label:after,#anbieterContent input[type=checkbox]+label:before{top:6px}\n"],
        encapsulation: 2
      });
    }
  }
  __decorate([OnChange('ordneAnbieterInBuchstabenKategorien')], AnbieterFilterComponent.prototype, "anbieterListe", void 0);
  return AnbieterFilterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
dayjs.locale('de'); // use locale
let DurationPipe = /*#__PURE__*/(() => {
  class DurationPipe {
    transform(start, end) {
      const startDay = dayjs(start);
      const endDay = dayjs(end).add(1, 'day');
      const years = endDay.diff(startDay, 'y');
      const months = endDay.diff(startDay.add(years, 'y'), 'M');
      const days = endDay.diff(startDay.add(years, 'y').add(months, 'M'), 'd');
      const leftoverDays = days % 7;
      const weeks = (days - leftoverDays) / 7;
      const dateParts = [{
        singular: 'Jahr',
        plural: 'Jahre',
        value: years
      }, {
        singular: 'Monat',
        plural: 'Monate',
        value: months
      }, {
        singular: 'Woche',
        plural: 'Wochen',
        value: weeks
      }, {
        singular: 'Tag',
        plural: 'Tage',
        value: leftoverDays
      }];
      const largestUnitIndex = dateParts.findIndex(({
        value
      }) => value > 0);
      return dateParts.slice(largestUnitIndex, largestUnitIndex + 2).filter(({
        value
      }) => value > 0).map(({
        singular,
        plural,
        value
      }) => `${value} ${value === 1 ? singular : plural}`).join(', ');
    }
    static {
      this.ɵfac = function DurationPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DurationPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "duration",
        type: DurationPipe,
        pure: true
      });
    }
  }
  return DurationPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PipesModule = /*#__PURE__*/(() => {
  class PipesModule {
    static {
      this.ɵfac = function PipesModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PipesModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PipesModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return PipesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CheckboxListeModule = /*#__PURE__*/(() => {
  class CheckboxListeModule {
    static {
      this.ɵfac = function CheckboxListeModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckboxListeModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckboxListeModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [DecimalPipe],
        imports: [CommonModule, CheckboxModule, TooltipModule, PipesModule]
      });
    }
  }
  return CheckboxListeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AnbieterFilterModule = /*#__PURE__*/(() => {
  class AnbieterFilterModule {
    static {
      this.ɵfac = function AnbieterFilterModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AnbieterFilterModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AnbieterFilterModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, CheckboxModule, ReactiveFormsModule, CheckboxListeModule, AnbieterFilterComponent, AuswahlBuchstabenComponent]
      });
    }
  }
  return AnbieterFilterModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TagTeaserComponent = /*#__PURE__*/(() => {
  class TagTeaserComponent {
    constructor(sanitizer) {
      this.sanitizer = sanitizer;
    }
    sanitize(text) {
      if (typeof text === 'string') {
        return this.sanitizer.sanitize(SecurityContext.HTML, text);
      }
      return text;
    }
    get altText() {
      return this.teaser.imageAlt?.length != undefined ? this.teaser.imageAlt : `Bild für ${this.teaser.title}`;
    }
    static {
      this.ɵfac = function TagTeaserComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TagTeaserComponent)(i0.ɵɵdirectiveInject(i1$1.DomSanitizer));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TagTeaserComponent,
        selectors: [["ba-bub-tagteaser"]],
        inputs: {
          id: "id",
          teaser: "teaser"
        },
        decls: 5,
        vars: 9,
        consts: [[3, "modalId", "modalTitle", "center", "infoModal", "primaryButtonText", "secondaryButtonText"], [1, "ba-bub-tagteaser", "row", "g-3"], [1, "ba-bub-tagteaser-image"], [3, "src", "alt"], [1, "ba-bub-tagteaser-text", 3, "innerHTML"]],
        template: function TagTeaserComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ba-bub-modal-popup", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵelement(3, "img", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(4, "div", 4);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("modalId", "modal-teaser-" + ctx.id)("modalTitle", ctx.teaser.title)("center", false)("infoModal", true)("primaryButtonText", "Schlie\xDFen")("secondaryButtonText", null);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("src", ctx.teaser.imageUrl, i0.ɵɵsanitizeUrl)("alt", ctx.altText);
            i0.ɵɵadvance();
            i0.ɵɵproperty("innerHTML", ctx.sanitize(ctx.teaser.text), i0.ɵɵsanitizeHtml);
          }
        },
        dependencies: [ModalPopupComponent],
        styles: [".ba-bub-tagteaser-image[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%}@media (max-width: 575.98px){.ba-bub-tagteaser-image[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{margin-bottom:20px}}.ba-bub-tagteaser-title[_ngcontent-%COMP%]{word-break:break-word;hyphens:auto;-ms-hyphens:auto;margin-top:0}.ba-bub-tagteaser-close-icon[_ngcontent-%COMP%]{border:none;background-color:#fff;text-align:right}.ba-bub-tagteaser-close-icon[_ngcontent-%COMP%]:focus, .ba-bub-tagteaser-close-icon[_ngcontent-%COMP%]:hover{color:#601}.ba-bub-tagteaser-close-icon[_ngcontent-%COMP%]:focus{outline:2px solid #660011}.ba-bub-tagteaser-close-link[_ngcontent-%COMP%]{color:#595959}.ba-bub-tagteaser-close-link[_ngcontent-%COMP%]:focus, .ba-bub-tagteaser-close-link[_ngcontent-%COMP%]:hover{color:#601}\n\n\n\n\n\n\n\n\n\n"]
      });
    }
  }
  return TagTeaserComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TaglisteComponent = /*#__PURE__*/(() => {
  class TaglisteComponent {
    constructor() {
      this.taglisteAriaLabel = '';
      this.removeTemplate = '';
      // ID für Tag als InputParameter, um nicht die gleichen IDs bei den Tags der aufklappbaren Tag-Liste zu erzeugen
      this.startId = 0;
      this.tagClicked = new EventEmitter();
      this.tagRemoved = new EventEmitter();
      this.trackById = (_, {
        id
      }) => id;
    }
    onRemove(item) {
      this.tagRemoved.emit(item);
    }
    /**
     * Gibt den Tooltipp-Text für das Entfernen-X auf Basis des übergebenen Templates zurück.
     * @param item Das auszugebende Array-Element.
     */
    getRemoveTooltip(item) {
      if (!this.removeTemplate || this.removeTemplate.length === 0) {
        return null;
      }
      return this.removeTemplate.replace('%name%', item.angezeigterText);
    }
    getTeaserTooltip(teaser) {
      return teaser.open ? 'Weniger anzeigen' : 'Mehr anzeigen';
    }
    getTeaserAriaLabel(teaser) {
      return `Weitere Informationen zu ${teaser.title}`;
    }
    static {
      this.ɵfac = function TaglisteComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TaglisteComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TaglisteComponent,
        selectors: [["ba-bub-tagliste"]],
        inputs: {
          taglisteAriaLabel: "taglisteAriaLabel",
          tagcloudListe: "tagcloudListe",
          removeTemplate: "removeTemplate",
          startId: "startId"
        },
        outputs: {
          tagClicked: "tagClicked",
          tagRemoved: "tagRemoved"
        },
        decls: 2,
        vars: 3,
        consts: [["aria-live", "polite", "aria-relevant", "additions", 1, "d-flex", "flex-wrap", "gap-1"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "ba-bub-tag", 3, "id"], ["class", "d-print-none ba-bub-tag-teaser-toggle ba-btn ba-btn-ghost ba-btn-icon-only ba-icon-information", "data-bs-toggle", "modal", 3, "title", 4, "ngIf"], [1, "ba-bub-tag-content", "ps-2", 3, "ngClass"], ["aria-hidden", "true", 3, "class", 4, "ngIf"], ["aria-hidden", "true", 1, "ba-bub-tag-text", "text-truncate", "ps-1", 3, "title"], [1, "sr-only"], ["type", "button", 1, "ba-bub-tag-remove", "d-print-none", "ba-btn", "ba-btn-ghost", "ba-btn-icon-only", "ba-icon-close", 3, "click", "title"], [3, "id", "teaser", 4, "ngIf"], ["data-bs-toggle", "modal", 1, "d-print-none", "ba-bub-tag-teaser-toggle", "ba-btn", "ba-btn-ghost", "ba-btn-icon-only", "ba-icon-information", 3, "title"], ["aria-hidden", "true"], [3, "id", "teaser"]],
        template: function TaglisteComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ul", 0);
            i0.ɵɵtemplate(1, TaglisteComponent_li_1_Template, 11, 12, "li", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵattribute("aria-label", ctx.taglisteAriaLabel);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.tagcloudListe)("ngForTrackBy", ctx.trackById);
          }
        },
        dependencies: [NgFor, NgIf, NgClass, TagTeaserComponent],
        styles: ["h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], .h1[_ngcontent-%COMP%], .h2[_ngcontent-%COMP%], .h3[_ngcontent-%COMP%], .h4[_ngcontent-%COMP%], .h5[_ngcontent-%COMP%], .h6[_ngcontent-%COMP%]{margin-right:0;margin-bottom:1rem;margin-left:0;font-family:Roboto Condensed Bold,Helvetica Neue,Arial,sans-serif;line-height:1.2}h1[_ngcontent-%COMP%], .h1[_ngcontent-%COMP%]{font-size:2.313125rem}h2[_ngcontent-%COMP%], .h2[_ngcontent-%COMP%]{margin-top:3.75rem;font-size:2.01125rem}@media (min-width: 768px){h2[_ngcontent-%COMP%], .h2[_ngcontent-%COMP%]{margin-top:6rem}}h3[_ngcontent-%COMP%], .h3[_ngcontent-%COMP%]{margin-top:3rem;font-size:1.74875rem}@media (min-width: 768px){h3[_ngcontent-%COMP%], .h3[_ngcontent-%COMP%]{margin-top:4.5rem}}h4[_ngcontent-%COMP%], .h4[_ngcontent-%COMP%]{margin-top:2.25rem;font-size:1.520625rem}@media (min-width: 768px){h4[_ngcontent-%COMP%], .h4[_ngcontent-%COMP%]{margin-top:3rem}}h5[_ngcontent-%COMP%], .h5[_ngcontent-%COMP%]{margin-top:1.5rem;font-size:1.3225rem}h6[_ngcontent-%COMP%], .h6[_ngcontent-%COMP%]{margin-top:1.5rem;font-size:1.15rem}[_ngcontent-%COMP%]:not(.container-fluid) > h1[_ngcontent-%COMP%]:first-child, [_ngcontent-%COMP%]:not(.container-fluid) > h2[_ngcontent-%COMP%]:first-child, [_ngcontent-%COMP%]:not(.container-fluid) > h3[_ngcontent-%COMP%]:first-child, [_ngcontent-%COMP%]:not(.container-fluid) > h4[_ngcontent-%COMP%]:first-child, [_ngcontent-%COMP%]:not(.container-fluid) > h5[_ngcontent-%COMP%]:first-child, [_ngcontent-%COMP%]:not(.container-fluid) > h6[_ngcontent-%COMP%]:first-child, [_ngcontent-%COMP%]:not(.container-fluid) > .h1[_ngcontent-%COMP%]:first-child, [_ngcontent-%COMP%]:not(.container-fluid) > .h2[_ngcontent-%COMP%]:first-child, [_ngcontent-%COMP%]:not(.container-fluid) > .h3[_ngcontent-%COMP%]:first-child, [_ngcontent-%COMP%]:not(.container-fluid) > .h4[_ngcontent-%COMP%]:first-child, [_ngcontent-%COMP%]:not(.container-fluid) > .h5[_ngcontent-%COMP%]:first-child, [_ngcontent-%COMP%]:not(.container-fluid) > .h6[_ngcontent-%COMP%]:first-child{margin-top:0}.ba-microcopy[_ngcontent-%COMP%], small[_ngcontent-%COMP%]{color:#595959;font-size:.8125rem;line-height:1.2}.ba-microcopy[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], small[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{font-size:.8125rem;line-height:1.2}code.code-block-small[_ngcontent-%COMP%]{display:block;font-size:.8rem;line-height:1rem}cite[_ngcontent-%COMP%]{font-style:normal}strong[_ngcontent-%COMP%], b[_ngcontent-%COMP%]{font-family:Roboto Bold,Helvetica Neue,Arial,sans-serif;font-weight:400}.font-bold[_ngcontent-%COMP%]{font-family:Roboto Bold,Helvetica Neue,Arial,sans-serif}.font-condensed[_ngcontent-%COMP%]{font-family:Roboto Condensed,Helvetica Neue,Arial,sans-serif}.font-condensed-bold[_ngcontent-%COMP%]{font-family:Roboto Condensed Bold,Helvetica Neue,Arial,sans-serif}ul[_ngcontent-%COMP%]{padding-left:0;list-style:none}li[_ngcontent-%COMP%]{display:block;max-width:100%}.ba-bub-tag[_ngcontent-%COMP%]{display:flex;border-radius:5px;background-color:#020e2514;max-width:100%}.ba-bub-tag[_ngcontent-%COMP%]   i.ba-icon[_ngcontent-%COMP%]{font-size:1.5rem;line-height:1.25rem;height:1.5rem}.ba-bub-tag-content[_ngcontent-%COMP%]{display:flex;gap:.5rem;align-items:center;justify-items:center;justify-content:center;font-family:Roboto Bold,Helvetica Neue,Arial,sans-serif;border-left:#FFFFFF solid 2px;max-width:calc(100% - 35px)}.ba-btn-icon-only[_ngcontent-%COMP%]:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.ba-btn-icon-only[_ngcontent-%COMP%]:last-child{border-top-left-radius:0;border-bottom-left-radius:0}\n\n\n\n\n\n\n\n\n\n\n\n"]
      });
    }
  }
  return TaglisteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TagcloudComponent = /*#__PURE__*/(() => {
  class TagcloudComponent {
    constructor() {
      this.tagListeAriaLabel = '';
      this.removeTemplate = '';
      this.maxTagsVisible = -1;
      this.headline = '';
      this.ariaLabel = '';
      this.ariaLabelContent = '';
      this.labelForOpen = '';
      this.labelForClose = '';
      this.removeAllTooltip = '';
      this.tagcloudListeRemove = new EventEmitter();
      this.tagcloudListeRemoveAll = new EventEmitter();
      this.tagcloudListeClick = new EventEmitter();
    }
    /**
     * Returns the number parameter of items which are displayed by default.
     * if maxTagsVisible is not set (which means it should be -1) then
     * the total list size of tags is returned, the maxTagsVisible number otherwise.
     */
    getVisibleItemCount() {
      if (this.maxTagsVisible > -1) {
        return this.maxTagsVisible;
      } else {
        return this.tagcloudListe ? this.tagcloudListe.length : 0;
      }
    }
    /**
     * emit model change event
     * @param item Das zu entfernende Element.
     */
    onRemove(item) {
      this.tagcloudListeRemove.emit(item);
    }
    /**
     * emit model change event
     * @param item Das aufzurufende Element.
     */
    onClick(item) {
      this.tagcloudListeClick.emit(item);
    }
    static {
      this.ɵfac = function TagcloudComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TagcloudComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TagcloudComponent,
        selectors: [["ba-bub-tagcloud"]],
        inputs: {
          id: "id",
          tagListeAriaLabel: "tagListeAriaLabel",
          tagcloudListe: "tagcloudListe",
          removeTemplate: "removeTemplate",
          maxTagsVisible: "maxTagsVisible",
          headline: "headline",
          ariaLabel: "ariaLabel",
          ariaLabelContent: "ariaLabelContent",
          labelForOpen: "labelForOpen",
          labelForClose: "labelForClose",
          removeAllTooltip: "removeAllTooltip",
          collapseId: "collapseId"
        },
        outputs: {
          tagcloudListeRemove: "tagcloudListeRemove",
          tagcloudListeRemoveAll: "tagcloudListeRemoveAll",
          tagcloudListeClick: "tagcloudListeClick"
        },
        decls: 4,
        vars: 8,
        consts: [["class", "ba-bub-tagcloud-header", 4, "ngIf"], ["removeTemplate", "%name% zur\xFCcksetzen", 3, "tagClicked", "tagRemoved", "taglisteAriaLabel", "tagcloudListe"], [3, "ariaLabel", "ariaLabelContent", "collapseId", "labelForOpen", "labelForClose", 4, "ngIf"], [1, "ba-bub-tagcloud-header"], [3, "id"], ["href", "javascript:void(0)", "class", "d-print-none", 3, "id", "title", "click", 4, "ngIf"], ["href", "javascript:void(0)", 1, "d-print-none", 3, "click", "id", "title"], [3, "ariaLabel", "ariaLabelContent", "collapseId", "labelForOpen", "labelForClose"], ["removeTemplate", "%name% zur\xFCcksetzen", 3, "tagClicked", "tagRemoved", "taglisteAriaLabel", "tagcloudListe", "startId"]],
        template: function TagcloudComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, TagcloudComponent_div_0_Template, 4, 4, "div", 0);
            i0.ɵɵelementStart(1, "ba-bub-tagliste", 1);
            i0.ɵɵpipe(2, "slice");
            i0.ɵɵlistener("tagClicked", function TagcloudComponent_Template_ba_bub_tagliste_tagClicked_1_listener($event) {
              return ctx.onClick($event);
            })("tagRemoved", function TagcloudComponent_Template_ba_bub_tagliste_tagRemoved_1_listener($event) {
              return ctx.onRemove($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, TagcloudComponent_ba_bub_collapse_3_Template, 3, 13, "ba-bub-collapse", 2);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.tagcloudListe && ctx.tagcloudListe.length > 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("taglisteAriaLabel", ctx.tagListeAriaLabel)("tagcloudListe", i0.ɵɵpipeBind3(2, 4, ctx.tagcloudListe, 0, ctx.getVisibleItemCount()));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.maxTagsVisible > -1 && ctx.tagcloudListe && ctx.tagcloudListe.length > ctx.maxTagsVisible);
          }
        },
        dependencies: [NgIf, TaglisteComponent, CollapseComponent, SlicePipe],
        styles: [".ba-bub-tagcloud-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;margin-top:20px}.ba-bub-tagcloud-header[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-weight:700}.ba-bub-tagcloud-header[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#595959}.ba-bub-tagcloud-header[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:focus, .ba-bub-tagcloud-header[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:#601}\n\n\n\n\n\n\n\n\n\n"]
      });
    }
  }
  return TagcloudComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TagcloudModule = /*#__PURE__*/(() => {
  class TagcloudModule {
    static {
      this.ɵfac = function TagcloudModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TagcloudModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TagcloudModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, CollapseModule, ModalModule]
      });
    }
  }
  return TagcloudModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SuchUmkreisSliderComponent = /*#__PURE__*/(() => {
  class SuchUmkreisSliderComponent {
    constructor() {
      this.auswahlUmkreis = new EventEmitter();
      this.id = 'suche';
      this.modifikatorFuerBeschreibung = value => value;
    }
    onChange(value) {
      if (!this.disabled) {
        this.auswahlUmkreis.emit(this.moeglicheWerte[value]);
      }
    }
    onInput(value) {
      if (!this.disabled) {
        this.aktuellerWert = this.moeglicheWerte[value];
      }
    }
    get aktuellerWertPosition() {
      return this.moeglicheWerte.findIndex(moeglicherWert => moeglicherWert === this.aktuellerWert);
    }
    static {
      this.ɵfac = function SuchUmkreisSliderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SuchUmkreisSliderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SuchUmkreisSliderComponent,
        selectors: [["ba-bub-such-umkreis-slider"]],
        inputs: {
          id: "id",
          disabled: "disabled",
          moeglicheWerte: "moeglicheWerte",
          aktuellerWert: "aktuellerWert",
          modifikatorFuerBeschreibung: "modifikatorFuerBeschreibung"
        },
        outputs: {
          auswahlUmkreis: "auswahlUmkreis"
        },
        decls: 9,
        vars: 24,
        consts: [[1, "umkreis-slider"], [3, "for"], ["data-initialized", "", 1, "ba-range-slider"], ["aria-hidden", "true", 3, "for", "ngClass"], ["type", "range", "autocomplete", "off", "name", "Suchumkreis", 3, "change", "input", "min", "max", "value", "disabled", "step"], ["aria-hidden", "true", 1, "px-0", "d-flex", "w-100"], ["role", "option", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], ["role", "option", 3, "click", "ngClass"]],
        template: function SuchUmkreisSliderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "label", 1);
            i0.ɵɵtext(2, "Gew\xE4hlter Umkreis");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2)(4, "output", 3);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "input", 4);
            i0.ɵɵlistener("change", function SuchUmkreisSliderComponent_Template_input_change_6_listener($event) {
              return ctx.onChange($event.target.value);
            })("input", function SuchUmkreisSliderComponent_Template_input_input_6_listener($event) {
              return ctx.onInput($event.target.value);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "datalist", 5);
            i0.ɵɵtemplate(8, SuchUmkreisSliderComponent_span_8_Template, 2, 9, "span", 6);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵattribute("id", "umkreis-slider" + ctx.id);
            i0.ɵɵadvance();
            i0.ɵɵproperty("for", "umkreis-slider-auswahl" + ctx.id);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("for", "umkreis-slider-auswahl" + ctx.id)("ngClass", i0.ɵɵpureFunction1(22, _c19, ctx.disabled));
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.modifikatorFuerBeschreibung(ctx.moeglicheWerte[ctx.aktuellerWertPosition], ctx.aktuellerWertPosition));
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("--min", 0)("--max", ctx.moeglicheWerte.length - 1)("--val", ctx.aktuellerWertPosition);
            i0.ɵɵproperty("min", 0)("max", ctx.moeglicheWerte.length - 1)("value", ctx.aktuellerWertPosition)("disabled", ctx.disabled)("step", 1);
            i0.ɵɵattribute("id", "umkreis-slider-auswahl" + ctx.id)("aria-valuenow", ctx.aktuellerWertPosition)("aria-valuetext", ctx.modifikatorFuerBeschreibung(ctx.moeglicheWerte[ctx.aktuellerWertPosition], ctx.aktuellerWertPosition))("aria-labelledby", "umkreis-slider-auswahl" + ctx.id + "-label");
            i0.ɵɵadvance();
            i0.ɵɵattribute("id", "umkreise-list" + ctx.id);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.moeglicheWerte);
          }
        },
        dependencies: [NgClass, NgFor],
        styles: ["h1,h2,h3,h4,h5,h6,.h1,.h2,.h3,.h4,.h5,.h6{margin-right:0;margin-bottom:1rem;margin-left:0;font-family:Roboto Condensed Bold,Helvetica Neue,Arial,sans-serif;line-height:1.2}h1,.h1{font-size:2.313125rem}h2,.h2{margin-top:3.75rem;font-size:2.01125rem}@media (min-width: 768px){h2,.h2{margin-top:6rem}}h3,.h3{margin-top:3rem;font-size:1.74875rem}@media (min-width: 768px){h3,.h3{margin-top:4.5rem}}h4,.h4{margin-top:2.25rem;font-size:1.520625rem}@media (min-width: 768px){h4,.h4{margin-top:3rem}}h5,.h5{margin-top:1.5rem;font-size:1.3225rem}h6,.h6{margin-top:1.5rem;font-size:1.15rem}:not(.container-fluid)>h1:first-child,:not(.container-fluid)>h2:first-child,:not(.container-fluid)>h3:first-child,:not(.container-fluid)>h4:first-child,:not(.container-fluid)>h5:first-child,:not(.container-fluid)>h6:first-child,:not(.container-fluid)>.h1:first-child,:not(.container-fluid)>.h2:first-child,:not(.container-fluid)>.h3:first-child,:not(.container-fluid)>.h4:first-child,:not(.container-fluid)>.h5:first-child,:not(.container-fluid)>.h6:first-child{margin-top:0}.ba-microcopy,small{color:#595959;font-size:.8125rem;line-height:1.2}.ba-microcopy a,small a{font-size:.8125rem;line-height:1.2}code.code-block-small{display:block;font-size:.8rem;line-height:1rem}cite{font-style:normal}strong,b{font-family:Roboto Bold,Helvetica Neue,Arial,sans-serif;font-weight:400}.font-bold{font-family:Roboto Bold,Helvetica Neue,Arial,sans-serif}.font-condensed{font-family:Roboto Condensed,Helvetica Neue,Arial,sans-serif}.font-condensed-bold{font-family:Roboto Condensed Bold,Helvetica Neue,Arial,sans-serif}.ba-range-slider datalist{margin-top:0}.ba-range-slider datalist>span[role=option]{font-family:Roboto Condensed,Helvetica Neue,Arial,sans-serif;cursor:pointer}.ba-range-slider datalist>span[role=option]:hover:not(.disabled){text-decoration:underline}.ba-range-slider datalist>span[role=option].disabled{cursor:not-allowed}.ba-range-slider input[type=range]:disabled{cursor:not-allowed}.ba-range-slider input[type=range]:disabled::-webkit-slider-thumb,.ba-range-slider input[type=range]:disabled::-webkit-slider-runnable-track{cursor:not-allowed}.ba-range-slider input[type=range]:disabled::-moz-range-thumb,.ba-range-slider input[type=range]:disabled::-moz-range-track{cursor:not-allowed}.umkreis-slider label+.ba-range-slider output{top:-35px}.umkreis-slider label{margin-bottom:16px}\n/*! @design/bapf-pattern-library v3.7.0 | 09.12.2024 | _type.scss */\n/*! @design/bapf-pattern-library v3.7.0 | 09.12.2024 | _colors.scss */\n/*! @design/bapf-pattern-library v3.7.0 | 09.12.2024 | _design-tokens.scss */\n/*! @design/bapf-pattern-library v3.7.0 | 09.12.2024 | _helpers.scss */\n/*! @design/bapf-pattern-library v3.7.0 | 09.12.2024 | _dpl-variables.scss */\n/*! @design/bapf-pattern-library v3.7.0 | 09.12.2024 | _variables.scss */\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return SuchUmkreisSliderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SuchUmkreisSliderModule = /*#__PURE__*/(() => {
  class SuchUmkreisSliderModule {
    static {
      this.ɵfac = function SuchUmkreisSliderModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SuchUmkreisSliderModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: SuchUmkreisSliderModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, InputrangeModule]
      });
    }
  }
  return SuchUmkreisSliderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Standard Facetten-Rahmen,
 * dessen Inhalt und Verhalten konfiguriert werden kann.
 * Bietet ferner auch Template-Referenzen an, zur inhaltlichen Ausgestaltung bei der Verwendung
 */
let FacetteComponent = /*#__PURE__*/(() => {
  class FacetteComponent {
    constructor() {
      this.showReset = false;
      this.headingLevel = 2;
      this.resetClicked = new EventEmitter();
    }
    static {
      this.ɵfac = function FacetteComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FacetteComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FacetteComponent,
        selectors: [["ba-bub-facette"]],
        inputs: {
          id: "id",
          icon: "icon",
          showReset: "showReset",
          facettenName: "facettenName",
          customStyle: "customStyle",
          headingLevel: "headingLevel",
          facettenInhalt: "facettenInhalt",
          druckansicht: "druckansicht"
        },
        outputs: {
          resetClicked: "resetClicked"
        },
        decls: 8,
        vars: 8,
        consts: [["role", "presentation", 1, "ba-tile", "ba-layoutless", "print-hide", "d-block"], [1, "ba-filterfacet", "ba-filterfacet-top"], [1, "d-flex"], ["class", "ba-filterfacet-top-headline h5 flex-grow-1 mb-0", "role", "heading", 3, "id", 4, "ngIf"], ["type", "reset", "class", "ba-filterfacet-top-remove ba-icon ba-icon-trash fs-5", "data-bs-toggle", "popover", "data-bs-placement", "top", 3, "id", "click", 4, "ngIf"], ["aria-hidden", "true", 4, "ngIf"], [4, "ngTemplateOutlet"], ["class", "print-only", "aria-hidden", "true", 4, "ngIf"], ["role", "heading", 1, "ba-filterfacet-top-headline", "h5", "flex-grow-1", "mb-0", 3, "id"], ["aria-hidden", "true"], [1, "sr-only"], ["type", "reset", "data-bs-toggle", "popover", "data-bs-placement", "top", 1, "ba-filterfacet-top-remove", "ba-icon", "ba-icon-trash", "fs-5", 3, "click", "id"], ["aria-hidden", "true", 1, "print-only"], [3, "id"]],
        template: function FacetteComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "fieldset", 1)(2, "div", 2);
            i0.ɵɵtemplate(3, FacetteComponent_div_3_Template, 7, 7, "div", 3)(4, FacetteComponent_button_4_Template, 1, 6, "button", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, FacetteComponent_hr_5_Template, 1, 0, "hr", 5)(6, FacetteComponent_ng_container_6_Template, 1, 0, "ng-container", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(7, FacetteComponent_fieldset_7_Template, 6, 4, "fieldset", 7);
          }
          if (rf & 2) {
            i0.ɵɵstyleMap(ctx.customStyle);
            i0.ɵɵadvance();
            i0.ɵɵattribute("aria-labelledby", "legende_" + ctx.id);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.facettenName);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showReset);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.facettenName);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.facettenInhalt);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.druckansicht);
          }
        },
        dependencies: [NgIf, TooltipDirective, NgTemplateOutlet],
        styles: ["@media screen{.print-only[_ngcontent-%COMP%]{visibility:hidden;display:none}}@media print{.print-only[_ngcontent-%COMP%]{display:block;visibility:visible}.print-hide[_ngcontent-%COMP%]{visibility:hidden;display:none}}.ba-filterfacet[_ngcontent-%COMP%]{padding:0;border:none;margin-bottom:0}.ba-filterfacet-top-headline[_ngcontent-%COMP%]{display:grid;gap:1rem;grid-template-columns:auto 1fr auto;align-items:center}.ba-filterfacet-top-headline[_ngcontent-%COMP%]   .facette-icon[_ngcontent-%COMP%]:before{display:grid;font-size:2rem}hr[_ngcontent-%COMP%]{border:none;height:2px;background-color:#b3b3b3;margin:16px 0 20px;opacity:.25}.ba-filterfacet-top-remove[_ngcontent-%COMP%]{border:0;background-color:transparent;color:#020e25;border-radius:10%}\n\n\n\n\n\n\n\n\n\n"]
      });
    }
  }
  return FacetteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FacetteModule = /*#__PURE__*/(() => {
  class FacetteModule {
    static {
      this.ɵfac = function FacetteModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FacetteModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: FacetteModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TooltipModule]
      });
    }
  }
  return FacetteModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FeedbackComponent = /*#__PURE__*/(() => {
  class FeedbackComponent {
    /**
     * Instanziiert die Services für die Komponente
     */
    constructor(scriptInjectorService, httpClient, loggingService, changeDetectorRef) {
      this.scriptInjectorService = scriptInjectorService;
      this.httpClient = httpClient;
      this.loggingService = loggingService;
      this.changeDetectorRef = changeDetectorRef;
      /**
       * True wenn die Scripte geladen sind und die Feedback Komponente zur Verfügung steht
       */
      this.componentReady = false;
      /**
       * Wird true wenn eines der Scripte nicht geladen werden konnte
       */
      this.componentHasError = false;
      this.initialized = new EventEmitter();
      this.conf = window.infosysbubLibConfig;
    }
    ngAfterContentInit() {
      this.checkUrl(this.conf?.feedbackScriptUrl).pipe(first(),
      // nur laden, wenn feedbackScriptUrl erreichbar ist
      filter(check => check)).subscribe(() => this.loadFeedbackScript());
    }
    /**
     * Lädt die Feedback-Komponente per Script Injector Service in die App rein
     */
    loadFeedbackScript() {
      this.componentReady = this.scriptInjectorService.inject(this.conf.feedbackScriptUrl, 'feedback/loader.js', true);
      this.changeDetectorRef.detectChanges();
      this.initialized.emit(this.componentReady);
    }
    /**
     * Test ob die URL geholt werden kann.
     * @returns url war erreichbar
     */
    checkUrl(url) {
      if (!url) {
        this.loggingService.error('Kein feedbackScriptUrl in infosysbubLibConfig konfiguriert');
        this.initialized.emit(false);
        return of(false);
      }
      return this.httpClient.get(url, {
        observe: 'response',
        responseType: 'blob'
      }).pipe(map(response => {
        if (response.status === 200) {
          return true;
        } else {
          throw new Error('http status ' + response.status);
        }
      }), catchError(error => {
        this.loggingService.error(`Script '${url}' konnte nicht geladen werden`, error);
        this.componentHasError = true;
        this.initialized.emit(false);
        return of(false);
      }));
    }
    static {
      this.ɵfac = function FeedbackComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FeedbackComponent)(i0.ɵɵdirectiveInject(ScriptInjectorService), i0.ɵɵdirectiveInject(i2.HttpClient), i0.ɵɵdirectiveInject(LoggingService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FeedbackComponent,
        selectors: [["ba-bub-feedback"]],
        inputs: {
          clientId: "clientId",
          subject: "subject",
          customHeader: "customHeader"
        },
        outputs: {
          initialized: "initialized"
        },
        decls: 2,
        vars: 2,
        consts: [[4, "ngIf"], [4, "ngTemplateOutlet"], ["slot", "header", "style", "font-size: 25px; margin-bottom: 10.5px", 4, "ngIf"], ["slot", "header", 2, "font-size", "25px", "margin-bottom", "10.5px"]],
        template: function FeedbackComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, FeedbackComponent_ba_feedback_0_Template, 3, 4, "ba-feedback", 0)(1, FeedbackComponent_div_1_Template, 2, 0, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.componentHasError && ctx.componentReady);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.componentHasError || !ctx.componentReady);
          }
        },
        dependencies: [NgIf, NgTemplateOutlet],
        encapsulation: 2
      });
    }
  }
  return FeedbackComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FeedbackModule = /*#__PURE__*/(() => {
  class FeedbackModule {
    static {
      this.ɵfac = function FeedbackModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FeedbackModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: FeedbackModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [ScriptInjectorService],
        imports: [CommonModule]
      });
    }
  }
  return FeedbackModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Ermöglicht das Tracken von Click-Events direkt im HTML-Template.
 * Ist besonders dann praktisch, wenn keine Handler-Funktion aufgerufen wird,
 * wie zum Beispiel bei Links oder Router-Navigation.
 *
 * @example
 * <a
 *   [routerLink]="routerLink"
 *   [queryParams]="queryParams"
 *   [trackEvent]="{ action: 'click', category: 'kachel', name: title }"
 *   class="ba-tile ba-with-image ba-img-large"
 * >
 * ...
 * </a>
 */
let TrackEventDirective = /*#__PURE__*/(() => {
  class TrackEventDirective {
    constructor(trackingService) {
      this.trackingService = trackingService;
    }
    trackClick() {
      this.trackingService.trackEvent(this.trackEvent.action, this.trackEvent.category, this.trackEvent.name, this.trackEvent.value);
    }
    static {
      this.ɵfac = function TrackEventDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrackEventDirective)(i0.ɵɵdirectiveInject(TrackingService));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TrackEventDirective,
        selectors: [["", "trackEvent", ""]],
        hostBindings: function TrackEventDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function TrackEventDirective_click_HostBindingHandler() {
              return ctx.trackClick();
            });
          }
        },
        inputs: {
          trackEvent: "trackEvent"
        }
      });
    }
  }
  return TrackEventDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let KachelComponent = /*#__PURE__*/(() => {
  class KachelComponent {
    constructor() {
      this.queryParams = null;
      this.id = Math.floor(Math.random() * (999 - 1) + 1).toString();
      this.clickable = true;
    }
    get imageUrl() {
      return `url(${this.img})`;
    }
    static {
      this.ɵfac = function KachelComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || KachelComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: KachelComponent,
        selectors: [["ba-bub-kachel"]],
        inputs: {
          title: "title",
          img: "img",
          routerLink: "routerLink",
          queryParams: "queryParams",
          id: "id",
          clickable: "clickable"
        },
        ngContentSelectors: _c0,
        decls: 8,
        vars: 13,
        consts: [[1, "ba-tile", "ba-link-tile", "ba-with-image", "ba-img-large"], [1, "ba-image", 3, "ngStyle"], [1, "ba-heading", 3, "id"], ["href", "#", 3, "routerLink", "queryParams", "trackEvent"], [1, "ba-copytext"]],
        template: function KachelComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "section", 0);
            i0.ɵɵelement(1, "div", 1);
            i0.ɵɵelementStart(2, "h2", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(4, "a", 3);
            i0.ɵɵelementStart(5, "div", 4)(6, "p");
            i0.ɵɵprojection(7);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("disabled", !ctx.clickable);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(9, _c21, ctx.imageUrl));
            i0.ɵɵadvance();
            i0.ɵɵproperty("id", "kachel-" + ctx.id);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("routerLink", ctx.routerLink)("queryParams", ctx.queryParams)("trackEvent", i0.ɵɵpureFunction1(11, _c22, ctx.title));
            i0.ɵɵattribute("aria-labelledby", "kachel-" + ctx.id);
          }
        },
        dependencies: [NgStyle, RouterLink, TrackEventDirective],
        styles: [".ba-tile.ba-img-large[_ngcontent-%COMP%]   .ba-image[_ngcontent-%COMP%]{height:250px}.ba-tile[_ngcontent-%COMP%]   h2.ba-heading[_ngcontent-%COMP%]{min-height:0!important}.disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:1}"]
      });
    }
  }
  return KachelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let KachelModule = /*#__PURE__*/(() => {
  class KachelModule {
    static {
      this.ɵfac = function KachelModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || KachelModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: KachelModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, RouterModule]
      });
    }
  }
  return KachelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// Kurzbezeichnung der Regionen
var RegionKurz = /*#__PURE__*/function (RegionKurz) {
  RegionKurz["BB"] = "BB";
  RegionKurz["BE"] = "BE";
  RegionKurz["BW"] = "BW";
  RegionKurz["BY"] = "BY";
  RegionKurz["HB"] = "HB";
  RegionKurz["HE"] = "HE";
  RegionKurz["HH"] = "HH";
  RegionKurz["MV"] = "MV";
  RegionKurz["NI"] = "NI";
  RegionKurz["NW"] = "NW";
  RegionKurz["RP"] = "RP";
  RegionKurz["SH"] = "SH";
  RegionKurz["SL"] = "SL";
  RegionKurz["SN"] = "SN";
  RegionKurz["ST"] = "ST";
  RegionKurz["TH"] = "TH";
  RegionKurz["iA"] = "iA";
  RegionKurz["iB"] = "iB";
  RegionKurz["iCH"] = "iCH";
  RegionKurz["iCZ"] = "iCZ";
  RegionKurz["iD"] = "iD";
  RegionKurz["iDK"] = "iDK";
  RegionKurz["iE"] = "iE";
  RegionKurz["iF"] = "iF";
  RegionKurz["iGB"] = "iGB";
  RegionKurz["iH"] = "iH";
  RegionKurz["iI"] = "iI";
  RegionKurz["iLU"] = "iLU";
  RegionKurz["iN"] = "iN";
  RegionKurz["iNL"] = "iNL";
  RegionKurz["iPL"] = "iPL";
  RegionKurz["iS"] = "iS";
  RegionKurz["iSK"] = "iSK";
  RegionKurz["iIRL"] = "iIRL";
  RegionKurz["iP"] = "iP";
  RegionKurz["iFIN"] = "iFIN";
  RegionKurz["iSLO"] = "iSLO";
  RegionKurz["iWORLD"] = "iWORLD";
  return RegionKurz;
}(RegionKurz || {});
// Langbezeichnung (z.B. Bayern) der Regionen
var RegionLang = /*#__PURE__*/function (RegionLang) {
  RegionLang["BB"] = "Brandenburg";
  RegionLang["BE"] = "Berlin";
  RegionLang["BW"] = "Baden-W\u00FCrttemberg";
  RegionLang["BY"] = "Bayern";
  RegionLang["HB"] = "Bremen";
  RegionLang["HE"] = "Hessen";
  RegionLang["HH"] = "Hamburg";
  RegionLang["MV"] = "Mecklenburg-Vorpommern";
  RegionLang["NI"] = "Niedersachsen";
  RegionLang["NW"] = "Nordrhein-Westfalen";
  RegionLang["RP"] = "Rheinland-Pfalz";
  RegionLang["SH"] = "Schleswig-Holstein";
  RegionLang["SL"] = "Saarland";
  RegionLang["SN"] = "Sachsen";
  RegionLang["ST"] = "Sachsen-Anhalt";
  RegionLang["TH"] = "Th\u00FCringen";
  RegionLang["iA"] = "\u00D6sterreich";
  RegionLang["iB"] = "Belgien";
  RegionLang["iCH"] = "Schweiz";
  RegionLang["iCZ"] = "Tschechien";
  RegionLang["iD"] = "Deutschland";
  RegionLang["iDK"] = "D\u00E4nemark";
  RegionLang["iE"] = "Spanien";
  RegionLang["iF"] = "Frankreich";
  RegionLang["iGB"] = "Gro\u00DFbritannien";
  RegionLang["iH"] = "Ungarn";
  RegionLang["iI"] = "Italien";
  RegionLang["iLU"] = "Luxemburg";
  RegionLang["iN"] = "Norwegen";
  RegionLang["iNL"] = "Niederlande";
  RegionLang["iPL"] = "Polen";
  RegionLang["iS"] = "Schweden";
  RegionLang["iSK"] = "Slowakei";
  RegionLang["iIRL"] = "Irland";
  RegionLang["iP"] = "Portugal";
  RegionLang["iFIN"] = "Finnland";
  RegionLang["iSLO"] = "Slowenien";
  RegionLang["iWORLD"] = "Weitere L\u00E4nder";
  return RegionLang;
}(RegionLang || {});
class Regionenliste {
  static {
    this.REGIONEN = {
      BB: RegionLang.BB,
      BE: RegionLang.BE,
      BW: RegionLang.BW,
      BY: RegionLang.BY,
      HB: RegionLang.HB,
      HE: RegionLang.HE,
      HH: RegionLang.HH,
      MV: RegionLang.MV,
      NI: RegionLang.NI,
      NW: RegionLang.NW,
      RP: RegionLang.RP,
      SH: RegionLang.SH,
      SL: RegionLang.SL,
      SN: RegionLang.SN,
      ST: RegionLang.ST,
      TH: RegionLang.TH,
      iA: RegionLang.iA,
      iB: RegionLang.iB,
      iCH: RegionLang.iCH,
      iCZ: RegionLang.iCZ,
      iD: RegionLang.iD,
      iDK: RegionLang.iDK,
      iE: RegionLang.iE,
      iF: RegionLang.iF,
      iGB: RegionLang.iGB,
      iH: RegionLang.iH,
      iI: RegionLang.iI,
      iLU: RegionLang.iLU,
      iN: RegionLang.iN,
      iNL: RegionLang.iNL,
      iPL: RegionLang.iPL,
      iS: RegionLang.iS,
      iSK: RegionLang.iSK,
      iIRL: RegionLang.iIRL,
      iP: RegionLang.iP,
      iFIN: RegionLang.iFIN,
      iSLO: RegionLang.iSLO,
      iWORLD: RegionLang.iWORLD
    };
  }
}
let KarteComponent = /*#__PURE__*/(() => {
  class KarteComponent {
    constructor(decimalPipe, trackingService) {
      this.decimalPipe = decimalPipe;
      this.trackingService = trackingService;
      this.focusedRegion = null;
      this.zoomLevel = 'national';
      this.isAnimated = false;
      this.keineErgebnisse = 'keine Ergebnisse';
      this.id = 'Bundesland';
      this.regionenKurz = RegionKurz;
      this.regionClicked = new EventEmitter();
      this.trackByItemKey = trackByItemKey;
    }
    ngOnChanges(simpleChanges) {
      // wenn nur ein/mehrere internationales Land gewählt ist, wird direkt die international-Karte angezeigt
      if (this.shouldShowInternational()) {
        this.onInternationalClicked();
      } else if (!this.hasInternational) {
        // Falls nur Bundesländer angezeigt werden können, schalte immer Nationalansicht ein,
        // da der Button zum Zurückwechseln automatisch ausgeblendet wird.
        this.onNationalClicked();
      }
    }
    get hasInternational() {
      return this.moeglicheLaender.filter(this.isInternational).length > 0;
    }
    shouldShowInternational() {
      return this.hasInternational && this.selectionIsOnlyInternational();
    }
    isInternational(item) {
      return item.key.startsWith('i');
    }
    isNational(item) {
      return !item.key.startsWith('i');
    }
    onInternationalClicked() {
      if (this.zoomLevel === 'national') {
        this.trackingService.trackEvent('click', 'regionen-facette-tab', 'international');
        this.triggerAnimation();
      }
      this.zoomLevel = 'international';
    }
    onNationalClicked() {
      if (this.zoomLevel === 'international') {
        this.trackingService.trackEvent('click', 'regionen-facette-tab', 'national');
        this.triggerAnimation();
      }
      this.zoomLevel = 'national';
    }
    triggerAnimation() {
      this.isAnimated = true;
      setTimeout(() => this.isAnimated = false, 1220);
    }
    toggleRegion(region) {
      // liste von selectedRegionen wird emitted, darin enthalten auch die Aenderung der geklickten Region
      // (je nachdem, ob Klick das Land deselektiert oder selektiert hat)
      const selectedRegionen = this.moeglicheLaender.map(l => l.key === region ? {
        ...l,
        selected: !l.selected
      } : l).filter(l => l.selected).map(l => RegionKurz[l.key]);
      this.regionClicked.emit(selectedRegionen);
    }
    get zoomLevelCss() {
      if (this.isAnimated) {
        return `${this.zoomLevel} animated`;
      }
      return this.zoomLevel;
    }
    selectionIsOnlyInternational() {
      const selectedInternational = this.moeglicheLaender.filter(item => item.selected && item.key.startsWith('i'));
      const selectedCountries = this.moeglicheLaender.filter(item => item.selected);
      return selectedInternational.length === selectedCountries.length && selectedInternational.length > 0;
    }
    /**
     * Get the CSS class names for the map group for the Bundesland.
     *
     * @param region The ISO 2-letter name of the Bundesland OR "i"+international car sign.
     */
    getClassnameForRegion(region) {
      const item = this.getRegionByKey(region);
      if (null === item) {
        return 'map-group';
      } else {
        return 'map-group' + (item.selected ? ' selected' : '') + (item.active && !item.selected ? ' enabled' : '') + (this.focusedRegion === item.key ? ' checkbox-focus' : '');
      }
    }
    /**
     * Get either the 1st or 2nd line for region comments.
     *
     * The first line always returns the name of the Bundesland and the second a dynamic status.
     *
     * @param region The ISO 2-letter name of the Bundesland OR the country.
     * @param commentNumber The number for the comment (1 or 2).
     */
    getCommentLine(region, commentNumber) {
      let result = '(keine Ergebnisse)';
      if (1 === commentNumber) {
        result = Regionenliste.REGIONEN[region];
      } else {
        const item = this.getRegionByKey(region);
        if (item) {
          let plus = '';
          // wenn bereits ein Land ausgewählt wurde, soll unter der Karte <Land> + x Ergebnisse stehen
          if (!item.selected && this.moeglicheLaender.filter(x => x.selected).length > 0) {
            plus = '+';
          }
          if (item.selected || item.active) {
            result = plus + this.decimalPipe.transform(item.treffer) + (item.treffer === 1 ? ' Ergebnis' : ' Ergebnisse');
          }
        }
      }
      return result;
    }
    /**
     * Get the region object from the ISO 2-letter name OR international car sign.
     *
     * @param region The ISO 2-letter name of the Bundesland OR international car sign.
     */
    getRegionByKey(region) {
      const matchList = this.moeglicheLaender.filter(x => x.key === region);
      if (matchList.length === 0) {
        return null;
      }
      return matchList[0];
    }
    moeglicheLaenderDerAnsicht() {
      if (this.zoomLevel === 'national') {
        // Für eine bessere Tab-Reihenfolge nach Namen sortiert
        // Matched die Reihenfolge der Buttons
        // Leider bei international nicht alphabetisch sortiert.
        return this.moeglicheLaender.filter(item => this.isNational(item)).sort((itemL, itemR) => itemL.ariaLabel.localeCompare(itemR.ariaLabel, 'de'));
      }
      return this.moeglicheLaender.filter(item => this.isInternational(item));
    }
    /**
     * Set the focus for the checkbox for the given Bundesland.
     *
     * Appends the Bundesland OR country to the end of the SVG in order to "raise" it for highlighting.
     *
     * @param region The Bundesland OR country to be focused.
     */
    focusCheckbox(region) {
      if (region.startsWith('i')) {
        if (typeof this.svgEurope !== 'undefined') {
          this.svgEurope.nativeElement.appendChild(this.svgEurope.nativeElement.querySelector(`[id=${this.id}-country-${region.substr(1)}]`));
          this.zoomLevel = 'international';
        }
      } else {
        if (typeof this.svgGermany !== 'undefined') {
          this.svgGermany.nativeElement.appendChild(this.svgGermany.nativeElement.querySelector(`[id=${this.id}-state-${region}]`));
          this.zoomLevel = 'national';
        }
      }
      this.focusedRegion = region;
    }
    /**
     * Blurs the checkbox for the given Bundesland or State
     */
    blurCheckbox() {
      this.focusedRegion = null;
    }
    /**
     * Berechnet die Anzahl für alle in Deutschland vorhandenen
     * Angebote und erzeugt einen entsprechenden Infotext.
     */
    getAnzahlDeutschland() {
      const anzahlGesamt = this.moeglicheLaender.filter(item => item.key.charAt(0) !== 'i').length;
      if (anzahlGesamt === 0) {
        return '(keine Ergebnisse)';
      }
      const anzahlAusgewaehlt = this.moeglicheLaender.filter(item => item.selected && !item.key.startsWith('i')).map(item => item.treffer).reduce((previousValue, currentValue) => previousValue + currentValue, 0);
      if (anzahlAusgewaehlt === 0) {
        return '';
      }
      if (anzahlAusgewaehlt === 1) {
        return '1 Ergebnis';
      }
      return anzahlAusgewaehlt + ' Ergebnisse';
    }
    static {
      this.ɵfac = function KarteComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || KarteComponent)(i0.ɵɵdirectiveInject(i1$3.DecimalPipe), i0.ɵɵdirectiveInject(TrackingService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: KarteComponent,
        selectors: [["ba-bub-karte"]],
        viewQuery: function KarteComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c23, 5);
            i0.ɵɵviewQuery(_c24, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.svgGermany = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.svgEurope = _t.first);
          }
        },
        inputs: {
          moeglicheLaender: "moeglicheLaender",
          id: "id"
        },
        outputs: {
          regionClicked: "regionClicked"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 164,
        vars: 94,
        consts: [["svg_germany", ""], ["svg_europe", ""], [3, "mousemove", "id"], ["class", "scope-switcher", 4, "ngIf"], [2, "overflow", "hidden", "position", "relative"], ["width", "254", "height", "254"], [1, "map", "map-national"], ["xmlns", "http://www.w3.org/2000/svg", "id", "svg-map-germany", "viewBox", "0 0 255 255", "version", "1.1", 2, "position", "absolute", "top", "0", "left", "0", "width", "100%"], ["id", "boxshadow"], ["in", "SourceAlpha", "stdDeviation", "1.1415"], ["dx", "0", "dy", "0", "result", "offsetblur"], ["flood-color", "rgba(0,0,255,1)"], ["in2", "offsetblur", "operator", "in"], ["in", "SourceGraphic"], [3, "click", "id"], ["x", "2", "y", "3", "width", "32", "height", "18", "rx", "2", "ry", "2", 1, "box"], ["x", "18", "y", "15.96", 1, "text"], ["x", "127", "y", "225", 1, "comment1"], ["x", "127", "y", "241", 1, "comment2"], ["d", "m 105.53,195.24 -0.03,0.08 -0.2,-0.08 z m -1.32,0.98 -0.08,-0.08 0,-0.08 z m -7.52,-1.29 0.27,0.64 -0.96,0.13 0.02,-0.74 z m 0.15,-50.38 0.08,-0.04 -0.05,0.04 z m -7.92,17.15 0.5,-0.36 0.27,-0.24 1.13,-2.35 1.32,-4.47 0.94,-0.87 0.35,-0.18 -0.61,-0.77 0.34,-0.57 0.43,-0.53 0.1,-0.68 -0.48,0.34 -0.16,-0.08 -0.01,-0.21 0.54,-0.41 0.05,-0.31 0.18,-0.68 -0.6,-0.17 -0.52,-0.21 0.37,-0.51 -0.67,-1.89 0.01,-0.87 -0.01,-0.25 0.72,-0.13 1.99,1.86 0.68,-0.65 -0.45,-1.76 1.46,-0.38 0.25,0.17 -0.36,0.26 0.44,0.36 -0.3,0.53 0.78,1.53 1.21,0.18 0.41,-0.33 0.15,0.85 0.3,-0.24 0.86,-0.03 0,0.49 -1.25,0.4 -0.22,1.92 0.68,0.03 0.8,-1.23 0.87,-0.32 -0.31,-0.41 0.18,-0.39 0.2,0.1 -0.04,-0.64 0.58,-0.12 0.97,0.32 0.4,-0.82 0.31,0.1 0.74,0.25 -0.66,-0.85 -0.26,-0.7 0.22,0.37 0.24,0.02 0.07,-0.45 2.32,-0.09 1.12,-1.93 1.36,0.31 0.47,-0.54 -0.19,-1.73 -0.74,0.64 -0.22,-0.37 0.52,-0.25 -1.34,-0.33 0.47,-0.1 -0.11,-0.66 2.64,-0.28 0.56,-0.21 1,1.13 -0.03,-0.95 1.48,-0.29 -0.28,2.6 0.75,0 0.56,-0.89 0.52,1.03 1.03,-1.14 1.25,3.19 -1.06,1.41 0.83,0.28 0.91,-1.06 0.27,2.68 1.6,-0.05 0.65,-0.83 -0.35,-0.37 0.77,-0.31 0.01,0.85 0.64,-0.01 -0.04,1.01 -0.4,0.66 1.16,1.39 -0.85,0.28 -0.15,1.16 0.93,1.6 -0.8,0.6 0.41,0.12 -0.13,1.42 2.13,1.32 0.16,0.53 -0.9,0.81 0.79,0.14 0.1,0.89 -0.07,0.54 1.7,0.27 1.05,1.33 0.85,1.6 -0.62,0.3 0.56,0.49 -0.48,3.78 0.72,0.26 0.41,1 -1.33,0.96 0.45,-0.87 -0.5,-0.14 -0.82,1.23 -0.43,-0.94 -1.2,-0.38 -0.23,1.05 1.21,1.43 -0.52,0.52 0.4,1.67 -0.64,0.3 -0.83,0.15 0.07,0.14 0.11,-0.02 -0.06,0.14 -1.79,1.21 -0.28,-0.47 -1.5,0.42 0.18,0.74 -1.31,1.47 0.53,0.64 1.2,1.81 0.56,3.11 0.72,1.46 0.02,2.25 -0.06,0.23 -0.3,1.03 -0.19,0.04 -0.34,0.46 0.46,0.53 -0.07,1.55 -0.52,0.29 0.98,1.25 -1.18,0.92 0.96,0.69 0.39,1.48 -1.09,1.7 -0.33,-1.09 -0.49,-0.04 -1.28,0.81 -2.07,-0.67 -1.67,1.96 -0.98,-0.18 -1.61,0.72 -0.91,-0.1 -0.98,-1.65 -3.68,-0.89 -1.13,-1.53 -2.71,-1.76 -0.16,-0.21 -0.39,-0.06 0,0.1 -0.16,0.18 0.89,0.91 0.63,0.33 0.34,0.33 0.23,-0.04 0.23,0.27 0.19,0.1 0.1,0.25 0.03,0.54 0.49,0.48 0.18,0.56 -0.18,0.08 -0.52,-0.11 0.06,0.29 -0.11,0.06 0,-0.06 -0.08,0.04 -0.23,-0.31 -0.18,-0.04 -0.15,0.1 -0.21,-0.08 -0.03,-0.19 -0.24,-0.31 -0.33,-0.04 -0.23,0.1 -0.49,-0.17 -0.19,-0.12 -0.03,-0.19 0.07,-0.08 -0.06,-0.1 0.13,0.02 0.1,0.12 0.13,-0.02 0.47,0.41 0.24,0 0.03,-0.06 0.07,0.04 -0.03,-0.06 0.07,0.02 -0.11,-0.31 -0.16,-0.12 -1.23,-0.58 -0.58,-0.4 -0.11,0.06 0.05,0.12 0.24,0.08 0.27,0.29 -0.02,0.06 -0.1,-0.02 0.03,-0.08 -0.08,0 -0.02,-0.06 -0.13,0.02 -0.41,-0.25 -0.11,0.02 -0.15,-0.08 -0.33,0.08 -0.05,0.14 0.06,0.12 0.52,0.33 0.37,0.13 0.21,0.31 -0.26,0.33 -0.25,0.1 -0.12,0.16 -0.36,0.12 -0.23,0.23 -0.23,-0.02 -0.54,0.2 -0.34,-0.11 -0.03,-0.39 -0.23,-0.27 -0.2,-0.02 0.13,-0.29 -0.11,-0.04 0.02,-0.08 0.11,-0.04 0.03,0.06 0.07,-0.06 0.05,0.06 -0.07,0.1 0.21,-0.04 0.03,-0.06 -0.11,-0.15 0.05,-0.06 -0.42,0.02 -0.1,-0.23 -0.18,-0.06 -0.16,0.08 -0.1,-0.04 0.13,-0.12 -0.13,0 -0.1,-0.17 -0.15,-0.02 0.13,-0.16 -0.07,0 -0.03,-0.21 -0.18,0.1 0.05,0.21 -0.13,-0.06 -0.11,0.06 -0.08,0.14 -0.08,-0.04 0.02,0.06 -0.13,0.06 0.05,0.14 -0.05,0.16 0.39,0.04 0.1,0.08 0,0.12 0.16,0.02 0.06,0.08 -0.18,0.04 -0.12,0.31 0.03,0.12 -0.1,0 -0.58,-0.38 -0.52,-0.09 -0.02,-0.1 0.17,-0.51 -0.31,-0.15 -0.13,-0.23 0.07,-0.23 0.15,-0.18 0.33,-0.06 -0.03,-0.14 -0.19,-0.13 0.03,-0.04 -0.29,-0.17 -0.38,0.24 -0.08,-0.06 -0.08,-0.31 0.08,-0.08 -0.1,-0.1 -0.03,-0.25 -0.08,0.02 -0.34,-0.15 0.05,-0.12 -0.05,-0.1 -0.13,0.04 -0.07,0.23 0.06,0.23 -0.03,0.21 0.1,0 -0.13,0.14 -0.02,0.1 -0.25,0.16 -0.06,-0.04 -0.14,-0.21 0.07,-0.27 -0.08,-0.02 -0.06,-0.15 0.13,-0.29 -0.18,-0.19 -0.78,-0.19 0.15,0.72 -1.19,0.13 -1.83,1.91 -0.04,0.78 1.18,0.94 2.37,-0.88 0.38,0.6 -0.59,0.18 -0.24,1.23 -1.15,-1.02 -1.09,0.83 0.66,0.57 -2,0.38 -1.04,-0.2 -0.62,-1.02 -1.5,-0.29 -2.02,1.63 -2.64,0.32 -0.86,-1.15 -1.29,-0.07 -0.61,0.87 -2.15,0.47 -0.6,-0.69 0.93,-0.1 0.15,-0.92 -1.6,0.56 -1.43,-2.3 0.49,-2.09 0.29,-3.54 1.21,-2.51 -0.9,-1.67 0.2,-2.12 1.91,-3.71 0.25,-1.17 0.92,-0.68 -0.19,-1.7 0.68,-2.56 0.69,-0.71 -0.04,-1.92 0.74,-1.43 2.09,-1.94 0.24,-1.05 2.15,-1.28 0.95,-2.48 z m 7.89,-17.23 -0.11,0.16 0.25,-0.06 -0.01,-0.1 z", 1, "state"], ["x", "2", "y", "30", "width", "32", "height", "18", "rx", "2", "ry", "2", 1, "box"], ["x", "18", "y", "42.96", 1, "text"], ["d", "m 127.84,199.13 -0.39,1.39 0.81,1.84 -0.7,0.61 0.01,0.8 -0.74,0.13 -1.14,1.89 -1.73,0.92 -1.09,-0.22 0.78,-0.85 -0.3,-0.41 0.64,-1.47 -0.99,-0.28 -0.27,0.64 -0.82,-0.18 -0.36,0.56 -0.55,-1.44 0.65,-0.52 -0.27,-0.8 -0.84,-0.76 -0.87,0.05 -0.5,-1.58 -0.83,0.44 -0.74,-0.49 -0.1,0.54 -1.05,-0.51 0.14,-1.05 -0.83,-0.2 -0.84,1.63 -2.27,-1.31 1.61,-0.72 0.98,0.18 1.67,-1.96 2.07,0.67 1.28,-0.81 0.49,0.04 0.33,1.09 1.09,-1.7 -0.39,-1.48 -0.96,-0.69 1.18,-0.92 -0.98,-1.25 0.52,-0.29 0.07,-1.55 -0.46,-0.53 0.34,-0.46 0.19,-0.04 0.3,-1.03 0.06,-0.23 -0.02,-2.25 -0.72,-1.46 -0.56,-3.11 -1.2,-1.81 -0.53,-0.64 1.31,-1.47 -0.18,-0.74 1.5,-0.42 0.28,0.47 1.79,-1.21 0.06,-0.14 -0.11,0.02 -0.07,-0.14 0.83,-0.15 0.64,-0.3 -0.4,-1.67 0.52,-0.52 -1.21,-1.43 0.23,-1.05 1.2,0.38 0.43,0.94 0.82,-1.23 0.5,0.14 -0.45,0.87 1.33,-0.96 -0.41,-1 -0.72,-0.26 0.48,-3.78 -0.56,-0.49 0.62,-0.3 -0.85,-1.6 -1.05,-1.33 -1.7,-0.27 0.07,-0.54 -0.1,-0.89 -0.79,-0.14 0.9,-0.81 -0.16,-0.53 -2.13,-1.32 0.13,-1.42 -0.41,-0.12 0.8,-0.6 -0.93,-1.6 0.15,-1.16 0.85,-0.28 -1.16,-1.39 0.4,-0.66 0.04,-1.01 -0.64,0.01 -0.01,-0.85 -0.77,0.31 0.35,0.37 -0.65,0.83 -1.6,0.05 -0.27,-2.68 -0.91,1.06 -0.83,-0.28 1.06,-1.41 -1.25,-3.19 -1.03,1.14 -0.52,-1.03 -0.56,0.89 -0.75,0 0.28,-2.6 -1.48,0.29 0.03,0.95 -1,-1.13 -0.56,0.21 -2.64,0.28 0.11,0.66 -0.47,0.1 1.34,0.33 -0.52,0.25 0.22,0.37 0.74,-0.64 0.19,1.73 -0.47,0.54 -1.36,-0.31 -1.12,1.93 -2.32,0.09 -0.62,-1.12 0.61,-0.59 -0.2,-1.36 0.61,-0.16 0.43,-1.13 -0.75,-0.44 0.43,-0.95 -0.69,0.1 -0.1,-1.51 -0.35,0.43 -0.48,-0.39 0.24,-0.53 -0.56,-3.3 0.56,-0.04 -0.29,-1.24 -0.9,-0.17 0.22,-0.58 0.47,-1.17 1.72,-0.38 0.56,0.23 -0.08,0.72 1.25,-1.54 2.59,0.52 0.5,1.11 1.82,-0.18 0.33,-1.75 -0.56,-0.37 0.05,-1.81 0.7,0.49 1.36,-0.13 0.68,-0.12 -0.19,-0.95 1.57,-1.08 -0.22,-1.19 0.47,-1.86 1.64,0.74 1.28,-0.58 1.4,-1.24 0.38,-1.34 1.08,-1.24 0.57,0.55 1.06,-0.34 0.46,1.13 1.68,0.46 0.7,1.64 0.56,0.18 -0.16,0.83 0.95,-0.22 0.71,1.23 0.88,-0.26 0.3,0.72 0.65,0.07 0.2,2.8 1.3,0.02 0.52,0.57 0.19,-0.68 0.04,-0.58 1.58,0.34 0.44,-0.67 -2.33,-1.51 -0.02,-1.11 0.67,0.13 1.27,-0.95 1.93,0.13 0.7,1.04 0.11,-0.5 0.84,0.54 1.21,-0.62 0.76,0.95 -0.27,1.1 0.81,0.46 0.13,-0.54 1.05,0.43 0.36,-2.28 -0.67,-2.33 0.29,-0.81 0.38,-0.17 0.04,0.27 0.54,-0.43 -0.04,-0.45 0.79,-0.41 1.2,0.57 -0.39,0.88 0.51,1.22 0.62,-0.3 -0.03,0.8 0.68,0.15 0.03,0.56 1.39,-0.68 1.35,0.11 1.83,-0.73 0.53,0.75 1.59,-0.96 1.11,0.89 -0.09,0.99 2.11,0.82 0.7,1.05 -0.78,0.77 1.17,0.74 0.98,1.35 -0.21,1.53 1.3,0.84 -0.23,0.5 0.31,0.03 2.63,1.32 0.02,0.47 1,0.04 -0.2,1.16 1.27,0.47 -1.19,2.29 0.03,1.26 -1.17,0.79 0.76,1.41 1.36,0.4 0.18,1.81 0.55,-0.06 0.65,2.02 0.88,0.48 -0.12,1.24 0.42,1.1 1.79,0.98 0.41,1.22 2.82,-0.02 1.53,0.98 0.13,1.07 2.46,2.28 0.04,0.78 1.16,0.73 0.93,-0.15 1.94,1.68 0.43,1.86 1.42,0.96 0.17,-0.75 1.27,-0.11 0.47,0.74 0.4,-0.19 0.83,1.77 1.13,-0.23 1.3,2.69 0.64,0.23 -0.68,1.57 0.75,0.31 -0.4,0.25 0.32,1.92 -1.55,2.89 -3.85,-1.86 -1.24,1.18 0.39,0.97 -0.62,3.62 -2.53,2.27 -1.48,0.07 -2.72,1.12 -1.24,1.4 -1.33,0.2 -1.96,2.44 0.17,0.96 1.7,1.54 0.5,1.36 0.89,0.6 1.51,2.41 -1.61,3.27 2.49,0.18 1.06,2.01 -0.91,1.43 0.19,2.41 -0.8,0.8 -3.61,-2.13 -0.47,-0.74 0.78,-0.92 -1.22,-0.96 0.42,-0.57 -1.56,-0.22 -1.62,0.31 -0.48,1.09 -1.34,0.26 -1.11,-1.81 -1.81,0.01 -1.46,0.53 -0.16,-1.64 -1.51,1.13 0.85,2.45 -2.59,-0.2 -2.6,0.21 -1.21,0.9 -3.76,-0.18 -1.02,2.09 -2.32,-0.02 -0.56,0.59 -0.44,0.63 0.69,0.7 -1.49,-0.09 -1.13,1.39 -0.87,0.1 0.49,-0.88 -0.82,-0.15 -1.62,1.05 -2.11,0.08 -0.48,-0.14 0.21,-0.81 -0.83,-1.32 -1.19,-0.02 0.82,-0.84 -0.58,-0.61 -1.92,0.63 -1.55,-1.15 -1.67,-0.26 -0.49,0.96 z m 0,0 0.32,-0.83 -0.76,0.26 z", 1, "state"], ["x", "2", "y", "57", "width", "32", "height", "18", "rx", "2", "ry", "2", 1, "box"], ["x", "18", "y", "69.96", 1, "text"], ["d", "m 169.96,69.82 -0.55,0.23 -0.74,-0.83 0.95,-2.23 -0.59,-0.36 0.5,-1.51 -0.42,-0.37 0.56,-0.31 0.87,0.25 -0.01,-1.07 0.71,0.01 0.25,-0.92 0.92,0.96 0.95,-0.73 0.56,0.26 0.85,-0.91 0.59,0.63 -0.16,1.41 1.72,1.19 0.79,0.45 -0.69,1.48 0.9,-0.13 1.56,0.86 -0.9,1.66 -0.79,1.07 -0.11,-1.02 -2.66,-0.35 -0.31,-0.62 -0.7,0.3 0.09,0.9 -1.3,-0.88 -0.49,0.35 -1.48,-0.48 z", 1, "state"], ["x", "2", "y", "84", "width", "32", "height", "18", "rx", "2", "ry", "2", 1, "box"], ["x", "18", "y", "96.96", 1, "text"], ["d", "m 155.78,74.82 0.01,-0.02 0.15,0.04 z m -0.17,-0.06 -0.03,-0.04 0.18,0.01 z m -1.38,-16.64 0.07,-0.02 -0.07,0.06 z m 14.79,31.49 2.14,-1.89 -1.21,-3.63 0.43,-0.14 -0.33,-0.58 -1.5,0.36 0.05,-0.79 -1.18,0.05 -0.24,-0.9 -1.76,0.08 -0.17,-0.86 -1.22,-0.26 -1.78,-0.83 -0.73,0.85 -1.24,-0.01 -1,-1.24 -0.73,0.46 -0.95,-0.71 -0.03,0 -1.67,-1.5 -1.04,-1.71 1.25,-1.55 -0.87,-0.52 0.93,-2.59 -0.62,-1.85 0.66,-1.03 0.17,-1.14 -0.94,0.28 -0.61,-0.95 -0.21,0.62 -0.8,-0.12 0.26,-0.71 -0.75,0.13 0.58,-1.25 -0.18,-1.33 1.03,-0.12 -0.72,-2.34 0.3,-1.9 0.47,-0.06 -0.31,-1.78 -0.6,-0.47 -1.15,0.68 0.01,-0.95 -0.03,-0.1 -0.17,0.48 -0.5,0 -0.1,-0.24 -0.16,0.07 -0.09,-0.12 -0.62,-0.02 -0.63,0.39 -0.8,-0.39 -0.56,-0.02 -0.39,-0.4 -0.54,0 -0.21,-0.14 -0.04,-0.29 0.37,-0.44 -0.11,-0.3 -0.9,-0.16 -0.37,-0.52 -0.34,-0.2 -0.8,0.31 -0.26,-0.77 -0.52,0.08 -0.3,-0.18 0.2,-0.68 -0.67,0.08 -2.41,-1.07 -1.72,0.66 -1.21,-1.74 2.03,0.26 0.43,-0.81 1.8,0.36 0.52,-1.08 -0.32,-1.12 1.21,-0.92 1.13,-0.09 0.47,0.71 1.57,-0.36 -0.54,-0.64 1.04,0.11 0.47,-0.82 0.91,0.16 0.37,-0.73 0.7,-0.04 0.36,-1.9 0.76,0.67 0.94,-0.46 0.28,0.57 0.94,-0.53 0.53,0.89 1.02,0.02 0.12,0.08 1,0.39 0.85,1.34 3.41,-0.26 0.14,0.61 1.43,0.13 0.13,0.92 1.29,-0.38 0.56,0.55 1.31,-0.61 -0.32,0.71 0.68,0.22 1.87,-1.42 0.03,-0.66 1.12,-0.32 0.8,0.87 0.17,-0.44 -0.04,-0.16 0.18,-0.23 -0.12,-0.04 0.11,-0.36 0.36,-0.1 0.13,-0.27 0.2,-0.15 0.63,0.17 0.18,-0.13 0.19,-0.01 0.14,0.18 0.04,0.24 0.19,0.28 0.07,0 0.01,0.16 0.29,-0.08 0.02,-0.41 0.09,-0.02 0.12,-0.17 0.11,-0.38 0.2,-0.09 -0.13,-0.08 0.07,-0.07 -0.06,-0.08 0.04,-0.13 0.29,0.03 0.1,0.24 0.33,-0.1 0.2,-0.28 0.01,-0.16 0.15,-0.21 -0.09,-0.28 0.13,0.22 0.2,-0.05 -0.08,-0.47 0.08,-0.15 -0.01,-0.21 -0.13,-0.01 0.12,-0.4 0.28,0.05 0.05,-0.21 0.15,-0.13 0,-0.08 -0.12,-0.01 0.09,-0.29 -0.16,-0.05 0.05,-0.15 0.23,-0.05 0.13,-0.19 0.24,-0.05 0.07,0.04 0.25,-0.16 0.12,-0.01 0.04,0.12 0.09,-0.03 0.15,-0.38 -0.13,-0.22 0.13,-0.03 0.02,-0.15 -0.07,-0.04 0.09,-0.19 0.18,0.07 0.03,-0.21 0.12,-0.17 0.17,-0.07 0.55,-0.52 1.59,-0.23 0.21,-0.4 -0.79,-0.33 0.26,-1.23 0.41,1.07 0.93,0.32 0.72,2.12 1.31,-0.43 1.31,0.56 0.57,-0.84 1.81,0.22 0.02,1.67 -1.9,2.85 2.54,-0.05 0.82,-1.47 1.48,-0.55 0.71,1.77 -1.05,1.63 -0.13,3.71 -3.19,2.83 0.31,1.73 -0.32,1.79 1.42,0.22 2.23,1.59 1.99,2.26 2.91,2.09 -0.47,1.19 0.55,0.99 -1.44,2.67 1.28,3.15 1.93,0.86 -0.35,3.16 1.35,1.25 -0.57,1.75 -0.2,2.63 -1.57,2.11 3.03,4.17 0.22,1.43 -0.52,0.72 -0.57,-0.35 -0.29,1.24 -1.05,0.07 -0.72,-0.78 -1.92,1.18 -0.99,0.06 -0.84,1.02 -1.01,-0.66 -1.82,-0.11 -0.89,0.57 -0.26,1.19 -0.89,0.11 0.53,0.75 -0.91,1.97 -0.69,-0.6 -2.04,0.65 -1.15,0.54 -1.22,-0.35 -1.59,0.21 -0.42,-0.41 -0.43,0.46 -0.39,-0.85 -1.86,-0.91 -0.18,-0.36 -0.37,0.8 -0.94,-0.28 -0.78,1.44 -0.99,-0.49 -0.2,-0.75 -0.42,0.12 0.44,-2.54 -1.12,-1.08 0.15,-0.87 -0.58,-0.47 -0.56,0.31 z m 0.93,-19.8 0.87,-0.72 1.48,0.48 0.49,-0.35 1.3,0.88 -0.09,-0.9 0.7,-0.3 0.31,0.62 2.66,0.35 0.11,1.02 0.79,-1.07 0.9,-1.66 -1.56,-0.86 -0.9,0.13 0.69,-1.48 -0.79,-0.45 -1.72,-1.19 0.16,-1.41 -0.59,-0.63 -0.85,0.91 -0.56,-0.26 -0.95,0.73 -0.92,-0.96 -0.25,0.92 -0.71,-0.01 0.01,1.07 -0.87,-0.25 -0.56,0.31 0.42,0.37 -0.5,1.51 0.59,0.36 -0.95,2.23 0.74,0.83 z", 1, "state"], ["x", "2", "y", "111", "width", "32", "height", "18", "rx", "2", "ry", "2", 1, "box"], ["x", "18", "y", "123.96", 1, "text"], ["d", "m 97.44,52.31 -0.52,-1.53 -1.42,-0.59 -0.71,-1.04 0.31,-0.04 1.49,0.45 -0.13,0.74 0.57,-0.36 0.56,0.6 2.63,0.33 0.55,0.87 1.29,-0.52 0.62,0.68 -0.6,0.26 0.7,0.52 -0.47,0.28 0.28,1.03 -1.03,0.94 -0.77,-0.81 -0.31,0.63 -1.22,-0.98 -0.95,0.22 -0.02,-0.82 z m -0.66,-2.35 0.01,-0.02 0.06,0.04 z m -1.33,-10.78 2.05,0.09 -0.53,0.75 0.55,1.55 -0.75,0.83 -1.78,0.29 0.95,-1.14 0.18,-0.88 -0.62,-1.12 z m 1.93,-0.06 0.03,-0.04 0.21,0.21 z", 1, "state"], ["x", "2", "y", "138", "width", "32", "height", "18", "rx", "2", "ry", "2", 1, "box"], ["x", "18", "y", "150.96", 1, "text"], ["d", "m 114.5,40.55 -0.03,0 0.01,-0.02 z m 0.14,0.02 0.17,0 0.42,0.06 0.07,0.08 -0.14,0.04 0,-0.04 0.01,-0.06 z m 0.49,0.35 0.71,0.37 0.1,-0.47 0.87,0.18 0.91,-0.11 -3.18,-0.54 0.46,-1.64 0.97,1.13 1.25,-1.77 0.63,-0.04 0.69,0.12 0.14,-0.86 1.11,0.03 0.03,-0.45 0.04,-0.04 -0.07,-0.2 0.06,-0.08 1.89,-0.59 -0.84,1.36 1.29,1.2 -1.09,2.35 1.37,1.28 1.03,1.39 0.39,-0.19 -0.27,0.45 -1.13,1 -0.96,-0.01 -1.97,-1.77 -1.05,1.28 -0.57,-0.41 -0.5,0.45 -0.21,-1.13 -0.65,0.72 -1.25,-1.78 -0.23,-0.2 z m -19.83,-10.23 0.18,0.29 -0.43,0.08 z m -0.8,-0.83 -0.45,0.38 0.24,-0.47 z", 1, "state"], ["x", "2", "y", "165", "width", "32", "height", "18", "rx", "2", "ry", "2", 1, "box"], ["x", "18", "y", "177.96", 1, "text"], ["d", "m 96.81,144.47 0.13,0 0.01,0.1 -0.25,0.06 z m 0.03,0.08 0.03,0 0.05,-0.04 z m -4.42,0.87 -0.12,-0.31 -0.95,-2.55 1.53,-1.03 0.05,-0.08 0.53,-0.82 -0.94,-0.1 -0.39,-0.93 -0.92,-2.05 0.01,-1.59 -0.91,-1.46 -0.75,-0.88 -0.9,-0.22 -0.25,0.04 -4.93,1.55 -1.84,-2.55 1.08,-0.43 0.3,-1.17 1.27,0.67 0.07,-1.05 -0.83,-1.01 1.84,-1.49 0.75,0.63 0.41,-0.49 -0.37,-1 1.12,0.33 0.33,-0.45 -1,-2.62 -1.47,-0.85 0.69,-1.22 -0.45,-1.55 1.01,-1.2 1.27,0.62 0.6,-1.7 -0.66,-1.54 0.27,-0.76 0.71,-1.31 -0.66,-1.41 2.81,-2.42 0.22,0.56 0.83,-0.01 1.7,-1.42 0.39,-1.4 1.02,-1.31 -0.59,-1.61 0.78,-0.57 2.83,-0.19 -0.45,-0.6 1.28,-2.01 -0.74,-1.72 -2.07,0.68 -0.52,-1.04 2.07,-2.34 4.13,-0.31 0.14,-1.03 -0.48,-0.07 -0.46,-1.36 1.33,-0.65 1.73,0.09 0.2,1.5 1.09,0.11 2.53,-1.84 1.07,-2.06 -0.6,-0.64 1.7,-0.92 0.89,-0.18 0.33,0.82 1.82,-0.29 0.98,1.44 -0.21,0.37 -0.75,-0.37 0.35,0.78 -0.63,-0.12 0.18,0.66 -0.57,0.39 0.95,1.27 -0.01,1.4 -1.06,0.39 -0.47,1.05 -0.03,0.08 0.15,0.19 0.18,0.31 2.71,1.19 0.66,-1.09 -0.57,0.43 -0.59,-1.17 1.63,-0.6 0.03,-0.62 1.03,1 -0.25,-1.11 0.94,-0.11 0.34,1.13 0.74,2.38 1.35,0.14 0.25,1.4 2.3,0.93 0.49,0.14 -0.43,1.1 -0.16,0.83 -0.53,-1.07 -0.82,0.36 0.93,0.61 -0.55,1.55 0.96,0.47 0.07,0.74 -0.33,0.37 -2.38,-0.37 -0.29,0.54 0.7,1.29 -1.88,0.05 0,0.41 0.7,-0.21 -0.35,0.7 0.75,-0.33 0.72,0.98 -0.62,0.5 0.04,0.86 -1.18,0.28 -0.01,1.28 -0.43,0.15 0.26,0.76 -1.06,2.58 1.4,0.3 -0.22,-0.91 0.9,-0.34 0.81,0.1 0.47,0.92 0.05,0.45 -0.74,0.21 0.43,1.48 -0.33,1.05 -0.38,1.34 -1.4,1.24 -1.28,0.58 -1.64,-0.74 -0.47,1.86 0.22,1.19 -1.57,1.08 0.19,0.95 -0.68,0.12 -1.36,0.13 -0.7,-0.49 -0.05,1.81 0.56,0.37 -0.33,1.75 -1.82,0.18 -0.5,-1.11 -2.59,-0.52 -1.25,1.54 0.08,-0.72 -0.56,-0.23 -1.72,0.38 -0.47,1.17 -0.22,0.58 0.9,0.17 0.29,1.24 -0.56,0.04 0.56,3.3 -0.24,0.53 0.48,0.39 0.35,-0.43 0.1,1.51 0.69,-0.1 -0.43,0.95 0.75,0.44 -0.43,1.13 -0.61,0.16 0.2,1.36 -0.61,0.59 0.62,1.12 -0.07,0.45 -0.24,-0.02 -0.22,-0.37 0.26,0.7 0.66,0.85 -0.74,-0.25 -0.31,-0.1 -0.4,0.82 -0.97,-0.32 -0.58,0.12 0.04,0.64 -0.2,-0.1 -0.18,0.39 0.31,0.41 -0.87,0.32 -0.8,1.23 -0.68,-0.03 0.22,-1.92 1.25,-0.4 0,-0.49 -0.86,0.03 -0.3,0.24 -0.15,-0.85 -0.41,0.33 -1.21,-0.18 -0.78,-1.53 0.3,-0.53 -0.44,-0.36 0.36,-0.26 -0.25,-0.17 -1.46,0.38 0.45,1.76 -0.68,0.65 -1.99,-1.86 z", 1, "state"], ["x", "2", "y", "192", "width", "32", "height", "18", "rx", "2", "ry", "2", 1, "box"], ["x", "18", "y", "204.96", 1, "text"], ["d", "m 185.54,34.25 -0.16,0.2 -0.12,-0.07 0.05,-0.13 z m -44.62,-4.21 -0.03,0.12 -0.05,-0.12 z m 0.74,-0.59 0.02,0.06 -0.04,-0.06 z m -0.14,0 -0.03,-0.02 0.03,-0.06 0.04,-0.04 z m 37.76,-9.15 0.1,0.08 -0.3,0.22 z m 1.06,8.14 0.01,-0.08 0.03,0.04 z m -38.78,-0.59 0.35,0.36 -0.58,1.41 -0.17,-1.04 -0.2,0.95 -0.7,-0.11 -0.18,-0.8 z m 0.35,-0.17 0.04,0.02 -0.05,0.17 -0.11,0 z m 0.29,-0.19 -0.04,-0.04 -0.02,-0.37 0.09,-0.27 0.07,-0.12 z m 9.03,-3.68 -0.03,-0.02 0.04,0 z m 0.06,0.12 -0.04,-0.06 0.04,-0.06 z m 30.19,4.36 -0.03,-0.02 0.04,-0.04 z m -0.06,-0.1 -0.08,-0.1 0.04,0.02 z m -4.34,-6.57 -0.08,0.15 -0.01,-0.2 z m 0.4,4.02 -0.09,-0.08 0.02,-0.08 z m 0.25,-0.86 0.03,0 -0.04,0.04 0.01,0.1 -0.03,-0.06 z m -0.16,-0.59 0.19,0.15 -0.05,0.17 -0.04,-0.18 -0.15,-0.14 z m -0.53,-0.48 0.06,0 0.07,0.2 0.3,0.25 -0.25,-0.05 -0.14,-0.26 0.02,0.06 -0.06,-0.04 0.04,-0.13 -0.09,0 z m 0.44,-1.28 0.12,0.03 0.06,0.08 0.06,0 0.07,0.16 -0.03,0.02 0.13,0.34 0.21,0.44 0.42,0.55 0.27,0.25 0.4,0.29 0.44,0.24 0.18,0.09 0.46,0.1 0.78,0.39 0.57,0.6 1.52,1.31 0.66,0.7 0.39,0.3 0.33,0.16 -0.26,0.37 -0.26,0.02 -0.08,0.05 0,0.06 0.32,0.02 -0.02,0.1 0.14,0.16 0.07,0.49 -0.01,0.39 -0.07,-0.02 -0.04,0 0,0.04 -0.08,-0.1 -0.16,-0.07 -0.18,0.07 -0.06,-0.04 -0.19,0.01 -0.38,0.06 -0.2,-0.03 -0.17,0.09 -0.03,-0.04 -0.23,0.01 -0.21,-0.09 -0.17,0.11 -0.18,0.03 -0.35,-0.1 -0.11,0.03 -0.09,0.13 -0.11,0.01 -0.16,0.28 -0.19,0.13 -0.06,0.15 -0.17,-0.03 -0.28,0.12 -0.35,0.1 -0.28,-0.09 0.02,-0.12 0.21,0.09 0.21,-0.05 0.05,-0.11 0.02,-0.19 -0.11,-0.1 -0.23,-0.09 -0.08,-0.08 -0.01,-0.1 -0.03,0.25 0.03,0.1 -0.05,0.04 -0.06,0.19 0.02,0.08 -0.01,0.06 -0.11,0.13 -0.22,0.1 -0.06,-0.02 -0.11,0.03 -0.07,-0.02 -0.01,0.04 -0.12,-0.08 -0.17,0.01 -0.06,-0.04 -0.01,0.02 -0.05,-0.04 0.04,-0.02 -0.03,-0.02 -0.18,-0.11 -0.31,0.06 -0.08,-0.2 0.13,-0.01 -0.02,-0.12 0.05,-0.06 -0.02,-0.06 0.04,-0.04 -0.01,-0.08 0.07,-0.02 0.19,0.03 0.13,-0.03 0.23,-0.18 0.09,0.04 0.21,-0.03 0.11,-0.15 0.02,-0.08 0.28,-0.08 0,-0.06 0.04,-0.02 0,-0.06 0.09,-0.15 0.03,-0.23 0.07,-0.05 -0.01,-0.12 -0.1,-0.18 0.02,-0.12 -0.05,-0.29 -0.14,-0.16 -0.04,-0.22 -0.4,-0.28 -0.05,-0.1 0.05,-0.41 0.09,-0.21 0.1,-0.05 0.29,0 0.1,-0.09 0.13,-0.03 0.23,0.05 0.09,0.06 0.01,0.14 -0.02,0.06 0.03,0.06 -0.03,0.17 0.1,0.01 0.05,0.08 -0.33,0.31 0.14,0.14 -0.07,0.11 -0.02,0.08 0.03,0.31 0.11,-0.01 -0.02,-0.1 0.11,-0.29 0.06,-0.02 -0.13,-0.18 0.31,-0.14 0.03,0 -0.02,0.06 0.17,-0.09 0.15,0.07 0.24,-0.1 0.06,0 0.02,0.06 -0.07,-0.02 -0.04,0.02 0.02,0.04 0.08,-0.05 0,0.06 -0.14,0.03 -0.05,0.09 0.04,0.12 0.13,0.09 0.01,-0.02 0.07,0.04 0.03,-0.02 0,0.04 0.03,0.04 0.06,-0.02 0.02,0.06 0.09,0 0.05,-0.13 -0.06,-0.06 0,0.02 -0.04,0 -0.03,-0.08 0.11,-0.34 -0.02,-0.14 0.08,-0.33 -0.04,-0.45 -0.07,-0.06 0.05,-0.04 -0.08,0.05 0.03,-0.04 -0.04,-0.18 -0.11,-0.18 -0.1,-0.06 -0.1,-0.01 -0.06,0.02 -0.03,-0.1 -0.03,0.04 0.05,0.14 -0.08,0.13 -0.13,-0.01 -0.03,-0.31 0.03,-0.02 -0.1,-0.2 -0.04,-0.26 -0.08,-0.14 -0.13,-0.05 -0.06,-0.04 0.01,-0.06 -0.06,0 -0.05,-0.1 -0.1,-0.06 0.02,-0.08 0.1,-0.01 -0.06,-0.04 -0.08,0.05 -0.02,0.08 -0.23,0.01 -0.16,-0.05 -0.47,-0.03 -0.01,0.04 0.1,0.04 -0.05,0.13 -0.01,0.25 -0.05,0.11 0.07,-0.02 -0.01,-0.1 0.06,0.02 0.05,0.12 0.05,0.04 0.22,0.32 -0.04,0.1 -0.11,0.03 0.04,0.18 -0.09,-0.04 -0.06,-0.1 0.01,-0.08 0.15,-0.17 -0.08,-0.1 -0.08,0.05 -0.04,0.13 -0.08,0.07 -0.02,0.17 -0.13,0.21 -0.16,0.03 -0.01,0.04 -0.19,0.01 -0.04,0.06 -0.09,0 -0.04,0.04 -0.03,0.17 -0.09,-0.04 -0.05,-0.08 -0.01,-0.25 0.14,-0.23 0.03,-0.29 0.05,-0.09 0,0.06 0.06,0.04 0.08,-0.11 0.01,-0.1 -0.08,-0.08 -0.12,-0.05 0.12,0.1 -0.04,0.08 -0.05,-0.12 -0.18,-0.11 -0.18,0.05 -0.03,0.04 0.03,0.04 -0.12,0.09 -0.27,0.08 -0.06,0.15 -0.11,0.05 -0.11,0.33 -0.21,0.03 -0.11,0.01 -0.03,-0.04 -0.13,0.01 -0.11,-0.16 0.01,-0.12 0.11,-0.29 0.07,0 0.06,0.06 0.05,-0.19 0.08,-0.09 -0.04,-0.18 0.13,-0.17 -0.01,-0.14 0.05,-0.19 0.08,-0.11 -0.02,-0.02 0.04,-0.04 -0.01,-0.25 0.05,-0.09 0.01,-0.14 -0.08,-0.2 0.08,-0.05 -0.03,-0.02 -0.07,0.02 -0.05,-0.06 -0.19,0.01 -0.12,-0.1 -0.04,-0.12 -0.07,-0.04 -0.04,0 0.02,0.04 -0.04,-0.02 0.02,-0.19 -0.07,-0.18 -0.09,-0.02 -0.05,-0.08 -0.04,0.02 0.05,0.08 -0.09,-0.02 -0.06,-0.08 -0.02,-0.18 -0.05,-0.12 0.1,-0.03 -0.02,-0.04 -0.1,0.05 0.01,-0.16 -0.05,-0.06 0.13,-0.21 -0.02,-0.04 0.01,-0.02 0.04,0.04 0.25,-0.16 z m 0.18,-0.11 0.05,0.06 -0.14,-0.01 z m -7.35,0.62 -0.03,0.02 0,-0.02 z m 0.26,-0.18 -0.04,-0.02 0,-0.02 0.03,0 z m 7.16,-0.24 -0.06,0.02 -0.05,-0.12 0.09,0.02 z m -0.02,-0.12 0,0.02 -0.03,-0.02 z m -6.38,0.22 0.34,0.23 0,0.08 -0.08,0.07 -0.05,0.11 -0.04,0.04 0.04,-0.1 -0.06,-0.12 -0.15,-0.07 -0.01,-0.2 -0.1,-0.04 z m -0.72,0.06 0,-0.04 0.01,-0.02 z m 0.22,-0.13 0.03,0.08 -0.09,-0.06 -0.28,0.03 0.19,-0.09 z m -2.86,-7.29 -0.06,0 0.04,-0.02 z m -0.79,-1.21 0.15,0.16 -0.05,0.13 -0.16,-0.12 z m -1.17,1.08 -0.02,-0.04 0.04,-0.02 z m 3.3,-1.9 0.03,0.08 -0.07,-0.04 z m -2.71,0.05 -0.09,0.13 0.06,-0.29 z m 4.05,7.5 -0.07,-0.04 0.04,0 0.04,0.04 z m 0.4,-0.35 -0.02,-0.04 0.03,0 z m -4.11,-1.11 -0.13,0.29 -0.13,-0.26 z m -9.29,-0.44 -0.01,-0.02 -0.03,-0.14 z m 30.78,25.21 -1.48,0.55 -0.82,1.47 -2.54,0.05 1.9,-2.85 -0.02,-1.67 -1.81,-0.22 -0.57,0.84 -1.31,-0.56 -1.31,0.43 -0.72,-2.12 -0.93,-0.32 -0.41,-1.07 -0.26,1.23 0.79,0.33 -0.21,0.4 -1.59,0.23 -0.55,0.52 -0.17,0.07 -0.12,0.17 -0.03,0.21 -0.18,-0.07 -0.09,0.19 0.07,0.04 -0.02,0.15 -0.13,0.03 0.13,0.22 -0.15,0.38 -0.09,0.03 -0.04,-0.12 -0.12,0.01 -0.25,0.16 -0.07,-0.04 -0.24,0.05 -0.13,0.19 -0.23,0.05 -0.05,0.15 0.16,0.05 -0.09,0.29 0.12,0.01 0,0.08 -0.15,0.13 -0.05,0.21 -0.28,-0.05 -0.12,0.4 0.13,0.01 0.01,0.21 -0.08,0.15 0.08,0.47 -0.2,0.05 -0.13,-0.22 0.09,0.28 -0.15,0.21 -0.01,0.16 -0.2,0.28 -0.33,0.1 -0.1,-0.24 -0.29,-0.03 -0.04,0.13 0.06,0.08 -0.07,0.07 0.13,0.08 -0.2,0.09 -0.11,0.38 -0.12,0.17 -0.09,0.02 -0.02,0.41 -0.29,0.08 -0.01,-0.16 -0.07,0 -0.19,-0.28 -0.04,-0.24 -0.14,-0.18 -0.19,0.01 -0.18,0.13 -0.63,-0.17 -0.2,0.15 -0.13,0.27 -0.36,0.1 -0.11,0.36 0.12,0.04 -0.18,0.23 0.04,0.16 -0.17,0.44 -0.8,-0.87 -1.12,0.32 -0.03,0.66 -1.87,1.42 -0.68,-0.22 0.32,-0.71 -1.31,0.61 -0.56,-0.55 -1.29,0.38 -0.13,-0.92 -1.43,-0.12 -0.14,-0.61 -3.41,0.26 -0.85,-1.34 -1,-0.39 -0.12,-0.08 -1.02,-0.02 -0.53,-0.89 -0.94,0.53 -0.28,-0.57 -0.94,0.46 -0.76,-0.67 -0.36,1.9 -0.7,0.04 -0.37,0.73 -0.91,-0.16 -0.47,0.82 -1.04,-0.11 0.54,0.64 -1.57,0.36 -0.47,-0.71 -1.13,0.09 -1.21,0.92 0.32,1.12 -0.52,1.08 -1.8,-0.36 -0.43,0.81 -2.03,-0.26 -1.51,-0.87 0.33,-0.66 -1.83,-0.99 -1.53,-2.95 -1.1,-0.39 -1.3,1.17 -2.16,-1.67 -1.66,0.19 0.56,-2.43 0.95,-0.01 0.12,-0.6 1.92,-0.98 -0.06,-1.62 1.39,0.08 0.61,-2.02 -0.49,-1.35 -1.12,0 -1.47,-1.23 0.04,-1.68 0.1,-1.64 1.74,-1.38 0.43,0.71 0.88,-0.26 -0.09,-0.18 -1.05,-0.25 0.11,-0.86 2.13,-1.35 0.74,-0.2 0.86,0.08 0.55,-0.16 0.43,0.71 0.33,0.14 0.38,-0.13 0.1,0.1 -0.21,0.27 -0.06,0.53 0.21,0.43 0.55,0.13 0.39,-0.3 0.3,-0.44 0.49,0.6 0.37,-0.11 0.29,0.1 -0.05,0.37 0.51,0.27 0.02,0.27 0.38,0.11 -0.08,-0.16 0.11,-0.02 -0.24,-0.06 -0.05,-0.16 0.43,-0.46 0.13,0.02 0,-1.05 -0.18,0.11 0.02,-0.21 0.23,-0.13 0.01,0.21 0.1,-0.08 0.08,-0.39 -0.15,-0.2 0.29,-0.48 0.37,-0.21 -0.06,-0.2 -0.2,0.03 0.03,-0.12 0.15,-0.09 0.09,0.18 0.43,-0.03 0.95,-1.67 -0.35,-0.32 -1.07,1.44 -0.13,-0.61 2.34,-2.18 2.64,0.13 2.28,-0.87 1.37,-0.31 0.05,1.95 0.41,0.44 0.61,-0.02 0.01,0.25 0.02,-0.33 -0.88,-0.59 -0.04,-0.82 0.69,-0.62 -0.65,0.17 -0.1,-0.32 1.58,-1.72 1.28,-0.85 0.57,-0.41 0.3,-0.36 0.89,-1.98 0.47,-0.41 0.42,-0.75 0.48,-1.47 0.13,-0.21 0.21,-0.11 0.04,0 0.03,0.02 -0.11,0.02 -0.03,0 -0.01,0.02 0.19,0.05 -0.07,0.04 -0.01,0.04 0.03,0.1 0.02,-0.12 0.01,0 -0.02,0.16 -0.07,0.02 -0.03,0 -0.02,-0.06 0.03,-0.04 -0.01,-0.02 -0.05,0.06 0,0.02 0.03,0 0.02,0.04 0,0.06 0.03,0.02 0.01,0 0,-0.06 0.03,0 0.07,0.1 0.16,0.18 0.15,0.1 0.19,0.05 0.84,0.09 0.21,0.03 0.46,0.12 0.28,0.01 0.42,-0.04 0.65,-0.01 0.43,0 0.27,0.01 0.44,0 0.58,-0.05 0.87,-0.16 0.11,-0.01 0.01,0.02 -0.05,0.1 0,-0.04 -0.03,0 0,0.06 -0.01,0.02 0.03,0.06 0,0.04 0.13,0.14 0.02,0.04 -0.03,0.06 -0.05,0.06 -0.11,0.07 -0.04,0.04 -0.16,-0.01 -0.03,0.04 -0.06,0 -0.03,0.02 -0.15,0.05 -0.12,0.09 -0.13,-0.12 -0.14,-0.06 -0.4,-0.04 -0.08,0.04 -0.08,0 -0.14,0.11 -0.04,0.06 -0.11,0.17 -0.04,-0.02 -0.12,-0.18 -0.09,-0.02 -0.1,0.02 -0.03,-0.02 -0.11,0 -0.08,0.04 -0.01,0.08 -0.01,0 -0.14,-0.03 -0.21,-0.01 -0.07,-0.08 -0.12,-0.18 -0.05,-0.12 -0.04,-0.02 -0.03,-0.04 -0.03,0 -0.07,0.11 -0.06,0 -0.17,-0.07 -0.1,-0.02 -0.06,0.02 -0.09,0.11 -0.21,0.17 -0.03,0.06 0.01,0.23 -0.03,0.04 -0.03,0.02 -0.17,-0.05 -0.05,-0.1 -0.04,-0.04 0,-0.08 -0.13,-0.1 0,-0.02 0.01,-0.02 -0.04,-0.02 -0.07,0.06 -0.03,0.04 -0.04,0.02 0,0.02 -0.01,0 -0.03,-0.02 -0.03,0 -0.1,0.07 0.02,0.04 -0.01,0.04 -0.04,0.02 -0.05,0.06 0,0.02 0.1,0.1 -0.03,0 -0.04,-0.04 -0.16,-0.01 -0.03,0.02 0.01,0.02 -0.08,0 -0.04,-0.02 -0.01,0.02 -0.08,0 -0.07,0.06 -0.07,0.04 -0.03,0.04 0,0.08 0.03,0.04 -0.01,0.04 0.1,0.04 0.07,0.06 0.06,0 0.03,-0.02 0.07,0.04 0,0.04 -0.07,0.08 -0.01,0.08 -0.02,-0.1 -0.07,-0.04 -0.09,0 0,0.02 -0.04,0 -0.09,-0.02 -0.01,-0.02 -0.1,0 -0.08,0.02 -0.13,-0.02 -0.06,0.02 -0.04,0.06 -0.12,0.07 -0.03,0.08 -0.07,0 0,-0.02 -0.01,0 -0.01,0.02 -0.06,0.02 -0.07,0.11 0,0.08 -0.06,0.02 -0.07,-0.08 -0.1,-0.08 -0.04,-0.04 -0.03,-0.02 -0.03,0 -0.07,-0.02 -0.59,0.04 -0.07,0.02 -0.03,0.02 -0.14,0.03 -0.04,0.02 -0.04,-0.02 -0.03,0.08 -0.1,0.04 -0.03,0.04 -0.07,0.02 -0.01,0.02 -0.01,-0.02 -0.01,0 0.01,0.02 -0.01,0 0,0.02 0.01,0 -0.03,0.08 -0.03,0.02 -0.03,0.04 0.04,0.04 -0.01,0.06 0.02,0.08 -0.01,0.04 0.03,0.04 0.04,0 0.02,0.12 -0.01,0.06 0.02,0.08 0,0.1 -0.08,0.13 0.01,0.02 -0.17,-0.03 -0.08,-0.16 -0.03,0 0,-0.02 -0.03,0 0.02,0.04 -0.11,-0.02 -0.03,0.02 0,0.04 -0.07,0.02 0.03,0.04 0.06,0.06 -0.01,0.02 0.12,0.08 -0.02,0.14 0.03,0.04 0,0.06 -0.08,0.04 0,0.08 -0.04,0.06 0,0.02 -0.06,0.02 -0.01,0.02 0,0.02 0.03,0.02 -0.04,0.06 -0.1,0.02 -0.03,-0.02 -0.06,0.02 -0.04,-0.04 -0.04,0 -0.03,0.08 -0.01,0 -0.03,0.02 0.02,0.08 -0.06,0.04 0.03,0.02 -0.01,0.02 0,0.04 0.04,0.02 0.04,0.06 -0.01,0.06 0.01,0 0.02,0.06 0.03,0.06 0.12,0.12 0.05,0.08 0.03,0 0.02,0.04 0.03,0 0.02,0.04 -0.04,0.02 -0.02,0.12 -0.18,0.09 -0.04,0.06 0,0.04 0.06,0 0.04,0.02 0,0.04 0.17,0.08 0.1,0.1 0.09,0.04 0.06,0.02 0.05,0.08 0.23,0.07 0.07,0.04 0.17,-0.01 0.1,0.04 0.06,-0.04 0.09,0.02 0.04,-0.02 0.1,-0.02 0.06,-0.02 0.03,0 0,-0.08 -0.04,0 -0.02,-0.04 -0.09,-0.06 -0.14,-0.02 -0.13,-0.02 -0.07,-0.04 -0.09,0 -0.09,-0.02 -0.02,-0.06 -0.12,-0.18 0,-0.06 0.01,-0.02 0,-0.04 -0.03,-0.1 0.01,-0.1 0.07,-0.08 0.02,-0.1 0.03,-0.04 0.03,-0.02 0.03,0 0.01,0 0.19,-0.19 0.06,0 0.17,-0.07 0.11,0 0.03,-0.02 -0.01,0 0.06,-0.02 0.06,-0.04 0.16,-0.03 0.03,-0.02 0.03,0 -0.02,-0.08 -0.03,-0.02 0.06,0 -0.02,-0.1 0.01,-0.02 -0.03,-0.02 0,-0.06 -0.11,-0.18 0.02,-0.19 0.07,-0.04 0.27,0.01 0.07,-0.02 -0.02,-0.06 0.04,0.02 0.03,-0.02 0.17,-0.07 0.1,0.06 0.03,-0.02 0.06,0 0.03,-0.04 0,0.02 0.01,0 0,-0.02 0.03,0 0.01,-0.04 0.06,-0.04 0,-0.04 0.05,-0.08 -0.01,-0.02 0.01,-0.02 -0.06,0 0.04,-0.12 0.01,-0.02 -0.02,-0.06 0.04,0.02 0.07,-0.06 0.07,-0.02 0,-0.04 0.04,0.02 -0.03,-0.04 0.01,-0.06 -0.13,-0.06 -0.13,-0.02 -0.03,-0.06 0.04,-0.04 0.13,-0.05 0.15,-0.11 -0.03,-0.06 0.01,-0.12 0.03,0.1 0.1,0.06 0.06,0.04 0.13,0 0.07,-0.04 0.04,-0.02 -0.02,0.1 -0.05,0.08 -0.02,0.21 0.07,0.06 0.11,0 0.13,-0.05 0.07,-0.11 0.03,-0.08 -0.03,-0.08 0.03,-0.02 -0.06,-0.08 0.07,0.04 0.04,-0.02 0.03,0.02 0.01,-0.02 0.09,0.02 0.01,-0.02 0.07,-0.02 0.03,-0.02 0,0.02 0.03,0 0,-0.02 0.08,-0.06 0.03,-0.04 0.08,-0.02 0.05,-0.04 0.01,0 0.03,-0.02 0.11,-0.05 0.1,-0.07 0.1,-0.09 0.01,-0.08 0.01,0.02 0.06,0.02 0.04,-0.06 0.03,0 0,-0.1 -0.04,-0.02 -0.05,-0.06 -0.09,-0.02 0,-0.06 0.03,-0.04 -0.06,-0.02 0,-0.04 0.1,0.02 0.04,0 -0.02,-0.04 0.03,-0.06 0.03,0 0,0.02 0.03,0.02 0.01,0 -0.02,-0.04 0.1,0.02 0,0.02 0.08,0 0.12,-0.09 0.07,-0.02 0.07,0 0.05,-0.04 0.03,0 0.06,0.04 0,0.06 0.06,0.1 -0.03,0.06 -0.07,-0.02 -0.03,0 0.01,0 -0.03,0.02 -0.04,-0.02 -0.15,0.03 -0.05,0.04 -0.04,0.1 -0.01,0 0,0.06 0.05,0.08 0.03,0.06 0.06,0.06 -0.08,0.09 0,0.04 -0.06,0.02 -0.03,-0.02 -0.01,0.02 0.01,0.02 -0.03,0.04 -0.01,0.06 -0.01,0.04 0,0.04 -0.04,0.02 0,0.04 0.1,-0.02 0.09,0.08 -0.03,-0.12 -0.06,-0.04 0.01,-0.02 0.04,-0.02 0.01,-0.06 0.05,-0.04 0.08,-0.15 -0.01,-0.18 0.04,-0.15 0.01,-0.02 0.06,-0.02 0.1,0.02 0.07,0 -0.01,0.12 0.02,0.08 -0.01,0.1 0.06,0.14 0,0.06 0.03,0.04 0,0.08 0.02,0.06 -0.01,0.02 0.01,0 0.04,0 0.01,-0.04 0.03,0.02 0,0.02 0.09,0.02 0,-0.02 0.09,0.02 0,0.02 0.01,0 -0.02,-0.04 0.07,-0.04 0.01,-0.06 0.02,-0.23 0.05,0.1 0.08,0.12 0.03,0 0,0.08 0.02,0.04 0.06,0 0.07,-0.04 0.07,0.04 0.03,-0.02 0.05,-0.21 -0.02,-0.06 0.04,-0.08 0,-0.1 0.04,-0.08 0.04,0 0.04,0 0.03,-0.06 -0.02,-0.04 0.03,-0.02 0.01,0 0.03,0.06 -0.05,0.23 0.02,0.16 0.01,0 0,0.02 0.14,0.01 0.06,0.04 0.08,0.14 0.02,0.14 0.02,0.06 0.03,0.02 -0.03,0 0.01,0.02 0.03,0 0.02,0.08 0.01,0.16 0,0.06 -0.03,0.02 0.02,0.04 0.02,0.1 0.05,-0.13 0.07,-0.09 0.1,-0.02 0.14,0.01 0.09,0 0.11,0 0.11,-0.07 0.17,-0.23 0.19,-0.09 0.08,-0.13 0.02,-0.14 -0.02,-0.18 0.03,0 0.01,-0.02 -0.04,0 0.01,-0.04 0.05,-0.1 0.07,-0.09 0.04,-0.06 0.01,-0.08 -0.02,-0.08 0.01,-0.04 0.06,0 0.15,-0.13 0.03,0 0.11,-0.13 0.1,-0.09 0.14,-0.01 0.2,-0.07 0.08,0 0.01,-0.02 0.01,-0.1 0.04,-0.04 0.13,-0.01 0.04,-0.02 0.03,-0.02 0.03,0.02 0.05,-0.04 0.04,0 -0.01,0.02 0.15,-0.05 0.1,-0.07 0.03,-0.04 0.02,-0.14 0.03,-0.04 0.04,-0.02 0.18,-0.05 0.19,0.05 0.07,0.06 -0.03,0 0.02,0.04 0.03,-0.04 0.02,0.08 0.01,0.18 -0.14,0.07 -0.03,0.19 0,0.06 -0.03,0 0.05,0.08 -0.03,0.04 0.01,0 0,0.08 0.03,0.06 0,0.02 0.03,0.06 -0.01,0.04 0.02,0.04 0.04,0.02 0.02,0.04 0.04,0.02 0.02,0.04 0.09,0.04 0.03,0.1 0.03,0 0.03,0.08 0.03,0.02 0.05,0.06 0.23,-0.03 0.14,-0.07 0.16,0.1 0.15,0.26 0.03,0.12 -0.03,0.04 -0.1,0.09 -0.01,0.06 -0.12,0.23 0,0.08 0.05,0.26 0.04,0.04 -0.01,0 0,0.02 0.01,0 0.03,0.1 0.05,0.06 0.02,0.18 0.09,0.04 0.04,0 -0.01,0.04 0.07,-0.02 0,0.02 -0.01,0 0.02,0.04 0.01,0 -0.01,0 0.03,0.08 0.12,0.1 -0.01,0.02 0.03,0.02 0.01,-0.02 0.03,0.04 -0.03,0.02 0,0.02 0.01,0 -0.01,0.06 0.03,0 -0.04,0.1 -0.01,0 -0.01,0.06 -0.01,0 -0.01,0.02 -0.03,0.06 0.03,0.02 0,0.04 -0.04,0.02 0.02,0.12 0.01,0.02 -0.03,0 0.01,0.02 0.01,0 0.08,0.1 0.15,0.14 0.12,0.06 0.03,0.04 0.09,0.02 0.23,0.03 0.08,-0.02 0.19,-0.28 0,0.02 0.03,0.06 0.15,0.1 0.02,0.06 -0.02,0.08 -0.09,-0.02 -0.07,-0.02 -0.07,0 -0.05,0.04 -0.09,0.13 -0.04,0 -0.04,0.04 -0.01,0.04 -0.04,0.02 0.02,0.12 0.08,-0.05 0.03,-0.06 0.08,-0.05 0.06,0 0.03,-0.04 0.03,-0.04 -0.02,-0.06 0.07,-0.06 0.04,0 0.05,0.08 0.1,-0.03 0.1,-0.07 0.04,0.02 0.03,0.06 0.01,0.1 0.09,0.02 0.04,0 0.06,0.02 0.06,0.06 0.08,0.12 0.1,0.02 0,0.06 -0.1,0.09 0.09,0.08 0.2,0.03 0.3,-0.01 0.18,-0.05 0.06,0.04 0.17,0.03 0.14,0.03 0.06,0.04 0.03,0.04 0.03,-0.02 0.03,0.04 -0.04,0.02 0.02,0.02 0.11,0.16 0.05,0.22 0.05,0.06 0.02,0.12 0.05,0.14 0.01,0 0.05,0.08 0.06,0.04 0.05,0.08 0.03,0.04 0.02,0.02 0.17,0.28 -0.17,0.6 1.4,-0.3 -0.34,0.69 0.39,-0.37 1.38,1.84 -0.15,-1.02 3.44,-1.4 -0.2,0.54 1.73,1.26 -0.84,1.85 2.81,2.66 -1.32,1.25 -0.09,0.91 2.5,1.73 2.15,0.74 2.49,-0.44 -0.68,1.3 1.11,0.49 0.08,1.25 0.54,0.4 -0.05,1.96 z m -30.82,-25.52 -0.04,-0.06 0.04,-0.04 z m 0.06,-0.02 0.07,0.06 -0.1,0.02 0.03,0.14 -0.06,-0.12 z m -0.08,-0.24 -0.06,-0.02 0.09,0 z m -0.08,-0.12 0.03,0.04 -0.09,-0.04 0.07,-0.04 z m 0.95,-0.12 -0.04,-0.04 0.07,-0.11 z m 1.23,-0.87 -0.04,0.04 -0.1,-0.06 z m -0.34,-0.33 -0.09,0.11 -0.04,-0.16 z m -1.75,1.57 -0.03,-0.06 0.06,-0.04 z m 6.14,-1.96 -0.11,-0.14 0.1,0.08 z m -3.14,0.14 -0.04,0 0.01,-0.06 0.03,0.02 z m 3.75,-0.39 -0.03,-0.06 0.05,-0.06 z m -0.59,-0.16 0.41,0.02 0.05,0.08 z m 0.86,-0.06 -0.01,0 0.03,-0.04 z m 2.1,0.33 -0.08,0.02 -0.02,-0.1 z m -2.21,-0.29 0.02,0.12 -0.13,-0.1 z m 1.05,-0.52 0.14,0.24 -0.26,0.24 -0.4,-0.02 -0.62,0.32 -0.02,-0.2 0.18,0.12 0.23,-0.32 0.51,0 z m 2.44,-0.2 -0.16,0.17 0.01,-0.12 z m 0.03,-0.06 0.02,0.04 -0.03,0.02 -0.01,-0.02 z m -0.46,-0.72 0.21,0.05 -0.01,0.12 0.07,0.04 0.37,-0.06 0.05,0.06 -0.14,0.03 0.1,0.04 0.03,0.31 -0.21,0.09 -0.13,-0.03 -0.16,0.13 -0.09,-0.04 0.01,0.16 -0.08,0.09 -0.18,-0.01 -0.13,0.21 -0.21,0.01 -0.2,0.17 -0.17,0.03 -0.01,-0.25 0.29,-0.71 0.27,-0.32 z m 0.67,0.6 -0.02,0.12 -0.14,0.03 -0.02,-0.08 z m -1.53,-3.5 0.16,0.03 0.04,0.26 0.14,0.36 0.02,0.14 -0.28,-0.64 -0.45,0.39 -0.55,3.37 0.35,-3.5 z m 6.64,7.09 -0.37,0.31 0.33,-0.55 z m -12.57,-1.76 -0.1,0.21 -0.17,0.01 0.09,-0.21 z m 7.33,0.08 -0.03,-0.1 0.15,-0.05 z m -8.34,-0.12 -0.05,-0.06 0.02,-0.08 z m 0.35,-0.42 0.57,0.37 -0.83,0.06 z m 10.99,-7.18 0.14,0.2 -0.13,0.44 -0.56,0.27 -0.19,0.42 0.3,0.95 0.4,0.45 0.66,0.23 0.13,-0.13 0.33,0.04 2.19,-0.44 0.72,0.58 0.06,0.51 -0.15,0.56 -0.9,0.64 -0.17,0.3 0.04,0.2 -0.16,-0.13 -0.16,0.17 -0.06,0.68 0.28,0.72 0.43,0.57 0.22,0.11 0.7,-0.1 0.52,0.51 0.29,0.56 0.73,0.43 -0.42,0.17 -0.25,0.57 -0.07,0.48 0.17,0.59 -0.25,0.16 -0.39,-0.37 0.11,-0.11 0.29,0.17 -0.14,-0.4 -0.15,0.17 -0.36,-0.04 -0.11,0.13 -0.27,-0.25 0.82,-0.56 0.04,-0.25 -0.5,-0.08 -0.94,0.4 0.96,-0.59 0.11,-0.33 -0.48,0.05 -0.41,0.39 0.09,0.08 -0.21,0.05 -0.23,-0.4 -0.38,-0.16 -0.39,0.37 -0.69,-0.09 -0.41,0.39 -0.23,0.03 -0.17,-0.18 -0.01,0.27 0.23,-0.01 -0.07,0.27 -0.63,0.38 -0.46,0.99 0.05,-0.35 -0.61,0.28 0.14,0.61 0.16,-0.19 -0.16,-0.09 0.08,-0.17 0.24,0.28 0.32,-0.34 0.27,0.23 0.14,0.47 -0.46,0.48 -0.17,-0.2 -0.93,-0.18 -0.53,-0.34 0.05,-0.11 0.42,0.23 0,-0.53 0.2,-0.34 -0.41,0.37 0.19,0.2 -0.53,-0.01 -0.29,0.16 -0.82,-0.47 0.01,-0.16 -0.02,0.21 -0.25,0.05 -0.06,-0.37 0.09,-0.17 -0.16,-0.18 -0.17,0.28 -0.24,-0.05 -0.36,0.24 -0.05,-0.41 0.22,-0.22 0.42,0.19 0.07,-0.09 -0.25,-0.25 -0.55,-0.18 -0.09,-0.08 0.08,-0.09 -0.34,-0.27 0.19,-0.99 1.04,-0.15 0.36,0.21 0.63,-0.46 -0.39,-0.06 -0.15,-0.38 0.39,-0.12 -0.35,0.06 0.08,-0.15 -0.27,-0.09 -0.15,-0.42 -0.34,0.2 -0.61,0.03 0.29,-0.83 0.34,-0.06 0.12,0.2 0.08,-0.33 0.72,-0.14 -0.34,-0.09 0.58,-0.36 -0.18,0.07 -0.14,-0.24 -0.19,0.13 -0.13,-0.06 0.01,-0.68 -0.47,0.21 -0.46,-0.08 -0.23,-0.77 -0.29,-0.07 0.06,-0.17 0.47,0 1.05,-0.3 0.72,0.31 0.11,0.14 -0.09,0.39 0.25,0.19 0.11,-0.27 -0.15,-0.1 0.06,-0.31 -0.17,-0.32 0.71,-0.73 0.34,-0.04 -0.17,0.75 -0.28,0.08 0.4,0.12 -0.21,0.63 0.42,-0.02 0.2,-0.3 0,-0.23 -0.53,-0.18 0.32,-0.34 0.07,0.37 0.57,0.65 -0.12,0.4 0.13,0.3 0.45,0.14 0.16,0.4 0.28,-0.26 0.53,-0.07 -0.08,-0.26 0.19,-0.46 -0.12,-0.38 0.1,-0.07 -0.4,-0.8 0.3,0.01 0.03,-0.21 -0.35,0.1 0.02,0.31 -0.68,0.01 -0.35,-0.45 -0.44,-0.06 -0.18,-0.22 -0.28,-0.87 -0.24,0.09 -0.09,0.27 -0.3,0.22 0.09,0.3 -1.31,0.7 0.14,-0.87 0.42,-0.94 -0.1,-0.53 -0.28,0.08 -0.55,0.5 0.21,0.81 -0.1,-0.06 -0.03,0.25 -0.22,0.05 -0.53,0.66 -0.05,-0.1 0.03,0.12 -0.24,0.05 0.08,-0.39 0.71,-0.61 0.15,-0.44 -0.12,-0.75 0.44,-0.53 0.55,-0.38 0.74,-0.08 0.64,-0.26 z m 1.48,5.32 -0.55,0.69 0.68,0.27 -0.57,0.48 0.92,0.2 0.15,-1.51 z", 1, "state"], ["x", "221", "y", "3", "width", "32", "height", "18", "rx", "2", "ry", "2", 1, "box"], ["x", "237", "y", "15.96", 1, "text"], ["d", "m 69.45,38.96 0.06,-0.02 -0.07,0.08 0.02,-0.1 z m 0.6,-1.48 -0.36,0.5 -0.16,-0.44 z m 10.27,-2.61 1.27,0.3 -2.67,0.57 0.31,-0.79 z m -2.49,0.53 0.62,0.37 -1.09,0.01 z m 9.74,-0.41 0.17,0.09 0.01,0.35 -0.24,-0.19 z m 0.21,0.09 -0.01,0 -0.07,-0.17 z m -0.15,-0.5 -0.05,0.27 -0.31,-0.11 z m -4.56,-0.26 1.42,0.16 -2.3,0.56 z m 2.52,-0.27 1.09,0.21 0.27,0.13 0.08,0.08 0,0.08 -1.67,-0.38 -0.1,0.43 -0.28,-0.4 z m 25.57,3.43 0.12,0.27 -0.12,-0.27 z m -38.48,-0.93 0.53,0.18 -3.9,0.32 z m 17.19,-0.44 -0.59,0.26 0.28,-0.55 0.7,0.05 z m 20.1,0.16 0.5,0.41 0,0.16 z m -32.97,-0.64 -1.11,0.56 -2.08,-0.14 z m 40.89,62.53 -0.34,-1.13 -0.94,0.11 0.25,1.11 -1.03,-1 -0.03,0.62 -1.63,0.6 0.59,1.17 0.57,-0.43 -0.66,1.09 -2.71,-1.19 -0.18,-0.31 -0.15,-0.19 0.03,-0.08 0.47,-1.05 1.06,-0.39 0.01,-1.4 -0.95,-1.27 0.57,-0.39 -0.18,-0.66 0.63,0.12 -0.35,-0.78 0.75,0.37 0.21,-0.37 -0.98,-1.44 -1.82,0.29 -0.33,-0.82 -0.89,0.18 -0.38,0.08 -0.71,-0.08 0.08,-0.41 0.27,-0.23 -0.15,-0.41 0.26,-0.31 -0.24,-0.47 0.12,-0.33 -0.31,-0.31 0.15,-0.37 0.3,-0.04 0.11,-0.31 0.63,-0.64 -0.19,-0.06 0.07,-0.16 -0.21,-0.19 0.24,-0.49 -0.15,-0.31 0.43,-0.37 0,-0.21 -0.37,0.16 -0.52,0.02 -0.69,-0.25 -0.45,0.31 -0.19,-0.04 0.36,-1.09 -0.6,-0.7 -0.6,-0.25 0.05,-1.09 -1.45,0.18 0.13,-2.76 -0.61,-0.72 -0.41,-1.11 -1.91,0.13 0.15,-0.99 -0.58,-0.6 0.96,0.29 -0.14,-1.09 0.67,-0.22 -1.83,-1.23 1.05,-1.74 0.93,-0.26 0.64,-1.48 -0.48,-0.83 0.61,-1.07 -1.27,-0.46 -1.88,2.58 -3.6,0.24 -0.16,-2.86 -0.53,-0.48 -0.28,-0.35 -1.55,0.85 -0.76,-0.42 -1.49,1.83 -1.95,-0.34 0.25,1.34 2.07,1.16 0.34,2.51 -0.41,1.43 1.21,0.76 -1.71,1.23 -0.05,0.6 -2.31,-0.49 -1.23,1.54 -1.57,0.38 -1.02,-0.31 -0.87,0.85 -1.52,-1.29 2.01,-0.8 0.18,-1.5 -1.35,-0.15 -0.53,-0.81 0.96,-1.71 -0.41,-0.79 0.92,-0.02 -0.34,-0.56 -1.15,-1.5 -1.37,0.22 -1.49,-0.82 -0.38,-1.41 -1.26,-0.57 -0.01,0 -0.74,1.09 0.61,0.3 -0.35,1.16 -4.35,2.43 -0.32,0.42 -2.85,-0.02 -0.39,0.48 -0.54,0.02 -0.6,-1.23 0.81,-2.24 -1.21,-2.53 -0.84,0.82 -3.88,-1.49 -0.2,-1.78 1.38,-0.18 -0.85,-1.76 1.23,-0.61 3.53,0.49 0.8,-0.12 0.67,-5.43 2.2,-4.07 -0.15,-2.8 -0.36,-0.69 0.8,-1.07 0.12,-3.02 0.3,-0.67 0.87,-0.08 -4.3,-0.46 -0.44,-0.63 0.75,-4.7 0.42,0.57 0.2,-0.38 0.23,0.52 0.26,0.05 0.48,-0.62 -0.78,-0.97 1.11,-1.46 3.23,-1.45 3.01,0.39 4.05,-0.75 0.04,-0.02 1.65,-0.23 1.78,0.3 0.18,1.75 0.78,0.12 0.18,0.29 0.69,0.67 0.32,1.77 -0.25,0.53 -1.48,0.2 0.22,1.24 1.18,0.33 0.66,1.02 1.01,0.24 0.88,-1.44 -0.05,-1.75 -1.3,0.04 0.41,-1.86 0.95,-0.64 1.35,1.25 1.9,0.31 0.52,1.12 -0.95,1.14 1.78,-0.29 0.75,-0.83 -0.55,-1.55 0.53,-0.75 -2.05,-0.09 -0.58,-2.22 1.12,-3.45 1.04,-1.59 1.13,-0.19 1.56,1.47 3.77,0.28 -0.13,-0.45 1.97,-0.56 1.18,0.03 0.86,0.19 0.77,0.82 0.6,1.34 0.82,1.31 1.19,1.21 0.74,1.74 0.72,0.7 0.98,0.47 0.56,0.53 0.39,0.08 0.13,-0.16 0.14,0.02 0.01,0.16 0.23,-0.1 0.46,0.12 -0.04,1.01 0.23,0.2 1.25,1.78 0.65,-0.72 0.21,1.13 0.5,-0.45 0.57,0.41 1.05,-1.28 1.97,1.77 0.96,0.01 1.13,-1 2.55,1.2 1.62,0.64 0.38,-0.07 1.66,-0.19 2.16,1.67 1.3,-1.17 1.1,0.39 1.53,2.95 1.83,0.99 -0.33,0.66 1.51,0.87 1.21,1.74 1.72,-0.66 2.41,1.07 -0.63,0.98 -0.71,-0.21 -0.07,1.75 -3.31,1.83 -4.12,-0.92 -0.64,0.09 -0.89,1.52 -1.57,0.07 -1.2,0.27 -0.1,1.23 0.64,2.15 0.53,-0.07 1.52,2.77 0.88,-0.39 -0.61,1.51 1.19,1.85 -0.94,0.04 -0.24,0.64 -0.01,0.29 1.34,1.89 0.98,0.35 -0.27,0.64 -1.18,0.25 1.71,2.95 -1.16,0.78 0.77,0.7 -0.23,1.03 -1.65,0.83 0.4,1.23 -0.31,-0.06 -2.33,0.33 -2.49,0.2 -0.34,0.89 -1.06,0.12 1.48,1.21 -0.61,0.48 0.6,1.33 -1.12,1.11 -0.08,0.99 2.15,4.41 -0.39,0.11 -0.71,0.83 0.4,1.29 -0.85,-0.54 -1.41,0.7 -0.5,-0.55 -1.92,-0.33 -0.1,0.85 -1.07,1.64 -1.08,0.63 -0.71,-0.26 -0.61,1.34 -1.19,-0.09 -0.18,0.41 -0.38,-0.47 z m -20.47,-45.84 0.85,0.87 0.02,0.82 0.95,-0.22 1.22,0.98 0.31,-0.63 0.77,0.81 1.03,-0.94 -0.28,-1.03 0.47,-0.28 -0.7,-0.52 0.6,-0.26 -0.62,-0.68 -1.29,0.52 -0.55,-0.87 -2.63,-0.33 -0.56,-0.6 -0.57,0.36 0.13,-0.74 -1.49,-0.45 -0.31,0.04 0.71,1.04 1.42,0.59 z m -0.66,-2.35 0.07,0.02 -0.06,-0.04 z m 0.6,-10.84 0.24,0.17 -0.21,-0.21 z m -28.93,-0.63 -1.32,0.57 0.6,0.45 -0.15,0.26 -1.42,-0.75 0.18,-0.51 1.31,-0.32 z m 46.71,2.26 -0.01,-0.02 0.01,-0.02 z m -1.17,-0.26 0.26,0.04 0.22,0.02 0.03,0 0.14,0.02 0.53,0.08 -1.53,-0.08 -0.23,-0.2 0.29,0.06 0.17,0.02 z m -1.4,-0.63 -0.27,-0.1 -0.33,-0.37 z", 1, "state"], ["x", "221", "y", "30", "width", "32", "height", "18", "rx", "2", "ry", "2", 1, "box"], ["x", "237", "y", "42.96", 1, "text"], ["d", "m 55.62,119.54 0,0.04 -0.23,-0.01 -0.07,-0.17 0.08,-0.1 0.06,0 0.04,0.1 0.1,0.07 z m 0.62,-1.46 -1.06,0.92 0.84,-1.26 z m -0.69,-2.28 -0.15,0.36 -0.28,-0.34 z m -0.17,0.49 0.03,0.08 0.03,0.04 0.06,0.02 0.11,-0.04 0.09,0.05 0.34,-0.03 0.06,-0.06 0.02,-0.12 0.05,-0.02 0.03,0 0.05,0.02 0.04,0.08 0.13,0.11 0.05,0.02 0.22,-0.07 0.05,0.02 0.04,0.04 0.1,0.27 0,0.04 -0.08,0.08 -0.03,-0.04 -0.09,-0.02 -0.09,0.02 -0.34,0.03 -0.3,-0.18 -0.05,0.02 -0.11,0 -0.07,-0.04 -0.06,0.04 -0.03,-0.04 -0.03,0 -0.03,-0.02 -0.08,0.08 -0.03,0.02 0.01,0.06 -0.05,0.02 -0.06,0.08 -0.1,-0.07 0,-0.04 0.08,-0.02 0.05,-0.1 -0.26,-0.32 0.08,-0.02 0.01,0.02 0.05,-0.02 0.02,0 0.05,0 0.08,-0.06 z m 32.51,-0.1 -0.44,-0.48 -1,0.15 0.03,-0.74 -1.17,-1.3 0.01,-1.85 -2.27,-1.06 0.39,-1.15 -1.08,-0.39 -0.85,0.56 0.4,1.93 -1.7,0.62 0.34,0.67 -0.46,0.73 -3.62,1.39 -1.05,-0.15 -0.37,1.76 -2.46,0.61 -0.01,-0.68 -0.12,-0.02 -0.14,0.18 -0.83,1.11 -0.53,-0.33 -0.48,0.67 -0.52,-0.55 -1,1.06 -1.17,0.13 -0.01,0.68 -0.79,0.14 0.27,1.53 -0.77,0.41 -0.9,-1.04 -0.96,0.46 0.84,2.96 -1.72,0.62 -0.51,-0.97 -0.76,0.51 -0.3,-0.98 -2.58,1.28 0.14,-0.68 -0.59,-0.21 -0.15,-0.56 -0.48,0.12 0.61,1.65 -0.34,-0.03 -1,-1.53 0.63,-1.89 -0.95,-1.24 -0.01,-0.02 0,-0.02 -0.09,-0.07 -0.19,0.1 -0.21,-0.05 -0.06,-0.13 -0.11,0.04 -0.07,-0.07 -0.14,0.14 -0.12,-0.03 -0.01,-0.08 -0.03,-0.02 -0.17,0.12 -0.19,0.03 -0.08,0.06 -0.1,-0.11 0.05,-0.04 -0.04,-0.13 -0.04,-0.04 -0.05,-0.17 -0.05,0 -0.03,-0.04 0.06,-0.02 -0.06,-0.06 -0.03,-0.06 0,-0.1 -0.03,-0.06 -0.1,-0.07 -0.03,-0.06 0.04,-0.12 0.01,-0.12 0.05,-0.08 0.09,-0.06 0.09,-0.24 0.08,-0.02 0.09,0.05 0.06,-0.02 0.03,-0.04 0.01,-0.12 0.11,-0.08 0.05,-0.06 0.02,-0.16 0.05,-0.14 0.01,-0.14 0.07,-0.2 0.12,-0.18 -0.04,-0.15 0.05,-0.04 0.17,-0.1 0.16,-0.24 0.01,-0.19 0.08,-0.06 0,-0.06 -0.12,-0.34 -0.06,-0.02 -0.22,0.07 -0.05,0 -0.13,-0.11 -0.06,-0.11 -0.06,-0.02 -0.08,0.02 -0.02,0.14 -0.06,0.06 -0.32,0.01 -0.08,-0.02 -0.11,0.02 -0.06,-0.02 -0.03,-0.04 -0.03,-0.12 0.05,-0.1 0.18,-0.16 -0.02,-0.17 -0.09,-0.05 -0.2,0.03 -0.2,0.01 -0.07,-0.19 0.03,-0.02 0,-0.02 -0.09,-0.05 -0.01,-0.06 -0.12,-0.09 -0.01,-0.04 -0.07,-0.07 0.02,-0.04 -0.03,-0.1 0.02,-0.04 -0.04,-0.04 -0.03,-0.08 -0.05,-0.02 -0.04,-0.04 -0.01,-0.08 -0.14,-0.21 0.02,-0.06 0,-0.04 -0.04,-0.1 -0.04,-0.13 -0.06,-0.09 -0.08,-0.02 -0.21,-0.01 -0.05,0.06 -0.06,-0.06 -0.06,0.04 -0.25,0.01 -0.39,-0.16 -0.07,-0.07 -0.06,0.27 -0.05,0 -0.04,-0.04 0.02,-0.1 0.02,-0.02 -0.05,0 -0.01,-0.02 -0.01,-0.14 0.03,-0.04 -0.01,-0.02 0.1,-0.12 0.02,-0.06 -0.01,-0.06 0.02,-0.08 -0.31,-0.2 -0.05,-0.27 0.02,-0.04 0.03,-0.04 0.13,-0.2 -0.04,-0.04 -0.08,-0.02 -0.06,-0.06 -0.15,-0.09 -0.06,-0.06 -0.03,0 -0.06,-0.09 -0.03,0.02 -0.01,-0.04 -0.01,-0.06 -0.1,-0.11 -0.14,-0.03 -0.03,-0.04 -0.06,-0.04 0.05,-0.16 0.05,-0.04 0.02,-0.08 0.06,-0.04 0.13,0.09 0.16,0.17 0.13,-0.08 0.11,-0.16 0.14,-0.1 -0.03,0 0.02,-0.04 -0.03,-0.02 0.06,-0.08 -0.05,-0.19 0.05,-0.02 -0.11,-0.05 -0.02,-0.12 0.04,-0.1 -0.04,-0.02 0.06,-0.2 0.06,0 0.06,-0.04 0.05,0 0.1,-0.08 0.14,-0.01 0.12,-0.06 0,-0.02 0.08,-0.06 0.03,0 0.01,0.02 -0.02,0.14 0.05,-0.02 0.07,0.04 0.16,0.09 0.08,-0.37 0.06,-0.04 0,-0.04 0.05,-0.02 0.05,-0.12 -0.01,-0.04 0.05,-0.04 -0.04,-0.08 0.02,-0.08 -0.09,-0.11 -0.07,-0.13 0,-0.1 -0.01,-0.04 0.09,-0.26 -0.01,-0.08 0.02,-0.04 0.02,0 0.02,-0.06 0.05,-0.02 0.03,-0.06 -1.12,-0.61 0.2,-1.29 -2.16,0.13 -0.41,-2.04 0.79,-0.37 0.71,0.88 0.92,-1.44 2.62,-1.41 -0.38,-0.68 0.6,-0.26 -1.55,0.26 -0.08,-1.88 2.65,-3.12 -0.03,-3.94 -1.88,-2.51 0.5,-1.32 -1.3,-0.49 0.17,-1.17 -1.48,-0.91 0.67,-0.88 -0.68,-1.12 1.98,-1 1.63,0.73 -0.96,-1.4 0.98,-0.18 0.74,0.88 1.13,-0.1 2.04,1.3 -0.24,-1.22 1.32,0.59 3.34,-1.5 0.76,0.54 0.81,-0.51 1.02,-1.86 -2.25,-1.46 0.15,-0.8 0.86,-0.28 0.24,-0.96 1.55,0.01 2.19,-2.68 1.32,-0.39 0.54,-0.02 0.39,-0.48 2.85,0.02 0.32,-0.42 4.35,-2.43 0.35,-1.16 -0.61,-0.3 0.74,-1.09 0.01,0 1.26,0.57 0.38,1.41 1.49,0.82 1.37,-0.22 1.15,1.5 0.34,0.56 -0.92,0.02 0.41,0.79 -0.96,1.71 0.53,0.81 1.35,0.15 -0.18,1.5 -2.01,0.8 1.52,1.29 0.87,-0.85 1.02,0.31 1.57,-0.38 1.23,-1.54 2.31,0.49 0.05,-0.6 1.71,-1.23 -1.21,-0.76 0.41,-1.43 -0.34,-2.51 -2.07,-1.16 -0.25,-1.34 1.95,0.34 1.49,-1.83 0.76,0.42 1.55,-0.85 0.28,0.35 0.53,0.48 0.16,2.86 3.6,-0.24 1.88,-2.58 1.27,0.46 -0.61,1.07 0.48,0.83 -0.64,1.48 -0.93,0.26 -1.05,1.74 1.83,1.23 -0.67,0.22 0.14,1.09 -0.96,-0.29 0.58,0.6 -0.15,0.99 1.91,-0.13 0.41,1.11 0.61,0.72 -0.13,2.76 1.45,-0.18 -0.05,1.09 0.6,0.25 0.6,0.7 -0.36,1.09 0.19,0.04 0.45,-0.31 0.69,0.25 0.52,-0.02 0.37,-0.16 0,0.21 -0.43,0.37 0.15,0.31 -0.24,0.49 0.21,0.19 -0.07,0.16 0.19,0.06 -0.63,0.64 -0.11,0.31 -0.3,0.04 -0.15,0.37 0.31,0.31 -0.12,0.33 0.24,0.47 -0.26,0.31 0.15,0.41 -0.27,0.23 -0.08,0.41 0.71,0.08 0.38,-0.08 -1.7,0.92 0.6,0.64 -1.07,2.06 -2.53,1.84 -1.09,-0.11 -0.2,-1.5 -1.73,-0.09 -1.33,0.65 0.46,1.36 0.48,0.07 -0.14,1.03 -4.13,0.31 -2.07,2.34 0.52,1.04 2.07,-0.68 0.74,1.72 -1.28,2.01 0.45,0.6 -2.83,0.19 -0.78,0.57 0.59,1.61 -1.02,1.3 -0.39,1.4 -1.7,1.42 -0.83,0.01 -0.22,-0.56 -2.81,2.42 0.66,1.41 z", 1, "state"], ["x", "221", "y", "57", "width", "32", "height", "18", "rx", "2", "ry", "2", 1, "box"], ["x", "237", "y", "69.96", 1, "text"], ["d", "m 88.92,161.7 -2.86,-0.92 -2.06,-1.52 -0.61,0.26 -0.77,0.31 -1.23,-0.89 -0.58,0.52 -1.52,-0.01 -2.47,-1.44 -0.54,-1.93 -1.03,0.1 0.2,-0.51 -1.34,0.56 -0.82,-0.77 -0.5,-1.29 1.87,-2.03 0.16,-1.36 -0.09,-0.11 -0.51,0.21 -1.3,-0.72 0.14,-0.41 -0.08,-0.11 -0.66,-0.64 0.91,-1.05 -0.45,-0.32 0.58,-1.01 -0.55,-0.7 -0.11,-0.93 -0.96,0.45 -0.65,-0.91 -1.47,-0.05 -0.98,-1.1 -2.37,0.58 0.01,0.04 -0.06,0 -3.44,1.94 -0.63,-0.44 -0.86,0.85 -0.67,-0.64 -0.81,0.32 -2.31,-0.71 -0.37,-0.61 1.15,-1.19 0.16,-1.23 1.58,-1.44 -0.12,-1.78 0.42,-0.42 -0.92,-0.41 -0.76,0.24 -1.11,-1.1 -0.71,0.26 -0.12,-0.79 -1.31,-0.86 -0.11,-1.33 -0.52,-0.52 -0.25,0.38 -0.97,-2.85 0.79,-2.15 -0.22,-0.73 0.91,-0.29 -0.27,-1.37 1.79,-0.81 0.91,-1.49 0.57,0.52 0.73,-0.44 0.34,0.03 -0.61,-1.65 0.48,-0.12 0.15,0.56 0.59,0.21 -0.14,0.68 2.58,-1.28 0.3,0.98 0.76,-0.51 0.51,0.97 1.72,-0.62 -0.84,-2.96 0.96,-0.46 0.9,1.04 0.77,-0.41 -0.27,-1.53 0.79,-0.14 0.01,-0.68 1.17,-0.13 1,-1.06 0.52,0.55 0.48,-0.67 0.53,0.33 0.83,-1.11 0.14,-0.18 0.12,0.02 0.01,0.68 2.46,-0.61 0.37,-1.76 1.05,0.15 3.62,-1.39 0.46,-0.73 -0.34,-0.67 1.7,-0.62 -0.4,-1.93 0.85,-0.56 1.08,0.39 -0.39,1.15 2.27,1.06 -0.01,1.85 1.17,1.3 -0.03,0.74 1,-0.15 0.44,0.48 -0.27,0.76 0.66,1.54 -0.6,1.7 -1.27,-0.62 -1.01,1.2 0.45,1.55 -0.69,1.22 1.47,0.85 1,2.62 -0.33,0.45 -1.12,-0.33 0.37,1 -0.41,0.49 -0.75,-0.63 -1.84,1.49 0.83,1.01 -0.07,1.05 -1.27,-0.67 -0.3,1.17 -1.08,0.43 1.84,2.55 4.93,-1.55 0.25,-0.04 0.9,0.22 0.75,0.88 0.91,1.46 -0.01,1.59 0.92,2.05 0.39,0.93 0.94,0.1 -0.53,0.82 -0.05,0.08 -1.53,1.03 0.95,2.55 0.12,0.31 0.01,0.25 -0.01,0.87 0.67,1.89 -0.37,0.51 0.52,0.21 0.6,0.17 -0.18,0.68 -0.05,0.31 -0.54,0.41 0.01,0.21 0.16,0.08 0.48,-0.34 -0.1,0.68 -0.43,0.53 -0.34,0.57 0.61,0.77 -0.35,0.18 -0.94,0.87 -1.32,4.47 -1.13,2.35 -0.27,0.24 z", 1, "state"], ["x", "221", "y", "84", "width", "32", "height", "18", "rx", "2", "ry", "2", 1, "box"], ["x", "237", "y", "96.97", 1, "text"], ["d", "m 57.49,145.34 2.31,0.71 0.81,-0.32 0.67,0.64 0.86,-0.85 0.63,0.44 3.44,-1.94 0.06,0 -0.01,-0.04 2.37,-0.58 0.98,1.1 1.47,0.05 0.65,0.91 0.96,-0.45 0.11,0.93 0.55,0.7 -0.58,1.01 0.45,0.32 -0.91,1.05 0.66,0.64 0.08,0.11 -0.14,0.41 1.3,0.72 0.51,-0.21 0.09,0.11 -0.16,1.36 -1.87,2.03 0.5,1.29 0.82,0.77 -1.33,1.2 -2.31,-0.21 -0.98,-0.98 -0.88,1.13 -0.23,-2.09 -1.85,-0.91 -1.51,0.2 0.38,0.94 -0.52,0.7 -1.63,-0.39 -0.2,-1.47 -0.48,0.09 -0.38,-1.73 -1.73,-1.86 0.65,-0.49 -1.02,-0.95 0.29,-0.46 -2.13,-1.59 -1.06,0.14 z", 1, "state"], ["x", "221", "y", "111", "width", "32", "height", "18", "rx", "2", "ry", "2", 1, "box"], ["x", "237", "y", "123.96", 1, "text"], ["d", "m 154.66,125.38 -2.11,-0.82 0.09,-0.99 -1.11,-0.89 -0.54,-0.5 1.04,-0.3 0.19,-0.89 -1.6,-1.35 0.89,-0.46 0.28,-0.94 1.07,-1.19 0.41,2.25 0.87,-0.79 1.22,0.08 -0.78,-0.36 0.62,-1.09 0.57,0.43 0.23,-0.79 1.13,0.25 0.86,-1.25 -0.97,-0.46 0.01,-1.11 -0.64,0 1.01,-1.23 -0.62,-0.12 -0.07,-0.78 1.62,-0.2 0.41,-0.8 1.07,0.25 1.11,-1.67 2.2,-0.07 0.19,-0.54 -0.66,-1.5 -1.5,-0.39 0.14,-0.71 -0.51,0.21 -0.09,-1.13 -0.79,-0.61 -1.42,0.24 -0.71,-0.67 -0.76,0.38 -0.91,-0.3 0.16,-0.73 -0.76,-0.28 0.23,-1.1 -0.62,0.08 0.47,-0.88 -0.63,-1.61 -0.42,-1.16 0.74,-0.36 -0.14,-2.34 -0.72,-1.09 0.87,-0.61 -0.1,-1.23 0.69,-0.95 2.98,-0.52 0.26,-0.73 0.66,0.41 1.56,-0.93 0.81,-0.01 -0.33,0.4 1.25,-1.43 1.4,0.33 1.16,-1 0.36,0.75 0.36,-0.35 0.91,0.72 0.64,-0.83 0.68,0.79 0.45,-0.29 0.62,1.02 0.56,-0.31 0.58,0.47 -0.15,0.87 1.12,1.08 -0.44,2.54 0.42,-0.12 0.2,0.75 0.99,0.49 0.78,-1.44 0.94,0.28 0.37,-0.8 0.18,0.36 1.86,0.91 0.39,0.85 0.43,-0.46 0.42,0.41 1.59,-0.21 1.22,0.35 1.15,-0.54 2.04,-0.65 0.69,0.6 0.91,-1.97 -0.53,-0.75 0.89,-0.11 0.26,-1.19 0.89,-0.57 1.82,0.11 1.01,0.66 0.84,-1.02 0.99,-0.06 1.92,-1.18 0.72,0.78 1.05,-0.07 0.29,-1.24 0.57,0.35 -0.03,0.17 -0.23,0.35 0.46,0.94 1.01,0.16 0.97,0.68 1.06,0.07 0.63,0.37 0.4,0.67 -0.24,0.31 0.07,0.94 0.46,0.54 -0.28,0.35 1.42,2.21 -0.59,2.99 0.15,1.04 -0.27,0.21 0.06,1.03 -0.88,2.23 -0.23,1.46 -1.18,1.55 0.11,0.47 -0.32,1.2 -0.56,0.14 -0.48,-0.24 -0.26,0.2 -0.26,-0.48 -1.53,-0.35 0.48,-1.29 -0.09,-0.68 -1.08,0.53 -0.33,-0.1 0.47,-1.85 -0.62,-0.56 -0.48,0.2 -0.07,-0.33 -0.57,-0.13 0.13,-0.57 -0.29,0.02 0.06,0.51 -0.67,-0.27 -0.72,0.5 -1.57,-0.87 -0.7,0.46 -0.17,1.39 1.19,0.05 -0.43,0.48 1.68,0.74 -0.16,0.92 -1.99,0.23 -0.67,0.99 -2.34,1.38 -1.48,-0.1 -1.46,0.79 0.04,1.3 -0.69,0.49 -3.39,0.11 -2.09,0.79 0.36,0.7 -0.64,1.19 -0.62,0.88 -1.6,-1.22 -0.69,1.87 -1.27,-0.23 -0.78,2.39 -2.75,-0.04 -0.12,1.68 -1.17,1.17 -2.22,-1.37 -0.11,0.77 -0.3,-0.48 -0.98,0.52 -0.42,0.93 -0.59,-0.49 -1.5,0.33 -1.19,0.29 -0.34,1.27 -1.5,0.82 -0.57,2.1 -0.48,0.02 0.13,1.87 -0.76,-0.12 0.02,-1.18 -0.95,-0.63 0.46,-0.12 -0.22,-0.55 -0.88,-0.01 -0.34,-1.29 z", 1, "state"], ["x", "221", "y", "138", "width", "32", "height", "18", "rx", "2", "ry", "2", 1, "box"], ["x", "237", "y", "150.96", 1, "text"], ["d", "m 143,102.46 -0.08,-0.06 0.12,0.02 -0.01,0.14 z m -12.46,-11.5 -2.15,-4.41 0.08,-0.99 1.12,-1.11 -0.6,-1.33 0.61,-0.48 -1.48,-1.21 1.06,-0.12 0.34,-0.89 2.49,-0.2 2.33,-0.33 0.31,0.06 -0.4,-1.23 1.65,-0.83 0.23,-1.03 -0.77,-0.7 1.16,-0.78 -1.71,-2.95 1.18,-0.25 0.27,-0.64 -0.98,-0.35 -1.34,-1.89 0.01,-0.29 0.24,-0.64 0.94,-0.04 -1.19,-1.85 0.6,-1.51 -0.88,0.39 -1.52,-2.77 -0.53,0.07 -0.64,-2.15 0.1,-1.23 1.2,-0.27 1.57,-0.07 0.89,-1.52 0.64,-0.09 4.12,0.92 3.31,-1.83 0.07,-1.75 0.71,0.21 0.63,-0.98 0.67,-0.08 -0.2,0.68 0.3,0.18 0.52,-0.08 0.26,0.77 0.8,-0.31 0.34,0.2 0.37,0.52 0.9,0.16 0.11,0.3 -0.37,0.44 0.04,0.29 0.21,0.14 0.54,0 0.39,0.4 0.56,0.02 0.8,0.39 0.63,-0.39 0.62,0.02 0.09,0.12 0.16,-0.07 0.1,0.24 0.5,0 0.17,-0.48 0.03,0.1 -0.01,0.95 1.15,-0.68 0.6,0.47 0.31,1.78 -0.47,0.06 -0.3,1.9 0.72,2.34 -1.03,0.12 0.18,1.33 -0.58,1.25 0.75,-0.13 -0.26,0.71 0.8,0.12 0.21,-0.62 0.61,0.95 0.94,-0.28 -0.17,1.14 -0.66,1.03 0.62,1.85 -0.93,2.59 0.87,0.52 -1.25,1.55 1.04,1.71 1.67,1.5 0.03,0 0.95,0.71 0.73,-0.46 1,1.24 1.24,0.01 0.73,-0.85 1.78,0.83 1.22,0.26 0.17,0.86 1.76,-0.08 0.24,0.9 1.18,-0.05 -0.05,0.79 1.5,-0.36 0.33,0.58 -0.43,0.14 1.21,3.63 -2.14,1.89 -0.45,0.29 -0.68,-0.79 -0.64,0.83 -0.91,-0.72 -0.36,0.35 -0.36,-0.75 -1.16,1 -1.4,-0.33 -1.25,1.43 0.33,-0.4 -0.81,0.01 -1.56,0.93 -0.66,-0.41 -0.26,0.73 -2.98,0.52 -0.69,0.95 0.1,1.23 -0.87,0.61 0.72,1.09 0.14,2.34 -0.74,0.36 0.42,1.16 0.63,1.61 -0.47,0.88 0.62,-0.08 -0.23,1.1 0.76,0.28 -0.16,0.73 0.91,0.3 -0.51,1.42 0.72,0.41 -1.07,2.12 -0.59,-0.6 -0.44,0.2 -1.17,-0.37 -1.2,0.18 -2.27,-2.21 -2.14,0.42 -1.05,-1.06 -0.02,-0.1 -0.52,-0.6 -0.77,0.37 -0.22,-0.36 -2.03,0.22 -0.35,-0.2 -0.22,-0.88 0.35,-0.05 0.2,-0.46 -0.25,-0.1 -0.05,-0.62 -0.64,-0.5 -0.65,0.24 -0.04,-0.37 -0.41,-0.09 0.32,-0.65 0.46,0.11 0.98,-1.45 -0.77,-1.17 -0.29,-0.05 -0.09,0 -0.1,-0.18 -0.13,-0.26 -0.02,-0.64 -1.03,-0.14 -0.18,-0.53 -2.76,0.29 -1.36,-0.69 -1.52,0.09 -0.12,-1.46 -0.77,-1.01 0.34,-0.46 -1.11,-1.11 0.19,-0.56 0.61,0.26 -0.25,-0.65 -2.5,-0.82 z m 25.07,-16.19 0.15,-0.03 -0.18,-0.01 z m 0.17,0.06 0.16,0.01 -0.15,-0.04 z m -1.54,-16.69 0,0.04 0.07,-0.06 z", 1, "state"], ["x", "221", "y", "165", "width", "32", "height", "18", "rx", "2", "ry", "2", 1, "box"], ["x", "237", "y", "177.96", 1, "text"], ["d", "m 109.55,35.24 0,0.04 -0.16,-0.31 -0.27,-0.8 0.33,0.68 z m 4.7,5.29 0.06,-0.02 0.17,0.02 -0.01,0.02 z m -0.26,-0.04 -0.12,-0.04 0.1,0.02 z m -2.71,-2.75 -0.12,-0.27 -0.36,-0.92 0,-0.04 0.06,0.02 0.42,1.17 z m 0.4,0.51 0.07,0.18 -0.13,-0.25 z m 0.06,0.51 -0.33,-0.53 0.11,-0.51 z M 85.8,23.65 85.87,24.11 85.55,23.69 z m 0.54,0.01 -0.02,0.2 -0.25,-0.17 z m 11.96,3.57 -0.13,0.22 0.26,0.11 -0.2,0.08 -0.13,-0.14 0,-0.31 0.27,-0.24 z m 38.94,-9.54 -0.04,-0.02 0.01,-0.04 0.03,0.04 z M 93.5,5.92 l 0.04,0 -0.06,0.02 -0.04,-0.06 z m -0.28,-0.21 0.01,0.04 -0.03,0.02 0,-0.04 z m 5.51,5.27 -0.04,0.14 -0.41,-0.07 z m -2.82,-2.08 0.98,0.42 -0.37,1.59 -2.6,-0.67 0.49,-1.1 z m 32.23,36.64 -0.38,0.07 -1.62,-0.64 -2.55,-1.2 0.27,-0.45 -0.39,0.19 -1.03,-1.39 -1.37,-1.28 1.09,-2.35 -1.29,-1.2 0.84,-1.36 -1.89,0.59 -0.06,0.08 0.07,0.2 -0.04,0.04 -0.03,0.45 -1.11,-0.03 -0.14,0.86 -0.69,-0.12 -0.63,0.04 -1.25,1.77 -0.97,-1.13 -0.46,1.64 -2.81,-1.45 0.39,-0.08 -0.98,-2.38 -1.38,-0.99 -0.47,-1.97 -3.14,-1.67 -3.62,-0.16 -1.91,-3.22 -0.58,-0.19 1.2,-0.58 1.2,0.32 0.42,-0.63 -0.93,-1.95 -1.04,0.34 -0.48,-0.66 -0.26,-1.21 0.57,-2 -0.08,-0.41 -0.25,-0.25 -0.66,0.26 -0.16,-0.04 -0.03,-0.16 -0.35,-0.04 -0.4,0.16 -0.1,-0.1 -0.37,0.34 -0.4,-0.19 -0.91,-0.81 -0.03,-0.74 0.31,-0.08 0.37,0.13 0.13,-0.27 0.6,-0.18 -0.02,-0.45 -0.4,0.08 -0.25,-0.27 0.1,-0.33 0.27,-0.2 2.38,-0.35 0.01,0.14 0.38,0.06 0.57,-0.12 1.11,-1.2 0.57,-0.14 -0.06,-0.1 0.2,-0.29 0.3,0.12 -0.34,-0.17 0.14,-0.14 -0.04,-0.33 -0.42,-0.74 -0.57,0.3 0.04,0.33 -0.51,0.67 0.14,0.21 -0.4,0.22 -0.89,-0.07 -0.52,-0.25 0.19,-0.43 -0.15,-0.08 -0.04,-0.23 1.01,-0.77 0.1,-0.45 -0.14,-0.43 0.36,-0.96 -0.1,-0.29 -0.59,-0.44 -0.23,-0.72 -0.8,-0.34 -0.4,-0.43 -0.16,-0.92 -0.34,-0.25 -0.37,0.04 -0.14,-0.17 0.31,-0.24 -0.27,-0.94 L 98.23,8.03 97.87,7.86 97.83,7.53 97.18,6.69 97.14,5.72 96.83,5.54 95.78,5.61 94.87,6.23 94.22,6.48 93.71,6.19 93.51,5.72 93.14,5.59 93.02,6.06 92.63,6.17 92.46,6.58 92.44,9.28 92.15,8.95 92.34,5.74 92.57,4.6 94.06,1.1 94.37,0.94 94.87,1.17 l -0.81,0.09 0.61,0.17 0.05,0.64 -1.35,1.23 0.16,1.66 0.83,0.71 3.82,-0.81 0.88,0.5 3.36,-0.24 2.52,0.77 1.95,0.64 0.14,1.04 0.69,0.23 0.74,0.04 0.61,-1.04 0.62,0.43 0.21,0.9 0.84,-0.88 1.54,-1.43 0.32,0.02 -0.36,0.66 0.23,0.53 0.28,-0.02 0.46,0.31 0.14,-0.08 1.67,0.71 0.31,-0.04 0.24,0.49 0.58,0.59 0.45,0.1 0.31,-0.49 0.16,0.2 -0.09,-0.25 0.15,-0.72 0.73,0.53 0.3,0.59 0.2,1.02 0.72,0.81 -0.04,0.39 -0.1,-0.16 0.13,-0.16 -0.21,0 0.11,-0.12 -0.03,-0.06 -0.04,0.12 -0.11,-0.18 -0.36,0.31 0,-0.41 -0.16,-0.08 -0.15,0.29 0.09,0.2 -0.62,0.25 -0.06,1.15 -0.25,0.02 -0.11,-0.16 0,0.18 -0.76,0.66 -0.39,0.15 0.09,0.08 -0.27,0.25 -0.16,-0.08 0.18,-0.16 -0.28,0.14 -0.07,0.21 0.13,-0.16 0.04,0.18 -0.3,0.17 -0.31,-0.02 0.13,-0.1 -0.17,-0.06 -0.01,0.41 -0.44,0.53 -0.08,0.35 -0.34,-0.04 0.1,0.08 -0.11,0.27 -0.16,0.02 -0.07,-0.2 -0.79,0.08 0.06,0.1 -0.17,-0.02 -0.07,0.21 -0.1,-0.47 -0.37,0.12 0.03,0.14 -0.28,0.29 -0.47,-0.08 -0.18,0.12 0.47,0.18 0.75,-0.27 0.37,0.04 0.25,0.08 0.17,0.29 0.52,0.1 -0.2,-0.7 0.28,0.04 0.08,-0.31 0.09,0.23 0.62,-0.17 -0.48,0 0.21,-0.53 2.9,-2.02 0.11,-0.37 0.37,-0.99 1,0.1 -0.05,0.9 -0.49,3.01 -1.82,1.22 -0.57,-0.02 -0.13,0.04 -0.04,0.04 0.54,0.67 4.04,-1.01 1.08,0.77 -0.48,0.6 0.01,0.04 0.38,1.08 -0.82,0.58 -0.1,1.5 0.63,-0.91 0.79,-1.81 1.58,-0.57 4.2,1.83 1.78,1.51 1.18,-0.2 1.26,-1.23 0.53,-0.26 0.36,-0.4 1.39,0.01 0.04,0.1 -0.1,0.02 0.04,-0.08 -0.03,-0.02 -0.18,0.15 0,-0.1 -0.28,0.07 -0.03,-0.1 -0.08,0.1 0.67,0.21 0.82,-0.26 0.22,-0.39 0.25,-0.15 0.04,0.1 0.24,0.51 -1.02,0.57 0.62,4.05 -3.29,2.98 -1.05,-0.45 -0.82,1.35 0.41,1.39 0.93,0.25 0.56,0.11 0.43,0.79 -0.11,0.86 1.05,0.25 0.09,0.18 -0.88,0.26 -0.43,-0.71 -1.74,1.38 -0.1,1.64 -0.04,1.68 1.47,1.23 1.12,0 0.49,1.35 -0.61,2.02 -1.39,-0.08 0.06,1.62 -1.92,0.98 -0.12,0.6 -0.95,0.01 z m 7.11,-28.46 0.14,0.02 -0.04,0.06 z m 0.01,-2.4 0.17,0 0.04,0.02 0.26,0.04 0.1,0.04 0.2,0.06 0.34,0.03 0.13,0 0.36,0.18 0.03,0.1 0.1,0.06 0.31,0.12 0.13,-0.02 0.09,0.06 -0.01,0.04 0.06,0 0.03,0.08 0.1,0.1 0.09,0.37 0.09,0.22 0.13,0.1 0.12,0.12 0.04,0.1 0.07,0.06 0.06,0.29 0.13,0.22 0.1,0.08 0.06,0.1 0.06,0.29 0.06,0.04 0.05,0.16 0.06,0.08 0.02,0.16 -0.03,0.02 -0.43,-0.07 -0.14,-0.04 -0.1,-0.06 -0.13,-0.04 -0.2,-0.04 -0.31,0.01 -0.2,0.02 -0.17,0.07 -0.03,-0.02 -0.04,0.04 0,0.04 -0.06,-0.06 0,-0.12 0.03,-0.02 -0.01,0.04 0.1,0.02 0.11,-0.04 0.03,-0.04 0,-0.06 -0.03,-0.02 -0.06,0.02 -0.13,-0.06 -0.06,0 0,0.02 -0.01,0 -0.01,-0.04 -0.01,0 0.01,-0.04 -0.03,0 -0.01,0.04 -0.03,0 -0.04,0.02 -0.11,-0.02 0,0.04 -0.04,-0.02 -0.07,0.1 0.02,0.04 -0.03,0 -0.04,0.04 0.01,0.04 0.06,0.02 0.01,0.02 0.14,0.1 0.07,-0.08 -0.01,-0.04 0.04,0.02 -0.08,0.15 -0.06,0.06 -0.07,0 -0.23,0.03 -0.11,-0.04 -0.34,-0.01 -0.13,0.04 -0.03,-0.02 0.01,-0.02 -0.01,-0.02 -0.01,0.02 -0.03,-0.04 -0.03,0.02 -0.07,-0.06 -0.23,-0.08 -0.01,-0.04 0.04,-0.06 0,-0.1 -0.03,-0.14 0.07,-0.12 0.03,-0.1 -0.02,-0.12 -0.06,-0.02 0.01,-0.04 -0.03,-0.02 0.01,-0.1 -0.03,-0.06 -0.08,0 -0.03,0 0,-0.06 -0.06,-0.02 -0.11,-0.04 -0.03,0.04 0.03,0.02 -0.03,0.06 -0.01,-0.02 0,-0.08 -0.06,-0.06 -0.11,-0.04 -0.03,0.04 -0.06,0 -0.06,0.04 0,0.06 -0.01,0.06 -0.03,0 -0.02,-0.06 -0.03,0 -0.17,0.04 -0.07,0.02 -0.03,0.06 -0.04,0 -0.04,-0.04 -0.04,0.02 -0.01,0.12 0,0.04 0.11,0.04 0.06,-0.02 0,0.02 0.06,0.06 0.02,0.06 0.07,0.02 0.03,0 0.04,0.02 0.01,0.04 -0.14,-0.04 -0.17,-0.14 -0.29,-0.16 -0.04,-0.08 -0.03,-0.12 0.08,-0.8 0,-0.08 0.09,-0.31 0.2,-0.45 0.15,-0.25 0.35,-0.38 0.07,-0.02 0.03,0.06 0.06,0.02 z m -42.2,-4.04 0.82,2 -0.48,0.07 -1.05,-1.45 1.02,-1.23 z m 2.55,4.28 -0.04,-0.02 0.14,-0.02 z m 4.93,-1.97 -0.17,0.24 -0.15,-0.25 z m -2.76,-1.24 0.18,0.08 -0.21,0.2 -0.96,0.13 -0.57,0.42 -0.28,-0.23 0.17,-0.26 z m 1.36,0.2 -0.14,0.37 -0.28,-0.06 z m 0.52,0.17 -0.16,0.04 0.07,-0.06 z m -3.43,4.63 -0.07,-0.25 0.21,0.11 z m 2.38,-2.55 -0.04,1.5 -1.28,0.27 -0.44,-1.11 z m 13.23,1.39 -0.06,-0.02 0.04,-0.06 z m -12.84,0.97 -0.06,0.14 -0.14,-0.1 z m -3.24,-2.95 0.59,0.01 0.28,0.47 -0.42,0.1 z m 4.57,0.73 0.12,0.25 -0.53,-0.23 z", 1, "state"], ["x", "221", "y", "192", "width", "32", "height", "18", "rx", "2", "ry", "2", 1, "box"], ["x", "237", "y", "204.96", 1, "text"], ["d", "m 151.52,122.68 -1.59,0.96 -0.53,-0.75 -1.83,0.73 -1.35,-0.11 -1.39,0.68 -0.03,-0.56 -0.68,-0.15 0.03,-0.8 -0.62,0.3 -0.51,-1.22 0.39,-0.88 -1.2,-0.57 -0.79,0.41 0.04,0.45 -0.54,0.43 -0.04,-0.27 -0.38,0.17 -0.29,0.81 0.67,2.33 -0.36,2.28 -1.05,-0.43 -0.13,0.54 -0.81,-0.46 0.27,-1.1 -0.76,-0.95 -1.21,0.62 -0.84,-0.54 -0.11,0.5 -0.7,-1.04 -1.93,-0.13 -1.27,0.95 -0.67,-0.13 0.02,1.11 2.33,1.51 -0.44,0.67 -1.58,-0.34 -0.04,0.58 -0.19,0.68 -0.52,-0.57 -1.3,-0.02 -0.2,-2.8 -0.65,-0.07 -0.3,-0.72 -0.88,0.26 -0.71,-1.23 -0.95,0.22 0.16,-0.83 -0.56,-0.18 -0.7,-1.64 -1.68,-0.46 -0.46,-1.13 -1.06,0.34 -0.57,-0.55 -1.08,1.24 0.33,-1.05 -0.43,-1.48 0.74,-0.21 -0.05,-0.45 -0.47,-0.92 -0.81,-0.1 -0.9,0.34 0.22,0.91 -1.4,-0.3 1.06,-2.58 -0.26,-0.76 0.43,-0.15 0.01,-1.28 1.18,-0.28 -0.04,-0.86 0.62,-0.5 -0.72,-0.98 -0.75,0.33 0.35,-0.7 -0.7,0.21 0,-0.41 1.88,-0.05 -0.7,-1.29 0.29,-0.54 2.38,0.37 0.33,-0.37 -0.07,-0.74 -0.96,-0.47 0.55,-1.55 -0.93,-0.61 0.82,-0.36 0.53,1.07 0.16,-0.83 0.43,-1.1 -0.49,-0.14 -2.3,-0.93 -0.25,-1.4 -1.35,-0.14 -0.74,-2.38 1.94,-1.64 0.38,0.47 0.18,-0.41 1.19,0.09 0.61,-1.34 0.71,0.26 1.08,-0.63 1.07,-1.64 0.1,-0.85 1.92,0.33 0.5,0.55 1.41,-0.7 0.85,0.54 -0.4,-1.29 0.71,-0.83 0.39,-0.11 1.03,-0.2 2.5,0.82 0.25,0.65 -0.61,-0.26 -0.19,0.56 1.11,1.11 -0.34,0.46 0.77,1.01 0.12,1.46 1.52,-0.09 1.36,0.69 2.76,-0.29 0.18,0.53 1.03,0.14 0.02,0.64 0.13,0.26 0.1,0.18 0.09,0 0.29,0.05 0.77,1.17 -0.98,1.45 -0.46,-0.11 -0.32,0.65 0.41,0.09 0.04,0.37 0.65,-0.24 0.64,0.5 0.05,0.62 0.25,0.1 -0.2,0.46 -0.35,0.05 0.22,0.88 0.35,0.2 2.03,-0.22 0.22,0.36 0.77,-0.37 0.52,0.6 0.02,0.1 1.05,1.06 2.14,-0.42 2.27,2.21 1.2,-0.18 1.17,0.37 0.44,-0.2 0.59,0.6 1.07,-2.12 -0.72,-0.41 0.51,-1.42 0.76,-0.38 0.71,0.67 1.42,-0.24 0.79,0.61 0.09,1.13 0.51,-0.21 -0.14,0.71 1.5,0.39 0.66,1.5 -0.19,0.54 -2.2,0.07 -1.11,1.67 -1.07,-0.25 -0.41,0.8 -1.62,0.2 0.07,0.78 0.62,0.12 -1.01,1.23 0.64,0 -0.01,1.11 0.97,0.46 -0.86,1.25 -1.13,-0.25 -0.23,0.79 -0.57,-0.43 -0.62,1.09 0.78,0.36 -1.22,-0.08 -0.87,0.79 -0.41,-2.25 -1.07,1.19 -0.28,0.94 -0.89,0.46 1.6,1.35 -0.19,0.89 -1.04,0.3 z m -8.52,-20.22 0.03,0.1 0.01,-0.14 -0.12,-0.02 z", 1, "state"], ["class", "map map-international", 4, "ngIf"], ["role", "group", "aria-live", "off", 3, "id"], ["type", "checkbox", "class", "studisu-bl-checkbox", 3, "id", "name", "checked", "change", "focus", "blur", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "id", "innerHTML", 4, "ngIf"], [1, "scope-switcher"], ["role", "radiogroup", "aria-label", "Kartenbereich", 1, "ba-btn-group"], [1, "form-check"], ["type", "radio", "value", "national", 3, "click", "id", "name", "checked"], [1, "toggle-button", 3, "for"], ["type", "radio", "value", "international", 3, "click", "id", "name", "checked"], [1, "map", "map-international"], ["width", "384", "height", "384"], ["style", "position: absolute; top: 0; left: 0; width: 100%", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 384 384", "version", "1.1", "aria-hidden", "true", 3, "id", 4, "ngIf"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 384 384", "version", "1.1", "aria-hidden", "true", 2, "position", "absolute", "top", "0", "left", "0", "width", "100%", 3, "id"], ["d", "M 60.5 -0.46875 C 60.12797 -0.24862 59.774928 -0.04472 60 0.125 C 60.273 0.308 66.18975 3.18425 66.46875 3.28125 C 66.83975 3.37125 67.19475 3.25825 67.46875 3.53125 C 68.02175 3.99525 68.0385 4.9415 68.6875 5.3125 C 69.0575 5.4955 69.5045 4.28625 69.6875 4.65625 C 70.0575 5.30625 68.84825 6.31425 69.40625 6.78125 C 69.44371 6.81135 69.49373 6.8084 69.53125 6.8125 C 69.52225 6.8326 69.50587 6.8542 69.5 6.875 C 69.314 7.337 69.784 7.87675 69.875 8.34375 C 70.525 10.18875 71.548 9.357 72.75 10.375 C 73.581 11.207 74.962 13.8845 76.625 14.4375 C 77.275 14.7165 80.69875 15.08935 81.34375 14.53125 C 81.62275 14.25725 81.707 12.03525 83 12.40625 C 83.74 12.68525 85.79075 12.78675 86.34375 12.96875 C 86.71375 13.15675 86.8175 13.9025 87.1875 13.8125 C 87.6485 13.6245 87.448 12.4035 88 12.3125 C 88.65 12.3125 88.81975 13.346 89.46875 13.625 C 89.65775 13.717 90.03075 13.62195 90.21875 13.53125 C 91.41975 13.06925 92.45525 12.058 93.65625 11.875 C 95.96925 11.505 94.5675 12.1485 97.0625 11.6875 C 97.1595 11.6875 96.69025 11.40625 96.78125 11.40625 C 96.96525 11.22325 97.3465 11.59425 97.4375 11.40625 C 97.7165 10.94525 97.164 9.8415 97.625 9.9375 C 99.107 10.3085 98.823 12.68575 99.375 12.59375 C 100.024 12.49775 100.4135 11.682 101.0625 11.5 C 101.3355 11.404 101.8805 11.9665 102.0625 11.6875 C 102.5245 11.1355 102.16575 10.0235 102.71875 9.5625 C 103.17975 9.0955 104.37725 9.7405 104.65625 9.1875 C 104.73315 9.05293 104.7361 8.89617 104.6875 8.75 C 104.73 8.8438 104.7861 8.94237 104.84375 9 C 105.49275 9.649 106.6065 8.62 107.4375 8.25 C 107.6225 8.16 108.06575 7.96925 107.96875 7.78125 C 107.78675 7.32025 106.505 7.05525 106.875 6.78125 C 107.336 6.41025 108.07025 7.71375 108.53125 7.34375 C 108.762 7.13575 108.72936 6.82077 108.53125 6.5 C 108.89365 6.65583 109.23475 6.72379 109.46875 6.59375 C 113.26275 4.37375 108.43525 3.81025 108.15625 3.53125 C 107.96925 3.34725 108.347 3.0005 108.625 2.8125 C 109.181 2.5395 110.0105 2.62 110.5625 2.25 C 111.51079 1.61752 111.30294 0.40046 110.9375 -0.46875 L 60.5 -0.46875 z M 70.78125 5.625 C 70.81893 5.623 70.87156 5.63895 70.90625 5.65625 C 71.27916 5.83968 70.59896 6.04449 70.0625 6.34375 C 70.26528 6.04672 70.46263 5.72641 70.6875 5.65625 C 70.72082 5.64585 70.74357 5.6266 70.78125 5.625 z M 104.15625 7.0625 C 104.3953 7.0999 104.44303 8.04164 104.65625 8.625 C 104.40816 8.09742 103.65803 7.56409 104 7.15625 C 104.0576 7.09765 104.11372 7.05574 104.15625 7.0625 z M 323.53125 80.09375 C 323.24399 80.42281 322.88985 80.72727 322.53125 80.90625 C 321.60825 81.36725 320.5775 81.563 319.5625 81.375 C 319.1975 81.284 318.92925 80.53075 318.65625 80.71875 C 318.18925 80.99275 319.30875 82.00375 318.84375 82.09375 C 317.92075 82.37275 315.14175 82.486 314.59375 83.875 C 314.40275 84.337 315.409 84.78725 315.125 85.15625 C 314.669 85.89725 311.89725 85.69925 311.53125 86.53125 C 310.23225 90.04525 312.6275 87.8325 313.1875 89.3125 C 313.4595 90.1455 312.09475 91.168 312.46875 92 C 312.83375 93.02 314.307 94.03625 314.5 94.40625 C 315.046 95.23925 314.1045 96.1615 315.3125 96.8125 C 315.7675 96.9945 316.3515 96.53565 316.8125 96.71875 C 317.2755 96.81575 317.533 97.74875 318 97.46875 C 318.649 97.09875 318.65675 93.563 320.59375 95.875 C 320.78675 96.154 320.125 96.4415 320.125 96.8125 C 320.125 97.5515 320.5 98.29525 320.5 99.03125 C 320.5 100.88225 319.7455 99.86725 319.9375 101.53125 C 320.0295 101.71425 320.03125 101.97 320.03125 102.25 C 320.39525 104.192 322.81 106.873 322.25 109 C 321.978 110.293 319.755 112.9995 318.375 113.1875 C 317.817 113.2785 317.456 112.718 317 112.625 C 316.076 112.346 315.8585 112.9855 315.3125 112.0625 C 314.6635 111.1345 314.67675 109.83475 313.84375 109.09375 C 313.01375 108.26275 311.07925 107.8945 310.15625 107.0625 C 309.59825 106.6015 310.15125 105.403 309.59375 105.125 C 308.76275 104.755 308.115 106.06525 307.375 106.53125 C 306.452 107.26925 305.1435 107.452 304.3125 108.375 C 302.0905 110.687 304.04975 113.3755 303.21875 115.6875 C 302.94475 116.6105 301.7125 116.97825 301.4375 117.90625 C 301.2565 118.46025 301.71875 119.01325 301.71875 119.65625 C 301.71875 120.30625 301.4429 120.945 301.625 121.5 C 301.625 121.591 301.7215 121.6875 301.8125 121.6875 C 300.8935 122.8015 302.3805 125.576 302.9375 126.875 C 303.0285 127.057 303.033 127.153 303.125 127.25 C 303.774 129.649 302.65975 128.16075 303.59375 130.46875 C 303.68575 130.66175 303.7555 130.84825 303.9375 131.03125 C 303.8465 131.12225 303.84375 131.21875 303.84375 131.21875 C 303.56975 131.96075 304.2105 132.6965 304.3125 133.4375 C 304.4045 134.3595 304.20775 135.392 303.84375 136.5 C 303.75205 136.7723 303.56907 137.13252 303.46875 137.40625 C 303.6608 137.13252 303.84721 136.7723 303.9375 136.5 C 304.2105 135.941 304.31425 135.366 304.40625 134.625 C 304.40625 134.25 304.5 132.9635 304.5 131.9375 C 304.955 132.5855 305.3465 133.35375 305.4375 134.09375 C 305.5295 134.65075 305.159 135.19 305.25 135.75 C 305.341 135.932 305.41175 135.28125 305.59375 135.28125 C 305.97075 135.17925 305.9715 135.93375 306.0625 136.21875 L 306.0625 136.5625 C 306.1542 136.84627 306.1542 137.03674 306.0625 137.21875 C 305.9722 137.40076 305.53125 137.1319 305.53125 137.3125 C 305.43815 138.33435 306.72127 139.268 306.4375 140.28125 C 306.16377 141.48798 301.25692 141.38978 301.4375 140.84375 C 301.5292 140.6517 301.6256 140.4647 301.71875 140.28125 C 300.70551 141.38622 299.59543 141.18701 298.125 141.5625 C 297.93296 141.5625 297.65625 141.47425 297.65625 141.65625 C 297.56595 142.39576 297.9375 143.13548 297.9375 143.875 C 297.9375 145.16198 297.29964 146.55128 296.1875 147.65625 C 301.46012 148.39576 313.93816 147.96532 318.1875 145.46875 C 318.1875 145.47275 318.19055 145.4647 318.28125 145.375 C 318.47425 145.182 318.476 144.80875 318.75 144.71875 C 320.14 144.25275 319.48225 145.4475 320.40625 145.8125 C 322.90907 146.89357 322.08123 145.06626 323.53125 147.125 L 323.53125 80.09375 z M 307.03125 89.09375 C 306.92475 89.09306 306.80975 89.125 306.71875 89.125 C 306.52575 89.679 306.36225 90.813 305.53125 91 C 304.88225 91.183 302.82975 91.44025 303.46875 91.53125 C 304.11875 91.71925 305.77925 91.361 306.15625 92.375 C 306.15625 92.375 306.26725 94.58325 307.28125 94.03125 C 310.70925 92.08925 308.10275 93.5665 308.84375 91.8125 C 309.03575 91.4425 311.98775 91.8195 308.84375 89.96875 C 308.47775 89.78675 307.83375 90.2506 307.46875 90.0625 C 307.18475 89.8795 307.47375 89.40675 307.28125 89.21875 C 307.23575 89.12775 307.13775 89.09444 307.03125 89.09375 z M 310.0625 94.5 C 307.9315 95.145 306.54825 94.31125 305.90625 96.53125 C 305.80625 96.81225 305.42925 95.87175 305.15625 95.96875 C 304.60025 96.24175 305.433 97.75 304.875 97.75 C 304.226 97.75 303.308 96.447 303.125 97 C 302.851 97.649 304.31425 97.91925 304.40625 98.65625 C 304.49725 99.02425 303.4935 99.22275 303.6875 99.59375 C 303.9605 100.24175 304.78575 100.4085 305.34375 100.6875 C 305.61675 100.8695 306.06425 100.50235 306.15625 100.78125 C 306.33825 101.80025 304.22875 102.54475 305.34375 103.84375 C 305.70775 104.21375 306.34825 103.2735 306.53125 102.8125 C 306.72425 102.0725 306.53125 101.241 306.53125 100.5 C 306.53125 100.409 306.5333 100.3125 306.625 100.3125 C 307.091 100.0335 307.7545 99.87175 308.3125 99.59375 C 308.4935 99.50275 308.47225 99.125 308.65625 99.125 C 308.92825 99.028 309.8575 99.3895 310.3125 98.1875 C 310.4045 97.8175 310.1305 97.3705 310.3125 97.1875 C 310.4045 96.9995 310.783 97.56575 310.875 97.46875 C 311.335 97.00775 310.7917 95.7785 311.34375 95.6875 C 311.59375 95.6522 311.78194 95.80912 311.90625 95.96875 C 311.81495 95.78375 311.8347 95.74725 311.9375 95.75 C 311.16853 95.36928 311.01664 95.1643 310.0625 94.5 z M 323.53125 239.8125 C 323.33148 240.06078 322.8935 240.08306 322.71875 240.34375 C 322.25075 241.35675 322.81845 244.70475 321.0625 245.34375 C 320.5055 245.53575 319.85875 244.87775 319.21875 244.96875 C 317.54575 245.24175 318.932 245.6955 318.75 246.0625 C 318.567 246.7095 315.77475 247.0055 315.21875 247.1875 C 315.03375 247.2795 314.96425 247.647 314.78125 247.75 C 314.31525 247.75 313.842 247.28125 313.375 247.28125 C 313.285 247.28125 310.87325 248.03125 310.78125 248.03125 C 309.20925 247.94025 310.97375 246.5494 308.84375 247.9375 C 307.82975 248.4895 307.2685 249.599 306.4375 250.25 C 305.6045 250.898 305.25375 249.965 304.96875 250.25 C 303.77375 251.639 303.6785 251.71875 302.9375 251.71875 C 302.6535 251.80975 302.37325 251.81425 301.90625 251.90625 C 301.26925 251.90625 301.187 253.193 301 253.375 C 299.803 254.388 295.7265 254.4945 294.4375 253.9375 C 293.7895 253.6645 293.20875 252.99175 292.46875 252.71875 C 292.28475 252.62775 290.44025 252.9295 290.15625 252.5625 C 288.21825 250.0705 286.08975 248.94225 283.59375 246.90625 C 282.94475 246.81325 281.365 246.43925 281 246.53125 C 279.976 246.71225 281.3705 248.009 280.8125 248.375 C 280.3565 248.567 279.79875 248.28085 279.34375 248.46875 C 279.15075 248.56575 279.442 248.942 279.25 249.125 C 278.325 249.866 276.8595 249.94825 275.9375 250.78125 C 274.8325 251.80425 277.9525 254.39225 276.5625 255.40625 C 273.3275 257.71925 275.369 253.85425 273.25 256.90625 C 272.965 257.28125 274.068 257.3575 274.25 257.8125 C 274.433 258.1875 273.34375 258.10275 273.34375 258.46875 C 273.34375 258.65975 274.26925 259.8465 273.90625 260.3125 C 272.87925 261.3285 271.39075 259.75 270.46875 259.75 C 269.07775 259.75 271.7505 261.05625 269.4375 260.40625 C 268.7885 260.22125 267.9635 259.20425 267.6875 258.65625 C 267.4955 258.46525 267.30975 257.91175 267.21875 258.09375 C 266.85475 258.65175 266.96875 259.284 266.59375 259.75 C 265.39675 261.324 263.73375 259.752 262.34375 260.21875 C 262.16075 260.31075 262.52675 260.693 262.34375 260.875 C 261.51275 261.343 259.834 261.251 259 260.875 C 258.717 260.875 258.15625 260.603 258.15625 260.875 C 258.25825 261.616 258.9035 262.1635 259.1875 262.8125 C 259.1875 262.9045 259 262.91 259 263 C 259.093 263.74 258.9063 264.47225 259.28125 265.03125 C 259.28125 265.03125 259.375 265.0343 259.375 265.125 C 259.009 265.682 260.4715 266.31775 260.9375 266.96875 C 261.3025 267.52775 261.57625 269.933 262.03125 269.375 C 262.49925 268.827 262.78025 268.0875 263.15625 267.4375 C 263.24725 267.1525 263.34375 266.86775 263.34375 266.59375 C 263.34375 266.50275 263.0625 266.59875 263.0625 266.40625 C 263.0625 266.31425 263.06555 265.9715 263.15625 266.0625 C 263.52125 266.1535 263.26825 268.25775 264.28125 266.59375 C 264.46425 266.12675 264.4375 265.681 264.4375 265.125 C 264.4375 265.074 264.4181 265.00644 264.375 264.9375 C 264.3939 264.9579 264.4148 264.9605 264.4375 264.9375 C 265.1785 264.5625 264.544 262.0625 265.375 262.0625 C 268.054 261.8795 267.1495 262.9225 268.8125 264.3125 C 269.1885 264.5865 269.716 264.2885 270 264.5625 C 271.665 266.5085 269.73575 268.9105 271.59375 270.9375 C 272.13975 271.5885 273.69475 272.9815 274.34375 273.4375 C 275.08375 273.8125 277.39625 274.18475 276.65625 274.46875 C 275.35725 274.83575 272.96775 272.14725 273.34375 275.65625 C 273.43575 276.77125 277.6645 279.20025 278.3125 280.03125 C 278.4955 280.12225 277.58925 279.74875 277.78125 279.84375 C 278.32825 280.20875 280.7205 280.94475 280.8125 281.21875 C 281.0055 281.86775 280.4695 282.8905 280.9375 283.4375 C 281.2105 283.6205 284.06525 282.592 284.15625 282.5 C 286.00125 282.136 284.71925 282.88775 287.03125 283.71875 C 287.77025 283.90075 288.60275 283.62225 289.34375 283.90625 C 290.36775 284.27125 290.97775 285.943 292.09375 286.5 C 293.39275 287.059 294.22975 287.40525 294.59375 287.78125 C 294.59375 287.87225 294.6875 287.78125 294.6875 287.78125 C 294.8685 287.78125 295.06425 287.59825 295.15625 287.78125 C 295.51517 288.4212 294.9984 288.46244 295.78125 288.8125 C 295.75455 288.8388 295.73615 288.87345 295.71875 288.90625 C 295.62875 289.19125 296.2775 289.28125 296.5625 289.28125 C 296.66698 289.28125 296.77048 289.25055 296.875 289.21875 C 296.8527 289.20875 296.8378 289.2001 296.8125 289.1875 C 296.99966 289.1462 297.19389 289.07405 297.375 289 C 297.21062 289.0723 297.04407 289.16735 296.875 289.21875 C 297.01217 289.27815 297.11785 289.26635 297.28125 289.34375 C 297.46725 289.43575 297.65075 290 297.46875 290 C 295.98875 289.909 294.87325 288.52975 293.40625 288.34375 C 292.75625 288.24375 292.025 288.43875 291.375 288.34375 C 291.194 288.34375 290.99825 287.87675 290.90625 287.96875 C 290.72425 288.05975 290.72425 288.535 290.90625 288.625 C 291.46425 288.808 292.102 288.534 292.75 288.625 C 293.299 288.717 293.94375 288.90525 294.59375 289.28125 C 294.77575 289.37125 294.695 289.7215 294.875 289.8125 C 298.021 291.4865 297.38225 288.8015 302.28125 292.6875 C 302.93025 293.1545 303.76175 293.59625 304.59375 293.78125 C 305.04875 293.88125 305.44025 293.90625 305.90625 293.90625 C 305.71425 294.08925 305.534 294.25625 305.625 294.53125 C 306.924 297.40125 307.17175 294.725 308.46875 295.375 C 308.74375 295.558 308.56705 295.93275 308.75 296.21875 C 309.49 297.14175 310.4125 296.95575 311.0625 297.96875 C 311.2445 298.24075 311.0655 298.7895 311.34375 299.0625 C 311.89775 299.6225 312.635 299.90075 313.375 300.09375 C 314.117 300.27675 315.03575 299.6286 315.59375 300.1875 C 316.06075 300.6425 315.4089 301.56975 315.5 302.21875 C 315.591 302.50375 316.2455 302.59825 316.0625 302.78125 C 315.6865 303.14725 314.86775 302.75905 314.59375 303.125 C 314.12675 303.774 314.21875 304.6065 314.21875 305.4375 C 314.21875 306.5525 315.77675 306.009 315.59375 307.125 C 315.50275 308.047 314.9419 311.6425 315.5 311.1875 C 315.773 310.9025 315.511 310.1535 315.875 310.0625 C 316.159 310.0625 316.33925 310.80975 316.15625 311.09375 C 315.87225 311.36575 315.1205 311.10475 314.9375 311.46875 C 314.6645 311.74175 314.9375 312.19025 314.9375 312.65625 C 314.8465 313.02225 314.966 313.509 314.875 313.875 C 314.875 314.159 314.398 314.227 314.5 314.5 C 314.772 315.512 316.62225 316.72325 316.53125 316.90625 C 316.25625 317.46625 314.9605 316.726 314.6875 317.375 C 314.34562 318.15382 315.80944 318.9436 317.375 319.65625 L 323.53125 319.65625 L 323.53125 239.8125 z M 224.3125 240.53125 C 224.1295 241.55425 223.87575 242.4695 223.96875 242.5625 C 224.05975 242.5625 224.31525 242.65625 224.78125 242.65625 L 224.78125 241.53125 L 224.3125 240.53125 z M 308.46875 263.375 C 308.58786 263.369 308.717 263.3621 308.84375 263.375 C 308.63587 263.3623 308.43782 263.38105 308.25 263.40625 C 308.3236 263.39595 308.3926 263.3788 308.46875 263.375 z M 304.34375 264.34375 C 304.39655 264.37075 304.43585 264.3637 304.5 264.375 C 304.66467 264.3922 304.81743 264.41285 304.96875 264.40625 C 304.81875 264.41425 304.6625 264.42795 304.5 264.40625 C 304.4359 264.39485 304.39654 264.37075 304.34375 264.34375 z M 278.1875 268 C 278.2148 268.0519 278.2273 268.07595 278.25 268.09375 C 278.243 268.08875 278.22555 268.09875 278.21875 268.09375 C 278.20545 268.08335 278.199 268.0221 278.1875 268 z M 279.46875 268.65625 C 279.59669 268.72755 279.72125 268.7895 279.8125 268.90625 C 279.8185 268.91125 279.8065 268.9323 279.8125 268.9375 C 279.7212 268.82075 279.59669 268.72759 279.46875 268.65625 z M 250.09375 279.25 C 250.03005 279.245 249.93637 279.2824 249.84375 279.375 C 249.56075 279.557 249.558 279.9135 249.375 280.1875 C 250.26225 281.32325 250.53936 279.28518 250.09375 279.25 z M 201.84375 281.125 C 201.10375 281.125 200.46875 281.6625 200.46875 282.3125 C 200.46875 282.9615 201.10375 283.625 201.84375 283.625 C 202.58475 283.625 203.25 282.9615 203.25 282.3125 C 203.25 281.6625 202.58475 281.125 201.84375 281.125 z M 152.375 291.1875 C 152.192 291.1875 149.87325 294.6445 154.03125 293.4375 C 154.95925 292.2315 154.779 291.0055 152.375 291.1875 z M 303.96875 292.5625 C 304.18447 292.76934 304.38498 293.0095 304.5625 293.34375 C 304.518 293.27755 304.4685 293.21855 304.40625 293.15625 C 304.26675 292.92425 304.12408 292.7264 303.96875 292.5625 z ", 2, "fill", "#ededed", "stroke", "none", 3, "id"], ["transform", "translate(-74.5,-128.00021)", 3, "click", "id"], ["d", "m 322.03,127.31 c -0.04,0.09 -0.09,0.18 -0.09,0.22 0,0.18 -0.47,2.11 -0.56,0.81 0,-0.19 0.47,-0.53 0.28,-0.53 -2.31,-0.74 -0.34,0.63 -0.72,0.81 -0.36,0.19 -1.4,-0.09 -1.22,0.28 0.36,0.65 3.14,1.57 1.84,2.12 -2.31,0.92 -3.69,-0.55 -4.34,2.88 -0.19,0.74 -0.46,2.22 0.38,2.41 0.65,0.09 1.2,-0.18 1.84,-0.09 0.28,0 0.85,0 0.66,0.09 -0.55,0.46 -5.55,1.1 -2.31,1.56 1.02,0.09 1.67,-1.56 2.59,-1.38 0.18,0.09 0.01,0.66 0.19,0.66 0.09,0 0.19,-0.09 0.28,-0.09 l 0,0.09 c 0.09,0.37 1.28,0.91 0.81,0.91 -0.55,0 -0.83,-0.72 -1.38,-0.91 -1.3,-0.27 -1.39,0.91 -2.22,1.28 -0.47,0.18 -3.51,-0.26 -2.03,0.94 0.47,0.37 1.29,-0.37 1.75,-0.09 0.47,0.27 0.38,1.1 0.56,1.56 0.09,0.37 0.65,1.1 0.38,1 -0.74,-0.18 -1.13,-1.37 -1.88,-1.28 -0.55,0 -1.38,2.13 -1.28,2.69 0.09,0.37 0.38,0.82 0.66,1.19 0.07,0.07 0.43,0.04 0.53,0.06 -0.01,0 0.01,0.03 0,0.03 -0.65,0.37 -1.84,0.01 -2.12,0.75 -0.18,0.37 -0.19,0.57 -0.19,0.84 -0.74,0.1 -0.72,2.66 -0.62,3.12 0.09,0.28 0.44,-0.28 0.62,-0.38 0.47,-0.46 0.85,-1.01 1.31,-1.47 -0.18,-0.37 -0.38,-0.54 -0.47,-0.72 0.65,0 1.47,-0.22 1.56,0.06 0.92,1.57 -2.38,1.58 -2.56,2.78 0,0.37 0.64,-0.18 1,-0.28 0.47,0 0.94,0.1 1.41,0 0.36,-0.18 1.09,-1.09 1.09,-0.62 -0.46,2.68 -2.31,1.83 -3.69,3.12 -0.19,0.18 0.18,0.66 0,0.84 -0.47,0.18 -3.35,0.01 -3.62,0.66 -0.09,0.18 0.56,-0.03 0.56,0.16 l 0,0.09 c 0.27,-0.09 0.47,-0.09 0.56,0.09 0.28,0.37 -3.69,2.77 -2.31,2.12 0.47,-0.19 0.82,-0.44 1.19,-0.72 -0.09,0.18 -0.25,0.54 -0.34,1.09 -0.84,3.51 2.47,0.11 2,1.41 -0.27,0.56 -1.48,0.45 -1.75,1 -0.18,0.37 1.32,0.1 1.12,0.38 -0.36,0.46 -1.13,0.66 -1.69,0.47 -0.92,-0.37 -1.2,-2.49 -1.94,-2.03 -0.74,0.46 -2.12,1.19 -1.66,1.84 0.27,0.46 1.49,0.91 1.03,1 -0.65,0.19 -1.21,-0.9 -1.84,-0.72 -0.38,0.1 0.9,0.54 0.81,0.91 -0.19,0.55 -1.01,0.47 -1.28,0.84 -0.27,0.37 -0.01,0.91 -0.19,1.19 -0.19,0.37 -0.84,-0.28 -1.12,0 -0.09,0.28 -0.19,0.56 -0.19,0.84 0,0.19 0.56,0.19 0.38,0.19 -0.28,0.18 -0.82,-0.28 -1,0 -0.36,0.55 -0.28,1.2 -0.38,1.84 0,0.19 -0.09,0.38 0.09,0.38 0.36,0.09 1.47,-0.47 1.19,-0.19 -0.36,0.55 -1.1,0.57 -1.66,0.84 -1.01,0.65 -3.05,1.85 -1.66,2.41 0.92,0.37 1.92,-1.13 2.56,-1.41 0.1,-0.1 -0.34,0.38 -0.16,0.38 0.05,0.02 0.12,0.02 0.19,0 -0.54,0.3 -1.18,0.5 -1.41,1.03 -0.19,0.37 0.46,0.63 0.66,1 0.18,0.37 0.01,1.12 0.47,1.22 0.74,0.18 3.03,-1.85 3.5,-2.22 0.46,-0.37 1.01,-0.56 1.47,-0.84 0.1,-0.09 0.37,-0.19 0.28,-0.19 -0.65,-0.28 -1.75,0.09 -2.12,-0.56 -0.27,-0.46 0.84,-0.72 1.22,-1 0.74,-0.65 4.06,-5.2 3.78,-1.5 -0.09,0.73 -1.76,0.57 -2.12,1.22 -0.47,0.65 1.75,0.64 1.84,1.38 0.18,0.93 -3.59,1.11 -3.88,2.31 -0.09,0.37 1.02,-0.37 1.12,0 0.09,0.74 -0.01,1.76 -0.66,2.22 -0.09,0 -3.88,-0.93 -3.88,-0.19 -0.09,0.74 1.27,1.32 1,2.06 -0.27,0.46 -0.91,-0.94 -1.47,-1.03 -0.36,-0.09 -0.85,0.75 -0.94,0.38 -0.09,-0.56 0.75,-0.85 0.75,-1.41 0,-0.46 -0.66,-0.63 -0.84,-1 -0.27,-0.46 0,-1.59 -0.56,-1.41 -0.74,0.09 -0.74,1.22 -1.28,1.78 -0.47,0.55 -1.47,0.73 -1.47,1.38 -0.09,0.56 1.18,-0.74 1.47,-0.38 0.36,0.37 -0.92,0.37 -1.38,0.56 -0.28,0.18 -0.57,0.94 -0.75,0.66 -0.47,-0.55 0.18,-1.78 -0.38,-2.06 -0.64,-0.37 -2.88,1.14 -2.97,1.97 -0.56,3.98 2.03,-1.77 2.41,1.28 0.36,2.5 -3.32,0.56 -3.41,0.56 -0.92,-0.19 0.28,0.93 0,0.75 -0.27,-0.09 -0.93,-0.65 -0.75,-0.38 0.19,0.65 0.38,1.47 1.03,1.84 0.36,0.18 0.73,-0.47 1.19,-0.56 0.18,-0.09 -0.47,0.28 -0.38,0.38 0.18,0.19 1.03,-0.18 0.84,0 -0.38,0.28 -1.41,-0.09 -1.41,0.38 0.09,0.74 1.87,1.01 1.59,1.66 -0.38,0.65 -1.56,-0.19 -2.03,-0.66 -0.36,-0.28 0.19,-0.82 0,-1.19 -0.18,-0.47 -0.85,-0.47 -1.12,-0.84 -0.18,-0.27 0.09,-0.9 -0.19,-0.81 -0.56,0.1 -1.28,0.63 -1.19,1.19 0.09,0.1 0.18,0.28 0.28,0.38 -0.56,-0.09 -1.04,-0.09 -1.59,0 -0.37,0 -0.62,0.65 -1,0.56 -0.55,-0.19 -0.57,-1.22 -1.12,-1.31 -2.5,-0.27 -2.77,0.39 -2.12,1.12 0.47,0.65 1.66,0.54 1.75,1.28 0.19,1.1 -4.7,1.75 0.84,1.66 0.65,0 1.29,-0.16 2.03,-0.44 -1.01,0.37 -2.3,1.38 -1.66,1.94 0.46,0.37 1.57,-0.56 1.84,0 0.28,0.46 -0.82,0.93 -1.38,0.84 0,-0.09 -1.38,-2.15 -2.03,-1.78 -0.37,0.19 0.18,1.41 -0.19,1.22 -0.47,-0.18 0.09,-1.13 -0.28,-1.41 -1.29,-1.02 -2.41,0.93 -2.69,0.84 -0.18,0 -0.09,-0.47 -0.28,-0.56 -0.36,-0.18 -0.82,-0.19 -1.19,-0.09 -0.28,0 -0.65,0.28 -0.56,0.38 0.38,0.28 2.86,1.1 3.31,1.75 0.38,0.46 0.2,1.32 0.66,1.69 0.65,0.46 1.94,-0.2 2.12,0.53 0.18,0.65 -1.39,-0.37 -1.94,0.09 -0.19,0.09 -0.28,0.38 -0.38,0.56 0,-1.48 -0.17,-3.06 -1.28,-2.88 -3.23,0.55 -1.21,1.77 -0.84,3.62 0,0.18 -0.1,0.53 -0.38,0.53 -0.18,0 0.28,-0.35 0.28,-0.53 -0.18,-0.55 -0.63,-0.94 -0.91,-1.5 -0.18,-0.37 -0.01,-1.1 -0.38,-1.19 -0.84,-0.18 -2.22,0.45 -2.12,1.28 0,0.65 0.16,1.29 0.62,1.84 0.28,0.37 1.68,0.2 1.5,0.66 -0.28,0.55 -1.2,0 -1.75,-0.28 -0.28,-0.18 -0.1,-0.81 -0.38,-0.81 -0.56,0 -0.29,1.19 -0.84,1.38 -0.1,0 0.09,-0.28 0.09,-0.38 0,-0.65 0.65,-1.47 0.19,-1.84 -0.37,-0.37 -0.19,1.38 -0.75,1.38 -0.74,0 -1.1,-1.47 -1.84,-1.38 -0.56,0.09 0.65,1.57 0.09,1.66 -0.56,0.09 -0.57,-1.01 -0.84,-1.47 -0.19,-0.27 -1.09,-0.65 -1.09,-0.28 0,0.92 1.84,1.29 1.66,2.12 -0.18,0.65 -1.65,0.67 -1.56,1.31 0.09,0.56 1.1,-0.28 1.66,-0.28 0.35,0 0.64,0.17 0.97,0.25 0.11,0.03 0.23,0.03 0.34,0.03 1.29,0.19 4.14,1.56 4.59,1.47 2.69,-0.18 -2.11,-1.13 1.12,-0.94 0.37,0 1.12,0.19 0.84,0.47 -1.66,1.57 -3.91,-0.36 -4.38,0.19 -0.18,0.19 0.93,0.84 0.56,0.84 -0.46,-0.1 -0.63,-1.03 -1.09,-0.94 -0.06,0.02 -0.12,0.08 -0.16,0.16 -0.18,0.39 -0.08,1.37 -0.31,1.06 -0.21,-0.28 0.21,-0.71 0.31,-1.06 0.03,-0.12 0.04,-0.25 -0.03,-0.34 -0.37,-0.56 -1.08,-0.83 -1.81,-0.94 -0.36,-0.05 -0.73,-0.06 -1.06,-0.06 -1.38,0.09 -3.61,2.48 -2.12,3.69 0.46,0.46 1.29,0.1 1.84,0.38 0.47,0.27 -1.84,0.17 -1.66,0.72 0.56,1.3 4.89,0.2 3.78,1.03 -1.11,0.74 -2.67,-0.38 -3.59,-0.47 -0.56,0 -2.88,1.04 -0.94,1.78 0.47,0.19 0.85,-0.47 1.31,-0.47 0.74,-0.09 2.22,-0.55 2.12,0.09 0,0.74 -1.39,-0.09 -2.12,0.09 -0.65,0.18 -1.48,0.45 -1.94,1.09 -0.19,0.28 1.19,1.84 1.38,1.84 1.02,0.28 2.2,0.12 3.22,-0.34 0.19,-0.09 0,-0.65 0.28,-0.56 0.74,0 3.63,1.28 3.72,1.19 0.19,-0.19 0.44,-0.64 0.72,-1.28 l 0.09,0.09 c 0.65,0.37 1.38,0.54 2.03,0.91 0.09,0.09 0.01,0.47 0.19,0.38 0.92,-0.09 2.06,-0.38 2.06,-0.47 0.18,-0.46 -0.56,-4.7 1.75,-3.78 0.92,0.37 -1.69,1.39 -1.69,2.41 0,0.37 0.09,0.94 0.47,1.03 0.55,0.19 1.75,-1.02 1.84,-0.38 0.65,3.23 -4.07,0.18 -4.16,1.47 -0.1,1.2 2.33,2.69 0.56,2.88 -2.86,0.19 -0.1,-4.52 -2.78,-3.78 -2.13,0.55 -0.91,2.22 -1.56,1.94 -0.65,-0.27 -0.72,-1.23 -1.38,-1.5 -2.03,-1.02 -3.91,1.22 -4,1.12 -0.83,0 -1.57,-1.4 -2.22,-0.94 -0.46,0.28 -1.11,2.41 -0.28,2.88 0.65,0.37 1.85,-0.56 2.59,-0.66 0.18,-0.09 0.37,0.28 0.28,0.38 -0.56,0.46 -1.66,0.48 -1.84,1.12 -0.09,0.18 0,0.35 0,0.44 -0.55,-0.46 -1.1,-1 -1.75,-1 -0.46,0.09 1.19,1.75 1.28,1.94 0.18,0.37 0.01,1.28 0.47,1.28 0.28,-0.1 0.63,-0.44 1.09,-0.91 0.74,-0.83 1.6,-1.76 1.78,-0.75 -0.74,0.37 -2.06,0.57 -2.06,1.41 0,0.37 1.23,1.74 1.88,1.09 -0.09,0.46 -0.29,0.85 -0.66,0.94 -1.66,0.55 -3.07,-0.2 -2.97,0.53 0.18,0.74 0.47,1.48 0.75,2.12 1.11,2.03 1.76,-2.03 2.69,-2.31 0.83,-0.19 -0.66,1.51 -1.03,2.25 -0.37,0.92 0.1,0.64 0.66,1.66 0.1,0.28 0,1.27 0.28,1 0.56,-0.56 0.35,-1.48 0.72,-2.22 0.28,-0.37 0.57,-0.81 1.03,-1.09 0.18,-0.19 0.47,0.28 0.66,0.28 -0.18,0.27 -0.38,0.53 -0.28,0.72 0,0.46 1.28,0.38 1.19,0.94 -0.1,0.46 -1.1,0.19 -1.56,0.47 -0.19,0.19 -0.37,0.44 -0.56,0.81 0,0.19 0.28,0.47 0.09,0.56 -0.37,0.27 -0.82,-0.09 -1.19,0.19 -0.27,0.09 -0.1,0.57 -0.28,0.75 -0.1,0.19 -0.65,0.09 -0.56,0.19 2.87,2.58 1.01,0.07 3.97,0.25 0.28,0 -3.5,1.69 -3.5,1.78 -0.09,0.37 1.21,0.35 0.84,0.44 -0.19,0.09 -0.47,-0.19 -0.66,0 -0.19,0.09 0.09,0.66 -0.09,0.56 -0.47,-0.09 -0.73,-1.09 -1.19,-0.81 -0.65,0.28 -0.48,1.48 -1.03,1.94 -0.37,0.28 -1.5,-0.55 -1.5,-0.09 0,0.28 0.28,0.47 0.56,0.66 0,0 -0.09,0.06 -0.09,0.16 0.1,-0.09 0.1,-0.09 0.19,-0.09 0.33,0.17 0.68,0.31 0.84,0.56 0.28,0.46 -0.18,1.69 0.47,1.69 1.2,0.09 0.74,-2.79 1.94,-3.16 0.74,-0.18 1.85,-0.02 2.12,0.72 0.18,0.65 -1.38,0.86 -1.47,1.59 0,0.84 0.16,0.84 0.53,0.38 0.56,0.56 3.16,-0.64 2.78,0.19 -0.27,0.64 -1.38,0.35 -1.94,0.72 -0.46,0.18 -0.94,0.48 -1.12,0.94 -0.09,0.28 0.94,0.09 0.75,0.28 -0.37,0.46 -1.75,0.26 -1.66,0.91 0.19,0.46 0.29,0.94 0.47,1.41 -0.18,-0.19 -0.38,-0.37 -0.56,-0.19 -0.46,0.19 -0.57,1.37 -0.94,1.09 -0.74,-0.28 -0.17,-1.85 -0.91,-2.03 -0.65,-0.19 0.09,1.2 0,1.75 -0.18,0.65 -0.84,1.04 -0.84,1.59 -0.09,0.65 1.01,3.04 1.66,3.41 0.37,0.19 0.94,0 1.22,0.28 0.56,0.37 1.2,2.04 2.31,2.5 0.56,0.28 1.1,0.65 1.66,0.56 0.47,-0.1 0.39,-0.94 0.75,-1.03 0.38,-0.09 1.01,0.29 0.91,0.66 -0.27,0.64 -3.32,1.67 -1.75,2.41 0.74,0.28 1.48,0.56 2.22,0.47 0.56,0 1.12,-1.21 1.41,-0.75 0.18,0.56 -1.4,0.91 -1.03,1.38 0.37,0.46 1.1,-0.53 1.75,-0.53 1.29,0 1.02,0.8 1.94,0.25 0.28,-0.09 0.38,-0.44 0.66,-0.53 0.38,-0.19 1.03,0.27 1.41,0 0.46,-0.37 0.16,-1.6 0.81,-1.78 0.65,-0.18 0.75,1.41 1.31,1.22 0.73,-0.09 0.63,-1.29 1.19,-1.75 0.18,-0.19 0.47,0.38 0.66,0.19 0.09,-0.09 2.5,-2.98 2.97,-3.62 0.09,-0.19 -0.31,-0.38 -0.22,-0.56 0.47,-1.94 1.22,2.98 1.78,-0.81 0.09,-0.37 -1.13,-0.47 -0.84,-0.84 0.46,-0.46 1.67,-0.01 2.12,-0.56 0.28,-0.28 -0.73,-0.63 -0.62,-1 0.28,-0.92 2.75,-1.1 2.66,-1.38 -0.27,-0.65 -1.46,-1.04 -1.19,-1.69 0.28,-0.46 1.11,0.57 1.56,0.84 0.38,0.28 -0.09,1.19 0.38,1.19 3.88,0 0.93,-1.01 2.5,-2.03 0.27,-0.18 -0.18,1.03 0.19,1.03 0.74,0 -0.09,-1.58 0.56,-2.78 0.18,-0.19 0.35,0.38 0.53,0.38 0.18,0 0.19,-0.28 0.19,-0.38 0.56,-1.29 0.02,-0.28 -0.72,-2.22 -0.18,-0.46 0.35,-1.29 0.16,-1.66 -0.27,-0.65 -1.19,-1.1 -1.09,-1.84 0.09,-0.46 1.03,0.35 1.31,0.81 0.18,0.46 -0.1,1.13 0,1.69 0,0.09 0.07,0.16 0.16,0.16 2.31,-1.57 -1.66,-4.44 0.66,-4.44 0.64,0 -0.18,1.23 -0.09,1.78 0.19,0.93 0.47,1.73 0.66,2.66 0,0.09 0.09,0.19 0.09,0.38 -0.18,-0.18 -0.37,1.2 0.19,2.03 0,0 0.53,-0.55 0.53,0 0,0.37 -0.52,0.94 -0.25,1.22 3.05,2.87 2.03,-1.68 3.97,1.38 0.28,0.37 0.83,1.13 0.47,1.41 -0.09,0.1 -0.09,0.09 -0.19,0.09 0.28,0.92 0.64,1.83 1.47,0.62 2.04,-2.87 -0.55,-6.55 0,-8.22 0.19,-0.64 1.1,-0.73 1.38,-1.28 0.18,-0.37 0.03,-0.85 -0.16,-1.22 0,-0.28 -0.47,-0.37 -0.38,-0.56 0.19,-0.64 3.13,-0.81 3.97,-2.94 l -0.09,-2.69 c 1.02,-5.27 -1.38,-4.27 -1.84,-8.25 -0.09,-0.92 1.76,-0.44 2.5,-1.09 l 1,-3.69 c -0.37,-2.31 -3.88,-2.16 -4.44,-4.28 -0.47,-1.94 1.03,-4.53 0.84,-6.56 -0.18,-1.39 -1.66,-2.58 -1.75,-3.97 -0.09,-0.56 0.34,-1.19 0.34,-1.75 -0.09,-0.64 -0.43,-1.19 -0.34,-1.84 0,-0.55 0.62,-0.95 0.62,-1.5 0,-11.19 -1.38,8.25 -1.38,-2.94 0,-1.02 1.28,-1.67 1.38,-2.69 0.1,-0.37 -0.47,-0.76 -0.38,-1.22 0.28,-1.48 2.32,-4.6 3.53,-5.34 3.78,-2.4 6.3,1.94 6.94,-2.41 0.65,-4.53 -3.25,-3.62 -2.69,-5.28 0.83,-2.59 2.14,-5.19 2.97,-7.69 0.09,-0.37 0.55,-0.44 0.66,-0.81 l -0.31,-3.44 c 0,-0.09 0.47,-2.84 0.47,-2.84 l -0.91,-3.62 c 0.36,-0.83 1.85,-0.01 2.59,-0.38 l 2.03,-1.75 c 0.27,-0.83 -0.94,-1.57 -0.75,-2.41 0.49,-1.48 2.94,-4.46 3.88,-6.22 l -8.19,0 c 0,0.04 -0.01,0.08 -0.03,0.12 -0.18,0.65 -1.21,1 -1.94,0.91 -0.4,-0.08 -0.21,-0.68 -0.31,-1.03 l -0.25,0 z m -11.56,26.38 c -0.74,0.09 -1.56,0.1 -0.91,0.19 0.27,0 0.54,-0.1 0.91,-0.19 z m -13.78,12.69 c -0.09,-0.09 -5.17,2.12 -1.28,1.56 0.36,-0.09 0.82,-0.1 1.19,-0.19 0.09,0 0.28,-0.1 0.38,-0.19 -0.09,-0.46 0.18,-1.1 -0.28,-1.19 z m -15.78,17.16 c -0.01,-0.01 -0.03,0.01 -0.03,0.03 -0.09,0 -0.09,0.09 -0.09,0.19 -0.46,-0.1 -0.91,-0.28 -1.28,-0.09 -0.19,0.19 -0.09,0.84 0.19,0.84 0.34,0 0.66,-0.35 1,-0.56 0.09,-0.09 0.19,-0.1 0.28,-0.19 0,-0.07 -0.04,-0.2 -0.06,-0.22 z m -5.94,28.62 0,0.09 0,0.09 c 0,0.08 -0.15,0.13 -0.25,0.22 -0.62,1.34 1.26,3.87 0.72,0.03 0,-0.19 -0.28,-0.25 -0.47,-0.44 z M 273.66,219 c -0.09,0.09 -0.09,0.07 -0.19,0.16 -0.18,1.11 -0.74,4.54 0.28,2.69 0.46,-0.92 0.09,-1.92 -0.09,-2.84 z", 1, "state"], ["rx", "23.7", "ry", "12", "y", "133", "x", "81.82", "height", "26", "width", "47.4", 1, "plaque-inner"], ["y", "153", "x", "107", 1, "text"], ["x", "265", "y", "465", 1, "comment1"], ["x", "265", "y", "490", 1, "comment2"], ["transform", "translate(-74.5,-128)", 3, "click", "id"], ["d", "m 188.03,271.7 c 0.18,0.47 1.01,0.93 0.64,1.3 -0.37,0.56 -1.48,0.09 -2.03,0.47 -0.28,0.27 0.74,0.46 0.74,0.83 0.09,0.74 -0.37,1.48 -0.37,2.22 0.09,0.64 0.74,1.01 0.74,1.66 0,0.46 -0.74,0.74 -0.74,1.29 -0.09,0.38 0.65,0.74 0.46,1.12 -0.28,0.36 -1.01,-0.47 -1.2,-0.09 -0.28,0.36 0.46,0.74 0.56,1.2 0,0.18 -0.19,0.38 -0.19,0.56 0.09,1.2 0.46,1.94 0.09,3.15 -0.27,0.83 -3.51,5.55 -4.07,6.01 -0.19,0.18 -0.65,0.27 -0.74,0.64 -0.19,0.65 0.09,1.39 0,2.04 0,0.09 -0.19,0.09 -0.19,0 -0.28,-0.65 -0.46,0.18 -1.39,-0.18 -0.37,-0.09 -0.37,-0.65 -0.74,-0.74 -0.65,-0.18 -2.68,0.83 -3.14,0.27 -0.09,-0.18 0.37,-0.18 0.37,-0.36 0.09,-0.28 -0.65,0.27 -0.92,0.18 -1.39,-0.09 -1.85,-0.83 -3.14,-0.38 -0.19,0.1 0.36,0.47 0.36,0.74 -0.09,0.47 -1.75,0.83 -1.75,0.83 -0.37,0 -0.55,-0.55 -0.92,-0.46 -0.65,0.27 -0.93,1.1 -1.48,1.48 -1.94,1.02 -0.74,-1.75 -2.5,-1.48 -0.55,0.09 0.47,1.1 0.28,1.57 -0.28,0.37 -0.92,0.37 -1.39,0.65 -0.28,0.18 -0.47,0.74 -0.84,0.83 -0.18,0 -0.09,-0.38 -0.27,-0.47 -0.19,-0.18 -0.46,-0.36 -0.74,-0.27 -0.19,0.18 0,0.74 -0.28,0.83 -0.92,0.09 -2.59,-1.01 -3.14,-0.92 -0.74,0.09 -1.29,0.65 -1.94,0.74 -1.85,0.18 1.02,-1.3 -0.46,-1.02 -0.55,0.19 -2.77,0.47 -2.96,0.28 -0.37,-0.56 3.15,-1.57 3.51,-2.4 0.1,-0.19 -0.27,-0.19 -0.46,-0.28 -0.09,-0.18 -2.22,0.28 -4.9,0 -0.1,0 0.18,-0.09 1.39,-0.46 0.19,0 0.37,-0.09 0.37,-0.28 0,-0.09 -0.28,-0.18 -0.18,-0.27 0.83,-0.74 0.46,0.47 1.57,0 0.55,-0.18 2.12,-0.27 1.75,-0.74 -0.09,-0.09 -4.25,0.47 -4.44,0.47 -0.83,-0.19 -1.48,-1.48 -1.39,-2.4 0.1,-0.38 0.83,0.36 1.11,0.18 0.28,-0.18 -0.18,-0.47 -0.18,-0.74 0.18,-0.83 1.66,-0.38 2.5,-0.56 0.65,-0.09 1.48,0 1.94,-0.46 0.37,-0.28 -0.92,-0.93 -1.39,-0.65 -0.09,0.18 0.19,0.55 0,0.65 -0.09,0.09 -2.87,-1.3 -3.42,-2.04 -0.1,-0.18 0.55,0.27 0.74,0.18 0.18,-0.09 0,-0.46 0.18,-0.55 0.46,-0.28 1.76,-0.19 2.4,-0.1 0.83,0 1.39,0.83 2.13,1.21 0.74,0.36 -1.39,-1.48 -1.02,-2.22 0.28,-0.65 1.39,-0.18 2.03,-0.47 0.37,-0.18 0.37,-0.73 0.74,-0.83 0.09,0 6.01,1.02 6.66,0.65 0.46,-0.27 -1.2,-0.18 -1.48,-0.65 -0.09,-0.27 0.28,-0.74 0.19,-1.01 -0.09,-0.18 -1.94,1.66 -2.87,1.57 -0.19,-0.09 0.55,-0.56 0.27,-0.65 -0.27,-0.09 -0.64,0.28 -1.01,0.19 -0.37,-0.1 -0.65,-0.37 -0.83,-0.65 -0.1,-0.19 0.09,-0.38 0,-0.47 0,0 -2.68,0.56 -3.05,0.38 -0.28,-0.1 0.64,0 0.92,-0.1 0.74,-0.37 1.29,-0.83 2.03,-1.1 0.19,-0.18 0.56,0.09 0.74,0 0.37,-0.37 0.46,-1.01 0.93,-1.48 0.18,-0.18 0.46,-0.27 0.73,-0.36 0.19,-0.19 -0.64,0 -0.83,-0.28 -0.37,-0.46 0.83,-0.83 1.2,-1.2 0.28,-0.38 0.47,-0.83 0.93,-0.92 0.27,-0.1 0.37,0.64 0.64,0.55 0.74,0 1.48,-0.28 2.13,-0.65 0.18,-0.09 -0.74,0.1 -0.74,-0.18 0,-0.28 0.65,-0.18 0.65,-0.46 -0.1,-0.28 -1.94,0.09 -3.98,-0.47 -1.94,-0.56 0,-0.47 -0.46,-2.04 -0.46,-1.66 -3.05,-0.46 -3.79,-1.57 -2.04,-2.68 1.75,-1.57 1.84,-1.57 0.1,-0.09 -0.37,-0.37 -0.27,-0.46 0.37,-0.65 0.83,-1.3 1.57,-1.48 0.64,-0.18 1.38,0.36 2.12,0.36 0.19,0 0.37,-0.09 0.46,-0.27 1.2,-2.87 -2.22,-0.74 -2.4,-1.57 -0.18,-0.36 0.83,0 1.11,-0.27 0.55,-0.38 -0.37,-1.3 -0.46,-1.39 0,-0.65 0.83,-1.48 0.37,-2.04 -0.37,-0.36 -1.11,1.02 -1.48,0.65 -0.37,-0.36 0.55,-0.83 0.74,-1.3 0.09,-0.36 -0.83,-0.27 0,-0.46 0.83,-0.18 5.18,-0.18 5.64,1.02 0.28,0.65 -0.09,1.66 0.46,1.85 0.56,0.18 0.56,-0.93 1.02,-1.21 0.83,-0.47 3.23,2.31 3.33,2.04 0.27,-0.65 -0.65,-1.39 -0.56,-2.13 0.19,-0.83 2.96,-0.56 2.96,-0.65 0.74,-0.28 1.29,-0.83 1.75,-1.39 0.28,-0.36 -1.38,0 -1.38,-0.18 -0.28,-1.01 0,0.38 -1.2,0.27 -0.19,0 0.09,-0.36 0.09,-0.55 0,-0.09 0,-0.28 -0.09,-0.28 -0.37,-0.18 -2.22,-0.27 -1.94,-1.38 0.55,-1.86 2.4,0.18 2.96,0 0.37,-0.19 -1.11,-0.74 -0.83,-1.12 0.37,-0.36 1.11,0.37 1.57,0.28 0.46,-0.1 -0.37,-0.74 -0.65,-1.02 -0.18,-0.18 0.65,-0.18 0.74,-0.46 0.37,-1.58 -3.6,0 1.2,-2.22 0.28,-0.1 0.65,0.18 1.02,0.27 1.29,0.37 2.77,0.28 3.88,1.02 0.65,0.46 -1.66,1.38 -1.29,2.03 0.37,0.38 1.11,-0.27 1.57,-0.74 0.18,-0.18 -0.28,-1.01 0.09,-1.01 0.55,0.18 0.92,0.92 1.29,1.39 l 0,0 c -2.03,0 -1.48,2.31 -2.96,3.23 -0.28,0.18 -2.68,-0.56 -2.5,0 0.09,0.55 1.3,0.83 1.11,1.38 0,0 -3.6,0.94 -3.7,0.94 -0.37,0.46 3.23,5.26 4.62,5.17 4.25,-0.36 -0.83,-2.22 3.15,-2.77 1.02,-0.19 0.56,2.03 1.02,2.96 0.19,0.36 1.11,0.18 1.02,0.83 -0.19,0.46 -0.83,1.29 -0.37,1.38 3.14,1.11 1.2,-1.01 2.59,-0.18 l 0.37,0.47 c -0.09,-0.1 -0.18,-0.19 -0.28,-0.29 z", 1, "state"], ["rx", "23.7", "ry", "12", "y", "166", "x", "81.82", "height", "26", "width", "47.4", 1, "plaque-inner"], ["y", "186", "x", "108", 1, "text"], ["d", "m 199.64,281.82 c 1.67,1.3 3.05,2.04 1.3,2.87 m -1.02,0.47 c -0.28,0.18 -0.55,0.27 -0.83,0.27 -0.28,0 0.28,-0.38 0.18,-0.56 -0.55,-1.94 -1.94,-2.31 0.37,-3.05 m 9.53,-62.79 c 0.55,0.28 1.75,0.83 1.85,1.48 0,0.46 -1.29,1.29 -0.93,1.01 0.55,-0.37 0.74,-1.48 1.39,-1.38 0.55,0.18 -0.1,1.38 0.37,1.75 0.37,0.28 0.55,-0.74 0.92,-0.83 1.39,-0.37 4.53,0.19 6.38,0.46 0.74,0.1 1.76,-0.55 2.22,0 0.46,0.47 -0.74,0.93 -1.02,1.48 -0.18,0.56 0,1.11 -0.18,1.66 -0.19,0.47 -6.01,3.98 -7.12,4.81 -1.85,1.39 0.83,-0.19 1.75,0.55 0.37,0.19 -0.46,0.56 -0.83,0.83 -0.28,0.28 -0.46,0.74 -0.92,0.83 -0.19,0 0,-0.64 -0.19,-0.64 -0.37,-0.1 -0.64,0.27 -0.92,0.37 -0.65,0.27 -0.74,-0.47 -1.02,0.18 -0.74,1.66 1.02,2.22 1.48,1.66 0.09,-0.18 -0.37,-0.46 -0.18,-0.46 0.46,-0.09 0.92,0.28 1.48,0.28 1.02,-0.09 2.31,-1.2 3.61,-0.92 0.65,0.09 1.2,0.74 1.85,0.92 1.57,0.46 6.75,0.37 7.59,2.22 0.18,0.55 0.27,1.1 0.09,1.66 l -2.13,2.12 c -0.27,0.37 -0.46,0.83 -0.55,1.3 -0.09,0.18 0.09,0.37 0,0.46 -0.74,1.39 -4.62,6.84 -5.83,6.94 -1.85,0.18 -2.49,-0.74 -4.07,0.46 -0.28,0.18 0.55,0.27 0.83,0.18 0.74,-0.09 1.38,-0.55 2.03,-0.64 1.29,-0.1 0.28,0.83 0.37,1.1 0.28,0.65 1.48,0.83 1.39,1.48 -0.28,2.03 -2.22,0.28 -2.78,0.37 -2.87,0.46 2.31,1.66 -3.7,1.2 -0.09,0 -0.09,1.02 0,1.02 0.65,0.28 -0.09,-0.28 0.55,-0.19 0.74,0.19 2.31,1.39 3.14,0.83 0.37,-0.27 0.47,-0.92 0.84,-1.1 0.18,-0.1 3.7,2.49 4.07,2.86 0.65,0.46 0.92,2.77 1.57,3.52 0.37,0.36 0.92,0.47 1.2,0.83 0.09,0.18 -0.09,0.37 -0.09,0.65 -0.09,0.56 -0.09,1.2 -0.09,1.75 0.09,1.66 0.74,8.51 1.29,9.9 0.09,0.18 0.28,-0.38 0.46,-0.28 0.37,0.1 0.65,0.56 1.02,0.74 1.66,1.03 1.29,0.19 2.87,2.13 0.56,0.65 0.28,1.75 0.74,2.5 0.46,1.02 1.75,0.09 1.75,1.95 0,0.55 -1.01,0.55 -1.1,1.1 -0.37,1.48 1.38,3.61 1.75,4.9 0.46,1.76 -1.01,-0.83 -1.11,1.11 0,0.46 3.33,3.98 1.67,5.73 -1.3,1.3 -1.85,-0.18 -2.78,2.13 -0.09,0.27 0.65,-0.09 0.84,0.09 0.37,0.27 0.46,0.83 0.73,1.11 0.28,0.27 0.74,0.73 1.02,0.55 1.85,-1.2 0.46,-2.4 2.4,-2.12 3.15,0.46 8.23,1.85 7.31,6.84 -0.28,1.57 -2.4,5.74 -3.98,6.29 -0.56,0.19 -1.39,-0.92 -1.57,-0.46 -0.83,1.66 3.51,1.2 -0.19,2.22 -0.27,0.09 -0.46,-0.1 -0.74,-0.28 -0.09,0 -0.09,-0.18 -0.18,-0.18 -0.74,0.09 -1.85,-0.09 -2.22,0.47 -0.28,0.55 1.39,-0.19 1.76,0.28 0.37,0.36 0.09,1.1 -0.19,1.57 -0.74,1.2 -2.77,0.36 -3.79,0.74 -0.28,0.09 -1.02,0.36 -0.74,0.56 0.09,0 2.77,-0.83 2.68,0.36 -0.09,0.47 -1.11,-0.09 -1.48,0.18 -0.28,0.29 0.74,0.74 1.11,0.56 0.18,-0.18 0.18,-0.74 0.46,-0.74 0.37,-0.09 0.74,0.28 1.11,0.56 1.29,1.2 -2.68,0.55 0,1.01 1.29,0.18 2.68,-0.83 4.07,-0.27 0.37,0.09 -0.55,0.55 -0.65,0.92 -0.18,0.65 -0.09,1.3 -0.18,2.03 -0.28,0.93 -1.94,0.56 -2.87,1.02 -0.37,0.27 -0.1,1.2 -0.56,1.39 -1.66,0.55 -0.83,-0.93 -1.85,-0.28 -1.01,0.65 -1.94,0.38 -2.96,0.83 -0.46,0.19 -0.65,0.92 -1.2,0.92 -0.83,0 -2.31,-1.57 -3.14,-1.75 -0.65,-0.09 -5.27,1.02 -5.55,0 -0.09,-0.46 1.21,-0.09 0.28,-0.74 -0.55,-0.36 -0.28,0.47 -0.46,0.74 -0.18,0.09 -0.46,-0.09 -0.55,-0.27 0,-0.28 0.65,-0.56 0.37,-0.56 -0.28,-0.09 -0.56,0.56 -0.84,0.47 -0.27,-0.09 0.28,-0.56 0.1,-0.83 -0.65,-0.83 -0.28,0.83 -0.56,0.74 -1.11,-0.38 -1.94,-2.22 -2.22,-1.95 -0.37,0.47 0.73,1.11 0.64,1.66 -0.09,0.92 -5.27,-0.27 -5.46,0 -0.28,0.47 0.65,1.12 0.56,1.66 -0.1,0.28 -0.56,-0.09 -0.83,-0.09 h -0.093 c -0.46,-0.27 -1.94,-1.29 -2.4,-1.1 -0.55,0.27 -0.37,1.1 -0.65,1.57 -0.18,0.18 0.19,-0.56 0.1,-0.83 -0.19,-0.47 -0.65,-0.83 -1.11,-1.21 -1.2,-1.2 -4.71,-2.03 -6.38,-1.39 0,0 -1.02,4.44 -2.41,5.09 -1.1,0.47 -3.05,-2.22 -3.79,-2.59 -0.47,-0.28 0.92,0.83 -0.28,0.55 -1.11,-0.27 -2.68,-1.38 -3.98,-1.01 -0.46,0.09 -0.28,0.92 -0.65,1.11 -0.55,0.19 -1.2,-0.19 -1.85,-0.19 -0.09,0 -0.18,0 -0.27,0.09 -0.19,0.47 -1.3,2.78 -1.67,2.78 -0.55,-0.09 -0.27,-1.3 -0.64,-1.75 -0.56,-0.93 -2.77,-0.28 -2.77,-1.3 0,-0.65 3.7,-0.83 3.79,-0.83 0.37,-0.09 0.74,-0.47 1.02,-0.83 0.18,-0.09 0,-0.47 0.18,-0.56 0.19,-0.18 0.56,0.09 0.74,0 0.65,-0.56 0.83,-1.39 1.48,-1.85 0.28,-0.18 0.74,0.18 1.02,0.09 0.27,-0.18 0.18,-0.56 0.46,-0.74 0.46,-0.47 1.29,-0.56 1.75,-1.1 0.28,-0.38 0.19,-2.51 0.84,-2.78 0.36,-0.09 0.73,0.65 1.1,0.74 2.13,0.18 -0.37,-3.05 4.81,-2.13 1.75,0.28 4.07,2.69 5.83,1.3 0.55,-0.47 0.37,-1.39 0.65,-1.95 0.1,-0.18 4.53,-2.95 5.08,-3.6 0.56,-0.65 -2.4,1.29 -2.77,1.57 -0.46,0.18 -0.92,0.27 -1.38,0.36 -0.28,0 -0.47,-0.46 -0.74,-0.36 -2.31,0.65 -1.76,2.59 -4.53,1.01 -0.92,-0.65 -0.74,-2.22 -1.57,-3.06 -0.74,-0.74 -2.12,0.93 -3.05,0.47 -0.18,-0.09 -0.37,-2.96 -0.46,-3.24 -0.09,-0.19 -0.18,0.37 -0.37,0.37 -0.65,0.09 0.19,-0.65 -2.03,0 -0.28,0 -0.19,0.56 -0.37,0.74 -0.55,0.18 -1.29,0.37 -1.85,0.18 -0.46,-0.09 -1.29,-0.65 -1.11,-1.01 0.28,-0.56 1.21,-0.18 1.76,-0.28 0.28,-0.09 -2.31,-0.19 -2.59,-0.56 -0.37,-0.56 -0.18,-1.3 -0.18,-1.95 0,-1.85 3.42,-0.83 3.88,-1.01 0.55,-0.18 0.64,-1.11 1.29,-1.2 0.46,0 0.92,0.46 1.39,0.36 1.48,-0.36 4.44,-2.87 4.99,-4.16 0.19,-0.38 -0.18,-3.98 -0.73,-4.53 -1.57,-1.95 -3.33,3.61 -3.98,-0.18 -0.18,-0.65 1.76,-0.74 2.96,-1.67 0.18,-0.28 0.09,-0.74 0.28,-1.02 0.18,-0.27 0.37,-0.46 0.55,-0.55 0.37,-0.28 0.74,-0.38 1.02,-0.47 0.65,0 1.2,0.27 2.49,-0.18 0.19,-0.09 -0.37,-0.74 -0.09,-0.65 0.65,0.09 1.01,0.83 1.66,0.92 1.29,0.18 1.57,-1.01 2.49,-0.18 0.47,0.46 0.65,1.85 1.21,1.48 0.55,-0.38 -0.47,-1.39 -0.28,-2.04 0.09,-0.37 1.75,-0.18 2.96,1.3 0.28,0.27 -0.74,0 -1.1,-0.18 -0.84,-0.47 -1.21,-1.86 -1.02,-2.87 0.09,-0.56 0.65,-1.01 1.11,-1.39 0.37,-0.27 1.29,0 1.2,-0.46 -0.19,-0.56 -1.29,-0.56 -1.48,-1.12 -1.2,-2.58 1.94,-0.56 1.94,-1.66 0.09,-0.56 -0.65,-0.27 -0.37,-0.92 0.28,-0.65 1.11,-1.12 1.02,-1.86 -0.09,-1.38 -1.2,1.11 -2.5,1.21 -0.83,0 0.28,-1.75 0,-2.49 -0.18,-0.37 -0.64,0.74 -1.01,0.65 -1.11,-0.38 -0.19,-1.39 -0.28,-1.95 l -1.11,-2.31 c -0.09,-1.11 2.96,-4.16 3.05,-4.16 0.18,0.09 0.09,0.56 0.28,0.46 0.74,-0.18 1.75,-0.37 1.94,-1.02 0.18,-0.56 -1.11,0 -1.67,-0.09 -0.37,-0.09 -0.74,-0.56 -1.2,-0.47 -0.55,0.19 -0.83,0.93 -1.38,1.11 -0.46,0.18 -1.02,-0.18 -1.48,-0.09 -0.55,0.18 -0.83,0.65 -1.29,0.83 -0.19,0.09 -0.46,0.09 -0.56,-0.09 -0.09,-0.28 0.46,-0.74 0.19,-0.83 -0.28,-0.09 -0.19,0.55 -0.37,0.74 -0.09,0.09 -0.28,0 -0.37,-0.1 -0.46,-0.55 -0.46,-1.94 -1.48,-2.12 -1.29,-0.28 0.46,1.29 -0.46,2.77 -0.37,0.56 -0.83,-0.92 -1.2,-1.48 -2.68,-3.51 0.09,0.56 -3.51,-1.57 -0.93,-0.55 1.29,-0.09 1.2,-0.55 -0.09,-2.13 0.28,-1.95 1.57,-3.43 2.4,-2.68 -1.66,0.47 1.29,-2.22 0.28,-0.27 0.93,-0.27 1.11,-0.64 0.37,-0.64 -1.39,-2.77 -1.48,-2.96 -0.09,-0.28 0.46,-0.28 0.56,-0.56 0.27,-0.64 0,-1.48 0.27,-2.22 0.37,-0.84 1.11,0.09 1.94,0.46 3.05,1.39 -1.57,-0.83 -1.57,-1.02 -0.27,-0.55 0,-1.29 0.1,-2.03 0,-0.46 0.37,-1.02 0.09,-1.39 -0.09,-0.09 -3.79,1.94 -4.07,2.22 -0.73,0.65 0.47,1.94 0.28,2.96 -0.09,0.37 -0.83,0.27 -1.11,0.55 -0.18,0.19 -0.37,0.46 -0.37,0.74 -0.09,0.28 0.1,0.65 0,0.83 -0.27,0.74 -1.01,1.11 -1.29,1.85 -0.09,0.18 0.46,0.55 0.28,0.65 -0.65,0.37 -1.48,0.65 -2.22,0.37 -0.55,-0.27 0.74,-1.01 1.02,-1.48 0.55,-0.74 0.37,-1.94 0.92,-2.68 l 1.94,-1.67 c -0.18,-0.47 -1.2,0.18 -1.39,-0.28 -0.18,-0.37 2.5,-1.94 1.21,-2.22 -0.56,-0.18 -0.84,1.2 -1.3,0.92 -0.55,-0.46 1.3,-0.83 1.66,-1.48 0.37,-0.74 0.1,-2.4 0.37,-3.05 0.19,-0.56 0.65,-1.11 1.11,-1.2 0.46,-0.09 1.3,0.92 1.3,0.46 0,-0.46 -1.02,-0.46 -1.3,-0.92 -0.64,-1.3 3.14,-1.94 3.24,-1.94 0.28,-0.28 -1.21,0.09 -1.21,-0.28 0,-0.56 0.93,-0.65 1.11,-1.2 0.19,-0.28 -0.55,0.18 -0.83,0.46 -0.65,0.46 -0.55,0.65 -1.11,0.92 -1.2,0.65 -2.31,1.67 -3.14,1.3 0.1,0.18 0.19,0.27 0.37,0.37 0.09,0.18 0.46,0.37 0.28,0.55 -0.74,0.65 -4.44,1.94 -5.09,0.65 -0.09,-0.09 0,-0.37 0.09,-0.37 1.85,-0.74 0.37,2.03 2.68,-1.11 1.48,-1.94 -4.35,-0.92 -0.18,-2.31 0.18,0.37 0.37,0.74 0.64,1.02 0.09,0.18 0.28,0.37 0.46,0.46 -0.18,-0.28 -0.37,-0.65 -0.46,-1.11 -0.09,-0.28 0.65,0 0.93,0 0.73,0 1.48,0.37 2.12,0.09 0.83,-0.37 -5,-0.28 -4.25,-1.38 0.56,-0.74 2.96,0.27 3.14,-0.1 0.37,-0.92 -2.31,-2.03 0.28,-2.68 0.65,-0.19 1.29,0.64 2.04,0.46 2.5,-0.56 -0.65,-2.22 -0.65,-2.22 0.28,-0.65 1.67,0.19 2.13,-0.37 0.46,-0.55 0.09,-1.48 0.09,-2.22 0,-0.55 0.09,-1.1 -0.09,-1.48 -0.09,-0.19 -3.14,-3.42 -1.11,-4.25 0.46,-0.28 0.55,1.48 1.11,1.29 0.74,-0.18 -0.28,-2.31 0.83,-1.66 1.48,0.83 1.57,0.92 1.57,0.83 0.28,-1.2 -0.74,-1.29 -0.65,-2.5 0,-0.47 1.2,0.55 1.39,0.09 0.37,-0.65 -0.46,-1.48 -0.37,-2.13 0,-0.27 0.28,0.47 0.55,0.47 0.65,0.27 1.67,0.83 2.13,0.27 0.37,-0.46 -0.93,-0.92 -1.11,-1.48 -0.46,-1.57 0.92,-0.36 0.92,-0.36 0.19,-0.19 -0.27,-0.56 -0.18,-0.74 0.18,-0.1 0.65,0.37 0.65,0.18 0,-0.28 -0.65,-0.46 -0.56,-0.74 0.09,-0.64 0.65,-1.1 1.02,-1.66 z m 27.37,-17.48 c 0,0.28 0.18,0.46 0.09,0.65 -0.09,0.18 -0.55,-0.09 -0.55,0.09 -0.1,0.46 0.83,-0.46 1.29,-0.37 0.28,0.09 -0.46,0.46 -0.65,0.74 0,0.09 0.37,0.37 0.28,0.46 -0.18,0.09 -0.55,-0.37 -0.65,-0.09 0,0.18 0.56,0.18 0.56,0.46 0.09,0.83 -1.11,0.56 -1.02,0.83 0.09,1.2 0.19,2.13 -1.66,4.07 -0.09,0.18 0.09,-0.37 0.18,-0.56 0.56,-1.2 1.57,-3.23 1.11,-3.51 -0.37,-0.37 -0.74,1.02 -1.2,0.74 -0.65,-0.28 -0.92,-1.11 -1.11,-1.75 -0.09,-0.19 0.28,-0.1 0.46,-0.19 0.74,-0.09 1.48,0.09 2.13,-0.18 0.46,-0.28 0.46,-0.93 0.74,-1.39 z m -12.3,16.65 c -1.2,2.4 -6.75,-2.77 -2.87,-3.05 0.55,0 1.11,0.65 1.11,1.29 0.09,0.37 -1.11,0.28 -0.93,0.56 0.28,0.55 1.11,0.55 1.67,0.74 0.27,0.18 0.64,0.27 1.01,0.46 z m -40.55,40.25 c 0.27,0.38 0.64,0.65 1.01,0.47 0.56,-0.27 0.74,-1.21 1.29,-1.48 0.56,-0.37 1.2,0.47 1.76,0.38 0.65,0 1.11,-0.47 1.66,-0.38 0.65,0.09 1.02,0.74 1.57,0.92 0.28,0.19 0.83,-0.18 0.93,0.09 0.37,0.65 0.55,1.57 0.37,2.31 0,0.28 -0.37,0.38 -0.37,0.56 1.01,3.98 0.55,-1.2 1.66,2.31 0.37,1.01 -2.03,2.4 -2.03,2.4 1.57,-0.36 3.23,-1.57 2.96,2.13 -0.37,3.6 -2.96,1.67 -3.7,2.5 -0.65,0.65 -0.19,2.13 -1.85,1.84 -0.37,0 -0.65,-0.36 -0.92,-0.64 l -0.37,-0.47 c -1.39,-0.83 0.55,1.3 -2.59,0.18 -0.46,-0.09 0.19,-0.92 0.37,-1.39 0.09,-0.64 -0.83,-0.46 -1.02,-0.83 -0.46,-0.93 0,-3.15 -1.01,-2.95 -3.98,0.55 1.11,2.4 -3.15,2.77 -1.39,0.09 -5,-4.72 -4.62,-5.17 0.09,0 3.7,-0.94 3.7,-0.94 0.19,-0.55 -1.01,-0.83 -1.1,-1.38 -0.19,-0.56 2.21,0.18 2.5,0 1.48,-0.93 0.92,-3.25 2.96,-3.25 l 0,0 z m 17.62,-38.3 c -0.47,0.74 -1.76,1.48 -1.94,2.03 -0.1,0.46 -0.19,3.05 -1.39,3.05 -0.65,-0.09 -0.55,-1.11 -1.02,-1.57 -0.56,-0.37 0.19,1.57 -0.37,1.84 -0.28,0.1 -0.65,-0.36 -0.84,-0.18 -0.64,0.37 -0.74,1.66 -1.48,1.66 -0.65,0 -1.2,-1.11 -0.84,-1.66 0.37,-0.65 1.94,0.46 2.22,-0.28 0.28,-0.64 -1.29,-0.74 -1.57,-1.47 -0.09,-0.28 0.65,-0.19 0.83,-0.37 0.09,-0.1 -0.27,0 -0.27,-0.1 -0.19,-0.37 -0.28,-0.74 -0.19,-1.11 0.83,-2.31 1.48,-0.19 2.77,0.09 0.09,0 -0.46,-1.39 -0.18,-1.67 0.92,-1.11 0.92,-0.09 1.84,-0.18 0.1,-0.09 0.1,-0.37 0.19,-0.37 0.55,-0.46 1.11,-1.2 1.75,-1.11 0.47,0.09 0.28,0.93 0.47,1.39 z m 1.2,50.03 c -0.47,0.1 -0.93,0.1 -1.39,0.37 -0.37,0.27 -0.46,0.92 -0.83,1.3 -3.98,3.6 2.4,2.68 2.22,-1.67 z", 1, "state"], ["rx", "23.7", "ry", "12", "y", "199", "x", "81.82", "height", "26", "width", "47.4", 1, "plaque-inner"], ["y", "219", "x", "107.5", 1, "text"], ["d", "m 203.94,292.03 c -2.34,0.14 -8.02,1.46 -8.75,2.59 -0.47,0.55 -0.63,1.13 -1,1.59 l -0.88,0.66 0.94,-0.59 c -0.05,0.06 -0.06,0.11 -0.06,0.12 0.14,-0.08 0.74,-0.6 0.81,-0.47 0.09,0.19 0.28,0.38 0.28,0.56 -0.09,0.65 -0.46,1.17 -0.56,1.81 0,0.84 2.22,-0.27 2.59,0.56 0.28,0.65 -1.19,1.32 -1,1.97 0.18,0.64 0.91,1.24 0.34,0.91 -1.5,-0.89 -3.54,2.84 -4.09,2.84 l -1.16,-0.44 c -0.19,-0.27 1,-0.87 1.19,-1.16 0.55,-0.54 -0.9,-1.16 -0.44,-1.81 0.37,-0.65 1.38,-0.44 2.03,-0.91 1.48,-1.11 -2.62,0.44 -1.69,-2.81 l 0.81,-0.59 -0.88,0.53 c -0.65,0.19 -1.41,-0.09 -2.06,-0.09 -0.27,0 -0.54,-0.18 -0.62,-0.09 -1.21,1.48 -0.86,4.46 -1.41,6.03 -0.56,1.39 -1.67,2.95 -2.69,4.06 -0.37,0.47 -0.62,0.99 -1.09,1.28 -0.27,0.18 -0.94,-0.19 -1.03,0.19 -0.19,0.56 0.66,1.28 0.38,1.84 -0.93,1.47 -3.8,0.76 -3.16,1.12 0.75,0.46 1.33,1.1 2.16,1.47 0.37,0.09 0.72,-0.48 1,-0.38 0.37,0.09 1.02,0.67 0.75,0.94 -0.46,0.28 -1.69,-0.75 -1.69,-0.19 0.1,0.83 2.52,0.76 2.06,1.41 -0.29,0.39 -0.59,0.53 -0.88,0.53 l 0.03,0.12 c 0.21,-0.02 0.4,-0.01 0.56,0.16 0.18,0.18 0.35,0.46 0.44,0.75 0.28,0.09 0.47,0.18 0.75,0.09 0.65,0 -1.09,-2.15 1.12,-1.5 0.19,0 -0.19,0.46 -0.09,0.56 1.11,0.92 1.39,-1.31 2.22,-0.66 0.28,0.27 -0.75,0.85 -0.47,1.03 2.12,1.12 0.28,-0.28 1.94,-0.66 0.28,-0.09 0.76,2.6 1.41,2.69 1.47,0.27 3.42,0.18 4.62,1.75 0.09,0.19 -0.38,0.38 -0.47,0.56 -0.19,0.55 -0.66,1.01 -0.75,1.56 0,0.19 0.47,0.1 0.38,0.28 -0.1,0.27 -0.57,0.38 -0.66,0.75 -0.65,2.31 0.92,1.66 2.41,1.75 l 0.09,0 c -0.19,-0.27 -0.28,-0.56 -0.28,-0.66 0.09,-0.37 0.75,-0.35 0.84,-0.72 0.28,-1.57 -2.39,-2.13 -1.56,-2.31 0.28,-0.1 0.43,0.28 0.62,0.28 l 1.78,-1.59 c 0.09,-0.46 -1.12,0.08 -0.75,-0.66 0.27,-0.65 0.91,-1.1 1.19,-1.75 0.83,-2.04 -1.19,-3.52 -1.75,-4.53 -0.09,-0.19 0.09,-0.45 0.19,-0.62 0,-0.19 -0.19,-0.47 0,-0.56 0.46,-0.28 1,0 1.56,-0.19 0.18,-0.09 -0.19,-0.66 0,-0.56 0.55,0.18 0.94,0.84 1.59,0.84 0.64,0.09 3.13,-0.76 3.41,-1.41 0.28,-0.65 -1.77,-0.72 -0.94,-1.28 1.48,-1.01 3.25,-1.41 2.88,-3.72 -0.09,-1.29 -3.52,-0.7 -2.69,-2.09 0.09,-0.28 0.56,-0.01 0.56,-0.19 0.09,-0.28 -0.38,-0.56 -0.28,-0.84 0,-0.19 0.29,-0.19 0.47,-0.19 0.65,0 1.19,0.28 1.84,0.28 0.74,0 0.1,-1.48 0.38,-2.22 0.19,-0.65 1.77,-3.61 1.59,-5.19 -1.86,0.93 -2.06,-2.49 -3.62,-2.88 -0.17,-0.03 -0.45,-0.02 -0.78,0 z", "transform", "translate(74.5,0)", 1, "state"], ["width", "47.4", "height", "26", "x", "81.82", "y", "232", "ry", "12", "rx", "23.7", 1, "plaque-inner"], ["x", "107.5", "y", "252", 1, "text"], ["d", "m 269.69,339.58 c -0.28,-0.09 -0.56,-0.18 -0.83,-0.18 -0.65,-0.09 -1.3,0.56 -1.85,0.27 -0.46,-0.18 -0.09,-1.01 -0.37,-1.38 -0.19,-0.28 -0.65,-0.1 -0.93,-0.28 -0.09,-0.09 0.37,-0.27 0.37,-0.36 -0.09,-0.18 -0.18,-0.38 -0.37,-0.47 -0.18,-0.09 -0.46,0.28 -0.55,0.18 -0.37,-0.27 -0.46,-0.83 -0.83,-1.1 -0.65,-0.27 -1.57,0 -1.94,-0.56 -0.37,-0.36 0.37,-0.92 0.37,-1.38 -0.09,-0.38 -0.65,-0.47 -0.65,-0.84 0,-0.46 0.37,-0.83 0.46,-1.2 0.1,-0.27 0.56,-0.56 0.37,-0.74 -0.65,-0.56 -1.2,1.1 -1.85,1.66 -1.3,1.21 -4.35,0.47 -4.07,-0.09 0.28,-0.47 0.74,-0.74 0.74,-1.21 0,-0.27 -0.74,-0.27 -0.65,-0.64 0,-0.56 0.74,-1.02 0.74,-1.57 -0.18,-1.57 -3.98,-0.65 -4.16,-1.39 -0.1,-0.38 0.18,-0.83 0.09,-1.21 -0.28,-1.48 -2.31,0 -2.87,-1.29 -0.37,-0.74 0.18,-2.87 -1.02,-3.34 -0.55,-0.27 -1.02,1.02 -1.76,1.02 -2.03,0 -2.12,-3.52 -2.31,-4.81 0.09,-0.1 0.09,-0.1 0.09,-0.1 1.66,-0.46 4.25,-2.5 6.38,-3.15 l 0.19,0.38 c -0.19,2.4 1.75,0.83 3.14,1.48 0.18,0.09 -0.19,0.46 0,0.65 1.11,0.74 2.03,-0.56 2.77,-1.21 0.55,0.47 1.11,0.83 1.29,0.74 0.28,-0.18 0.19,-0.56 0,-0.92 0.28,0.09 0.46,0.18 0.74,0.09 0.65,0 -1.11,-2.13 1.11,-1.48 0.18,0 -0.19,0.47 -0.09,0.56 1.11,0.92 1.39,-1.3 2.21,-0.65 0.28,0.27 -0.74,0.83 -0.46,1.01 2.13,1.12 0.28,-0.27 1.94,-0.65 0.28,-0.09 0.74,2.6 1.39,2.69 1.48,0.27 3.42,0.18 4.62,1.75 0.1,0.18 -0.37,0.38 -0.46,0.56 -0.18,0.55 -0.64,1.02 -0.74,1.57 0,0.18 0.47,0.09 0.37,0.27 -0.09,0.27 -0.55,0.38 -0.64,0.74 -0.65,2.31 0.92,1.67 2.4,1.76 h 0.091 c 0.37,0.65 0.92,1.66 1.02,1.66 0.18,0.19 0.74,-0.18 0.74,0.1 0.09,0.36 -0.65,0.74 -0.56,1.1 0.19,0.56 1.02,0.47 1.29,0.92 1.02,1.66 -1.48,1.95 -2.12,3.7 -1.02,-1.75 -2.87,1.66 -3.23,2.68 -0.28,0.83 2.5,4.44 0.46,4.26 l -0.09,0.36 z", 1, "state"], ["rx", "23.7", "ry", "12", "y", "265", "x", "81.82", "height", "26", "width", "47.4", 1, "plaque-inner"], ["y", "285", "x", "107", 1, "text"], ["d", "m 274.04,340.5 c -0.46,-0.18 -1.02,-0.46 -1.57,-0.46 -0.46,0 -0.93,0.46 -1.48,0.46 -0.09,0.1 0,-0.27 -0.09,-0.36 -0.37,-0.18 -0.74,-0.37 -1.2,-0.56 l 0.09,-0.36 c 2.03,0.18 -0.74,-3.43 -0.46,-4.26 0.37,-1.02 2.22,-4.43 3.23,-2.68 -0.09,0.47 -0.18,0.92 0,1.66 0.46,1.95 2.68,2.13 2.87,2.4 1.3,1.57 -2.4,2.31 -1.39,4.16 z", 1, "state"], ["rx", "23.7", "ry", "12", "y", "298", "x", "81.82", "height", "26", "width", "47.4", 1, "plaque-inner"], ["y", "318", "x", "107", 1, "text"], ["d", "m 245.83,318.68 c 0.18,1.29 0.27,4.81 2.31,4.81 0.74,0 1.21,-1.3 1.76,-1.02 1.2,0.47 0.65,2.6 1.02,3.34 0.55,1.29 2.59,-0.19 2.87,1.29 0.09,0.38 -0.19,0.83 -0.09,1.21 0.18,0.74 3.98,-0.18 4.16,1.39 0,0.55 -0.74,1.01 -0.74,1.57 -0.09,0.37 0.65,0.37 0.65,0.64 0,0.47 -0.46,0.74 -0.74,1.21 -0.28,0.56 2.77,1.3 4.07,0.09 0.64,-0.56 1.2,-2.22 1.85,-1.66 0.19,0.18 -0.27,0.47 -0.37,0.74 -0.09,0.36 -0.46,0.74 -0.46,1.2 0,0.38 0.56,0.47 0.65,0.84 0,0.46 -0.74,1.01 -0.37,1.38 0.37,0.56 1.29,0.28 1.94,0.56 0.37,0.27 0.46,0.83 0.83,1.1 0.09,0.1 0.37,-0.27 0.55,-0.18 0.18,0.09 0.28,0.28 0.37,0.47 0,0.09 -0.46,0.27 -0.37,0.36 0.28,0.18 0.74,0 0.93,0.28 0.28,0.37 -0.09,1.2 0.37,1.38 0.55,0.28 1.2,-0.36 1.85,-0.27 0.27,0 0.55,0.09 0.83,0.18 0.46,0.19 0.83,0.38 1.2,0.56 0.09,0.09 0,0.47 0.09,0.36 0.55,0 1.02,-0.46 1.48,-0.46 0.55,0 1.11,0.27 1.57,0.46 0.18,0.28 0.74,0 1.01,0.28 0.74,0.46 1.2,2.59 2.13,3.51 1.11,1.21 -0.74,-2.59 2.03,-0.09 0.18,0.18 -0.18,0.56 -0.09,0.83 0.18,0.28 3.15,-0.92 3.61,-0.55 0.28,0.27 0.09,0.83 0.37,1.11 0.36,0.27 5.92,0.92 5.55,1.57 -1.01,1.75 -2.87,2.87 -3.61,4.35 -0.27,0.64 -0.36,2.68 -0.46,3.23 l -1.3,2.12 c -0.18,0.47 -0.36,0.93 -0.27,1.39 0,0.28 0.36,0.28 0.36,0.47 -0.09,1.29 -1.01,2.5 -0.92,3.79 0,1.2 0,1.57 0.09,1.57 -3.14,3.24 -2.03,-0.28 -4.62,0.46 -0.19,0.09 0.18,0.47 0.18,0.65 0,0.09 -0.18,0 -0.18,0 -0.28,0.38 -1.02,0.74 -0.83,1.21 0.09,0.46 1.48,-0.47 1.48,0 -0.09,1.29 -0.55,0.27 -1.01,0.64 -0.83,0.65 -1.57,2.5 -2.22,3.05 -0.55,0.65 -1.85,0.38 -2.22,1.12 -0.27,0.65 0.28,1.48 0,2.03 -0.37,1.02 -2.03,1.02 -2.68,1.95 -1.11,1.39 0.09,2.68 -0.37,4.16 -0.1,0.28 -1.02,-0.18 -1.02,1.01 0,0.19 -0.46,0.38 -0.37,0.38 1.11,0.27 2.4,-0.18 2.96,-1.3 0.09,-0.18 -0.37,-0.36 -0.47,-0.55 0,-0.28 -0.09,-0.47 0.1,-0.65 0.83,-1.3 3.42,-1.3 4.62,-0.74 0.36,0.09 -0.37,0.65 -0.28,0.93 0,0.47 0.55,0.65 0.64,1.1 0.1,0.56 -1.2,0.47 -0.64,1.39 0.18,0.18 0.74,-0.09 0.83,0.18 0.18,0.29 -0.28,0.74 -0.19,1.03 0.1,0.18 0.47,-0.38 0.56,-0.19 0.46,0.47 0.46,1.11 0.83,1.67 -4.25,2.5 -1.85,1.38 -0.55,3.6 0.18,0.37 -0.19,1.02 0.09,1.39 0.28,0.65 1.2,0.74 1.48,1.3 0.46,0.83 -2.5,3.24 -2.96,3.33 -0.28,0.09 -0.46,-0.47 -0.74,-0.47 -0.46,0.09 -1.29,0.09 -1.29,0.56 -0.19,1.48 2.87,2.68 3.33,3.42 0.28,0.56 0.37,1.3 0.37,2.04 -0.09,0.28 -0.92,-0.18 -1.01,0.09 -0.1,0.18 0.18,0.38 0.09,0.47 -0.28,0.46 -0.74,0.74 -1.11,1.1 -0.28,0.56 0.65,0.83 0.74,1.11 0,0.18 -0.46,0.18 -0.46,0.36 -0.09,1.3 2.31,3.05 3.33,3.33 0.56,0.19 1.2,-0.09 1.76,-0.09 0.56,-0.09 1.2,-0.46 1.67,-0.18 1.39,1.01 -1.75,3.14 -1.3,4.81 -0.09,0 -1.66,0.56 -1.84,0.74 -0.09,0.09 0.18,0.47 0,0.47 -0.09,-0.09 0,-0.47 -0.09,-0.47 -0.56,0.09 -1.2,0.18 -1.57,0.56 -0.28,0.27 0.18,0.92 -0.19,1.2 -0.37,0.28 -1.01,-0.09 -1.48,0.19 -0.37,0.27 -0.28,1.01 -0.74,1.38 -0.37,0.19 -0.83,-0.27 -1.2,-0.09 -0.28,0.09 -0.1,0.56 -0.37,0.83 -0.28,0.38 -1.02,0.47 -1.21,0.92 -0.09,0.38 0.74,0.93 0.37,1.21 -0.46,0.47 -1.39,0 -2.04,0.09 -0.83,0.18 -1.38,1.01 -2.12,1.3 -0.83,0.27 -0.19,-1.02 -2.03,-1.11 -1.2,-0.09 0.09,0.47 -0.1,0.65 -0.18,0.18 -0.55,0.18 -0.83,0.09 -0.28,0 -0.55,0 -0.64,-0.18 0,-0.18 0.64,-0.65 -0.65,-1.3 -0.28,-0.09 -0.56,0 -0.92,0 -0.65,-0.18 -1.39,-0.09 -1.85,-0.55 -0.46,-0.47 0,-1.39 -0.37,-1.85 -0.19,-0.27 -0.56,0.38 -0.92,0.38 -0.56,0 -1.67,0.18 -1.57,-0.38 0.09,-0.74 1.76,-0.46 1.85,-1.2 0,-0.74 -1.01,-1.3 -1.66,-1.21 -0.55,0.09 0.46,1.11 0.18,1.48 -0.46,0.47 -1.2,0.74 -1.85,0.65 -1.48,-0.09 -1.02,-2.68 -1.3,-2.31 -1.29,1.48 1.57,2.13 0.74,2.5 -2.96,1.21 -1.66,-0.74 -1.75,-1.11 -0.09,-0.38 -3.33,-0.74 -3.6,-0.92 -0.74,-0.38 -1.67,-1.57 -2.59,-1.02 -1.02,0.56 -2.5,2.4 -3.52,2.96 -0.92,0.47 -2.77,0.09 -3.88,1.66 -0.19,0.18 0.28,0.56 0.28,0.83 -0.19,0.93 -1.39,1.48 -1.48,2.5 0,0.28 0.65,0.19 0.74,0.47 0.46,1.66 -0.74,1.21 -0.09,3.05 0.18,0.56 0.74,1.01 1.29,1.48 h -0.371 c -1.48,-0.38 -3.14,-1.21 -4.53,-0.27 -0.27,0.18 0.1,0.92 -0.27,1.01 -0.93,0.28 -2.5,-1.57 -3.42,-1.57 -0.83,0 -1.48,0.46 -2.22,0.56 -0.55,0.09 -0.64,-0.93 -0.83,-1.11 -0.46,-0.36 -1.2,-0.56 -1.85,-0.83 0.93,-1.21 0.74,-2.4 -1.66,-2.22 -0.09,0 -0.37,0.38 -0.55,0.83 v -0.091 c -0.47,-0.27 -0.19,-1.1 -0.65,-1.48 -0.28,-0.27 -0.83,-0.27 -1.29,-0.36 -0.19,0 -0.47,0.09 -0.56,0 -1.01,-0.92 -1.94,-2.04 -3.51,-2.31 -1.11,-0.18 -0.65,1.94 -0.65,1.94 -1.02,-0.09 -1.85,-0.83 -2.78,-0.74 -0.27,0 -0.27,0.56 -0.55,0.56 -0.55,-0.09 -0.83,-0.74 -1.39,-0.83 -0.56,-0.09 -0.93,0.47 -1.48,0.37 -1.2,0 -0.74,-1.2 -1.39,-1.76 -1.29,-1.1 -2.5,0.56 -3.7,-0.36 -0.1,0 -1.02,-2.13 -1.11,-2.22 -1.2,-0.92 -3.23,-0.47 -4.53,-1.66 -0.18,-0.18 0.09,-0.65 0,-0.83 -0.18,-0.19 -0.74,0.83 -1.29,0.65 -1.2,-0.56 1.48,-1.68 0.65,-2.6 -0.28,-0.37 -0.84,-0.55 -1.3,-0.65 -0.09,0 0,0.47 -0.18,0.38 0,0 -1.02,-0.92 -1.57,-1.48 0.55,-0.09 0.92,-0.18 1.29,-0.37 2.68,-1.29 3.79,-10.18 4.81,-12.95 0.19,-0.47 0.37,-1.1 0.84,-1.3 0.37,-0.19 1.2,0.65 1.39,0.19 0.28,-0.47 -0.37,-1.21 -0.92,-1.3 -0.46,-0.09 -0.56,1.2 -1.02,1.01 -0.92,-0.28 0.46,-1.75 0.65,-2.68 0.37,-1.48 1.39,-6.94 2.4,-7.68 0.37,-0.18 1.66,1.84 2.03,2.77 1.29,2.78 -0.46,0.19 0.46,3.15 0.19,0.56 0.74,1.02 0.93,1.57 0.09,0.28 -0.28,1.11 0,1.02 0.46,-0.09 0.74,-0.74 0.64,-1.12 -0.18,-0.55 -0.83,-0.74 -1.2,-1.2 -0.74,-1.21 0.28,-3.43 -0.46,-4.81 -0.37,-0.74 -1.02,-1.39 -1.57,-2.04 -0.37,-0.47 -0.83,-0.92 -1.38,-1.3 l 0,0 c 0.55,0.19 1.2,0.38 1.75,0.1 0.65,-0.38 -1.39,-1.3 -1.2,-2.04 0.18,-0.74 1.02,-1.11 1.11,-1.84 0.09,-0.56 -0.56,-1.02 -0.56,-1.57 0,-0.65 0.56,-1.3 0.56,-1.95 0,-0.18 -0.46,-0.18 -0.74,-0.09 -0.19,0.09 0,0.65 -0.19,0.56 -0.46,-0.19 -0.55,-0.93 -0.92,-1.21 -0.28,-0.09 -0.65,0.27 -0.92,0.09 -0.28,-0.18 0,-0.83 -0.28,-1.01 -1.66,-1.57 -0.74,1.84 -2.31,-1.21 -0.09,-0.27 -0.18,-2.31 -0.55,-2.77 -0.1,-0.09 -0.37,0 -0.47,-0.09 -0.37,-0.56 -0.83,-1.21 -1.1,-1.85 -0.37,-0.92 1.48,-1.85 1.66,-2.22 0.37,-0.84 -1.85,-1.38 -1.85,-1.48 -0.18,-0.65 -0.18,-1.02 -0.09,-1.3 h -0.091 c -3.79,-0.37 -0.28,-1.3 -0.19,-3.32 0.09,-1.21 -3.79,-0.2 -3.88,-0.65 -0.18,-0.74 0.93,-1.01 1.48,-1.39 0.09,-0.09 -0.46,0.18 -0.55,0.09 -0.1,-0.09 0,-0.36 -0.1,-0.46 -0.27,0 -0.37,0.27 -0.65,0.36 -0.74,0 -1.48,-0.56 -2.13,-0.27 -0.09,0.09 -0.18,0.18 -0.18,0.27 v -0.091 c 0.18,-1.21 1.11,-2.4 -0.83,-2.59 -1.02,-0.09 -0.74,1.2 -1.48,0.74 -0.56,-0.38 -1.29,-1.57 -1.85,-1.86 -0.37,-0.09 -0.83,0.28 -1.11,0 -1.2,-0.92 0.28,-2.03 -2.03,-1.85 -0.18,0.09 0.19,0.56 0,0.65 -0.65,0.27 -1.57,0.83 -2.12,0.36 -0.56,-0.36 0,-1.39 -0.19,-2.03 -0.28,-1.11 -1.48,-0.84 -2.22,-1.3 -0.09,-0.09 0.18,-0.37 0.37,-0.37 0.93,-0.18 1.85,-0.09 2.78,-0.09 0.18,0 0.64,0.38 0.64,0.19 0,-0.19 -0.83,-1.48 -1.38,-2.41 l 0.09,0.1 c 0.46,0.18 1.01,0 1.57,0.09 0.37,0 1.2,0.36 0.92,0.18 -0.64,-0.37 -1.75,-0.18 -2.03,-0.83 -0.18,-0.56 1.29,-0.38 1.39,-0.92 0.27,-1.12 -5.55,3.14 -3.61,-1.86 0.1,0 3.15,-1.2 3.98,-1.2 1.01,0 -1.3,1.2 0.92,0.55 0.65,-0.1 1.29,-0.83 1.94,-0.64 0.55,0.18 0.28,1.29 0.83,1.48 0.37,0 0.09,-1.12 0.46,-1.21 0.65,0 1.11,1.21 1.76,1.01 0.55,-0.18 0.18,-1.38 0.74,-1.75 0.18,-0.18 0.55,0.38 0.83,0.38 0.55,0 1.2,-0.56 1.66,-0.28 0.46,0.28 0.09,1.21 0.55,1.48 0.28,0.18 0.28,-0.46 0.56,-0.65 0.46,-0.36 1.94,3.61 2.31,4.35 0.09,0.09 0.09,-0.38 0.27,-0.38 0.56,-0.36 1.11,-0.46 1.76,-0.74 0.46,-0.27 0.83,-1.02 1.29,-0.83 0.83,0.38 0.09,3.61 2.31,2.69 0.65,-0.28 0.28,-1.48 0.74,-2.13 0.46,-0.65 0.56,1.3 1.11,1.39 0.55,0.09 1.02,-0.18 1.57,-0.09 0.55,0 1.66,0.83 1.85,0.27 0.18,-1.01 -1.94,-1.75 -1.67,-2.77 0.19,-0.65 0.37,-1.3 0.65,-1.95 -0.18,0 -0.37,-0.09 -0.28,-0.47 0.19,-0.64 0.74,-1.38 0.74,-2.12 0,-0.19 -0.55,0.09 -0.64,-0.09 -0.19,-0.47 0,-1.21 -0.28,-1.67 -0.09,-0.27 -0.65,-0.27 -0.83,-0.55 -0.19,-0.56 -0.28,-1.3 -0.19,-1.85 0,-0.27 0.46,-0.36 0.46,-0.55 0,-0.65 -0.36,-1.3 -0.46,-1.95 0,-0.18 0.19,0.38 0.28,0.47 0.74,0.36 1.39,0.74 2.12,0.93 0.19,0.09 0.47,-0.09 0.65,-0.09 0.74,0 1.48,-0.38 2.13,0 0.37,0.09 0.18,0.65 0,1.01 -0.1,0.18 -0.37,0.09 -0.56,0.28 -0.28,0.27 0.74,3.24 0.83,3.24 3.79,0.55 -1.66,-1.77 1.3,-0.65 1.39,0.56 3.14,0.83 4.44,1.48 0.46,0.27 0.74,0.92 1.2,1.01 2.12,0.27 1.66,-0.92 3.23,-1.39 0.37,-0.09 0.74,-0.09 1.2,-0.09 -1.01,-0.18 -1.94,-0.83 -0.64,-3.05 0.92,-1.48 7.12,-1.66 8.78,-2.59 0.65,-0.27 1.11,-0.83 1.76,-1.21 0.55,-0.27 1.57,-0.18 1.85,-0.74 0.28,-0.55 -0.74,-0.83 -0.83,-1.38 -0.09,-0.28 0,-0.74 0.19,-0.93 0.18,-0.18 0.55,0.19 0.55,0 0,-0.18 -0.46,-0.18 -0.46,-0.46 0,-0.65 0.74,-5.09 0.92,-5.55 0.37,-1.11 3.42,-1.3 4.25,-1.39 1.1,-0.09 2.21,-0.18 3.23,-0.37 z m 51.88,100.89 c 1.29,0.93 0,3.42 0,4.43 0,0.38 0.83,1.21 0.74,0.83 -0.19,-0.36 -0.74,-1.38 -0.65,-1.02 0.18,0.56 0.56,0.93 0.74,1.39 0.27,0.65 0.27,2.68 0.27,3.23 0.09,1.57 -1.48,2.78 -1.48,3.88 0,1.21 0.47,2.87 -0.55,3.98 -0.1,0.18 -0.55,0 -0.55,0.18 0,0.28 0.65,0 0.55,0.19 0,0.36 -0.55,0.36 -0.73,0.64 -0.28,0.65 0,1.48 -0.47,2.04 -1.3,1.3 -0.92,-1.39 -1.21,-1.48 -1.2,-0.36 -1.94,0.56 -2.77,-0.83 -0.18,-0.27 0.36,-0.65 0.18,-1.01 -0.27,-0.56 -1.39,-0.74 -1.3,-1.39 0,-0.74 1.48,-1.1 1.39,-1.84 -0.09,-0.56 -1.57,0.55 -1.67,0 -0.18,-0.74 1.3,-1.11 1.21,-1.77 -0.09,-0.74 -1.48,-0.55 -1.67,-1.29 -0.1,-0.56 1.11,-0.74 1.11,-1.39 0,-0.56 -0.92,-0.83 -1.21,-1.39 -0.09,-0.36 0.93,-0.09 1.12,-0.36 0.18,-0.65 0.09,-1.48 0.46,-2.04 0.1,-0.18 0.28,0.47 0.47,0.38 0.47,-0.1 0.56,-0.74 1.01,-0.94 0.38,-0.18 0.83,0.19 1.21,0 0.46,-0.27 0.46,-1.11 0.92,-1.2 0.56,-0.09 1.01,0.65 1.66,0.65 0.56,0 -0.09,-1.21 0,-1.85 0.09,-0.74 0.83,-1.29 1.21,-2.03 z m -21.36,-7.96 c 0.74,0 1.39,-0.64 1.39,-1.29 0,-0.65 -0.64,-1.21 -1.39,-1.21 -0.74,0 -1.39,0.56 -1.39,1.21 0,0.65 0.65,1.29 1.39,1.29 0.74,0 -0.74,0 0,0 z", 1, "state"], ["rx", "23.7", "ry", "12", "y", "331", "x", "81.82", "height", "26", "width", "47.4", 1, "plaque-inner"], ["y", "351", "x", "107", 1, "text"], ["d", "M 71.5625 262.59375 C 70.9115 262.71488 70.21775 263.44575 69.59375 263.71875 C 67.37275 264.64375 64.153 266.692 61.75 266.875 C 61.060799 266.9597 60.518135 266.72809 59.625 266.84375 L 59.625 267.3125 C 59.89538 267.2972 60.144938 267.2772 60.09375 267.4375 C 60.07075 267.5515 59.872281 267.56855 59.625 267.59375 L 59.625 271.96875 C 60.857552 271.94935 62.230547 270.9564 61.9375 273.8125 C 61.8445 274.3695 60.99775 274.44725 60.71875 274.90625 C 60.44575 275.28025 60.6205 275.75 60.4375 276.125 C 60.36475 276.1925 59.85075 275.53483 59.625 275.59375 L 59.625 276.21875 C 59.760469 276.51238 59.9725 276.8315 60.25 276.96875 C 60.711 277.14975 62.0325 276.40975 61.9375 276.96875 C 61.7545 277.61675 60.553 277.3105 60 277.6875 C 59.63 278.0515 59.789 278.9045 60.25 278.8125 C 60.808 278.7215 61.3835 278.1615 61.9375 278.0625 C 62.2155 277.9715 61.83825 278.44025 61.65625 278.53125 C 61.11319 278.99816 60.066566 278.87834 59.625 279.3125 L 59.625 281.625 C 59.71246 281.82154 59.769538 282.01197 59.71875 282.21875 C 61.10275 281.47775 63.3945 280.9375 65.0625 281.3125 C 65.2445 281.4045 64.784 281.7545 64.875 281.9375 C 65.063 282.1305 65.443 281.9325 65.625 282.125 C 66.736 283.229 62.37875 283.6175 64.59375 285.1875 C 65.43175 285.7485 66.56425 284.44675 67.03125 284.34375 C 67.12325 284.25275 67.03125 284.62675 67.03125 284.71875 C 67.03125 284.90075 66.8465 285.0955 66.9375 285.1875 C 67.4955 285.2915 68.1295 285.0955 68.6875 285.1875 C 69.0575 285.1875 69.50275 285.29025 69.59375 285.65625 C 69.78175 285.83825 69.03575 286.033 69.21875 286.125 C 69.49675 286.306 69.97275 285.8392 70.34375 286.03125 C 70.71475 286.12225 72.11325 287.38525 73.40625 286.28125 C 73.58825 286.09925 73.21825 285.65275 73.40625 285.46875 C 74.23825 284.90975 74.13 285.83925 74.5 286.03125 C 76.624 286.86325 76.99 286.01445 78.75 286.9375 C 79.121 287.1195 78.283 290.648 78.75 290.75 C 79.395 290.842 81.802 290.642 81.25 292.5 C 80.509 294.527 77.91725 294.636 76.53125 295.375 L 74.59375 297.40625 C 74.22375 297.58825 73.5855 297.03945 73.3125 297.3125 L 74.125 299.53125 C 74.216 300.27125 73.69075 301.011 73.59375 301.75 C 73.50175 302.393 73.49675 303.0375 73.21875 303.6875 C 73.12675 303.9715 72.74725 303.97325 72.65625 304.15625 C 72.10425 305.26025 73.12225 304.42075 73.03125 305.34375 C 72.94025 306.64075 70.06375 305.8065 70.34375 307.5625 C 70.62375 309.5085 72.01175 308.5895 70.71875 311.1875 C 69.60775 313.3055 69.15625 313.1105 67.03125 312.5625 C 66.19325 312.3685 65.6435 312.272 64.8125 312 C 64.6235 312 64.24675 311.7132 64.34375 311.90625 C 64.34375 311.99725 65.80925 314.86675 65.90625 314.96875 C 65.90625 315.15075 65.2605 317.07325 65.8125 318.28125 C 65.9975 318.65125 66.515 319.14006 67 319.5625 L 137.21875 319.5625 C 137.6533 319.14612 138.09642 318.72963 138.5 318.3125 C 139.423 317.3885 139.79625 315.79975 140.90625 314.96875 C 141.08925 314.86775 143.96875 314.2225 143.96875 313.9375 C 144.06475 313.2885 142.654 313.399 142.375 312.75 C 142.193 311.92 143.50725 311.46425 144.15625 310.90625 C 146.65125 308.87725 152.2925 309.52675 155.4375 308.59375 C 156.2695 308.41175 157.09725 307.02225 157.65625 306.65625 C 158.39125 306.00725 159.95075 305.626 160.96875 305.25 C 162.07875 304.794 166.07025 303.2135 166.53125 302.1875 C 167.45925 300.6165 165.97375 298.501 166.34375 298.125 C 166.80575 297.659 167.9995 297.865 168.1875 297.125 C 168.3715 296.568 167.99225 296.11325 167.53125 295.65625 L 167.15625 295.65625 C 165.67625 295.28125 164.014 294.442 162.625 295.375 C 162.351 295.558 162.745 296.284 162.375 296.375 C 161.448 296.651 159.8615 294.8125 158.9375 294.8125 C 158.1065 294.8125 157.45975 295.273 156.71875 295.375 C 156.16575 295.467 156.063 294.433 155.875 294.25 C 155.414 293.886 154.68025 293.7095 154.03125 293.4375 C 151.16625 294.2685 151.3485 292.96625 151.8125 292.03125 L 151.8125 291.9375 C 151.3465 291.6635 151.61725 290.8135 151.15625 290.4375 C 150.87725 290.1655 150.336 290.18475 149.875 290.09375 C 149.687 290.09375 149.4035 290.18475 149.3125 290.09375 C 148.2985 289.17275 147.3845 288.05425 145.8125 287.78125 C 144.7015 287.59925 145.15625 289.71875 145.15625 289.71875 C 144.13825 289.62775 143.304 288.87675 142.375 288.96875 C 142.101 288.96875 142.12175 289.53125 141.84375 289.53125 C 141.28975 289.44025 140.9895 288.7785 140.4375 288.6875 C 139.8795 288.5955 139.52175 289.1655 138.96875 289.0625 C 137.76675 289.0625 138.2115 287.8705 137.5625 287.3125 C 136.2695 286.2085 135.077 287.8595 133.875 286.9375 C 133.779 286.9375 132.87225 284.80875 132.78125 284.71875 C 131.57925 283.79575 129.51775 284.2575 128.21875 283.0625 C 128.03675 282.8795 128.30975 282.40175 128.21875 282.21875 C 128.03675 282.02475 127.4905 283.058 126.9375 282.875 C 125.7355 282.316 128.42475 281.20325 127.59375 280.28125 C 127.31375 279.91525 126.74225 279.723 126.28125 279.625 C 126.19025 279.625 126.27625 280.091 126.09375 280 C 126.09375 280 125.08425 279.09025 124.53125 278.53125 C 122.77225 278.99825 120.201 279.08645 119 278.4375 C 118.534 278.1595 118.2455 277.50375 117.6875 277.21875 C 117.3165 276.94575 116.58575 277.50195 116.21875 277.125 C 115.11075 275.84 116.8705 275.5625 114.1875 275.9375 C 113.8175 276.0295 113.432 276.13325 113.25 276.40625 C 113.062 276.59125 113.528 277.21875 113.25 277.21875 C 112.508 277.21875 110.49 275.27575 109.75 275.09375 C 109.841 274.99175 109.90625 274.80975 109.90625 274.71875 C 109.35325 273.61075 107.4275 273.80975 106.6875 273.71875 C 106.3175 273.71875 105.9335 273.62675 105.5625 273.71875 C 105.3805 273.80975 105.40675 274.17925 105.21875 274.28125 C 102.17175 275.20625 96.15575 272.22925 93.84375 270.65625 C 93.56775 270.47525 92.9955 271.12275 92.8125 270.84375 C 92.6255 270.75175 93.188 270.47425 93 270.28125 C 92.448 269.73425 91.33925 270.29975 90.78125 269.84375 C 90.22925 269.37775 90.15 268.27575 89.5 268.09375 C 88.76 267.89975 88.116 268.8125 87.375 268.8125 C 86.817 268.8125 86.52475 268.27575 85.96875 268.09375 C 85.41675 267.99175 84.2115 268.27855 83.5625 268.1875 C 80.9715 267.8115 82.37225 267.7125 79.78125 267.0625 C 79.32025 266.9715 79.12225 267.966 78.65625 267.875 C 76.34425 267.327 76.52625 263 74.03125 263 C 73.29125 263 72.82875 264.2785 72.09375 264.1875 C 71.62675 264.0975 72.5575 262.99075 72.1875 262.71875 C 71.9795 262.57925 71.7795 262.55338 71.5625 262.59375 z ", "transform", "translate(74.5,128)", 1, "state"], ["rx", "23.7", "ry", "12", "y", "364", "x", "81.82", "height", "26", "width", "47.4", 1, "plaque-inner"], ["y", "384", "x", "107", 1, "text"], ["d", "M 246.71875 241.90625 C 245.32875 241.90625 244.2035 243.12875 242.8125 243.21875 C 241.9825 243.30975 238.741 242.91075 238 243.46875 L 236.8125 245.96875 C 235.3325 246.80175 234.58375 244.87325 233.84375 244.78125 C 232.36375 244.59725 233.6665 245.52025 232.1875 244.78125 C 232.0945 245.14625 232.1845 245.60475 232 245.96875 C 231.909 246.34675 231.6195 246.624 231.4375 247 C 231.4375 247.182 233.19875 248.47375 232.09375 248.84375 C 230.15675 249.30975 230.788 246.63675 229.125 247.84375 C 227.837 248.76575 229.5035 249.783 229.6875 250.25 C 229.7785 250.616 229.21875 250.885 229.21875 251.25 C 229.31875 251.625 229.692 251.82175 229.875 252.09375 C 229.964 252.46975 229.20775 252.83925 228.84375 252.65625 C 228.19375 252.28025 228.58375 250.7795 227.84375 250.6875 C 225.33875 250.2315 226.5435 252.08 225.0625 251.625 C 222.6595 251.067 224.1455 249.21425 222.9375 249.03125 C 221.3665 248.75725 222.375 251.2545 222.375 251.4375 C 222 253.0995 219.78125 253.6495 219.78125 255.6875 C 219.78125 256.6095 221.6365 256.2295 220.0625 257.4375 C 219.5065 257.9035 219.34375 256.341 218.96875 255.875 C 218.69475 255.6 218.0275 255.7822 217.9375 255.40625 C 217.8455 255.04125 218.50175 254.78225 218.59375 254.40625 C 218.59375 254.22425 218.4155 254.03125 218.3125 254.03125 C 217.2985 253.65525 215.80525 253.3965 215.15625 252.1875 C 215.06525 251.8225 215.34375 251.43025 215.34375 251.15625 C 215.34375 250.59925 215.434 250.061 215.25 249.5 C 215.149 249.41 214.96425 249.5945 214.78125 249.6875 C 214.31525 250.0635 213.966 250.41625 213.5 250.78125 C 213.043 251.15525 212.313 251.34725 212.125 251.90625 C 212.03 252.27025 212.841 252.44925 212.75 252.90625 C 212.75 253.37425 210.1545 256.0625 210.0625 256.0625 C 209.2295 256.0625 208.61225 254.943 207.78125 255.125 C 206.57325 255.399 204.07925 257.25775 203.15625 255.59375 C 198.90225 258.08975 201.29475 256.99775 202.59375 259.21875 C 202.77575 259.59275 202.40855 260.22675 202.6875 260.59375 C 202.9665 261.24275 203.87825 261.34925 204.15625 261.90625 C 204.61725 262.73825 201.6495 265.12875 201.1875 265.21875 C 200.9085 265.31075 200.74775 264.75 200.46875 264.75 C 200.00775 264.842 199.15625 264.8465 199.15625 265.3125 C 198.96925 266.7925 202.038 267.97975 202.5 268.71875 C 202.779 269.27775 202.875 270.04225 202.875 270.78125 C 202.784 271.05725 201.93475 270.56975 201.84375 270.84375 C 201.74675 271.02775 202.02855 271.2215 201.9375 271.3125 C 201.6595 271.7675 201.21375 272.0735 200.84375 272.4375 C 200.56475 272.9945 201.4705 273.24725 201.5625 273.53125 C 201.5625 273.71325 201.09375 273.72425 201.09375 273.90625 C 201.00275 275.20625 203.4235 276.978 204.4375 277.25 C 204.9955 277.444 205.6295 277.15625 206.1875 277.15625 C 206.7465 277.06625 207.407 276.69475 207.875 276.96875 C 209.263 277.98275 206.1075 280.11725 206.5625 281.78125 C 207.9535 281.59625 210.08425 281.67375 211.28125 280.46875 C 212.02125 279.82875 212.475 278.3365 213.125 277.6875 C 213.399 277.4135 214.13225 277.53325 214.40625 277.15625 C 214.68925 276.88425 214.43205 276.3015 214.625 275.9375 C 214.805 275.5625 217.1985 274.1875 217.5625 274.1875 C 218.4965 274.1875 220.43925 275.10925 220.90625 275.65625 C 220.99725 275.84925 221.2545 275.93475 221.4375 275.84375 C 221.6325 275.74075 221.3695 275.3125 221.5625 275.3125 C 222.2965 275.3125 224.59 277.692 224.875 277.875 C 225.525 278.342 226.0725 278.90075 226.8125 279.09375 C 227.0965 279.18475 226.5395 278.34375 226.8125 278.34375 C 227.2795 278.34375 227.56525 278.90075 228.03125 279.09375 C 228.12125 279.18475 228.19025 278.90625 228.28125 278.90625 C 228.56525 279.00825 228.942 279.102 229.125 279.375 C 231.437 281.503 230.053 283.975 232 286.75 C 233.015 288.322 233.283 288.98975 233 290.84375 C 233 291.39175 232.283 292.21525 232.75 292.40625 C 233.49 292.68125 234.40875 292.12475 234.96875 292.59375 C 235.42475 292.86675 234.59095 293.59375 234.875 293.96875 C 235.241 294.51575 236.159 294.249 236.625 294.625 C 236.989 294.897 236.99725 295.4495 237.28125 295.8125 C 237.46325 295.9975 237.807 295.8145 238 296 C 238.274 296.284 239.39175 297.47975 238.84375 298.21875 C 238.65175 298.40175 237.9105 298.68925 238.1875 298.78125 C 240.0325 299.52325 241.15125 298.42425 242.90625 299.90625 C 243.92125 300.73725 243.9155 302.293 244.9375 303.125 C 245.1215 303.227 245.5055 302.9402 245.6875 303.03125 C 246.3375 303.40825 246.97425 303.783 247.53125 304.25 C 248.81925 305.263 247.52105 304.99425 248.625 306.65625 C 249.185 307.30725 250.19675 307.3775 250.84375 307.9375 L 252.25 309.875 C 252.808 310.253 254.476 310.064 255.125 310.625 C 255.671 311.183 255.57525 312.3695 256.40625 312.5625 C 257.14825 312.7445 257.794 311.65175 258.625 311.46875 C 259.55 311.37675 260.294 312.3695 261.125 312.5625 C 261.956 312.7445 260.006 310.98425 262.5 311.90625 C 263.422 312.27025 265.385 315.23875 265.75 316.34375 C 265.841 316.62775 265.5708 317.0965 265.84375 317.1875 C 269.45475 317.6565 266.20525 315.1585 269.53125 317.5625 C 270.2667 318.07851 269.16504 319.11198 268.8125 319.5625 L 270.5 319.5625 C 271.67184 318.83276 272.32674 317.33404 273.90625 319.5 C 273.91791 319.51784 273.92549 319.54449 273.9375 319.5625 L 292.5625 319.5625 C 292.5725 319.5454 292.65025 319.41513 292.65625 319.40625 C 293.92239 318.07443 294.81631 318.81299 295.90625 319.5625 L 306.65625 319.5625 C 305.40306 318.41691 303.71574 318.2023 302.9375 317.09375 C 302.6535 316.82075 303.0312 316.17925 302.65625 315.90625 C 301.73325 315.16625 298.6685 314.705 297.5625 314.25 C 296.1725 313.781 295.696 312.74075 294.5 312.09375 C 291.082 310.33975 286.462 310.5355 283.125 308.3125 C 279.616 305.9085 286.563 304.99925 284.25 302.40625 C 283.418 301.47825 282.024 302.50275 281.375 302.59375 C 278.412 303.04975 273.71475 303.86725 271.21875 301.28125 C 271.03675 301.09925 271.30425 300.52675 271.03125 300.34375 C 270.56525 299.87775 269.7335 299.8035 269.1875 299.4375 C 267.5135 298.1385 265.399 296.3845 264.375 294.4375 C 263.362 292.5925 261.57925 285.27325 260.28125 284.15625 C 259.08425 283.14325 258.7285 283.604 257.4375 282.875 C 256.1435 282.135 249.65175 277.52575 249.09375 276.59375 C 248.80875 276.04575 247.6305 271.05175 247.8125 270.59375 C 248.4615 269.02275 250.684 270.0225 250.125 267.4375 C 250.034 266.7865 249.1215 266.5295 248.5625 266.0625 C 248.3795 266.0625 248.18475 266.216 248.09375 266.125 C 247.99175 265.943 248.09875 265.7795 248.28125 265.6875 C 248.64525 265.4025 248.27625 264.64625 248.09375 264.28125 C 247.89975 264.09925 247.807 264.74725 247.625 264.65625 C 247.249 264.47425 247.622 263.46875 247.15625 263.46875 C 247.11025 263.46875 247.0853 263.49705 247.0625 263.53125 C 247.23939 263.27426 247.45371 262.95309 247.53125 262.71875 C 247.71425 262.34275 247.35475 261.7905 247.71875 261.6875 C 248.09475 261.4145 248.56325 261.9025 249.03125 261.8125 C 250.51225 261.5285 251.701 260.046 253 259.5 C 253.555 259.307 254.1875 259.5615 254.5625 259.1875 C 254.9275 258.8225 254.4815 257.80425 254.9375 257.53125 C 255.7675 257.16725 257.53125 257.35825 257.53125 258.28125 C 258.40034 257.11433 258.45803 256.51322 260.125 258.09375 C 260.491 258.54975 260.46425 258.919 260.28125 259.375 C 263.51625 259.566 259.84125 257.3715 258.90625 256.8125 C 258.26825 256.4465 259.27575 255.23725 259.09375 254.78125 C 258.89975 254.31425 257.4435 255.61325 257.8125 254.40625 C 258.0865 253.57625 259.8375 252.809 259.1875 252.25 C 258.7215 251.887 256.58825 252.07275 256.78125 250.96875 C 256.96525 249.48575 259.28475 249.87725 259.46875 248.03125 C 257.15675 247.84825 254.84125 247.648 252.53125 247.375 C 250.12725 247.01 249.67225 246.82025 247.90625 245.53125 C 247.72325 245.34025 247.43575 245.71425 247.34375 245.53125 C 247.15175 245.15725 247.61955 244.785 247.4375 244.5 C 246.6975 243.395 245.50075 244.697 245.96875 242.75 C 246.05975 242.384 247.08275 241.90625 246.71875 241.90625 z M 221.375 312.75 C 220.543 313.765 215.4525 317.93075 214.0625 317.84375 C 212.3985 317.84375 211.74725 315.909 211.65625 316 C 211.38325 316.274 211.84205 316.636 211.75 317 C 211.659 317.651 210.99725 318.11 210.90625 318.75 C 210.88547 319.09928 210.88421 319.30521 210.875 319.5625 L 225.53125 319.5625 C 225.40367 319.40779 225.26939 319.08205 225.15625 318.40625 C 225.15625 318.13125 225.806 318.03275 225.625 317.84375 C 225.158 317.29475 223.84925 317.4625 223.65625 316.8125 C 223.47425 316.1635 225.06325 316.3605 225.15625 315.8125 C 225.71325 313.7735 221.66 314.04 221.375 312.75 z M 226.28125 319.40625 C 226.18874 319.40935 226.10583 319.48629 226 319.5625 L 226.46875 319.5625 C 226.41302 319.44621 226.34819 319.404 226.28125 319.40625 z ", "transform", "translate(74.5,128)", 1, "state"], ["rx", "23.7", "ry", "12", "y", "397", "x", "81.82", "height", "26", "width", "47.4", 1, "plaque-inner"], ["y", "417", "x", "107", 1, "text"], ["d", "M 63.71875 281.1875 C 62.299656 281.221 60.75675 281.69425 59.71875 282.25 C 59.70457 282.3192 59.66095 282.37317 59.625 282.4375 L 59.625 319.5625 L 66.96875 319.5625 C 66.49313 319.1545 65.9932 318.6739 65.8125 318.3125 C 65.2605 317.1045 65.90625 315.15075 65.90625 314.96875 C 65.80925 314.86675 64.34375 312.0285 64.34375 311.9375 C 64.24675 311.7445 64.6235 312 64.8125 312 C 65.6435 312.272 66.19325 312.3685 67.03125 312.5625 C 69.15625 313.1105 69.60775 313.3055 70.71875 311.1875 C 72.01175 308.5895 70.62375 309.5085 70.34375 307.5625 C 70.06375 305.8065 72.94025 306.64075 73.03125 305.34375 C 73.12225 304.42075 72.10425 305.26025 72.65625 304.15625 C 72.74725 303.97325 73.12675 303.9715 73.21875 303.6875 C 73.49675 303.0375 73.50175 302.393 73.59375 301.75 C 73.69075 301.011 74.216 300.27125 74.125 299.53125 L 73.3125 297.3125 C 73.5855 297.0395 74.22375 297.5883 74.59375 297.40625 L 76.53125 295.375 C 77.91725 294.636 80.509 294.527 81.25 292.5 C 81.802 290.642 79.395 290.842 78.75 290.75 C 78.283 290.648 79.121 287.1195 78.75 286.9375 C 76.99 286.0145 76.624 286.8632 74.5 286.03125 C 74.13 285.83925 74.23825 284.90975 73.40625 285.46875 C 73.21825 285.65275 73.58825 286.1305 73.40625 286.3125 C 72.11325 287.4165 70.71475 286.12225 70.34375 286.03125 C 69.97275 285.83925 69.528 286.30605 69.25 286.125 C 69.067 286.033 69.78175 285.83825 69.59375 285.65625 C 69.50275 285.29025 69.0575 285.1875 68.6875 285.1875 C 68.1295 285.0955 67.4955 285.2915 66.9375 285.1875 C 66.8465 285.0955 67.03125 284.90075 67.03125 284.71875 C 67.03125 284.62675 67.12325 284.25275 67.03125 284.34375 C 66.56425 284.44675 65.463 285.7485 64.625 285.1875 C 62.41 283.6175 66.736 283.26025 65.625 282.15625 C 65.443 281.96325 65.063 282.13045 64.875 281.9375 C 64.784 281.7545 65.2445 281.4045 65.0625 281.3125 C 64.6455 281.2188 64.191781 281.17634 63.71875 281.1875 z ", "transform", "translate(74.5,128)", 1, "state"], ["rx", "23.7", "ry", "12", "y", "430", "x", "81.82", "height", "26", "width", "47.4", 1, "plaque-inner"], ["y", "450", "x", "107", 1, "text"], ["d", "m 258.25,127.31 c -0.94,1.76 -3.39,4.75 -3.88,6.22 -0.19,0.83 1.02,1.58 0.75,2.41 l -2.03,1.75 c -0.74,0.37 -2.23,-0.46 -2.59,0.38 l 0.91,3.62 c 0,0 -0.47,2.75 -0.47,2.84 l 0.31,3.44 c -0.11,0.37 -0.57,0.47 -0.66,0.84 -0.83,2.49 -2.14,5.06 -2.97,7.66 -0.56,1.66 3.34,0.76 2.69,5.28 -0.64,4.35 -3.16,0 -6.94,2.41 -1.21,0.74 -3.26,3.86 -3.53,5.34 -0.09,0.47 0.48,0.85 0.38,1.22 -0.09,1.02 -1.38,1.67 -1.38,2.69 0,11.19 1.38,-8.25 1.38,2.94 0,0.55 -0.66,0.92 -0.66,1.47 -0.09,0.65 0.28,1.23 0.38,1.88 0,0.55 -0.47,1.19 -0.38,1.75 0.1,1.38 1.6,2.58 1.78,3.97 0.18,2.03 -1.31,4.65 -0.84,6.59 0.55,2.12 4.06,1.94 4.44,4.25 l -1.03,3.69 c -0.73,0.65 -2.56,0.2 -2.47,1.12 0.47,3.97 2.86,2.95 1.84,8.22 l 0.09,2.69 c -0.85,2.13 -3.81,2.3 -4,2.94 -0.09,0.19 0.41,0.28 0.41,0.56 0.18,0.37 0.34,0.85 0.16,1.22 -0.27,0.55 -1.19,0.64 -1.38,1.28 -0.55,1.67 2.04,5.36 0,8.22 -0.83,1.2 -1.19,0.29 -1.47,-0.62 -0.55,0.09 -1.5,-0.74 -1.88,-0.28 0,0 1.12,4.17 1.22,5.28 0,0.65 -0.93,2.28 -0.38,2.84 3.52,3.51 2.58,-2.21 4.25,-0.09 1.2,1.48 -1.38,4.74 -1.19,6.12 0,0.56 -0.08,1.19 0.19,1.56 0.28,0.28 0.89,-0.09 1.09,0.19 0.64,1.01 0.11,3.23 0.56,4.06 0.29,0.46 0.66,1 1.12,1.38 0.18,0.09 0.53,0 0.62,0.19 0.09,0.09 -0.28,0.18 -0.28,0.38 0,0.09 1.13,1.57 1.31,2.03 0.18,0.37 -0.09,0.85 0.09,1.22 0.38,0.47 1.11,0.45 1.47,0.91 0.56,0.64 0.35,1.94 1.09,2.22 0.37,0.09 0.94,-0.18 1.12,0.19 0.37,0.65 0.65,1.57 0.19,2.22 -0.28,0.56 -1.56,-0.17 -1.84,0.47 -0.37,0.75 2.21,1.83 1.47,2.12 -0.83,0.36 -2.13,-1.47 -2.5,-0.62 -0.19,0.18 0.29,1.1 1.03,2.31 -1.39,-0.28 -3.16,-0.68 -4.19,0.62 1.03,-0.74 2.61,-0.38 3.81,-0.19 0.09,0.19 0.47,0.38 0.47,0.56 -0.09,0.56 -0.66,0.92 -0.66,1.47 0.09,1.8 1.5,1.79 0.38,3.16 2.04,-1.85 0.18,-1.64 0.09,-3.59 0,-0.46 0.47,-0.85 0.56,-1.22 1.3,2.03 2.94,4.34 2.94,4.34 -0.18,0.47 -0.91,0.75 -0.91,1.31 -0.1,0.56 0.44,1 0.44,1.56 0,0 -1.65,0.28 -1,0.66 0.37,0.18 0.9,-0.09 1.28,-0.09 0.65,0.09 1.29,0.53 2.03,0.53 2.32,0 1.7,-1.56 3.91,-1.38 0.28,0 1.76,0.94 2.22,0.47 0.56,-0.54 1.03,-1.2 1.12,-1.94 0.09,-2.41 -2.97,-1.3 -0.56,-4.81 0.27,-0.47 0.35,-1.13 0.91,-1.31 0.65,-0.18 1.47,0.37 1.94,-0.09 0.27,-0.47 -0.74,-1 -0.56,-1.56 0.09,-0.38 0.67,-0.09 1.03,-0.09 0.47,0 0.82,0.18 1.28,0.09 0.19,0 1.04,-0.18 1.69,-0.56 0.27,-0.09 -0.3,1.31 0.53,0.66 0.46,-0.47 0.56,-0.93 1.5,-1.03 0.09,0 -0.18,0.38 -0.09,0.47 0,0 1.56,-0.18 1.56,0.09 0.1,0.2 -0.19,0.38 -0.19,0.56 0.09,0.18 0.38,0.28 0.47,0.19 1.57,-1.48 1.66,-4.53 1.94,-6.47 0.46,-3.14 0.01,2.11 1.03,-0.94 0.18,-0.28 -0.47,-0.66 -0.28,-0.94 0.09,-0.27 0.81,0.02 0.81,-0.25 0.28,-1.21 -1.27,-2.69 -0.53,-3.44 0.28,-0.27 0.73,0.1 0.91,-0.09 0.1,-0.18 -1.19,-2.22 -1,-2.78 0.09,-0.73 0.47,-1.48 0.84,-2.12 0.09,-0.09 0.53,-0.09 0.44,-0.28 -0.37,-0.46 -1.28,-0.45 -1.28,-1 -0.1,-0.74 1.12,-1.1 1.12,-1.75 0,-0.74 -1.51,-1.23 -1.88,-1.69 -0.19,-0.18 -0.55,-0.53 -0.28,-0.53 0.65,-0.28 1.76,0.55 2.22,0 0.65,-0.84 -1.37,-3.35 -1.28,-3.81 0.1,-0.37 1,0.3 1.19,-0.06 0.27,-0.47 -0.44,-2.16 -0.81,-2.44 -0.55,-0.37 -2.4,-0.07 -1.94,-0.62 0.46,-0.55 1.39,0.47 2.12,0.47 1.01,0 0.16,-0.57 0.53,-0.94 0.1,-0.09 0.56,0.18 0.56,0 -0.65,-1.48 -1.83,-1.84 -3.31,-1.47 -0.28,0 0,0.53 -0.19,0.53 -0.27,0.1 -0.28,-0.44 -0.47,-0.53 -0.09,0 -0.19,0.28 -0.28,0.28 -0.27,0 -0.57,-0.03 -0.66,-0.22 -0.36,-0.83 4.34,-0.16 4.53,-0.16 0.09,0 0.19,-0.19 0.28,-0.28 0.19,-0.09 0.56,0.09 0.47,0 0,-0.28 -0.74,-0.28 -0.56,-0.38 0.19,-0.19 1.58,0.54 1.22,-0.56 0,-0.28 -1.03,-0.47 -0.75,-0.56 0.65,-0.09 1.48,0.21 2.03,-0.16 1.67,-1.21 1.38,-5.28 1.38,-5.28 1.48,-0.18 0.2,2.97 1.12,3.34 0.27,0.18 -0.47,-0.85 -0.19,-1.03 0.46,-0.19 0.75,1.56 0.94,1.19 0.27,-0.65 -0.02,-1.48 0.34,-2.12 0.38,-0.64 1.14,-1 1.78,-1.38 0.19,-0.18 0.75,0.1 0.66,-0.09 0,-0.65 -0.57,-1.22 -0.84,-1.78 -0.09,-0.09 -0.37,-0.34 -0.28,-0.34 0.74,-0.27 1.84,0.36 2.31,-0.28 0.27,-0.47 -0.63,-1.4 -1.19,-1.31 -0.4,0.05 -0.61,0.44 -0.81,0.81 -0.19,0.33 -0.39,0.66 -0.69,0.78 -0.46,0.28 -1.1,-0.27 -1.56,0 -0.37,0.28 -0.01,1.29 -0.47,1.47 -0.65,0.28 -1.29,-0.18 -2.03,-0.38 -0.36,-0.09 -0.74,-0.65 -1.19,-0.47 -0.2,0.09 0.52,0.57 0.34,0.75 -0.27,0.28 -1,0.47 -1.19,0.19 -0.19,-0.46 0.85,-1 0.56,-1.28 -0.46,-0.46 -1.31,0.19 -1.88,0 -0.55,-0.28 -0.73,-1.31 -1.28,-1.31 -0.46,-0.09 0.65,1.03 0.28,1.22 -0.84,0.28 -1.76,-0.94 -2.69,-0.84 -0.56,0.18 -1.48,0.93 -2.22,0.47 -0.18,-0.19 -0.66,-0.46 -0.47,-0.56 0.64,-0.36 1.49,-0.37 2.22,-0.47 0.28,0 0.56,0.37 0.66,0.19 0.28,-0.46 -0.19,-1.38 0.28,-1.47 0.55,-0.09 0.65,1.09 1.19,1.09 0.84,0 1.2,-1.01 1.94,-1.19 0.55,-0.19 3.24,3.07 4.34,0.94 0.29,-0.46 -1.09,-0.38 -1.38,-0.84 -0.37,-0.55 -0.11,-1.38 -0.47,-2.03 -0.09,-0.18 -0.9,0.19 -0.81,-0.09 0.27,-0.46 0.9,-0.93 1.38,-0.75 0.63,0.28 0.77,1.13 1.12,1.69 0.09,0.18 0,0.35 0,0.44 0.27,0.37 0.81,0.3 0.72,0.94 0,0.65 -0.65,2.03 0.09,2.03 0.74,0 1.38,-0.57 2.03,-0.66 0.37,-0.09 0.84,0.37 1.03,0.09 0,-0.09 -0.56,-0.91 -0.47,-1 2.6,-1.2 1.75,-2.05 2.59,-2.97 0.36,-0.28 0.47,-0.85 0.94,-0.94 0.09,0 0.91,1.02 1,0.09 0.29,-2.49 -0.74,-1.46 -2.12,-3.03 -0.37,-0.28 -0.08,-1.13 -0.53,-1.31 -0.38,-0.19 -0.56,0.84 -0.84,0.75 -0.55,-0.37 -0.66,-1.19 -1.03,-1.75 -0.27,-0.37 -1.37,-0.76 -0.91,-0.94 0.55,-0.19 1.39,1.12 1.75,0.66 2.51,-2.78 -2.22,-0.94 -2.31,-0.94 -0.19,-0.09 0.27,-0.47 0.09,-0.66 -0.09,-0.18 -0.47,0.19 -0.56,0.09 -0.56,-0.37 -1.12,-0.73 -1.41,-1.28 -0.18,-0.37 0.2,-1.03 -0.16,-1.22 -0.92,-0.55 -2.87,0 -3.88,0 -0.28,0 -0.1,-0.62 -0.38,-0.72 -0.19,-0.09 -0.47,0.19 -0.47,0 -0.09,-0.55 0.44,-1.1 0.34,-1.66 -0.09,-0.55 -0.73,-0.85 -0.91,-1.31 -0.1,-0.19 -0.1,-0.47 0,-0.66 0.09,-0.09 0.56,-0.07 0.47,-0.16 0,-0.19 -0.38,0.18 -0.47,0 -0.19,-0.37 -0.1,-0.85 -0.19,-1.22 -0.18,-0.37 -0.19,-0.82 -0.19,-1.19 0,-0.19 0.47,-0.09 0.38,-0.28 -0.1,-0.37 -0.84,-0.48 -0.75,-0.94 0,-0.28 0.94,0.28 0.94,-0.09 0.28,-2.03 -3.35,-3.98 -1.22,-4.72 0.74,-0.28 1.6,1.31 2.16,0.75 0.55,-0.55 -0.47,-1.48 -0.84,-2.12 -0.1,-0.09 -0.38,0.19 -0.38,0.09 -0.18,-0.55 -0.18,-1.11 -0.09,-1.66 0.09,-0.47 0.47,-0.84 0.56,-1.31 0.09,-0.74 -0.09,-1.48 0,-2.22 0,-0.1 0.28,-0.1 0.28,0 0.09,0.09 0.56,0.01 0.47,-0.09 -1.11,-1.29 -3.64,-1.76 -2.16,-2.88 0.56,-0.37 1.41,-0.25 2.06,-0.34 0.27,0 0.71,0.37 0.81,0.09 0.37,-0.46 0,-1.23 0.28,-1.69 0.18,-0.18 0.1,0.75 0.28,0.75 0.74,0.19 0.28,-1.57 0,-2.22 -0.18,-0.27 -0.38,-0.56 -0.47,-0.84 0.37,-0.09 1.4,-0.83 1.12,-0.28 -0.09,0.28 -0.75,0.1 -0.84,0.38 0,0.28 0.57,0.37 0.84,0.28 0.27,-0.09 0.45,-0.47 0.62,-0.66 0.46,-0.64 1.32,-1.1 1.59,-1.84 0.18,-0.65 -1.5,0.09 -2.06,-0.38 -0.36,-0.28 1.05,0.03 1.41,-0.34 0.27,-0.28 0.1,-0.94 0.28,-1.31 0.11,-0.09 0.47,0.09 0.47,0 -0.09,-0.28 -0.74,-0.38 -0.56,-0.56 0.29,-0.28 0.83,0.27 1.03,0.09 0.18,-0.28 -0.5,-0.56 -0.41,-0.84 0.09,-0.18 0.48,-0.15 0.66,-0.06 -0.33,-0.16 -0.68,-0.28 -0.47,-0.28 0.65,-0.09 1.31,0.84 1.88,0.56 0.65,-0.37 0.72,-1.32 0.81,-1.97 0.09,-0.56 -0.46,-1.29 0,-1.66 0.37,-0.27 1.04,1.12 1.31,0.66 0.28,-0.65 -1.12,-1.39 -0.75,-1.94 0.37,-0.46 1.22,0.56 1.78,0.38 0.45,-0.18 0.34,-0.94 0.62,-1.31 0.28,-0.56 1.37,-0.35 1.66,-0.72 0.27,-0.19 -0.09,-0.76 0.09,-1.03 l 0.09,0 c 0,-0.1 0,-0.19 0.09,-0.19 0.27,-0.18 0.18,1.12 0.47,0.94 0.65,-0.28 -0.28,-1.78 0.38,-1.88 0.19,-0.1 0.18,0.56 0.38,0.56 1.1,-0.18 1.29,-4.7 1.84,-5.81 0.37,-0.83 2.32,-3.25 2.22,-3.34 -0.74,-1.67 -3.81,-1.84 -3.72,-4.06 0.09,-1.85 2.89,-2.58 2.34,-4.25 -0.28,-0.74 -0.85,-1.41 -1.5,-1.88 -0.18,-0.09 -0.75,0.22 -0.75,-0.06 0.38,-1.38 2.51,-0.95 3.25,-1.41 0.19,-0.1 -0.18,-0.44 -0.09,-0.53 0.19,-0.09 0.28,0.43 0.38,0.34 0.55,-0.46 -0.47,-1.1 -0.56,-1.19 -0.19,0 -0.56,0 -0.47,-0.09 0.56,-0.28 1.88,0.08 1.69,-0.47 -0.19,-1.02 -2.69,-0.64 -2.5,-1.66 0.09,-0.28 0.34,0.47 0.62,0.56 0.55,0.28 1.23,0.35 1.88,0.53 -0.1,-0.09 -0.19,-0.18 -0.19,-0.28 -0.18,-0.55 0.38,-1.1 0.47,-1.75 0.09,-0.18 0,-0.35 0,-0.53 0,-0.28 -0.39,-0.84 -0.19,-0.84 1.37,0.28 2.02,2.48 3.97,1.28 0.46,-0.28 -0.27,-1.38 0.19,-1.66 0.65,-0.36 1.48,0.28 2.22,0.19 0.19,0 0.26,-0.47 0.44,-0.56 0.47,-0.1 0.74,0.85 1.12,0.66 0.36,-0.18 0.66,-0.66 0.94,-1.03 -1.11,-2.41 -3.17,-3.41 -4,-6.38 -0.03,-0.17 0.09,-0.84 0.22,-1.59 l -36.47,0 z M 276.56,171 c 0.18,0.19 -0.27,0.62 -0.09,0.62 0.18,0 0.65,-0.09 0.56,-0.28 -0.04,-0.15 -0.25,-0.24 -0.47,-0.34 z m -30.88,94.88 c -0.03,0.04 -0.06,0.05 -0.09,0.09 0.09,0 0.09,0 0.09,-0.09 z m 4.88,-45.66 c 1.06,0.02 2.17,0.39 3,0.72 0.09,3.52 0.09,5.53 -2.69,7.84 -0.65,0.56 -1.01,1.31 -1.75,1.59 -0.65,0.09 -1.32,-0.65 -1.97,-0.56 -1.01,0.18 -1.36,3.98 -3.31,2.78 -0.55,-0.28 1,-1.85 1,-3.06 0,-0.65 -2.11,-4.72 0.56,-5.09 0.65,-0.09 1.29,0.84 1.84,0.47 L 247.72,221.5 c 0.74,-0.97 1.78,-1.3 2.84,-1.28 z m 8.81,6.25 c 0.18,1.76 0.83,3.14 -0.56,4.53 -0.27,0.28 -0.66,0.47 -0.84,0.84 -0.45,1.01 -0.34,2.2 -0.72,3.31 l -1.22,2.69 c -2.4,-0.83 1.21,-10.18 3.34,-11.38 z", "transform", "translate(74.5,0)", 1, "state"], ["rx", "23.7", "ry", "12", "y", "133", "x", "403.83", "height", "26", "width", "47.4", 1, "plaque-inner"], ["y", "153", "x", "429", 1, "text"], ["d", "m 298.82,276.14 c -1.2,-0.18 -2.4,-0.83 -3.61,-1.01 -0.27,0 -1.38,0.09 -2.03,0 0,-0.47 0,-0.93 0.09,-1.48 0,-0.47 0.74,-1.01 0.36,-1.39 0.38,-0.46 -0.18,-1.2 -0.18,-1.85 -0.09,-0.56 0.18,-1.39 -0.18,-1.76 -0.83,-0.83 -3.23,0.1 -3.7,-1.57 -0.27,-1.02 0.65,-2.12 0.65,-3.33 0.09,0.09 0.09,0.09 0.18,0.18 2.87,1.39 1.02,-2.31 0.83,-2.68 -0.09,-0.18 -0.18,-0.74 -0.46,-0.56 -0.47,0.19 -0.38,1.02 -0.83,1.11 -0.28,0.09 -0.09,-0.65 -0.09,-0.92 0.09,-0.65 0.27,-1.3 0.27,-1.86 0.09,-0.56 -0.47,-1.29 0,-1.66 0.09,-0.09 0.27,-0.18 0.36,-0.18 -0.09,-0.19 -0.46,-4.17 0.47,-3.79 0.56,0.18 0.18,1.11 0.47,1.57 0.83,1.94 4.81,-2.87 4.99,-2.87 1.95,-0.56 -0.27,2.5 0.09,2.96 0.38,0.46 1.11,0.09 1.75,-0.09 -0.18,0 -0.27,0 -0.27,-0.09 -0.18,-0.47 0.38,-1.02 0.09,-1.39 -0.18,-0.28 -0.74,0.46 -0.83,0.19 -0.18,-0.37 0.56,-0.65 0.56,-1.02 0.09,-2.12 -1.3,-1.48 0.46,-2.77 0.38,-0.37 1.48,-0.28 1.77,0 0.18,0.18 -0.28,1.02 -0.09,0.83 0.36,-0.37 0.36,-1.2 0.83,-1.48 0.36,-0.18 0.83,0 1.2,0 0.47,0.28 2.69,0.83 2.69,0.83 0.18,0.56 -0.28,1.2 -0.19,1.85 0,0.46 0.74,0.92 0.56,1.39 -0.18,0.37 -0.83,-0.1 -1.2,0 -0.56,0.09 1.38,0.46 1.29,1.01 0,0.19 -0.09,0.28 -0.09,0.37 0.38,0.09 0.47,0.93 0.92,1.02 1.12,0.28 2.78,-1.3 3.23,0.83 0.19,0.74 -2.03,4.44 -2.77,4.07 -0.65,-0.36 -0.65,-1.57 -1.39,-1.85 -0.83,-0.28 -0.74,4.53 -1.01,5.08 -0.47,1.21 -1.21,2.04 -2.49,2.04 -0.65,0 -2.04,-1.01 -1.85,-0.38 0.28,0.65 1.75,0.28 2.13,1.02 0,0.09 0,0.18 0,0.27 0.09,0 0.18,0 0.18,0 0.37,0 0.47,0.65 0.74,0.65 1.01,-0.27 1.75,-1.85 2.78,-1.48 0.55,0.27 0.83,1.11 1.48,1.21 0.36,0.09 0.46,-0.56 0.73,-0.74 1.67,3.42 -0.36,0.46 0.28,1.75 0.56,1.01 2.31,5.27 -1.11,4.9 -0.74,-0.09 -1.38,-0.65 -2.12,-0.83 -0.28,0 -0.74,0.47 -1.02,0.18 -0.74,-0.55 1.86,-0.36 0.38,-1.2 -2.31,-1.21 0,0.83 -0.74,0.83 -0.27,0 -0.92,-2.78 -0.92,-2.87 -0.28,-0.65 -1.21,-1.01 -1.39,-1.75 0,-0.09 0.09,-0.09 0.09,-0.09 -0.74,0.27 -1.75,0.46 -1.75,0.56 -0.18,0.36 0.92,0 1.1,0.36 0.09,0.27 -0.55,0.37 -0.55,0.65 -0.1,0.56 0,1.1 0.18,1.57 0.09,0.28 0.55,0.37 0.55,0.65 0,1.01 -1.67,1.38 -1.85,2.4 0,0.36 0.74,-0.18 1.01,0 0.65,0.46 1.21,1.11 1.3,1.85 0.09,0.38 -0.65,-0.74 -1.01,-0.65 -0.47,0.19 -1.03,1.02 -1.3,1.39 z m -91.92,-93.77 c -0.09,0.83 -0.28,2.31 -0.28,2.31 0,0 0.19,-1.48 0.28,-2.31 z m 1.38,-9.06 c -1.1,2.31 0.47,-0.56 0.74,0.83 0,0.18 -0.46,0.18 -0.46,0.28 0.19,0.37 0.93,0.27 0.93,0.64 0,0.65 -0.19,1.76 -0.84,1.76 -0.55,-0.09 0.1,-1.2 0,-1.76 -0.27,-0.92 -3.05,-1.94 -0.37,-1.75 z m 108.02,87.48 v 0.102 c 1.02,-0.74 2.59,-0.38 3.69,-0.19 0.09,0.19 0.47,0.38 0.47,0.56 -0.09,0.56 -0.65,0.92 -0.65,1.48 0.09,1.85 1.57,1.76 0.27,3.23 -0.46,0.47 -1.2,0.56 -1.66,1.01 -0.83,0.94 0.18,1.21 1.02,1.67 l 0.55,1.39 c -0.74,0.65 -2.77,0.37 -2.77,1.21 0.09,1.01 2.31,2.4 0,2.49 -0.83,0 -1.48,-0.56 -2.22,-0.92 0.36,0.18 0.83,0.36 0.92,0.09 0.18,-0.65 -0.36,-1.39 -0.83,-1.95 -0.18,-0.18 -0.28,0.38 -0.47,0.38 -0.55,0 -0.92,-0.47 -1.38,-0.56 -0.47,-0.09 -0.94,0.28 -1.3,0.18 -0.18,0 -0.18,-0.27 -0.18,-0.37 0.55,-1.48 -1.11,-1.1 -1.02,-1.39 0.09,-0.36 0.74,-0.27 0.83,-0.65 0.38,-2.68 -0.46,-1.94 -1.94,-3.23 -0.18,-0.18 -0.74,-0.65 -0.47,-0.74 0.83,-0.46 5.27,0.56 4.44,-2.31 -0.18,-0.65 -1.2,-0.46 -1.75,-0.83 -0.28,-0.18 0.65,0.18 0.92,0.18 0.47,0.19 0.92,0.37 1.39,0.37 1.39,0 3.6,-0.65 3.14,2.22 -0.09,0.46 -1.3,0.92 -0.92,1.2 1.66,1.39 1.1,-1.94 0.83,-3.23 -0.09,-0.56 -1.57,-0.09 -1.39,-0.56 0.09,-0.37 0.28,-0.55 0.47,-0.84 z m 1.85,14.8 h -0.466 c 0,0.09 0,0.19 0,0.19 0.09,0.18 0,0.27 0,0.36 -0.28,0.18 -0.65,0.47 -0.74,0.65 -0.27,0.18 -0.46,0.37 -0.55,0.65 l -0.1,0.09 c 0,0.09 0,0.09 0,0.09 0,0 0,-0.09 0,-0.18 -0.56,0 -1.2,-0.09 -1.48,0 -0.47,0.09 -0.83,0.92 -1.39,0.83 -0.74,-0.09 -1.12,-1.03 -1.75,-1.39 -0.47,-0.27 -1.11,-0.47 -1.48,-0.83 -0.28,-0.18 0.74,-0.37 1.66,-2.04 1.29,1.12 3.24,1.39 4.34,2.31 0.1,0.09 0.1,0.09 0.1,0.09 -0.56,-0.83 -1.76,-1.47 -1.29,-2.21 0.18,-0.38 0.74,-0.19 1.01,-0.28 0.65,0.65 2.04,0.56 2.22,1.39 0,0.09 0,0.18 -0.09,0.27 z m -27.93,-13.5 c 0,0.18 0,0.47 0,0.74 -0.09,-0.56 -0.09,-1.1 0,-0.74 z m 16.19,-17.66 c 0.27,1.02 -0.65,6.01 -2.31,5.46 -0.56,-0.19 -1.02,-0.83 -1.66,-0.83 0.65,-0.83 -2.13,-0.19 -2.87,0 -0.65,0.18 -1.2,0.74 -1.85,0.83 -0.28,0 -0.47,-0.46 -0.74,-0.46 -0.74,-0.09 -1.48,0 -2.13,0.18 -0.27,0.09 -0.09,0.65 -0.36,0.83 -1.3,0.56 0.09,-3.15 -1.77,1.76 -0.09,0.09 0.47,2.68 0.38,2.68 -3.05,-0.1 -1.39,-5.83 0.36,-6.48 1.57,-0.74 3.79,0.09 5.37,-0.55 2.13,-1.02 1.66,-3.98 3.61,-5.09 0.65,-0.28 1.48,-0.1 2.12,-0.37 0.65,-0.37 1.02,-1.67 1.76,-1.67 1.38,0 -0.74,1.02 -0.83,1.85 -0.19,1.3 0.46,0.46 0.92,1.85 z m 8.51,31.45 -0.83,0.09 c 0.64,0.18 1.2,0.46 1.66,0.92 h 0.092 c -0.27,-0.36 -0.65,-0.65 -0.92,-1.01 z", 1, "state"], ["rx", "23.7", "ry", "12", "y", "166", "x", "403.83", "height", "26", "width", "47.4", 1, "plaque-inner"], ["y", "186", "x", "429.5", 1, "text"], ["d", "m 294.69,127.31 c -0.13,0.75 -0.22,1.42 -0.19,1.59 0.83,2.96 2.89,4 4,6.41 0.38,-0.65 0.82,-1.21 2.12,-0.47 0.65,0.37 0.26,1.66 0.91,2.03 0.56,0.37 1.3,-0.37 1.94,-0.19 0.28,0 0.29,0.57 0.47,0.75 0.56,0.28 0.58,-0.86 1.12,0.06 1.02,2.13 0.26,3.98 0.62,4.91 0.29,0.83 2.8,-0.99 1.69,1.69 -0.27,0.65 -1.22,0.44 -1.78,0.81 -0.56,0.37 -1.19,0.67 -1.56,1.22 -0.18,0.19 0.09,0.63 -0.09,0.81 -0.18,0.19 -0.63,-0.28 -0.72,-0.09 -0.27,0.65 -0.38,1.48 -0.38,2.22 0,0.46 0.28,0.95 0.09,1.41 -0.09,0.83 -1.22,1.2 -1.41,1.94 -0.18,0.56 0.28,1.19 0.09,1.66 -0.46,1.01 -1.47,0.83 -1.56,2.22 -0.09,0.28 0.47,0.57 0.47,0.94 -0.28,1.75 -2.78,1.49 -2.88,3.06 -0.09,0.65 -0.57,2.31 -0.66,2.41 -0.36,0 -0.82,-0.94 -1.19,-0.66 -0.83,0.74 0.46,2.57 -0.38,3.12 -0.27,0.18 -0.84,-1 -0.75,-0.62 0,0.47 0.66,0.63 0.84,1.09 0.83,3.05 -0.26,1.02 -1.56,2.5 -0.27,0.37 0.28,1.31 -0.09,1.31 -0.56,-0.09 -0.28,-1.22 -0.75,-1.31 -0.74,-0.19 -1.67,0.1 -2.03,0.75 -1.48,2.5 1.66,0.74 1.47,2.22 -0.18,0.93 -2.57,2.49 -2.66,3.5 -0.47,6.11 0.08,-0.19 1,2.12 0.09,0.09 -0.83,1.76 -0.09,2.22 0.09,0.1 0.28,-0.38 0.38,-0.28 0.18,0.27 -0.08,0.94 0.28,1.03 0.18,0.09 -0.18,-0.84 0.09,-0.84 0.28,-0.09 0.38,0.29 0.47,0.56 0.55,1.48 -0.12,3.88 0.16,4.44 0.18,0.37 0.76,0.19 1.03,0.47 0.38,0.46 0.57,1.01 0.84,1.47 0.09,0.18 -0.09,0.47 0,0.66 0.19,0.28 0.54,0.28 0.72,0.47 0.09,0.09 -0.34,0 -0.34,0.09 -0.09,0.18 0.07,0.35 0.16,0.53 0.47,0.56 1.5,0.85 1.41,1.5 -0.09,0.56 -1.57,0.1 -1.66,0.66 -0.19,0.74 0.91,1.2 1.09,1.84 0.09,0.28 -0.37,0.54 -0.28,0.91 0.09,0.18 0.66,0.19 0.66,0.47 -0.1,1.2 -1.03,-0.08 -0.66,0.94 0.09,0.37 0.56,0.63 0.47,0.91 -0.09,0.37 -1,-0.09 -1.09,0.19 -0.09,2.4 0.92,2.7 1.66,3.72 0.18,0.18 -0.74,0.35 -0.56,0.62 0.09,0.47 0.29,0.85 0.56,1.22 2.04,2.68 0.47,-0.1 2.41,-0.47 0.38,0 -0.36,1.03 0,1.31 0.56,0.28 1.19,-0.19 1.84,-0.19 0.55,0.09 0.83,1 1.28,1 0.47,0 0.66,-0.56 1.03,-0.56 0.18,-0.09 0,0.28 0.09,0.38 0.27,0.09 0.47,0 0.75,-0.09 0.09,-0.09 0.1,-0.63 0.19,-0.44 0.92,2.03 -0.56,2.38 -0.19,2.47 0.18,0 2.29,-1.57 2.56,-1.75 0.09,-0.1 0.28,-0.57 0.38,-0.66 -0.46,1.39 -1.66,2.98 0.56,3.81 0.38,0.18 1.09,-0.65 1.28,-0.28 0.18,0.56 -1.28,1.38 -0.72,1.56 0.55,0.28 0.44,-1.28 1,-1.38 0.47,-0.1 0.09,0.91 -0.09,1.28 -0.27,0.46 -0.81,0.67 -1.28,1.03 -0.13,0.2 -0.53,0.58 -0.66,0.72 2.87,-1.1 1.77,-2.95 3.25,-3.88 0.46,-0.27 -0.74,1.23 -0.28,1.5 0.65,0.37 1.48,-0.1 2.12,-0.47 0.47,-0.18 0.63,-0.94 1,-1.22 0.56,-0.46 3.06,-0.72 3.34,-1.09 0.27,-0.28 -0.65,-0.75 -0.38,-1.03 0.47,-0.36 1.2,-0.1 1.84,-0.19 0.19,0 0.57,0.09 0.66,-0.09 0.19,-0.28 -0.18,-0.63 -0.09,-0.81 0.09,-0.19 0.09,0.44 0.28,0.53 0.09,0.09 2.51,-1.38 2.69,-1.66 0.09,-0.09 -0.37,-1.93 0.56,-1.75 0.1,0 1.1,0.87 1.91,1.19 l 0,-2.12 c -0.44,-0.21 -0.87,-0.42 -0.72,-0.81 0.08,-0.29 0.37,-0.38 0.72,-0.38 l 0,-67.59 3.97,0 c -0.16,-0.33 -0.38,-0.7 -0.59,-1.06 l -32.22,0 z", "transform", "translate(74.5,0)", 1, "state"], ["rx", "23.7", "ry", "12", "y", "199", "x", "403.83", "height", "26", "width", "47.4", 1, "plaque-inner"], ["y", "219", "x", "430", 1, "text"], ["d", "m 285.19,272.47 c -2.98,0.22 -6.06,2.65 -8.25,3.94 -0.83,0.47 -1.85,0.3 -2.5,0.84 -1.57,1.39 -1.94,3.6 -2.41,3.69 -3.42,0.83 -6.64,2.33 -9.88,3.62 -0.84,0.37 -1.39,1.38 -2.22,1.56 -0.47,0.18 -0.94,-0.28 -1.41,-0.09 -0.83,0.46 1.11,2.5 0.28,2.69 0.19,1.48 1.65,4.36 1.84,5.28 0.27,2.22 -2.68,3.68 -2.03,5.44 0.37,1.1 3.88,1.58 3.88,2.97 0,1.38 -1.08,1.83 -0.25,2.84 0.27,0.47 0.91,0.66 1.09,1.22 0.27,0.46 -0.09,1.1 0,1.56 0.09,0.27 0.47,0.19 0.56,0.38 0.46,0.65 -0.66,2.23 -0.94,2.78 -0.56,0.83 0.85,1.29 1.12,2.12 0.18,0.46 -0.47,1.01 -0.19,1.38 0.36,0.56 1.19,0.39 1.56,0.75 1.11,1.03 0.93,5.75 0.19,7.5 2.5,-0.37 -0.47,-2.4 2.12,-1.94 1.66,0.19 0.27,0.92 1.28,1.66 1.48,1.2 2.71,0.35 3.91,1.09 0.38,0.27 0.29,0.76 0.47,1.03 0.18,0.09 0.25,-0.19 0.34,-0.19 0.28,-0.09 0.57,-0.28 0.66,-0.09 0.28,0.27 0,0.76 0.28,1.03 0,0 2.03,-1.12 2.5,-0.84 2.5,1.21 -1.03,1.67 -0.84,2.88 l 2.12,1.28 c 0.29,0.36 0.84,2.78 2.22,2.22 0.38,-0.18 0.29,-0.82 0.56,-1.09 0.47,-0.37 1.38,-0.19 1.66,-0.75 0.09,-0.18 -1.92,-2.22 -1.38,-2.31 1.39,-0.18 2.95,1.23 3.78,1.5 0.38,0.09 0.84,-0.09 1.22,-0.09 0.36,0 0.82,0.18 1.19,0 0.19,-0.09 0.08,-0.47 0.19,-0.66 0.09,-0.09 0.28,-0.09 0.28,0 1.1,2.22 0.38,0.83 -0.81,1.94 -0.37,0.28 0.91,0.38 1.28,0.66 0.27,0.28 0.2,0.72 0.47,1 0.18,0.18 0.47,0.28 0.66,0.28 2.68,-0.28 -0.38,-0.46 1.19,-1.09 0.19,-0.1 0.19,0.25 0.38,0.34 0.37,0.27 1.39,0.57 1.84,0.66 0.56,0.18 1.38,-0.08 1.84,0.28 0.09,0.09 0.94,2.32 1.03,2.41 0.36,0.28 1.09,0 1.47,0.38 0.36,0.46 0.1,1.28 0.47,1.75 0.19,0.27 0.82,-0.18 1.09,0.09 0.27,0.27 -0.18,0.93 0.09,1.22 1.48,1.2 2.69,-3.53 3.62,-2.88 0.55,0.36 0.53,1.2 1,1.66 0.09,0.09 0.47,-0.18 0.56,-0.09 0.09,0.18 -0.29,0.57 -0.09,0.66 0.46,0.09 0.92,-0.38 1.28,-0.19 0.65,0.27 0.09,2.04 0.09,2.22 0,0.47 0.85,-0.28 1.31,-0.38 0.37,-0.09 0.73,0.65 1.09,0.47 0.09,-0.1 1.2,-2.97 2.5,-3.25 0.36,-0.09 0.75,0.28 1.12,0.28 0.36,-0.09 0.54,-0.65 0.91,-0.56 0.74,0.09 1.23,1.12 1.97,1.12 0.55,0 1.01,-0.57 1.28,-1.03 0.09,-0.18 -0.47,-0.19 -0.47,-0.38 0.27,-1.3 0.85,0.01 1.22,-0.19 0.28,-0.09 0.26,-0.62 0.53,-0.62 1.39,-0.38 4.55,-0.3 5.75,0.62 0.28,0.28 0.2,0.94 0.56,1.12 0.02,0.01 0.04,0.02 0.06,0.03 l 0,-61 c -1.51,-2.16 -0.6,-0.28 -3.12,-1.38 -0.92,-0.36 -0.27,-1.56 -1.66,-1.09 -0.27,0.09 -0.28,0.56 -0.56,0.75 -4.25,2.5 -16.73,2.93 -22,2.19 -1.66,1.76 -4.28,2.8 -6.41,1.97 -1.85,-0.74 -1.47,-2.51 -2.03,-3.62 -0.18,-0.27 -0.81,-1 -0.44,-0.91 0.27,0 0.52,0 0.72,0.09 -0.47,-0.27 -1.01,-0.55 -1.56,-0.66 -0.42,-0.07 -0.86,-0.09 -1.28,-0.06 z m 4.06,1.34 c 0.09,0.27 0.27,0.66 0.91,1.12 0.19,0.09 0.18,-0.28 0.09,-0.38 -0.28,-0.37 -0.62,-0.57 -1,-0.75 z m -32.28,14.44 0,0.09 0.09,0 -0.09,-0.09 z m 1.47,0.47 0.09,0 -0.09,0 z", "transform", "translate(74.5,0)", 1, "state"], ["rx", "23.7", "ry", "12", "y", "232", "x", "403.83", "height", "26", "width", "47.4", 1, "plaque-inner"], ["y", "252", "x", "429.5", 1, "text"], ["d", "m 358.66,348.55 c 1.38,-5.46 4.43,-0.83 7.21,-4.35 0.18,-0.27 -0.09,-0.74 0.09,-1.01 0.27,-0.38 0.93,-0.18 1.21,-0.56 0,0 0.74,-2.87 0.74,-2.96 0.83,-1.48 3.04,-2.68 4.61,-3.42 -0.36,-0.47 -0.09,-1.3 -0.46,-1.75 -0.38,-0.38 -1.11,-0.09 -1.48,-0.38 -0.09,-0.09 -0.92,-2.31 -1.01,-2.4 -0.47,-0.37 -1.3,-0.09 -1.86,-0.27 -0.46,-0.09 -1.48,-0.38 -1.85,-0.65 -0.18,-0.09 -0.18,-0.47 -0.37,-0.36 -1.57,0.64 1.48,0.83 -1.2,1.11 -0.18,0 -0.47,-0.09 -0.65,-0.28 -0.27,-0.28 -0.18,-0.74 -0.46,-1.02 -0.38,-0.27 -1.67,-0.36 -1.3,-0.65 1.2,-1.11 1.94,0.28 0.83,-1.94 0,-0.09 -0.18,-0.09 -0.27,0 -0.1,0.18 0,0.56 -0.19,0.65 -0.36,0.18 -0.83,0 -1.2,0 -0.38,0 -0.83,0.18 -1.21,0.09 -0.83,-0.27 -2.4,-1.66 -3.79,-1.48 -0.55,0.09 1.48,2.13 1.39,2.31 -0.27,0.56 -1.2,0.37 -1.66,0.74 -0.27,0.27 -0.18,0.92 -0.56,1.1 -1.38,0.56 -1.94,-1.84 -2.22,-2.21 l -2.12,-1.3 c -0.18,-1.21 3.33,-1.66 0.83,-2.87 -0.47,-0.27 -2.5,0.83 -2.5,0.83 -0.28,-0.27 0,-0.74 -0.28,-1.01 -0.09,-0.18 -0.36,0 -0.65,0.09 -0.09,0 -0.18,0.27 -0.36,0.18 -0.18,-0.27 -0.09,-0.74 -0.47,-1.01 -1.2,-0.74 -2.4,0.09 -3.88,-1.1 -1.01,-0.74 0.38,-1.48 -1.29,-1.67 -2.6,-0.46 0.36,1.57 -2.13,1.95 -0.18,0.36 -0.27,0.65 -0.56,0.65 -1.2,0.27 -3.15,-4.81 -4.16,-1.95 -0.18,0.47 1.48,0.83 1.1,1.11 -1.1,0.92 -2.68,1.01 -3.78,1.66 -0.19,0.09 0,0.56 -0.19,0.65 -0.74,0.36 -1.75,-0.19 -2.31,0.27 -0.46,0.37 -0.27,1.1 -0.74,1.48 -0.18,0.18 -0.36,-0.47 -0.64,-0.38 -0.83,0.19 -0.93,1.3 -1.48,1.68 -0.28,0.27 -0.83,-0.19 -1.12,0.09 -0.27,0.18 0,0.74 -0.27,1.01 -0.38,0.47 -1.39,-0.36 -1.66,-0.36 -2.31,0.36 -2.69,2.12 -3.43,3.6 -0.18,0.38 -0.18,-0.92 -0.55,-1.2 -0.28,-0.38 -0.83,-0.47 -1.3,-0.56 -0.83,-0.18 0.92,2.77 2.78,3.98 0.18,0.09 0.83,0.18 0.92,0.74 0.27,1.3 -0.92,0.83 -1.11,1.84 -0.09,0.28 1.95,3.7 2.22,3.98 1.57,1.57 1.95,0.47 2.96,1.48 0.65,0.65 0.74,1.66 1.39,2.22 1.29,0.93 4.53,2.13 5.17,3.98 h 0.101 c 1.47,0.74 2.59,2.69 4.53,1.95 0.38,-0.09 0.28,-0.83 0.65,-0.83 0.65,0 1.3,0.83 1.95,0.64 l 0.74,-2.4 c 0.36,-0.27 1.01,0.38 1.2,0.1 0.18,-0.19 0,-2.87 0.09,-3.05 0.28,-0.28 0.83,-0.1 1.21,0.09 0.18,0.09 0,0.55 0.18,0.65 0.47,0 0.83,-0.56 1.3,-0.56 2.68,0 4.81,2.03 7.3,2.31 0.36,0 0.83,0.18 1.21,0.09 0.55,-0.27 0.73,-1.01 1.19,-1.21 0.65,-0.18 1.57,1.02 2.04,1.11 0.27,0 0.65,-0.56 0.92,-0.38 0.45,0.38 0.65,0.74 0.65,1.11 z", 1, "state"], ["rx", "23.7", "ry", "12", "y", "265", "x", "403.83", "height", "26", "width", "47.4", 1, "plaque-inner"], ["y", "285", "x", "429.5", 1, "text"], ["d", "m 319.28,334.19 c -0.82,-0.01 -1.6,0.08 -2.12,0.22 -0.28,0 -0.25,0.54 -0.53,0.62 -0.36,0.19 -0.95,-1.08 -1.22,0.22 0,0.18 0.56,0.16 0.47,0.34 -0.27,0.47 -0.73,1.03 -1.28,1.03 -0.74,0 -1.23,-1.03 -1.97,-1.12 -0.36,-0.09 -0.54,0.47 -0.91,0.56 -0.37,0 -0.76,-0.37 -1.12,-0.28 -1.3,0.28 -2.41,3.15 -2.5,3.25 -0.36,0.18 -0.73,-0.56 -1.09,-0.47 -0.47,0.09 -1.31,0.84 -1.31,0.38 0,-0.18 0.56,-1.95 -0.09,-2.22 -0.36,-0.19 -0.83,0.28 -1.28,0.19 -0.19,-0.09 0.18,-0.47 0.09,-0.66 -0.09,-0.09 -0.47,0.18 -0.56,0.09 -0.47,-0.46 -0.45,-1.29 -1,-1.66 -0.93,-0.65 -2.14,4.07 -3.62,2.88 -0.27,-0.28 0.18,-0.95 -0.09,-1.22 -0.27,-0.28 -0.9,0.18 -1.09,-0.09 -1.57,0.74 -3.79,1.93 -4.62,3.41 0,0.1 -0.75,2.97 -0.75,2.97 -0.28,0.38 -0.91,0.19 -1.19,0.56 -0.18,0.27 0.09,0.73 -0.09,1 -2.78,3.43 -5.83,-1.08 -7.12,4.38 0.09,1.2 -1.31,2.48 -0.75,3.41 0.83,1.39 1.76,2.57 2.88,3.78 0.18,-0.09 0.47,-0.15 0.84,-0.06 1.66,0.18 2.95,2.56 4.72,2.94 1.11,0.18 8.96,-1.2 8.59,-1.84 -0.37,-0.55 -1.66,-1.85 -0.47,-2.59 1.3,-0.92 4.16,-0.26 5.19,-1.28 0.36,-0.37 -0.09,-1.22 0.19,-1.69 0.74,-1.29 2.39,0.75 3.12,0.66 2.31,-0.37 0.18,-1.01 1.66,-1.94 0.38,-0.19 0.94,0.18 1.31,0.09 1.01,-0.47 0.64,-2.95 1.19,-3.69 1.39,-1.75 3.43,-0.09 5,-0.38 0.92,-0.09 1.48,-1.41 2.41,-1.41 2.31,0.09 0.93,1.85 2.69,2.41 0.2,0.13 0.46,-0.06 0.72,-0.22 l 0,-10.56 c -0.02,-0.01 -0.04,-0.02 -0.06,-0.03 -0.36,-0.18 -0.28,-0.84 -0.56,-1.12 -0.75,-0.58 -2.26,-0.83 -3.62,-0.84 z", "transform", "translate(74.5,0)", 1, "state"], ["rx", "23.7", "ry", "12", "y", "298", "x", "403.83", "height", "26", "width", "47.4", 1, "plaque-inner"], ["y", "318", "x", "429.5", 1, "text"], ["d", "m 320.12,344.59 c -0.92,0 -1.48,1.28 -2.41,1.38 -1.57,0.28 -3.61,-1.38 -5,0.38 -0.55,0.74 -0.17,3.22 -1.19,3.69 -0.38,0.09 -0.94,-0.29 -1.31,-0.09 -1.48,0.92 0.66,1.57 -1.66,1.94 -0.74,0.09 -2.38,-1.94 -3.12,-0.66 -0.27,0.47 0.18,1.32 -0.19,1.69 -1.02,1.02 -3.89,0.36 -5.19,1.28 -1.2,0.74 0.09,2.04 0.47,2.59 0.37,0.65 -7.49,2.03 -8.59,1.84 -1.76,-0.38 -3.06,-2.76 -4.72,-2.94 -0.38,-0.09 -0.66,0 -0.84,0.09 -1.3,0.56 0.01,3.5 -0.09,3.88 -0.55,1.01 -3.9,-0.46 -5.19,0.66 -0.56,0.46 2.22,0.27 2.31,1.84 0.18,1.86 -1.38,0.46 -2.03,1.75 -0.46,0.93 1.22,2.87 1.03,3.25 -0.83,1.38 -1.59,1.65 -3.25,3.5 l -0.09,0.09 c 0.18,-0.09 0.29,-0.19 0.47,-0.19 l 1.03,-0.09 c 0.38,0 1.09,2.86 3.03,4.44 2.5,2.04 4.62,3.16 6.56,5.66 0.28,0.37 2.13,0.07 2.31,0.16 0.74,0.27 1.32,0.95 1.97,1.22 1.29,0.56 5.36,0.45 6.56,-0.56 0.19,-0.18 0.27,-1.47 0.91,-1.47 1.77,-0.27 1.49,0.1 3.06,-1.66 0.28,-0.28 0.64,0.65 1.47,0 0.83,-0.65 1.39,-1.76 2.41,-2.31 2.13,-1.39 0.37,0 1.94,0.09 0.09,0 2.5,-0.75 2.59,-0.75 0.47,0 0.94,0.47 1.41,0.47 0.18,-0.1 0.25,-0.47 0.44,-0.56 0.56,-0.18 3.35,-0.48 3.53,-1.12 0.18,-0.37 -1.2,-0.82 0.47,-1.09 0.64,-0.09 1.29,0.57 1.84,0.38 1.76,-0.64 1.19,-3.99 1.66,-5 0.17,-0.26 0.61,-0.28 0.81,-0.53 l 0,-21.06 c -0.26,0.16 -0.51,0.35 -0.72,0.22 -1.76,-0.56 -0.37,-2.28 -2.69,-2.38 z", "transform", "translate(74.5,0)", 1, "state"], ["rx", "23.7", "ry", "12", "y", "331", "x", "403.83", "height", "26", "width", "47.4", 1, "plaque-inner"], ["y", "351", "x", "429", 1, "text"], ["d", "m 299.2,364.73 c 0,0.65 1.2,0.84 0.83,1.76 -0.09,0.18 -0.47,0.09 -0.56,0.18 -0.09,0.27 -0.38,1.02 -0.65,1.85 l 0.47,1.02 v 1.107 c 0.92,0.09 2.4,0.27 2.5,0.27 0.18,0.19 -0.27,0.47 -0.09,0.65 0.46,0.56 1.01,0.92 1.66,1.21 1.48,0.74 1.75,-1.76 2.77,-1.57 1.95,0.27 -0.09,1.29 0.56,1.57 1.48,0.74 0.18,-0.18 1.66,0 0.74,0.09 1.48,2.03 2.96,1.2 l 1.21,-2.49 c 0.74,-0.56 3.98,-0.18 4.81,-0.27 1.39,-0.09 2.5,-1.3 3.89,-1.3 0.36,0 -0.65,0.47 -0.74,0.83 -0.47,1.95 0.74,0.65 1.48,1.75 0.18,0.28 -0.28,0.65 -0.09,1.02 0.09,0.18 0.36,-0.19 0.55,0 1.77,1.29 2.22,1.48 4.63,1.85 2.78,0.38 5.64,0.47 8.51,0.92 0.74,0.09 1.48,0.65 2.22,0.74 0.74,0.09 1.48,-0.46 2.22,-0.36 0.46,0.09 0.74,0.74 1.2,0.74 0.19,0.09 0.09,-0.47 0.28,-0.56 0.46,-0.47 1.2,-0.65 1.66,-1.21 0.36,-0.27 0.09,-0.92 0.36,-1.2 1.76,-1.39 3.61,0.36 5.27,-0.38 0.56,-0.28 0.65,-1.11 1.21,-1.29 0.09,-0.09 3.15,0.36 3.24,0.27 0.27,-0.09 -0.29,-0.46 -0.38,-0.74 -0.18,-0.92 0.18,-1.48 0.83,-1.66 l 0,0 c 1.66,-1.85 2.4,-2.13 3.23,-3.51 0.19,-0.38 -1.47,-2.31 -1.01,-3.25 0.65,-1.29 2.22,0.1 2.04,-1.75 -0.09,-1.57 -2.87,-1.39 -2.31,-1.85 1.29,-1.12 4.62,0.36 5.17,-0.65 0.1,-0.37 -1.2,-3.32 0.1,-3.88 -1.12,-1.21 -2.04,-2.4 -2.87,-3.79 -0.74,-1.2 1.94,-3.14 0,-4.53 -0.27,-0.18 -0.65,0.38 -0.92,0.38 -0.47,-0.09 -1.39,-1.3 -2.04,-1.11 -0.47,0.19 -0.65,0.93 -1.19,1.21 -0.38,0.09 -0.84,-0.09 -1.21,-0.09 -2.5,-0.28 -4.62,-2.31 -7.3,-2.31 -0.47,0 -0.83,0.56 -1.3,0.56 -0.18,-0.1 0,-0.56 -0.18,-0.65 -0.38,-0.19 -0.92,-0.38 -1.21,-0.09 -0.09,0.18 0.09,2.86 -0.09,3.05 -0.18,0.27 -0.83,-0.38 -1.2,-0.1 l -0.74,2.4 c -0.65,0.19 -1.3,-0.64 -1.95,-0.64 -0.36,0 -0.27,0.74 -0.65,0.83 -1.94,0.74 -3.05,-1.21 -4.53,-1.95 h -0.101 c 0.1,0.29 0.19,0.56 0.19,0.83 -0.09,2.5 -0.65,1.95 -2.6,1.48 -0.18,0 -0.36,0.09 -0.46,0.28 -0.19,0.92 0.36,1.94 -0.56,2.68 -0.83,0.65 -4.71,1.57 -4.81,3.05 0,0 2.22,3.05 2.22,3.14 0.09,0.09 -1.21,1.2 -0.74,1.57 1.01,0.92 2.03,-0.47 1.2,2.59 0,0.18 -0.18,0.47 -0.36,0.47 -2.96,-0.83 -0.65,-2.31 -2.04,-2.4 -0.74,0 -1.39,0.65 -2.13,0.55 -0.36,-0.09 -0.27,-0.73 -0.55,-0.83 -0.56,-0.18 -1.11,0.28 -1.57,0.1 -0.18,-0.1 0.18,-0.64 0,-0.64 -1.12,0.09 -0.09,1.57 -0.38,1.66 -1.29,0.36 -3.42,-0.18 -4.62,0.27 -0.36,0.18 -0.18,0.83 -0.55,1.01 -0.38,0.28 -0.83,-0.18 -1.21,0.1 -0.27,0.09 0.09,0.55 -0.09,0.74 -0.09,0.09 -3.23,0.92 -3.61,0.73 -0.18,-0.18 0,-0.64 -0.18,-0.83 -0.09,-0.18 -0.56,-0.18 -0.65,-0.36 -0.09,-0.18 0.47,-0.09 0.38,-0.27 -0.38,-1.21 -2.96,0.27 -3.7,-0.56 0,0 0.18,-0.09 0.18,-0.18 -0.55,-0.38 0,1.2 -0.18,1.84 0,0.36 -1.75,2.5 -2.4,1.85 -0.37,-0.36 0.65,-0.93 0.36,-1.29 -0.09,-0.09 -0.36,0.27 -0.55,0.27 -0.18,0 -0.47,-0.09 -0.56,-0.27 -0.18,-0.28 0.47,-0.65 0,-1.02 -0.36,-0.27 -0.56,-0.74 -0.92,-0.92 -0.27,-0.18 -0.65,0.28 -1.01,0.18 -0.19,-0.18 0,-0.64 -0.19,-0.83 -0.46,-0.36 -0.36,1.3 -1.85,0.83 -0.09,-0.09 -0.18,-0.09 -0.27,-0.09 v 0.092 z", 1, "state"], ["rx", "23.7", "ry", "12", "y", "364", "x", "403.83", "height", "26", "width", "47.4", 1, "plaque-inner"], ["y", "384", "x", "429", 1, "text"], ["d", "m 306.68,372.78 c -0.09,0.36 0,0.83 -0.18,1.2 -0.09,0.38 -0.38,0.65 -0.56,1.03 0,0.18 1.75,1.48 0.65,1.84 -1.94,0.47 -1.3,-2.22 -2.96,-1.01 -1.29,0.92 0.38,1.94 0.56,2.4 0.09,0.36 -0.47,0.65 -0.47,1.01 0.1,0.38 0.47,0.56 0.65,0.83 0.09,0.38 -0.65,0.74 -1.01,0.56 -0.65,-0.38 -0.27,-1.85 -1.01,-1.95 -2.5,-0.46 -1.3,1.39 -2.78,0.93 -2.4,-0.56 -0.92,-2.42 -2.13,-2.6 -1.57,-0.27 -0.55,2.22 -0.55,2.4 -0.38,1.66 -2.6,2.22 -2.6,4.26 0,0.92 1.86,0.55 0.28,1.75 -0.56,0.47 -0.74,-1.11 -1.11,-1.57 -0.27,-0.27 -0.92,-0.09 -1.01,-0.47 -0.09,-0.36 0.56,-0.64 0.65,-1.01 0,-0.18 -0.18,-0.36 -0.28,-0.36 -1.01,-0.38 -2.49,-0.65 -3.14,-1.86 -0.09,-0.36 0.19,-0.74 0.19,-1.01 0,-0.56 0.09,-1.1 -0.09,-1.66 -0.1,-0.09 -0.28,0.09 -0.47,0.18 -0.47,0.38 -0.83,0.74 -1.3,1.1 -0.46,0.37 -1.2,0.56 -1.39,1.11 -0.1,0.36 0.73,0.56 0.64,1.01 0,0.47 -2.58,3.14 -2.68,3.14 -0.83,0 -1.48,-1.1 -2.31,-0.92 -1.21,0.27 -3.7,2.13 -4.62,0.47 -0.37,-0.56 -0.37,-1.21 -0.83,-1.67 -0.09,-0.18 -0.46,0.38 -0.56,0.19 -0.09,-0.28 0.37,-0.74 0.19,-1.03 -0.09,-0.27 -0.65,0 -0.83,-0.18 -0.56,-0.92 0.74,-0.83 0.64,-1.39 -0.09,-0.46 -0.64,-0.64 -0.64,-1.1 -0.09,-0.27 0.64,-0.83 0.28,-0.93 -1.21,-0.56 -3.79,-0.56 -4.62,0.74 -0.19,0.18 -0.1,0.36 -0.1,0.65 0.1,0.18 0.56,0.36 0.47,0.55 -0.56,1.11 -1.85,1.57 -2.96,1.3 -0.09,0 0.37,-0.18 0.37,-0.38 0,-1.2 0.92,-0.73 1.02,-1.01 0.46,-1.48 -0.74,-2.77 0.37,-4.16 0.65,-0.92 2.31,-0.92 2.68,-1.95 0.28,-0.55 -0.27,-1.38 0,-2.03 0.37,-0.74 1.67,-0.47 2.22,-1.12 0.65,-0.55 1.39,-2.4 2.22,-3.05 0.46,-0.37 0.92,0.65 1.01,-0.64 0,-0.47 -1.38,0.46 -1.48,0 -0.19,-0.47 0.55,-0.83 0.83,-1.21 0,0 0.18,0.09 0.18,0 0,-0.18 -0.37,-0.56 -0.18,-0.65 2.59,-0.74 1.48,2.78 4.62,-0.46 0.09,0 0.28,-0.19 0.37,-0.38 l 0.18,-0.18 c 0.18,-0.09 0.36,-0.09 0.56,0.09 0.09,0.09 -0.56,0.18 -0.47,0.38 0.27,0.55 4.54,-0.47 4.81,-0.47 1.85,-0.09 0.19,1.66 2.49,0.47 0.1,-0.1 -0.18,-0.56 0,-0.65 0.28,-0.2 1.3,-0.29 0.93,-0.38 -0.56,-0.09 -1.12,0.09 -1.67,0 -0.28,-0.09 1.29,-2.58 2.68,-1.2 0.18,0.18 -0.27,0.55 -0.18,0.83 0.09,0.18 0.46,0.27 0.65,0.18 0.18,-0.09 -0.1,-0.74 0,-0.56 0.36,0.19 0.36,0.83 0.73,1.02 0,0 3.05,-0.19 3.15,-0.19 0.93,0.19 1.58,1.12 2.41,1.57 v 0.092 c 0,0.65 1.2,0.84 0.83,1.76 -0.09,0.18 -0.47,0.09 -0.56,0.18 -0.27,0.47 -1.21,3.79 -1.01,3.89 0.18,0.09 3.23,0.36 3.33,0.36 0.18,0.19 -0.27,0.47 -0.09,0.65 0.46,0.56 1.01,0.92 1.66,1.21 1.48,0.74 1.75,-1.76 2.77,-1.57 0.28,0 0.47,0.09 0.65,0.18 l -0.09,0.83 c -0.09,0.27 -0.18,0.47 0.01,0.56 z", 1, "state"], ["rx", "23.7", "ry", "12", "y", "397", "x", "403.83", "height", "26", "width", "47.4", 1, "plaque-inner"], ["y", "417", "x", "429.5", 1, "text"], ["d", "m 358.1,374.9 c -0.65,-0.09 -2.22,-0.46 -2.59,-0.36 -1.02,0.18 0.36,1.48 -0.19,1.84 -0.46,0.19 -1.01,-0.09 -1.47,0.1 -0.19,0.1 0.09,0.46 -0.1,0.64 -0.93,0.74 -2.4,0.83 -3.33,1.67 -1.1,1.02 2.04,3.61 0.65,4.62 -3.23,2.31 -1.21,-1.57 -3.33,1.48 -0.28,0.38 0.83,0.47 1.01,0.92 0.18,0.38 -0.92,0.28 -0.92,0.65 0,0.19 0.92,1.39 0.56,1.85 -1.03,1.02 -2.51,-0.56 -3.43,-0.56 -1.39,0 1.3,1.3 -1.01,0.65 -0.65,-0.18 -1.48,-1.21 -1.76,-1.76 -0.19,-0.19 -0.38,-0.74 -0.47,-0.56 -0.36,0.56 -0.27,1.2 -0.65,1.66 -1.2,1.57 -2.86,0 -4.25,0.47 -0.18,0.09 0.18,0.46 0,0.64 -0.83,0.47 -2.49,0.38 -3.33,0 0,0 0,-0.09 0.09,-0.09 0.46,-0.46 1.01,-0.92 1.2,-1.39 3.23,0.19 -0.46,-2.03 -1.39,-2.59 -0.64,-0.37 0.38,-1.57 0.19,-2.03 -0.19,-0.47 -1.67,0.83 -1.3,-0.38 0.27,-0.83 2.04,-1.57 1.39,-2.13 -0.47,-0.36 -2.6,-0.18 -2.4,-1.29 0.18,-1.48 2.49,-1.12 2.68,-2.96 -0.09,0 -0.09,0 -0.18,0 0.56,0.09 1.11,0.18 1.76,0.27 0.74,0.09 1.48,0.65 2.22,0.74 0.74,0.09 1.48,-0.46 2.22,-0.36 0.46,0.09 0.74,0.74 1.2,0.74 0.19,0.09 0.09,-0.47 0.28,-0.56 0.46,-0.47 1.2,-0.65 1.66,-1.21 0.36,-0.27 0.09,-0.92 0.36,-1.2 1.76,-1.39 3.61,0.36 5.27,-0.38 0.56,-0.28 0.65,-1.11 1.21,-1.29 0.09,-0.09 3.15,0.36 3.24,0.27 0.27,-0.09 -0.29,-0.46 -0.38,-0.74 -0.27,-1.48 0.83,-1.85 2.22,-1.85 0.38,0 1.11,2.86 3.06,4.44 z", 1, "state"], ["rx", "23.7", "ry", "12", "y", "430", "x", "403.83", "height", "26", "width", "47.4", 1, "plaque-inner"], ["y", "450", "x", "430", 1, "text"], ["transform", "translate(-74.5,-128)", 1, "map-group", "enabled", 3, "click", "id"], ["d", "m 333.31,288.71 c 0.19,1.48 1.67,4.35 1.86,5.27 0.27,2.22 -2.69,3.7 -2.04,5.46 0.37,1.1 3.88,1.57 3.88,2.96 0,1.38 -1.1,1.85 -0.27,2.86 0.27,0.47 0.92,0.65 1.11,1.21 0.27,0.46 -0.09,1.1 0,1.57 0.09,0.27 0.47,0.18 0.56,0.36 0.46,0.65 -0.65,2.22 -0.92,2.78 -0.56,0.83 0.83,1.3 1.1,2.13 0.18,0.46 -0.47,1.02 -0.18,1.38 0.36,0.56 1.2,0.38 1.57,0.74 1.29,1.21 0.74,7.96 -0.38,8.14 -1.2,0.27 -3.15,-4.81 -4.16,-1.95 -0.18,0.47 1.48,0.83 1.1,1.11 -1.1,0.92 -2.68,1.01 -3.78,1.66 -0.19,0.09 0,0.56 -0.19,0.65 -0.74,0.36 -1.75,-0.19 -2.31,0.27 -0.46,0.37 -0.27,1.1 -0.74,1.48 -0.18,0.18 -0.36,-0.47 -0.64,-0.38 -0.83,0.19 -0.93,1.3 -1.48,1.68 -0.28,0.27 -0.83,-0.19 -1.12,0.09 -0.27,0.18 0,0.74 -0.27,1.01 -0.38,0.47 -1.39,-0.36 -1.66,-0.36 -2.31,0.36 -2.69,2.12 -3.43,3.6 -0.18,0.38 -0.18,-0.92 -0.55,-1.2 -0.28,-0.38 -0.83,-0.47 -1.3,-0.56 -0.83,-0.18 0.92,2.77 2.78,3.98 0.18,0.09 0.83,0.18 0.92,0.74 0.27,1.3 -0.92,0.83 -1.11,1.84 -0.09,0.28 1.95,3.7 2.22,3.98 1.57,1.57 1.95,0.47 2.96,1.48 0.65,0.65 0.74,1.66 1.39,2.22 1.48,1.02 5.46,2.4 5.36,4.81 -0.09,2.5 -0.65,1.95 -2.6,1.48 -0.18,0 -0.36,0.09 -0.46,0.28 -0.19,0.92 0.36,1.94 -0.56,2.68 -0.83,0.65 -4.71,1.57 -4.81,3.05 0,0 2.22,3.05 2.22,3.14 0.09,0.09 -1.21,1.2 -0.74,1.57 1.01,0.92 2.03,-0.47 1.2,2.59 0,0.18 -0.18,0.47 -0.36,0.47 -2.96,-0.83 -0.65,-2.31 -2.04,-2.4 -0.74,0 -1.39,0.65 -2.13,0.55 -0.36,-0.09 -0.27,-0.73 -0.55,-0.83 -0.56,-0.18 -1.11,0.28 -1.57,0.1 -0.18,-0.1 0.18,-0.64 0,-0.64 -1.12,0.09 -0.09,1.57 -0.38,1.66 -1.29,0.36 -3.42,-0.18 -4.62,0.27 -0.36,0.18 -0.18,0.83 -0.55,1.01 -0.38,0.28 -0.83,-0.18 -1.21,0.1 -0.27,0.09 0.09,0.55 -0.09,0.74 -0.09,0.09 -3.23,0.92 -3.61,0.73 -0.18,-0.18 0,-0.64 -0.18,-0.83 -0.09,-0.18 -0.56,-0.18 -0.65,-0.36 -0.09,-0.18 0.47,-0.09 0.38,-0.27 -0.38,-1.21 -2.96,0.27 -3.7,-0.56 0,0 0.18,-0.09 0.18,-0.18 -0.55,-0.38 0,1.2 -0.18,1.84 0,0.36 -1.75,2.5 -2.4,1.85 -0.37,-0.36 0.65,-0.93 0.36,-1.29 -0.09,-0.09 -0.36,0.27 -0.55,0.27 -0.18,0 -0.47,-0.09 -0.56,-0.27 -0.18,-0.28 0.47,-0.65 0,-1.02 -0.36,-0.27 -0.56,-0.74 -0.92,-0.92 -0.27,-0.18 -0.65,0.28 -1.01,0.18 -0.19,-0.18 0,-0.64 -0.19,-0.83 -0.46,-0.36 -0.36,1.3 -1.85,0.83 -1.01,-0.36 -1.66,-1.38 -2.68,-1.66 -0.1,0 -3.15,0.19 -3.15,0.19 -0.36,-0.19 -0.36,-0.84 -0.73,-1.02 -0.1,-0.18 0.18,0.47 0,0.56 -0.19,0.09 -0.56,0 -0.65,-0.18 -0.09,-0.28 0.36,-0.65 0.18,-0.83 -1.39,-1.39 -2.96,1.1 -2.68,1.2 0.55,0.09 1.11,-0.09 1.67,0 0.36,0.09 -0.65,0.18 -0.93,0.38 -0.18,0.09 0.1,0.55 0,0.65 -2.3,1.2 -0.64,-0.56 -2.49,-0.47 -0.27,0 -4.53,1.01 -4.81,0.47 -0.09,-0.19 0.56,-0.29 0.47,-0.38 -0.83,-0.65 -1.21,2.13 -1.21,-1.11 -0.09,-1.3 0.83,-2.5 0.92,-3.79 0,-0.18 -0.36,-0.18 -0.36,-0.47 -0.09,-0.46 0.09,-0.92 0.27,-1.39 l 1.3,-2.12 c 0.09,-0.56 0.18,-2.6 0.46,-3.23 0.74,-1.48 2.6,-2.6 3.61,-4.35 0.38,-0.65 -5.18,-1.3 -5.55,-1.57 -0.27,-0.28 -0.09,-0.83 -0.37,-1.11 -0.47,-0.38 -3.43,0.83 -3.61,0.55 -0.09,-0.27 0.28,-0.65 0.09,-0.83 -2.77,-2.5 -0.92,1.3 -2.03,0.09 -0.93,-0.92 -1.39,-3.05 -2.13,-3.51 -0.27,-0.28 -0.83,0 -1.01,-0.28 -1.02,-1.84 2.68,-2.59 1.38,-4.16 -0.18,-0.27 -2.4,-0.46 -2.87,-2.4 -0.83,-3.42 3.42,-3.23 2.12,-5.36 -0.27,-0.46 -1.1,-0.36 -1.29,-0.92 -0.09,-0.36 0.65,-0.74 0.56,-1.1 0,-0.28 -0.56,0.09 -0.74,-0.1 -0.1,-0.09 -1.39,-2.03 -1.3,-2.31 0.1,-0.37 0.74,-0.37 0.83,-0.74 0.28,-1.57 -2.41,-2.13 -1.57,-2.31 0.28,-0.1 0.47,0.27 0.65,0.27 l 1.76,-1.57 c 0.09,-0.47 -1.11,0.09 -0.74,-0.65 0.27,-0.65 0.92,-1.1 1.2,-1.75 0.83,-2.04 -1.2,-3.52 -1.76,-4.54 -0.09,-0.18 0.09,-0.47 0.19,-0.65 0,-0.18 -0.19,-0.46 0,-0.55 0.46,-0.28 1.01,0 1.57,-0.19 0.18,-0.09 -0.19,-0.65 0,-0.55 0.55,0.18 0.92,0.83 1.57,0.83 0.64,0.09 3.15,-0.74 3.42,-1.39 0.27,-0.65 -1.76,-0.74 -0.93,-1.3 1.48,-1.01 3.24,-1.39 2.87,-3.7 -0.09,-1.29 -3.51,-0.73 -2.68,-2.12 0.09,-0.28 0.55,0 0.55,-0.18 0.09,-0.28 -0.37,-0.56 -0.28,-0.84 0,-0.18 0.28,-0.18 0.47,-0.18 0.64,0 1.2,0.28 1.85,0.28 0.74,0 0.09,-1.48 0.38,-2.22 0.18,-0.65 1.75,-3.61 1.57,-5.18 0.27,-0.09 0.55,-0.27 0.83,-0.65 0.37,-0.36 -0.47,-0.18 -1.3,-0.18 l 0,0 c -0.18,-0.18 -0.47,-0.09 -0.65,-0.09 -0.18,0 -0.27,-0.09 -0.36,-0.18 -0.74,-0.93 1.29,-3.79 2.03,-4.17 0.47,-0.27 1.02,0.28 1.48,0.28 6.94,-0.28 -7.21,-0.83 3.34,-0.56 0.09,0 0.36,0.09 0.46,0.18 0.56,1.02 0.92,5.27 3.23,4.35 0.74,-0.28 -0.74,-6.66 1.39,-6.66 0.18,0 0.18,0.56 0.47,0.65 0.27,0.18 0.74,0.18 1.1,0.18 0.92,0.19 1.94,-0.74 2.78,-0.36 0.64,0.27 0.64,1.2 1.01,1.75 0.46,0.74 2.96,5.46 2.96,2.31 0,-0.65 -1.39,-0.47 -1.95,-1.01 -0.92,-0.83 -0.74,-2.96 -2.5,-3.23 -0.27,0 -2.4,0.46 -2.22,-0.83 0.09,-0.83 1.39,-3.43 0.56,-4.44 -0.28,-0.27 -2.31,0.74 -2.59,-0.27 -0.1,-0.19 0.55,0 0.64,-0.19 0.19,-0.18 -0.64,-0.55 -0.46,-0.55 0.92,-0.28 2.49,0.64 2.77,-1.21 0,-0.18 -2.12,-2.5 -2.31,-2.87 -0.27,-0.64 -0.36,-1.38 -0.36,-2.03 0.65,0.09 1.75,0 2.03,0 1.21,0.18 2.41,0.83 3.61,1.01 -0.09,0.27 -0.09,0.38 0.09,0.27 0.37,-0.27 0.56,-0.74 0.92,-0.83 0.19,0 -0.09,0.47 0,0.65 0.28,0.18 0.65,0.09 0.93,0.18 0.64,0.1 1.29,0.1 1.75,0.37 0.27,0.18 0.36,0.56 0.36,0.83 0,0.09 -0.18,0 -0.18,0 -0.18,0.09 -0.56,0.28 -0.36,0.36 0.09,0.19 0.55,-0.18 0.64,0 0.28,0.47 0.19,1.02 0,1.48 -0.18,0.47 -1.47,0.74 -1.1,1.21 0.47,0.65 2.22,-1.01 2.31,-0.18 0.09,0.55 -0.92,1.57 -0.37,1.76 0.64,0.27 0.64,-1.3 1.29,-1.39 0.56,-0.09 2.69,1.75 3.14,1.57 0.09,0 1.95,-2.13 2.59,-1.01 1.29,2.4 -5.17,4.9 -1.67,5.27 0.74,0.09 1.3,-0.83 2.04,-0.83 0.92,0.09 -0.09,2.77 1.94,1.38 0.47,-0.27 0.74,-2.59 1.57,-3.05 1.21,-0.64 2.51,-0.92 3.05,0.38 -0.09,-0.28 -0.18,-0.74 -0.09,-0.83 0.56,-0.65 1.3,-0.92 1.76,-1.48 0.55,-0.65 0.64,-1.66 1.2,-2.31 0.18,-0.18 1.39,0.27 2.49,0.65 0.47,-0.09 0.93,-0.19 1.12,-0.19 0.64,0 0.27,1.29 0.64,1.85 0.28,0.36 0.93,0.18 1.21,0.56 0.56,0.46 0.83,1.75 1.66,1.66 0.65,0 1.39,-0.47 2.13,-0.28 0.27,0.09 -0.38,0.56 -0.38,0.83 0.1,0.74 0.38,1.48 0.65,2.22 0.28,0.74 1.21,1.02 1.95,1.3 0.55,0.18 0.92,0.27 1.19,0.18 z m -8.42,-7.12 c 0.19,-0.83 -0.18,-1.85 0.1,-2.68 0.27,-0.83 3.05,1.57 2.5,0.74 -0.38,-0.56 -1.57,-0.28 -1.86,-0.93 -0.09,-0.55 0.74,-1.02 1.12,-1.48 0.36,-0.27 -0.28,1.12 0.09,1.21 0.65,0.18 1.3,-0.09 1.85,0.09 0.56,0.18 -0.74,0.92 -0.55,1.48 0.18,0.65 1.01,0.74 1.29,1.39 0.19,0.18 -1.01,1.1 -2.5,1.48 -0.74,0.28 -1.39,-0.83 -2.04,-1.3 z", 1, "state", "germany"], ["rx", "23.7", "ry", "12", "y", "307", "x", "277.83", "height", "26", "width", "47.4", 1, "plaque-inner", "germany"], ["y", "327", "x", "303", 1, "text", "germany"], ["rx", "23.7", "ry", "12", "y", "473", "x", "81.82", "height", "26", "width", "47.4", 1, "plaque-inner"], ["y", "493", "x", "107", 1, "text"], ["type", "checkbox", 1, "studisu-bl-checkbox", 3, "change", "focus", "blur", "id", "name", "checked"], [3, "id", "innerHTML"]],
        template: function KarteComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 2);
            i0.ɵɵlistener("mousemove", function KarteComponent_Template_div_mousemove_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.focusedRegion = null);
            });
            i0.ɵɵtemplate(1, KarteComponent_div_1_Template, 10, 14, "div", 3);
            i0.ɵɵelementStart(2, "div", 4);
            i0.ɵɵelement(3, "canvas", 5);
            i0.ɵɵelementStart(4, "div", 6);
            i0.ɵɵelement(5, "canvas", 5);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(6, "svg", 7, 0)(8, "filter", 8);
            i0.ɵɵelement(9, "feGaussianBlur", 9)(10, "feOffset", 10)(11, "feFlood", 11)(12, "feComposite", 12);
            i0.ɵɵelementStart(13, "feMerge");
            i0.ɵɵelement(14, "feMergeNode")(15, "feMergeNode", 13);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(16, "g", 14);
            i0.ɵɵlistener("click", function KarteComponent_Template_g_click_16_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleRegion(ctx.regionenKurz.BW));
            });
            i0.ɵɵelement(17, "rect", 15);
            i0.ɵɵelementStart(18, "text", 16);
            i0.ɵɵtext(19, "BW");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(20, "text", 17);
            i0.ɵɵtext(21);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "text", 18);
            i0.ɵɵtext(23);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(24, "path", 19);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(25, "g", 14);
            i0.ɵɵlistener("click", function KarteComponent_Template_g_click_25_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleRegion(ctx.regionenKurz.BY));
            });
            i0.ɵɵelement(26, "rect", 20);
            i0.ɵɵelementStart(27, "text", 21);
            i0.ɵɵtext(28, "BY");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(29, "text", 17);
            i0.ɵɵtext(30);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(31, "text", 18);
            i0.ɵɵtext(32);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(33, "path", 22);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(34, "g", 14);
            i0.ɵɵlistener("click", function KarteComponent_Template_g_click_34_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleRegion(ctx.regionenKurz.BE));
            });
            i0.ɵɵelement(35, "rect", 23);
            i0.ɵɵelementStart(36, "text", 24);
            i0.ɵɵtext(37, "BE");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(38, "text", 17);
            i0.ɵɵtext(39);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(40, "text", 18);
            i0.ɵɵtext(41);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(42, "path", 25);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(43, "g", 14);
            i0.ɵɵlistener("click", function KarteComponent_Template_g_click_43_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleRegion(ctx.regionenKurz.BB));
            });
            i0.ɵɵelement(44, "rect", 26);
            i0.ɵɵelementStart(45, "text", 27);
            i0.ɵɵtext(46, "BB");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(47, "text", 17);
            i0.ɵɵtext(48);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(49, "text", 18);
            i0.ɵɵtext(50);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(51, "path", 28);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(52, "g", 14);
            i0.ɵɵlistener("click", function KarteComponent_Template_g_click_52_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleRegion(ctx.regionenKurz.HB));
            });
            i0.ɵɵelement(53, "rect", 29);
            i0.ɵɵelementStart(54, "text", 30);
            i0.ɵɵtext(55, "HB");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(56, "text", 17);
            i0.ɵɵtext(57);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(58, "text", 18);
            i0.ɵɵtext(59);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(60, "path", 31);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(61, "g", 14);
            i0.ɵɵlistener("click", function KarteComponent_Template_g_click_61_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleRegion(ctx.regionenKurz.HH));
            });
            i0.ɵɵelement(62, "rect", 32);
            i0.ɵɵelementStart(63, "text", 33);
            i0.ɵɵtext(64, "HH");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(65, "text", 17);
            i0.ɵɵtext(66);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(67, "text", 18);
            i0.ɵɵtext(68);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(69, "path", 34);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(70, "g", 14);
            i0.ɵɵlistener("click", function KarteComponent_Template_g_click_70_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleRegion(ctx.regionenKurz.HE));
            });
            i0.ɵɵelement(71, "rect", 35);
            i0.ɵɵelementStart(72, "text", 36);
            i0.ɵɵtext(73, "HE");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(74, "text", 17);
            i0.ɵɵtext(75);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(76, "text", 18);
            i0.ɵɵtext(77);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(78, "path", 37);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(79, "g", 14);
            i0.ɵɵlistener("click", function KarteComponent_Template_g_click_79_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleRegion(ctx.regionenKurz.MV));
            });
            i0.ɵɵelement(80, "rect", 38);
            i0.ɵɵelementStart(81, "text", 39);
            i0.ɵɵtext(82, "MV");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(83, "text", 17);
            i0.ɵɵtext(84);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(85, "text", 18);
            i0.ɵɵtext(86);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(87, "path", 40);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(88, "g", 14);
            i0.ɵɵlistener("click", function KarteComponent_Template_g_click_88_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleRegion(ctx.regionenKurz.NI));
            });
            i0.ɵɵelement(89, "rect", 41);
            i0.ɵɵelementStart(90, "text", 42);
            i0.ɵɵtext(91, "NI");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(92, "text", 17);
            i0.ɵɵtext(93);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(94, "text", 18);
            i0.ɵɵtext(95);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(96, "path", 43);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(97, "g", 14);
            i0.ɵɵlistener("click", function KarteComponent_Template_g_click_97_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleRegion(ctx.regionenKurz.NW));
            });
            i0.ɵɵelement(98, "rect", 44);
            i0.ɵɵelementStart(99, "text", 45);
            i0.ɵɵtext(100, "NW");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(101, "text", 17);
            i0.ɵɵtext(102);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(103, "text", 18);
            i0.ɵɵtext(104);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(105, "path", 46);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(106, "g", 14);
            i0.ɵɵlistener("click", function KarteComponent_Template_g_click_106_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleRegion(ctx.regionenKurz.RP));
            });
            i0.ɵɵelement(107, "rect", 47);
            i0.ɵɵelementStart(108, "text", 48);
            i0.ɵɵtext(109, "RP");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(110, "text", 17);
            i0.ɵɵtext(111);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(112, "text", 18);
            i0.ɵɵtext(113);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(114, "path", 49);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(115, "g", 14);
            i0.ɵɵlistener("click", function KarteComponent_Template_g_click_115_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleRegion(ctx.regionenKurz.SL));
            });
            i0.ɵɵelement(116, "rect", 50);
            i0.ɵɵelementStart(117, "text", 51);
            i0.ɵɵtext(118, "SL");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(119, "text", 17);
            i0.ɵɵtext(120);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(121, "text", 18);
            i0.ɵɵtext(122);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(123, "path", 52);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(124, "g", 14);
            i0.ɵɵlistener("click", function KarteComponent_Template_g_click_124_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleRegion(ctx.regionenKurz.SN));
            });
            i0.ɵɵelement(125, "rect", 53);
            i0.ɵɵelementStart(126, "text", 54);
            i0.ɵɵtext(127, "SN");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(128, "text", 17);
            i0.ɵɵtext(129);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(130, "text", 18);
            i0.ɵɵtext(131);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(132, "path", 55);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(133, "g", 14);
            i0.ɵɵlistener("click", function KarteComponent_Template_g_click_133_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleRegion(ctx.regionenKurz.ST));
            });
            i0.ɵɵelement(134, "rect", 56);
            i0.ɵɵelementStart(135, "text", 57);
            i0.ɵɵtext(136, "ST");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(137, "text", 17);
            i0.ɵɵtext(138);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(139, "text", 18);
            i0.ɵɵtext(140);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(141, "path", 58);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(142, "g", 14);
            i0.ɵɵlistener("click", function KarteComponent_Template_g_click_142_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleRegion(ctx.regionenKurz.SH));
            });
            i0.ɵɵelement(143, "rect", 59);
            i0.ɵɵelementStart(144, "text", 60);
            i0.ɵɵtext(145, "SH");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(146, "text", 17);
            i0.ɵɵtext(147);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(148, "text", 18);
            i0.ɵɵtext(149);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(150, "path", 61);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(151, "g", 14);
            i0.ɵɵlistener("click", function KarteComponent_Template_g_click_151_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleRegion(ctx.regionenKurz.TH));
            });
            i0.ɵɵelement(152, "rect", 62);
            i0.ɵɵelementStart(153, "text", 63);
            i0.ɵɵtext(154, "TH");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(155, "text", 17);
            i0.ɵɵtext(156);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(157, "text", 18);
            i0.ɵɵtext(158);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(159, "path", 64);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(160, KarteComponent_div_160_Template, 3, 1, "div", 65);
            i0.ɵɵelementEnd();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(161, "div", 66);
            i0.ɵɵtemplate(162, KarteComponent_input_162_Template, 1, 7, "input", 67);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(163, KarteComponent_div_163_Template, 1, 3, "div", 68);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "Content");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.hasInternational);
            i0.ɵɵadvance();
            i0.ɵɵclassMap(ctx.zoomLevelCss);
            i0.ɵɵadvance(4);
            i0.ɵɵattribute("aria-hidden", true);
            i0.ɵɵadvance(10);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-state-BW");
            i0.ɵɵattribute("class", ctx.getClassnameForRegion(ctx.regionenKurz.BW));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.BW, 1), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.BW, 2), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-state-BY");
            i0.ɵɵattribute("class", ctx.getClassnameForRegion(ctx.regionenKurz.BY));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.BY, 1), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.BY, 2), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-state-BE");
            i0.ɵɵattribute("class", ctx.getClassnameForRegion(ctx.regionenKurz.BE));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.BE, 1), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.BE, 2), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-state-BB");
            i0.ɵɵattribute("class", ctx.getClassnameForRegion(ctx.regionenKurz.BB));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.BB, 1), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.BB, 2), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-state-HB");
            i0.ɵɵattribute("class", ctx.getClassnameForRegion(ctx.regionenKurz.HB));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.HB, 1), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.HB, 2), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-state-HH");
            i0.ɵɵattribute("class", ctx.getClassnameForRegion(ctx.regionenKurz.HH));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.HH, 1), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.HH, 2), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-state-HE");
            i0.ɵɵattribute("class", ctx.getClassnameForRegion(ctx.regionenKurz.HE));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.HE, 1), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.HE, 2), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-state-MV");
            i0.ɵɵattribute("class", ctx.getClassnameForRegion(ctx.regionenKurz.MV));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.MV, 1), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.MV, 2), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-state-NI");
            i0.ɵɵattribute("class", ctx.getClassnameForRegion(ctx.regionenKurz.NI));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.NI, 1), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.NI, 2), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-state-NW");
            i0.ɵɵattribute("class", ctx.getClassnameForRegion(ctx.regionenKurz.NW));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.NW, 1), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.NW, 2), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-state-RP");
            i0.ɵɵattribute("class", ctx.getClassnameForRegion(ctx.regionenKurz.RP));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.RP, 1), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.RP, 2), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-state-SL");
            i0.ɵɵattribute("class", ctx.getClassnameForRegion(ctx.regionenKurz.SL));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.SL, 1), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.SL, 2), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-state-SN");
            i0.ɵɵattribute("class", ctx.getClassnameForRegion(ctx.regionenKurz.SN));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.SN, 1), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.SN, 2), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-state-ST");
            i0.ɵɵattribute("class", ctx.getClassnameForRegion(ctx.regionenKurz.ST));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.ST, 1), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.ST, 2), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-state-SH");
            i0.ɵɵattribute("class", ctx.getClassnameForRegion(ctx.regionenKurz.SH));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.SH, 1), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.SH, 2), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-state-TH");
            i0.ɵɵattribute("class", ctx.getClassnameForRegion(ctx.regionenKurz.TH));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.TH, 1), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.getCommentLine(ctx.regionenKurz.TH, 2), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.hasInternational);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-cb");
            i0.ɵɵattribute("aria-label", "Regionen (" + ctx.zoomLevel + ")");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.moeglicheLaenderDerAnsicht())("ngForTrackBy", ctx.trackByItemKey);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (ctx.moeglicheLaender == null ? null : ctx.moeglicheLaender.length) === 0);
          }
        },
        dependencies: [NgIf, NgFor],
        styles: ["[_nghost-%COMP%] > div[_ngcontent-%COMP%]{margin-bottom:-15px}.map[_ngcontent-%COMP%]{top:0;position:absolute;width:100%;background:transparent}canvas[_ngcontent-%COMP%]{display:block;width:100%;visibility:hidden}.scope-switcher[_ngcontent-%COMP%]{text-align:center;margin-bottom:14px;margin-top:5px}.scope-switcher[_ngcontent-%COMP%]   .ba-btn-group[_ngcontent-%COMP%]{display:inline-flex;flex-direction:row}.scope-switcher[_ngcontent-%COMP%]   .ba-btn-group[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]{border-top-width:1px;border-left-width:0;border-radius:0}.scope-switcher[_ngcontent-%COMP%]   .ba-btn-group[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]:before{inset:auto 0 0;width:100%;height:4px}.ba-keyboard-mode[_ngcontent-%COMP%]   .scope-switcher[_ngcontent-%COMP%]   .ba-btn-group[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]:focus + label[_ngcontent-%COMP%]{margin-top:0;margin-left:-1px;border-left-width:1px;border-color:#020e25}.scope-switcher[_ngcontent-%COMP%]   .ba-btn-group[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:first-child   input[type=radio][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]{border-left-width:1px;border-top-left-radius:5px;border-bottom-left-radius:5px}.ba-keyboard-mode[_ngcontent-%COMP%]   .scope-switcher[_ngcontent-%COMP%]   .ba-btn-group[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:first-child   input[type=radio][_ngcontent-%COMP%]:focus + label[_ngcontent-%COMP%]{margin-left:0}.scope-switcher[_ngcontent-%COMP%]   .ba-btn-group[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:last-child   input[type=radio][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]{border-top-right-radius:5px;border-bottom-right-radius:5px}.scope-switcher[_ngcontent-%COMP%]   .ba-btn-group[_ngcontent-%COMP%]   label.toggle-button[_ngcontent-%COMP%]{height:36px}.scope-switcher[_ngcontent-%COMP%]   .ba-btn-group[_ngcontent-%COMP%]   div.form-check[_ngcontent-%COMP%]{min-width:95px}.map-group[_ngcontent-%COMP%]   .state[_ngcontent-%COMP%]{fill:#dde3e8;stroke:#fff;stroke-width:.6}.map-group[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%]{fill:#fff;stroke:#6d7480;stroke-width:.35px}.map-group[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{font-size:12px;text-align:center;fill:#6d7480;text-anchor:middle}.map-group[_ngcontent-%COMP%]   .comment1[_ngcontent-%COMP%], .map-group[_ngcontent-%COMP%]   .comment2[_ngcontent-%COMP%]{display:none;width:253px;height:32px;alignment-baseline:middle;text-anchor:middle}.map-group[_ngcontent-%COMP%]   .plaque-outer[_ngcontent-%COMP%]{fill:#fff;stroke:#fff;stroke-width:.4}.map-group[_ngcontent-%COMP%]   .plaque-inner[_ngcontent-%COMP%]{fill:#fff;stroke:#6d7480;stroke-width:.62}.map-group[_ngcontent-%COMP%]:hover, .map-group.checkbox-focus[_ngcontent-%COMP%], .map-group[_ngcontent-%COMP%]:focus{cursor:pointer}.map-group[_ngcontent-%COMP%]:hover   .comment1[_ngcontent-%COMP%], .map-group[_ngcontent-%COMP%]:hover   .comment2[_ngcontent-%COMP%], .map-group.checkbox-focus[_ngcontent-%COMP%]   .comment1[_ngcontent-%COMP%], .map-group.checkbox-focus[_ngcontent-%COMP%]   .comment2[_ngcontent-%COMP%], .map-group[_ngcontent-%COMP%]:focus   .comment1[_ngcontent-%COMP%], .map-group[_ngcontent-%COMP%]:focus   .comment2[_ngcontent-%COMP%]{display:block}.map-group.enabled[_ngcontent-%COMP%]   .state[_ngcontent-%COMP%]{fill:#b3b3b3}.map-group.enabled[_ngcontent-%COMP%]   .state.germany[_ngcontent-%COMP%]{fill:#595959}.map-group.enabled[_ngcontent-%COMP%]   .plaque-outer[_ngcontent-%COMP%], .map-group.enabled[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%], .map-group.enabled[_ngcontent-%COMP%]   .plaque-inner[_ngcontent-%COMP%]{stroke:#020e25;fill:#dde3e8}.map-group.enabled[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%]{fill:#dde3e8}.map-group.enabled[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{fill:#020e25}.map-group.enabled[_ngcontent-%COMP%]:hover   .state[_ngcontent-%COMP%], .map-group.enabled.checkbox-focus[_ngcontent-%COMP%]   .state[_ngcontent-%COMP%], .map-group.enabled[_ngcontent-%COMP%]:focus   .state[_ngcontent-%COMP%]{fill:#020e25}.map-group.enabled[_ngcontent-%COMP%]:hover   .box[_ngcontent-%COMP%], .map-group.enabled[_ngcontent-%COMP%]:hover   .plaque-inner[_ngcontent-%COMP%], .map-group.enabled.checkbox-focus[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%], .map-group.enabled.checkbox-focus[_ngcontent-%COMP%]   .plaque-inner[_ngcontent-%COMP%], .map-group.enabled[_ngcontent-%COMP%]:focus   .box[_ngcontent-%COMP%], .map-group.enabled[_ngcontent-%COMP%]:focus   .plaque-inner[_ngcontent-%COMP%]{fill:#020e25}.map-group.enabled[_ngcontent-%COMP%]:hover   .box.germany[_ngcontent-%COMP%], .map-group.enabled[_ngcontent-%COMP%]:hover   .plaque-inner.germany[_ngcontent-%COMP%], .map-group.enabled.checkbox-focus[_ngcontent-%COMP%]   .box.germany[_ngcontent-%COMP%], .map-group.enabled.checkbox-focus[_ngcontent-%COMP%]   .plaque-inner.germany[_ngcontent-%COMP%], .map-group.enabled[_ngcontent-%COMP%]:focus   .box.germany[_ngcontent-%COMP%], .map-group.enabled[_ngcontent-%COMP%]:focus   .plaque-inner.germany[_ngcontent-%COMP%]{fill:#fff}.map-group.enabled[_ngcontent-%COMP%]:hover   .text[_ngcontent-%COMP%], .map-group.enabled.checkbox-focus[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%], .map-group.enabled[_ngcontent-%COMP%]:focus   .text[_ngcontent-%COMP%]{fill:#fff;stroke:#fff;stroke-width:.1}.map-group.enabled[_ngcontent-%COMP%]:hover   .text.germany[_ngcontent-%COMP%], .map-group.enabled.checkbox-focus[_ngcontent-%COMP%]   .text.germany[_ngcontent-%COMP%], .map-group.enabled[_ngcontent-%COMP%]:focus   .text.germany[_ngcontent-%COMP%]{fill:#020e25;stroke:#020e25}.map-group.selected[_ngcontent-%COMP%]   .state[_ngcontent-%COMP%]{fill:#b30920}.map-group.selected[_ngcontent-%COMP%]   .plaque-outer[_ngcontent-%COMP%]{stroke:#020e25}.map-group.selected[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%], .map-group.selected[_ngcontent-%COMP%]   .plaque-inner[_ngcontent-%COMP%]{fill:#b30920;stroke:#b30920}.map-group.selected[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{fill:#fff;stroke:#fff;stroke-width:.1}.map-group.selected[_ngcontent-%COMP%]:hover   .state[_ngcontent-%COMP%], .map-group.selected.checkbox-focus[_ngcontent-%COMP%]   .state[_ngcontent-%COMP%], .map-group.selected[_ngcontent-%COMP%]:focus   .state[_ngcontent-%COMP%]{fill:#601}.map-group.selected[_ngcontent-%COMP%]:hover   .box[_ngcontent-%COMP%], .map-group.selected[_ngcontent-%COMP%]:hover   .plaque-inner[_ngcontent-%COMP%], .map-group.selected.checkbox-focus[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%], .map-group.selected.checkbox-focus[_ngcontent-%COMP%]   .plaque-inner[_ngcontent-%COMP%], .map-group.selected[_ngcontent-%COMP%]:focus   .box[_ngcontent-%COMP%], .map-group.selected[_ngcontent-%COMP%]:focus   .plaque-inner[_ngcontent-%COMP%]{fill:#601;stroke:#601}.map-group.selected.checkbox-focus[_ngcontent-%COMP%], .map-group.selected[_ngcontent-%COMP%]:focus{text-decoration:underline}.map[_ngcontent-%COMP%]{top:0;position:absolute;width:100%;background:transparent;animation-duration:.72s;animation-fill-mode:forwards}.map.map-national[_ngcontent-%COMP%]{transform-origin:52.1% 44.3%}.map.map-international[_ngcontent-%COMP%]{transform-origin:51.89% 43%}.map[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{animation-duration:0s}.national[_ngcontent-%COMP%]   .map-national[_ngcontent-%COMP%]{z-index:2}.national[_ngcontent-%COMP%]   .map-international[_ngcontent-%COMP%]{z-index:1;visibility:hidden}.international[_ngcontent-%COMP%]   .map-international[_ngcontent-%COMP%]{z-index:2}.international[_ngcontent-%COMP%]   .map-national[_ngcontent-%COMP%]{z-index:1;visibility:hidden}.animated.national[_ngcontent-%COMP%]   .map-national[_ngcontent-%COMP%]{animation-name:_ngcontent-%COMP%_map-national-on;z-index:1}.animated.national[_ngcontent-%COMP%]   .map-national[_ngcontent-%COMP%]   text.text[_ngcontent-%COMP%], .animated.national[_ngcontent-%COMP%]   .map-national[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{animation-duration:.72s;animation-name:_ngcontent-%COMP%_map-hide-legends}.animated.national[_ngcontent-%COMP%]   .map-international[_ngcontent-%COMP%]{z-index:2;visibility:visible;animation-name:_ngcontent-%COMP%_map-international-off}.animated.national[_ngcontent-%COMP%]   .map-international[_ngcontent-%COMP%]   text.text[_ngcontent-%COMP%], .animated.national[_ngcontent-%COMP%]   .map-international[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{visibility:hidden}.animated.international[_ngcontent-%COMP%]   .map-international[_ngcontent-%COMP%]{animation-name:_ngcontent-%COMP%_map-international-on}.animated.international[_ngcontent-%COMP%]   .map-international[_ngcontent-%COMP%]   text.text[_ngcontent-%COMP%], .animated.international[_ngcontent-%COMP%]   .map-international[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{animation-name:_ngcontent-%COMP%_map-hide-legends;animation-duration:.72s}.animated.international[_ngcontent-%COMP%]   .map-national[_ngcontent-%COMP%]{visibility:visible;animation-name:_ngcontent-%COMP%_map-national-off}.animated.international[_ngcontent-%COMP%]   .map-national[_ngcontent-%COMP%]   text.text[_ngcontent-%COMP%], .animated.international[_ngcontent-%COMP%]   .map-national[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{visibility:hidden}@keyframes _ngcontent-%COMP%_map-hide-legends{0%{opacity:0}90%{opacity:0}to{opacity:1}}@keyframes _ngcontent-%COMP%_map-national-on{0%{opacity:0;transform:scale(.3);left:10.3%;top:3%}20%{opacity:.4}40%{opacity:.6}60%{opacity:.8}to{left:0;top:0;opacity:1}}@keyframes _ngcontent-%COMP%_map-national-off{0%{opacity:1;left:0;top:0}20%{opacity:1}40%{opacity:.8}60%{opacity:.6}80%{opacity:.4}to{opacity:0;left:10.3%;top:3%;transform:scale(.3)}}@keyframes _ngcontent-%COMP%_map-international-on{0%{opacity:0;transform:scale(3.29);left:-30.1%;top:-26%}20%{opacity:.8}to{opacity:1;left:0;top:0}}@keyframes _ngcontent-%COMP%_map-international-off{0%{opacity:1;left:0;top:0}40%{opacity:.6}80%{opacity:.2}to{opacity:0;transform:scale(3.29);left:-30.1%;top:-26%}}.svg-map-europe[_ngcontent-%COMP%]   .map-group[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{font-size:20.5px}.svg-map-europe[_ngcontent-%COMP%]   .map-group[_ngcontent-%COMP%]   .comment1[_ngcontent-%COMP%], .svg-map-europe[_ngcontent-%COMP%]   .map-group[_ngcontent-%COMP%]   .comment2[_ngcontent-%COMP%]{font-size:22px}\n\n\n\n\n\n\n\n\n\n"]
      });
    }
  }
  return KarteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let KarteModule = /*#__PURE__*/(() => {
  class KarteModule {
    static {
      this.ɵfac = function KarteModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || KarteModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: KarteModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return KarteModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Wrapper für den DPL-Kontextinfo-Header:
 * https://container.webapp.idst.ibaintern.de/develop/apok/pds/?search=pa#/109264516/109264800
 */
let KontextinfoHeaderComponent = /*#__PURE__*/(() => {
  class KontextinfoHeaderComponent {
    constructor(router) {
      this.router = router;
      this.smallHeader = false;
      this.breadcrumbUrls = [];
      console.warn(`'ba-bub-kontextinfo-header' selector is deprecated; use 'ba-bub-responsive-kontextinfo-header' instead. see docs`);
    }
    extractUrl(breadcrumb, change) {
      let extractedbreadcrumbUrls = [];
      if (change.currentValue instanceof Map) {
        change.currentValue.forEach((value, key) => {
          const parsedUrl = this.router.parseUrl(value);
          extractedbreadcrumbUrls.push({
            name: key,
            path: value.split('?')[0],
            queryParams: parsedUrl.queryParams
          });
        });
      } else {
        extractedbreadcrumbUrls = change.currentValue;
      }
      this.breadcrumbUrls = extractedbreadcrumbUrls;
    }
    getBackgroundImageUrl() {
      return this.backgroundImage != null ? 'url(' + this.backgroundImage + ')' : 'none';
    }
    static {
      this.ɵfac = function KontextinfoHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || KontextinfoHeaderComponent)(i0.ɵɵdirectiveInject(i1$2.Router));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: KontextinfoHeaderComponent,
        selectors: [["ba-bub-kontextinfo-header"]],
        inputs: {
          breadcrumb: "breadcrumb",
          parentBreadcrumbs: "parentBreadcrumbs",
          baKontexinfoHeaderCss: "baKontexinfoHeaderCss",
          headline: "headline",
          subheadline: "subheadline",
          backgroundImage: "backgroundImage",
          smallHeader: "smallHeader",
          overlayColor: "overlayColor",
          overlayTextColor: "overlayTextColor"
        },
        decls: 10,
        vars: 16,
        consts: [["noBreadcrumbPlaceholder", ""], ["id", "kontextinfo-header", 3, "ngClass"], ["role", "presentation", 1, "ba-header-image", "d-print-none"], [1, "ba-content-wrap"], ["id", "kontextinfo-header-breadcrumb", "class", "ba-breadcrumb", "aria-label", "Du befindest Dich hier:", 4, "ngIf", "ngIfElse"], [1, "ba-overlay"], ["id", "kontextinfo-header-ueberschrift"], ["id", "kontextinfo-header-subheadline", 3, "innerHTML"], ["id", "kontextinfo-header-breadcrumb", "aria-label", "Du befindest Dich hier:", 1, "ba-breadcrumb"], [4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "routerLink", "queryParams", "title", "trackEvent"], [1, "sr-only"], ["class", "no-breadcrumb-placeholder", 4, "ngIf"], [1, "no-breadcrumb-placeholder"]],
        template: function KontextinfoHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "header", 1);
            i0.ɵɵelement(1, "div", 2);
            i0.ɵɵelementStart(2, "div", 3);
            i0.ɵɵtemplate(3, KontextinfoHeaderComponent_nav_3_Template, 4, 2, "nav", 4)(4, KontextinfoHeaderComponent_ng_template_4_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(6, "div", 5)(7, "h1", 6);
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(9, "p", 7);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            const noBreadcrumbPlaceholder_r3 = i0.ɵɵreference(5);
            i0.ɵɵclassMapInterpolate1("ba-content-header ba-with-overlay ba-with-image ba-full-width ", ctx.baKontexinfoHeaderCss, "");
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c25, ctx.smallHeader));
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("background-image", ctx.getBackgroundImageUrl());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.parentBreadcrumbs)("ngIfElse", noBreadcrumbPlaceholder_r3);
            i0.ɵɵadvance(3);
            i0.ɵɵstyleProp("background-color", ctx.overlayColor)("color", ctx.overlayTextColor);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.headline);
            i0.ɵɵadvance();
            i0.ɵɵproperty("innerHTML", ctx.subheadline, i0.ɵɵsanitizeHtml);
          }
        },
        dependencies: [NgClass, NgIf, NgFor, RouterLink, TrackEventDirective],
        styles: ["@media print{header{padding:0!important;margin:0!important;margin-top:1rem!important;margin-bottom:1rem!important}header .ba-overlay{padding:0!important;margin:0!important}.ba-pull-header{margin:0!important}}\n"],
        encapsulation: 2
      });
    }
  }
  __decorate([OnChange('extractUrl')], KontextinfoHeaderComponent.prototype, "parentBreadcrumbs", void 0);
  return KontextinfoHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let KontextinfoHeaderModule = /*#__PURE__*/(() => {
  class KontextinfoHeaderModule {
    static {
      this.ɵfac = function KontextinfoHeaderModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || KontextinfoHeaderModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: KontextinfoHeaderModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, RouterModule]
      });
    }
  }
  return KontextinfoHeaderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AnsichtSwitchIconDetailsansichtComponent = /*#__PURE__*/(() => {
  class AnsichtSwitchIconDetailsansichtComponent {
    static {
      this.ɵfac = function AnsichtSwitchIconDetailsansichtComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AnsichtSwitchIconDetailsansichtComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AnsichtSwitchIconDetailsansichtComponent,
        selectors: [["ba-bub-icon-detailsansicht"]],
        decls: 3,
        vars: 0,
        consts: [["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 100 100", "width", "17"], ["x", "2", "y", "9", "width", "96", "height", "36", "rx", "2.5801"], ["x", "2", "y", "55", "width", "96", "height", "36", "rx", "2.5801"]],
        template: function AnsichtSwitchIconDetailsansichtComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(0, "svg", 0);
            i0.ɵɵelement(1, "rect", 1)(2, "rect", 2);
            i0.ɵɵelementEnd();
          }
        },
        encapsulation: 2
      });
    }
  }
  return AnsichtSwitchIconDetailsansichtComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AnsichtSwitchIconListenansichtComponent = /*#__PURE__*/(() => {
  class AnsichtSwitchIconListenansichtComponent {
    static {
      this.ɵfac = function AnsichtSwitchIconListenansichtComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AnsichtSwitchIconListenansichtComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AnsichtSwitchIconListenansichtComponent,
        selectors: [["ba-bub-icon-listenansicht"]],
        decls: 7,
        vars: 0,
        consts: [["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 100 100", "width", "17"], ["x", "2", "y", "9", "width", "22", "height", "22", "rx", "2"], ["x", "32", "y", "9", "width", "66", "height", "22", "rx", "2"], ["x", "2", "y", "39", "width", "22", "height", "22", "rx", "2"], ["x", "32", "y", "39", "width", "66", "height", "22", "rx", "2"], ["x", "2", "y", "69", "width", "22", "height", "22", "rx", "2"], ["x", "32", "y", "69", "width", "66", "height", "22", "rx", "2"]],
        template: function AnsichtSwitchIconListenansichtComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(0, "svg", 0);
            i0.ɵɵelement(1, "rect", 1)(2, "rect", 2)(3, "rect", 3)(4, "rect", 4)(5, "rect", 5)(6, "rect", 6);
            i0.ɵɵelementEnd();
          }
        },
        encapsulation: 2
      });
    }
  }
  return AnsichtSwitchIconListenansichtComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AnsichtSwitchComponent = /*#__PURE__*/(() => {
  class AnsichtSwitchComponent {
    constructor() {
      this.initialState = AnsichtsTypen.KOMPAKT;
      this.showLabels = 'auto';
      this.ansichtSelected = new EventEmitter();
      this.AnsichtsTypen = AnsichtsTypen;
    }
    ngOnInit() {
      this.state = this.initialState;
    }
    toggleView({
      target: {
        value
      }
    }) {
      if (value === this.state) {
        return;
      }
      this.state = value;
      this.ansichtSelected.emit(value);
    }
    toolTip(typ) {
      const text = typ === AnsichtsTypen.LISTE ? 'Listenansicht' : 'Kompaktansicht';
      return typ === this.state ? `${text} gewählt` : `Auf ${text} umschalten`;
    }
    forceLabel() {
      return this.showLabels === 'auto' ? {} : {
        'force-show': this.showLabels === true,
        'force-hide': this.showLabels === false
      };
    }
    static {
      this.ɵfac = function AnsichtSwitchComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AnsichtSwitchComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AnsichtSwitchComponent,
        selectors: [["ba-bub-ansicht-switch"]],
        inputs: {
          initialState: "initialState",
          showLabels: "showLabels"
        },
        outputs: {
          ansichtSelected: "ansichtSelected"
        },
        decls: 17,
        vars: 8,
        consts: [[1, "ba-form-row"], [1, "ba-input-group"], ["id", "ansicht-switch"], ["role", "radiogroup", "aria-labelledby", "ansicht-switch", 1, "ba-btn-group"], [1, "form-check"], ["id", "ansicht-switch-option-detail", "type", "radio", "name", "ansichtentyp", 3, "click", "value", "checked"], ["for", "ansicht-switch-option-detail", 1, "flex", 3, "ngClass", "title"], ["aria-hidden", "true", 1, "icon", "lh-1"], ["id", "ansicht-switch-option-liste", "type", "radio", "name", "ansichtentyp", 3, "click", "value", "checked"], ["for", "ansicht-switch-option-liste", 1, "flex", 3, "ngClass", "title"]],
        template: function AnsichtSwitchComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "fieldset", 1)(2, "legend", 2);
            i0.ɵɵtext(3, "Auswahl Ansicht");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 3)(5, "div", 4)(6, "input", 5);
            i0.ɵɵlistener("click", function AnsichtSwitchComponent_Template_input_click_6_listener($event) {
              return ctx.toggleView($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "label", 6);
            i0.ɵɵelement(8, "ba-bub-icon-detailsansicht", 7);
            i0.ɵɵelementStart(9, "span");
            i0.ɵɵtext(10, "Kompakt");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(11, "div", 4)(12, "input", 8);
            i0.ɵɵlistener("click", function AnsichtSwitchComponent_Template_input_click_12_listener($event) {
              return ctx.toggleView($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "label", 9);
            i0.ɵɵelement(14, "ba-bub-icon-listenansicht", 7);
            i0.ɵɵelementStart(15, "span");
            i0.ɵɵtext(16, "Liste");
            i0.ɵɵelementEnd()()()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("value", ctx.AnsichtsTypen.KOMPAKT)("checked", ctx.initialState === ctx.AnsichtsTypen.KOMPAKT);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.forceLabel())("title", ctx.toolTip(ctx.AnsichtsTypen.KOMPAKT));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("value", ctx.AnsichtsTypen.LISTE)("checked", ctx.initialState === ctx.AnsichtsTypen.LISTE);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.forceLabel())("title", ctx.toolTip(ctx.AnsichtsTypen.LISTE));
          }
        },
        dependencies: [NgClass, AnsichtSwitchIconDetailsansichtComponent, AnsichtSwitchIconListenansichtComponent],
        styles: [".flex[_ngcontent-%COMP%]{display:flex!important;align-items:center;justify-items:center}.icon[_ngcontent-%COMP%]{padding-right:.33em}.ba-btn-group[_ngcontent-%COMP%]{display:inline-flex;flex-direction:row}.ba-btn-group[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]{border-top-width:1px;border-left-width:0;border-radius:0}.ba-btn-group[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]:before{inset:auto 0 0;width:100%;height:4px}.ba-keyboard-mode[_ngcontent-%COMP%]   .ba-btn-group[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]:focus + label[_ngcontent-%COMP%]{margin-top:0;margin-left:-1px;border-left-width:1px;border-color:#020e25}.ba-btn-group[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:first-child   input[type=radio][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]{border-left-width:1px;border-top-left-radius:5px;border-bottom-left-radius:5px}.ba-keyboard-mode[_ngcontent-%COMP%]   .ba-btn-group[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:first-child   input[type=radio][_ngcontent-%COMP%]:focus + label[_ngcontent-%COMP%]{margin-left:0}.ba-btn-group[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:last-child   input[type=radio][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]{border-top-right-radius:5px;border-bottom-right-radius:5px}.ba-btn-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:not(.force-show).force-hide   span[_ngcontent-%COMP%]{width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}.ba-btn-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:not(.force-show).force-hide   span[_ngcontent-%COMP%]:not(caption){position:absolute!important}.ba-btn-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:not(.force-show).force-hide   .icon[_ngcontent-%COMP%]{padding-right:0}@media (max-width: 575.98px){.ba-btn-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:not(.force-show)   span[_ngcontent-%COMP%]{width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}.ba-btn-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:not(.force-show)   span[_ngcontent-%COMP%]:not(caption){position:absolute!important}.ba-btn-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:not(.force-show)   .icon[_ngcontent-%COMP%]{padding-right:0}}\n\n\n\n\n\n\n\n\n\n"]
      });
    }
  }
  return AnsichtSwitchComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var AnsichtsTypen = /*#__PURE__*/function (AnsichtsTypen) {
  AnsichtsTypen["LISTE"] = "LISTE";
  AnsichtsTypen["KOMPAKT"] = "KOMPAKT";
  return AnsichtsTypen;
}(AnsichtsTypen || {});
let AnsichtSwitchModule = /*#__PURE__*/(() => {
  class AnsichtSwitchModule {
    static {
      this.ɵfac = function AnsichtSwitchModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AnsichtSwitchModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AnsichtSwitchModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return AnsichtSwitchModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PaginierungComponent = /*#__PURE__*/(() => {
  class PaginierungComponent {
    constructor() {
      this.firstClicked = new EventEmitter();
      this.prevClicked = new EventEmitter();
      this.nextClicked = new EventEmitter();
      this.lastClicked = new EventEmitter();
    }
    pageFirstClicked() {
      this.firstClicked.emit();
    }
    pagePrevClicked() {
      this.prevClicked.emit();
    }
    pageNextClicked() {
      this.nextClicked.emit();
    }
    pageLastClicked() {
      this.lastClicked.emit();
    }
    get isFirstPage() {
      return this.aktuelleSeite === 1;
    }
    get isLastPage() {
      return this.aktuelleSeite === this.anzahlSeiten || this.anzahlSeiten === 0;
    }
    get labelVorherigeSeite() {
      return `Seite ${this.aktuelleSeite - 1}`;
    }
    get labelNaechsteSeite() {
      return `Seite ${this.aktuelleSeite + 1}`;
    }
    get labelLetzteSeite() {
      return `Letzte Seite ${this.anzahlSeiten}`;
    }
    static {
      this.ɵfac = function PaginierungComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaginierungComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PaginierungComponent,
        selectors: [["ba-bub-pagination"]],
        inputs: {
          anzahlTreffer: "anzahlTreffer",
          aktuelleSeite: "aktuelleSeite",
          anzahlSeiten: "anzahlSeiten",
          position: "position"
        },
        outputs: {
          firstClicked: "firstClicked",
          prevClicked: "prevClicked",
          nextClicked: "nextClicked",
          lastClicked: "lastClicked"
        },
        decls: 2,
        vars: 1,
        consts: [["class", "ba-pagination m-0", "tabindex", "-1", 4, "ngIf"], ["tabindex", "-1", 1, "ba-pagination", "m-0"], ["aria-label", "Schaltfl\xE4chen zum Durchbl\xE4ttern der Ergebnisliste"], [1, "ba-page-first", 3, "id"], ["href", "javascript:void(0)", "aria-label", "Erste Seite", "title", "Erste Seite", 3, "click", "tabindex"], [1, "ba-page-previous", 3, "id"], ["href", "javascript:void(0)", 3, "click", "tabindex", "title"], ["tabindex", "-1", 1, "ba-page-active", 3, "id"], [1, "sr-only"], ["aria-current", "page"], ["aria-hidden", "true"], [1, "ba-page-next", 3, "id"], [1, "ba-page-last", 3, "id"]],
        template: function PaginierungComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵtemplate(1, PaginierungComponent_nav_1_Template, 19, 36, "nav", 0);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.anzahlSeiten > 1);
          }
        },
        dependencies: [NgIf],
        styles: [".ba-pagination[_ngcontent-%COMP%]{outline:none}.ba-pagination[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%] > li.ba-page-first[_ngcontent-%COMP%]{display:inline-flex}.ba-pagination[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%] > li.ba-page-last[_ngcontent-%COMP%]{display:inline-flex}.ba-pagination[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .ba-page-active[_ngcontent-%COMP%]:not(.ba-page-active){display:inline-flex}.ba-pagination[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%] > li.ba-page-active[_ngcontent-%COMP%] > span.sr-only[_ngcontent-%COMP%]{width:0;min-width:0}@media (min-width: 768px){.ba-pagination[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%] > li.ba-page-active[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{background:transparent;color:#020e25;width:auto}}.ba-pagination[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%] > li.ba-page-active[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline}@media screen and (max-width: 350px){.ba-pagination[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%] > li.ba-page-active[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:none}}@media (max-width: 767.98px){nav.ba-pagination[_ngcontent-%COMP%]{padding-top:0}}\n\n\n\n\n\n\n\n\n\n"]
      });
    }
  }
  return PaginierungComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PaginierungModule = /*#__PURE__*/(() => {
  class PaginierungModule {
    static {
      this.ɵfac = function PaginierungModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaginierungModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PaginierungModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return PaginierungModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DetailNavigationComponent = /*#__PURE__*/(() => {
  class DetailNavigationComponent {
    constructor() {
      this.scrollLimitFixiertesMenu = 100;
      this.naechstesElement = new EventEmitter();
      this.vorherigesElement = new EventEmitter();
      this.zurueckZurErgebnisseite = new EventEmitter();
      this.isScrolled = false;
    }
    onScroll($event) {
      this.isScrolled = $event.target.documentElement.scrollTop > this.scrollLimitFixiertesMenu;
    }
    onZurueckZurErgebnisseite() {
      this.zurueckZurErgebnisseite.emit();
    }
    onVorherigesErgebnis() {
      this.naechstesElement.emit();
    }
    onNaechstesErgebnis() {
      this.vorherigesElement.emit();
    }
    showPageBasedNavigation() {
      return this.anzahlVorherigeSeiten !== null || this.anzahlFolgendeSeiten !== null;
    }
    static {
      this.ɵfac = function DetailNavigationComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DetailNavigationComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DetailNavigationComponent,
        selectors: [["ba-bub-detail-navigation"]],
        hostBindings: function DetailNavigationComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("scroll", function DetailNavigationComponent_scroll_HostBindingHandler($event) {
              return ctx.onScroll($event);
            }, false, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          anzahlVorherigeSeiten: "anzahlVorherigeSeiten",
          anzahlFolgendeSeiten: "anzahlFolgendeSeiten",
          scrollLimitFixiertesMenu: "scrollLimitFixiertesMenu"
        },
        outputs: {
          naechstesElement: "naechstesElement",
          vorherigesElement: "vorherigesElement",
          zurueckZurErgebnisseite: "zurueckZurErgebnisseite"
        },
        decls: 6,
        vars: 7,
        consts: [["zurstartseite", ""], ["aria-label", "Angebot", 3, "ngClass"], [1, "row", "__detailpager_", "d-print-none"], [1, "ba-buttons"], [4, "ngIf", "ngIfElse"], ["id", "back_button", "title", "Zur\xFCck zur Suche", 1, "__back_", 3, "click"], ["aria-hidden", "true", 1, "ba-icon", "ba-icon-chevron-left-double", "left"], [1, "sr-only"], ["id", "prev_angebot", 1, "__prev_", 3, "click", "disabled", "title"], ["aria-hidden", "true", 1, "ba-icon", "ba-icon-chevron-left", "left"], [4, "ngIf"], ["id", "next_angebot", 1, "__next_", 3, "click", "disabled", "title"], ["aria-hidden", "true", 1, "ba-icon", "ba-icon-chevron-right-after", "right"], ["aria-hidden", "true"], [1, "number"], ["id", "to_start_button", "title", "Zur\xFCck zur Startseite", 1, "__back_", 3, "routerLink"]],
        template: function DetailNavigationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "nav", 1)(1, "div", 2)(2, "div", 3);
            i0.ɵɵtemplate(3, DetailNavigationComponent_ng_container_3_Template, 19, 10, "ng-container", 4)(4, DetailNavigationComponent_ng_template_4_Template, 6, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            const zurstartseite_r3 = i0.ɵɵreference(5);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(3, _c27, ctx.isScrolled, !ctx.isScrolled, !ctx.showPageBasedNavigation()));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.showPageBasedNavigation())("ngIfElse", zurstartseite_r3);
          }
        },
        dependencies: [NgClass, NgIf, RouterLink],
        styles: [".row[_ngcontent-%COMP%]{overflow-x:hidden;background-color:#dde3e8;margin:0}button[_ngcontent-%COMP%]{margin-right:2px;background-color:#fff;border:none;float:left;height:50px;text-transform:uppercase}button[_ngcontent-%COMP%]:last-child{margin-right:0}button[_ngcontent-%COMP%]:not(:disabled):hover, button[_ngcontent-%COMP%]:not(:disabled):focus{color:#b30920}button[_ngcontent-%COMP%]:not(:disabled):focus{border:2px solid #020E25;border-radius:5%;outline:none}button[_ngcontent-%COMP%]:not(:disabled)   .number[_ngcontent-%COMP%]{color:#b30920}button[_ngcontent-%COMP%]:disabled{color:#b3b3b3}button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{position:relative;top:-1px}@media (min-width: 768px){button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{top:-2px}}button[_ngcontent-%COMP%]   i.left[_ngcontent-%COMP%]{margin-right:8px}button[_ngcontent-%COMP%]   i.right[_ngcontent-%COMP%]{margin-left:8px}.__back_[_ngcontent-%COMP%]{width:150px}.__prev_[_ngcontent-%COMP%], .__next_[_ngcontent-%COMP%]{width:calc(50% - 77px)}@media (max-width: 575.98px){.__back_[_ngcontent-%COMP%]{width:100px}.__prev_[_ngcontent-%COMP%], .__next_[_ngcontent-%COMP%]{width:calc(50% - 52px)}}.__aktivierungsangebotpagerbezeichnung_[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;background-color:#fff;margin:0;padding:1rem 10px 10px;width:100%}nav[_ngcontent-%COMP%]{padding:0!important}nav[_ngcontent-%COMP%]   .ba-buttons[_ngcontent-%COMP%]{height:52px}@media (min-width: 768px){nav.affix[_ngcontent-%COMP%]{top:0;left:0;width:100%;z-index:1!important;border-top:none}nav.affix[_ngcontent-%COMP%]   .ba-buttons[_ngcontent-%COMP%]{border-bottom:.063em solid #F9FBFC;border-bottom-width:2px}}@media (min-width: 768px) and (min-width: 576px){nav.affix[_ngcontent-%COMP%]   .__aktivierungsangebotpagerbezeichnung_[_ngcontent-%COMP%]{position:fixed;box-shadow:0 3px 3px #dde3e8}}@media (min-width: 768px) and (min-width: 768px){nav.affix[_ngcontent-%COMP%]   .__aktivierungsangebotpagerbezeichnung_[_ngcontent-%COMP%]{display:none}}@media (max-width: 575.98px){nav[_ngcontent-%COMP%]{position:static}}@media (min-width: 992px){nav.unfix[_ngcontent-%COMP%]{margin-top:-3rem;margin-right:2rem;width:600px;z-index:1!important;float:right;border:#F9FBFC 2px solid;border-radius:.3rem}nav.unfix[_ngcontent-%COMP%]   .ba-buttons[_ngcontent-%COMP%]{border:none;height:100%}}@media (min-width: 992px) and (min-width: 768px) and (max-width: 991.98px){nav.unfix[_ngcontent-%COMP%]{margin-top:0;margin-right:0;width:100%;float:none;border:none}}nav.small[_ngcontent-%COMP%]{width:auto;border:none}@media (max-width: 575.98px){nav.small[_ngcontent-%COMP%]   .ba-buttons[_ngcontent-%COMP%]{margin-top:1rem;margin-left:1rem}nav.small[_ngcontent-%COMP%]   .ba-buttons[_ngcontent-%COMP%]   .__back_[_ngcontent-%COMP%]{border:2px solid #ededed}}@media (min-width: 768px) and (max-width: 991.98px){nav.small[_ngcontent-%COMP%]   .ba-buttons[_ngcontent-%COMP%]{margin-top:2rem}}@media (min-width: 768px){nav.small[_ngcontent-%COMP%]{margin-left:2rem;float:none;margin-right:0}}@media (min-width: 992px){nav.small.affix[_ngcontent-%COMP%]{display:none}}nav.small[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]{background-color:inherit}nav.small[_ngcontent-%COMP%]   .ba-buttons[_ngcontent-%COMP%]{border:none}nav.small[_ngcontent-%COMP%]   .__back_[_ngcontent-%COMP%]{border-right:2px solid #ededed;border-bottom:2px solid #ededed}@media (min-width: 768px){nav.small[_ngcontent-%COMP%]   .__back_[_ngcontent-%COMP%]{border:2px solid #ededed}}\n\n\n\n\n\n\n\n\n\n"],
        changeDetection: 0
      });
    }
  }
  return DetailNavigationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DetailNavigationModule = /*#__PURE__*/(() => {
  class DetailNavigationModule {
    static {
      this.ɵfac = function DetailNavigationModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DetailNavigationModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: DetailNavigationModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, RouterModule]
      });
    }
  }
  return DetailNavigationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PaginierungDplComponent = /*#__PURE__*/(() => {
  class PaginierungDplComponent {
    constructor() {
      this.firstClicked = new EventEmitter();
      this.prevClicked = new EventEmitter();
      this.nextClicked = new EventEmitter();
      this.lastClicked = new EventEmitter();
      this.threePagesNextClicked = new EventEmitter();
      this.threePagesPreviousClicked = new EventEmitter();
    }
    pageFirstClicked() {
      this.firstClicked.emit();
    }
    pagePrevClicked(event) {
      this.prevClicked.emit();
      event.target.blur();
    }
    pageNextClicked(event) {
      this.nextClicked.emit();
      event.target.blur();
    }
    pageLastClicked() {
      this.lastClicked.emit();
    }
    pageThreePagesNextClicked(event) {
      this.threePagesNextClicked.emit();
      event.target.blur();
    }
    pageThreePagesPreviousClicked(event) {
      this.threePagesPreviousClicked.emit();
      event.target.blur();
    }
    get isFirstPage() {
      return this.aktuelleSeite === 1;
    }
    get isThreePagesPrevious() {
      return this.aktuelleSeite > 3;
    }
    get isThreePagesNext() {
      return this.aktuelleSeite + 2 < this.anzahlSeiten;
    }
    get isLastPage() {
      return this.aktuelleSeite === this.anzahlSeiten || this.anzahlSeiten === 0;
    }
    get isSecondLastPage() {
      let vorletzteSeite = this.anzahlSeiten - 1;
      return this.aktuelleSeite >= vorletzteSeite || this.anzahlSeiten === 0;
    }
    get isSecondPage() {
      return this.aktuelleSeite === 2 || this.anzahlSeiten === 0;
    }
    get labelVorherigeSeite() {
      return `Seite ${this.aktuelleSeite - 1}`;
    }
    get labelNaechsteSeite() {
      return `Seite ${this.aktuelleSeite + 1}`;
    }
    get labelLetzteSeite() {
      return `Letzte Seite ${this.anzahlSeiten}`;
    }
    static {
      this.ɵfac = function PaginierungDplComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaginierungDplComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PaginierungDplComponent,
        selectors: [["ba-bub-pagination-dpl"]],
        inputs: {
          anzahlTreffer: "anzahlTreffer",
          aktuelleSeite: "aktuelleSeite",
          anzahlSeiten: "anzahlSeiten",
          position: "position"
        },
        outputs: {
          firstClicked: "firstClicked",
          prevClicked: "prevClicked",
          nextClicked: "nextClicked",
          lastClicked: "lastClicked",
          threePagesNextClicked: "threePagesNextClicked",
          threePagesPreviousClicked: "threePagesPreviousClicked"
        },
        decls: 2,
        vars: 1,
        consts: [["class", "ba-pagination m-0", "tabindex", "-1", 4, "ngIf"], ["tabindex", "-1", 1, "ba-pagination", "m-0"], [1, "ba-page-previous", 3, "id"], ["href", "javascript:void(0)", 3, "click", "tabindex", "title"], [3, "id", 4, "ngIf"], ["class", "ba-page-previous-group", 3, "id", 4, "ngIf"], ["tabindex", "-1", 1, "ba-page-active", 3, "id"], [1, "sr-only"], ["aria-current", "page"], ["class", "ba-page-next-group", 3, "id", 4, "ngIf"], [1, "ba-page-next", 3, "id"], [3, "id"], ["href", "javascript:void(0)", "aria-label", "Erste Seite", "title", "Erste Seite", 3, "click", "tabindex"], [1, "ba-page-previous-group", 3, "id"], ["href", "javascript:void(0)", "aria-label", "Drei Seiten zur\xFCck", "title", "Drei Seiten zur\xFCck", 3, "click", "tabindex"], ["href", "javascript:void(0)", 3, "click", "title"], [1, "ba-page-next-group", 3, "id"], ["href", "javascript:void(0)", "aria-label", "Drei Seiten vor", "title", "Drei Seiten vor", 3, "click", "tabindex"]],
        template: function PaginierungDplComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵtemplate(1, PaginierungDplComponent_nav_1_Template, 19, 28, "nav", 0);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.anzahlSeiten > 1);
          }
        },
        dependencies: [NgIf],
        encapsulation: 2
      });
    }
  }
  return PaginierungDplComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PaginierungDplModule = /*#__PURE__*/(() => {
  class PaginierungDplModule {
    static {
      this.ɵfac = function PaginierungDplModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaginierungDplModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PaginierungDplModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return PaginierungDplModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FilterChipListeComponent = /*#__PURE__*/(() => {
  class FilterChipListeComponent {
    constructor(changeDetector, trackingService) {
      this.changeDetector = changeDetector;
      this.trackingService = trackingService;
      this.showAnzahlOnlyOnDesktop = false;
      this.filterEntfernt = new EventEmitter();
      this.alleFilterEntfernt = new EventEmitter();
      this.chipVisibility = new Map();
      this.collapsed = true;
      this.numberHiddenElements = 0;
      this.trackByItemKey = trackByItemKey;
      this.countHidden = (entries, observer) => {
        for (const entry of entries) {
          const id = entry.target.getAttribute('id');
          if (entry.boundingClientRect.height == 0) {
            observer.unobserve(entry.target);
            this.chipVisibility.delete(id);
            continue;
          }
          this.chipVisibility.set(id, entry.isIntersecting);
        }
        this.numberHiddenElements = this.calculateNumberHiddenElements();
        this.changeDetector.detectChanges();
      };
    }
    ngOnInit() {
      let options = {
        root: document.querySelector('.collapsable .aktive-filter-liste'),
        rootMargin: '0px',
        threshold: 0.9
      };
      this.intersectionObserver = new IntersectionObserver(this.countHidden, options);
    }
    filterEntfernen($event) {
      this.trackingService.trackEvent('remove', 'quick-filter', $event.text);
      this.filterEntfernt.emit($event);
    }
    alleFilterEntfernen(event) {
      this.trackingService.trackEvent('remove', 'quick-filter', 'all');
      event.preventDefault();
      this.alleFilterEntfernt.emit();
    }
    ngAfterViewChecked() {
      this.updateChipList();
    }
    ngOnDestroy() {
      this.intersectionObserver.disconnect();
    }
    ngOnChanges(changes) {
      this.intersectionObserver?.disconnect();
      this.chipVisibility.clear();
    }
    onResize() {
      // Falls durchs Resizen alle Chips sichtbar werden, Ausklapp-Button deaktivieren.
      const chipElements = Array.from(this.chipVisibility.keys());
      const firstRowY = document.getElementById(chipElements[0])?.getBoundingClientRect().y;
      const allInOneRow = chipElements.every(id => document.getElementById(id).getBoundingClientRect().y == firstRowY);
      if (allInOneRow) {
        this.collapsed = true;
      }
    }
    updateChipList() {
      let targets = document.querySelectorAll('.collapsable ba-bub-filter-chip .filter-chip');
      targets.forEach(element => this.intersectionObserver.observe(element));
    }
    calculateNumberHiddenElements() {
      let total = 0;
      this.chipVisibility.forEach(visibility => {
        if (!visibility) {
          total++;
        }
      });
      return total;
    }
    get idPrefix() {
      return this.id ? this.id + '-' : '';
    }
    static {
      this.ɵfac = function FilterChipListeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FilterChipListeComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(TrackingService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FilterChipListeComponent,
        selectors: [["ba-bub-filter-chip-liste"]],
        hostBindings: function FilterChipListeComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("orientationchange", function FilterChipListeComponent_orientationchange_HostBindingHandler() {
              return ctx.onResize();
            }, false, i0.ɵɵresolveWindow)("resize", function FilterChipListeComponent_resize_HostBindingHandler() {
              return ctx.onResize();
            }, false, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          id: "id",
          aktiveFilter: "aktiveFilter",
          showAnzahlOnlyOnDesktop: "showAnzahlOnlyOnDesktop"
        },
        outputs: {
          filterEntfernt: "filterEntfernt",
          alleFilterEntfernt: "alleFilterEntfernt"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 2,
        vars: 2,
        consts: [["class", "aktive-filter desktop", "id", "aktive-filter-desktop", 4, "ngIf"], ["class", "aktive-filter mobile d-print-none", "id", "aktive-filter-mobile", 4, "ngIf"], ["id", "aktive-filter-desktop", 1, "aktive-filter", "desktop"], ["id", "anzahl-aktive-filter-desktop", 1, "aktive-filter-anzahl"], [1, "d-none", 3, "ngClass"], [3, "aktiverFilter", "filterEntfernt", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["href", "#", 1, "d-print-none", 3, "click"], [3, "filterEntfernt", "aktiverFilter"], ["id", "aktive-filter-mobile", 1, "aktive-filter", "mobile", "d-print-none"], [1, "head-row"], ["id", "anzahl-aktive-filter-mobile", 1, "aktive-filter-anzahl"], ["href", "#", 3, "click", 4, "ngIf"], [1, "collapsable", 3, "ngClass"], [1, "aktive-filter-liste"], [3, "id", "aktiverFilter", "disabled", "filterEntfernt", 4, "ngFor", "ngForOf"], ["href", "#", "role", "button", "class", "collapse-mobile", 3, "click", 4, "ngIf"], ["href", "#", 3, "click"], [3, "filterEntfernt", "id", "aktiverFilter", "disabled"], ["href", "#", "role", "button", 1, "collapse-mobile", 3, "click"]],
        template: function FilterChipListeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, FilterChipListeComponent_div_0_Template, 9, 8, "div", 0)(1, FilterChipListeComponent_div_1_Template, 12, 11, "div", 1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", (ctx.aktiveFilter == null ? null : ctx.aktiveFilter.length) > 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (ctx.aktiveFilter == null ? null : ctx.aktiveFilter.length) > 0);
          }
        },
        dependencies: [NgIf, NgClass, NgFor, FilterChipComponent],
        styles: [".aktive-filter[_ngcontent-%COMP%]{margin-top:1rem}.aktive-filter.desktop[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;row-gap:.5rem;column-gap:.75rem;align-items:center}.aktive-filter.mobile[_ngcontent-%COMP%]   .head-row[_ngcontent-%COMP%]{display:grid;grid-template-columns:1fr 90px;margin-bottom:1rem}.aktive-filter.mobile[_ngcontent-%COMP%]   .collapsable[_ngcontent-%COMP%]{display:grid;grid-template-columns:1fr auto;grid-gap:.25rem}.aktive-filter.mobile[_ngcontent-%COMP%]   .collapsable.open[_ngcontent-%COMP%]{grid-template-columns:1fr;grid-template-rows:auto auto}.aktive-filter.mobile[_ngcontent-%COMP%]   .collapsable[_ngcontent-%COMP%]   .aktive-filter-liste[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;gap:.75rem;align-items:center}.aktive-filter.mobile[_ngcontent-%COMP%]   .collapsable[_ngcontent-%COMP%]:not(.open)   .aktive-filter-liste[_ngcontent-%COMP%]{overflow:hidden;max-height:32px}.aktive-filter.mobile[_ngcontent-%COMP%]   .collapse-mobile[_ngcontent-%COMP%]{padding-top:3px}.aktive-filter.mobile[_ngcontent-%COMP%]   .collapse-mobile[_ngcontent-%COMP%]:not(:hover){color:#020e25}.aktive-filter[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{padding-left:.2rem;color:#595959;justify-self:end}.aktive-filter[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:#601}.aktive-filter.desktop[_ngcontent-%COMP%]{display:none}@media (min-width: 768px),print{.aktive-filter.desktop[_ngcontent-%COMP%]{display:flex}.aktive-filter.mobile[_ngcontent-%COMP%]{display:none}}\n\n\n\n\n\n\n\n\n\n"]
      });
    }
  }
  return FilterChipListeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FilterChipListeModule = /*#__PURE__*/(() => {
  class FilterChipListeModule {
    static {
      this.ɵfac = function FilterChipListeModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FilterChipListeModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: FilterChipListeModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, ChipsModule]
      });
    }
  }
  return FilterChipListeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CollapsibleFacetteComponent = /*#__PURE__*/(() => {
  class CollapsibleFacetteComponent {
    constructor() {
      this.anzahlSelektierterFilter = 0;
      this.isExpanded = true;
      this.resetClicked = new EventEmitter();
    }
    static {
      this.ɵfac = function CollapsibleFacetteComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CollapsibleFacetteComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CollapsibleFacetteComponent,
        selectors: [["ba-bub-collapsible-facette"]],
        inputs: {
          id: "id",
          icon: "icon",
          facettenName: "facettenName",
          anzahlSelektierterFilter: "anzahlSelektierterFilter",
          isExpanded: "isExpanded"
        },
        outputs: {
          resetClicked: "resetClicked"
        },
        ngContentSelectors: _c0,
        decls: 14,
        vars: 14,
        consts: [[1, "ba-accordion"], [1, "accordion-item"], [1, "accordion-header"], ["type", "button", "data-bs-toggle", "collapse", 1, "accordion-button"], [3, "class", 4, "ngIf"], [1, "h5", "my-0"], ["class", "anzahl-selected", 4, "ngIf"], [1, "accordion-collapse", "collapse", 3, "ngClass"], [1, "accordion-body", "position-relative"], [1, "ba-filterfacet", "ba-filterfacet-top"], [1, "position-relative"], [1, "anzahl-selected"]],
        template: function CollapsibleFacetteComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "button", 3);
            i0.ɵɵtemplate(4, CollapsibleFacetteComponent_span_4_Template, 1, 3, "span", 4);
            i0.ɵɵelementStart(5, "span", 5);
            i0.ɵɵtext(6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, CollapsibleFacetteComponent_span_7_Template, 2, 1, "span", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 7)(9, "div", 8);
            i0.ɵɵelement(10, "hr");
            i0.ɵɵelementStart(11, "fieldset", 9)(12, "div", 10);
            i0.ɵɵprojection(13);
            i0.ɵɵelementEnd()()()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("id", "collapsible-facette-" + ctx.id + "-title");
            i0.ɵɵadvance();
            i0.ɵɵattribute("data-bs-target", "#collapsible-facette-" + ctx.id + "-panel")("aria-expanded", ctx.isExpanded)("aria-controls", "collapsible-facette-" + ctx.id + "-panel")("aria-label", ctx.facettenName + " Facette");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.icon);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.facettenName);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.anzahlSelektierterFilter);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c3, ctx.isExpanded));
            i0.ɵɵattribute("id", "collapsible-facette-" + ctx.id + "-panel")("aria-labelledby", "collapsible-facette-" + ctx.id + "-title");
            i0.ɵɵadvance(3);
            i0.ɵɵattribute("aria-labelledby", "collapsible-facette-" + ctx.id + "-title");
          }
        },
        dependencies: [NgIf, NgClass],
        styles: [".ba-accordion[_ngcontent-%COMP%]{border:none;margin-bottom:10px;--checkbox-liste-info-i-right: -10px}.ba-accordion[_ngcontent-%COMP%]   .accordion-body[_ngcontent-%COMP%]{padding:15px;background-color:#fff}.ba-accordion[_ngcontent-%COMP%]   .accordion-header[_ngcontent-%COMP%] > button.accordion-button[_ngcontent-%COMP%]{border:none;background-color:#fff;font-family:Roboto Condensed Bold,Helvetica Neue,Arial,sans-serif;letter-spacing:unset;padding:15px 60px 15px 20px;color:#020e25;text-align:start;display:grid;grid-template-columns:min-content auto 1fr;gap:1rem;align-items:center}.ba-accordion[_ngcontent-%COMP%]   .accordion-header[_ngcontent-%COMP%] > button.accordion-button[_ngcontent-%COMP%]:focus, .ba-accordion[_ngcontent-%COMP%]   .accordion-header[_ngcontent-%COMP%] > button.accordion-button[_ngcontent-%COMP%]:hover{background-color:#d9e1ed}.ba-accordion[_ngcontent-%COMP%]   .accordion-header[_ngcontent-%COMP%] > button.accordion-button[_ngcontent-%COMP%]:focus   .anzahl-selected[_ngcontent-%COMP%], .ba-accordion[_ngcontent-%COMP%]   .accordion-header[_ngcontent-%COMP%] > button.accordion-button[_ngcontent-%COMP%]:hover   .anzahl-selected[_ngcontent-%COMP%]{background-color:#f9fbfc;justify-self:start}.ba-accordion[_ngcontent-%COMP%]   .accordion-header[_ngcontent-%COMP%] > button.accordion-button[_ngcontent-%COMP%]:after{color:#020e25;right:12px}.ba-accordion[_ngcontent-%COMP%]   .ba-icon[_ngcontent-%COMP%]:before{font-size:32px}.ba-accordion[_ngcontent-%COMP%]   .anzahl-selected[_ngcontent-%COMP%]{background-color:#dde3e8;border-radius:3px;padding:1px 8px;font-size:1rem;justify-self:start}.ba-accordion[_ngcontent-%COMP%]   .ba-filterfacet[_ngcontent-%COMP%]{padding:0;border:none;margin-bottom:0}.ba-accordion[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{height:1px;border-top:2px solid #D9E1ED;margin-top:-18px;margin-bottom:15px;position:relative;z-index:100}\n\n\n\n\n\n\n\n\n\n"]
      });
    }
  }
  return CollapsibleFacetteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CollapsibleFacetteModule = /*#__PURE__*/(() => {
  class CollapsibleFacetteModule {
    static {
      this.ɵfac = function CollapsibleFacetteModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CollapsibleFacetteModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CollapsibleFacetteModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return CollapsibleFacetteModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const GEOIS_CONFIG = new InjectionToken('GeoisConfig');
let GeocodeService = /*#__PURE__*/(() => {
  class GeocodeService {
    constructor(backend, config) {
      this.backend = backend;
      this.config = config;
      // Manuelle Konstruktion des Clients, um die BaOauthLib, die ungewünschte
      // Header hinzufügt, zu umgehen.
      this.http = new HttpClient(backend);
    }
    getCoordinates(street, zipcode, city) {
      const address = {
        OBJECTID: 1,
        Strasse: street,
        PLZ: zipcode,
        Ort: city
      };
      const records = JSON.stringify({
        records: [{
          attributes: address
        }]
      });
      const parameters = {
        f: 'json',
        addresses: records
      };
      return this.http.get(this.config.geoisGeocodeServer + '/geocodeAddresses', {
        params: parameters,
        withCredentials: true
      }).pipe(timeout(4000), map(response => {
        const res = response;
        if (!res.locations || res.locations[0].location.x === 'NaN' || res.locations[0].location.y === 'NaN') {
          throw new Error('Keine bekannte Location!');
        }
        return {
          x: res.locations[0].location.x,
          y: res.locations[0].location.y
        };
      }));
    }
    static {
      this.ɵfac = function GeocodeService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GeocodeService)(i0.ɵɵinject(i2.HttpBackend), i0.ɵɵinject(GEOIS_CONFIG));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: GeocodeService,
        factory: GeocodeService.ɵfac
      });
    }
  }
  return GeocodeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const MAX_WIDTH_PHABLET = 767;
const ERROR_MESSAGE_NOT_AVAILABLE = 'Kartenansicht aktuell nicht verfügbar. Bitte später erneut versuchen...';
let GeoisMapComponent = /*#__PURE__*/(() => {
  class GeoisMapComponent {
    constructor(geocodeService, changeDetectorRef, loggingService, config) {
      this.geocodeService = geocodeService;
      this.changeDetectorRef = changeDetectorRef;
      this.loggingService = loggingService;
      this.config = config;
      // Muss true sein, da er hierbei die benoetigte breite fuer die Karte berechnet.
      this.state = 'loading';
      this.mapError = new EventEmitter();
      this.viewInitialized = false;
      this.initialized = false;
      console.warn(`'ba-bub-geois-map' selector is deprecated; use 'ba-bub-map' instead. see docs`);
      this.errorMessage = this.blurWithMessage;
    }
    async ngOnChanges() {
      if (this.viewInitialized) {
        // Es wird nur noch darauf geprueft ob blurWithMessage ein Leer-String ist
        // Wenn er LEER ist, dann kann eine Koordinate angezeigt werden
        // Wenn nicht, wird die Defaultkarte angezeigt mit dem blurWithMessage Text
        if (this.blurWithMessage !== '') {
          this.loggingService.debug('blurWithMessage = ' + this.blurWithMessage);
          this.errorMessage = this.blurWithMessage;
          this.doShowError();
        } else {
          // Geokarte anzeigen und wenn noch nicht gemacht die Map initialisieren
          this.doShowGeoisMap();
          this.initMapIfNotDone();
          this.update();
        }
      }
    }
    ngAfterViewInit() {
      /**
       * Ist der String blurWithMessage befuellt handelt es sich
       * um einen expliziten Aufruf des Default-Bildes mit einem konkreten Text.
       * Die GEO Karte muss nicht geladen werden.
       */
      if (this.blurWithMessage) {
        this.doBlurWithMessage();
      } else {
        // Die Karte muss eventuell initialisiert werden.
        this.initMapIfNotDone();
      }
      this.viewInitialized = true;
    }
    doBlurWithMessage() {
      // nur blurbild anzeigen, keine position abfragen
      // Message fuer das blurbild hinterlegen
      this.loggingService.debug('blurWithMessage = ' + this.blurWithMessage);
      this.errorMessage = this.blurWithMessage;
      this.doShowError();
    }
    /**
     * Diese Methode initialisiert die Karte fuer das GEOIS Mapping.
     * Das passiert nur, wenn sie noch nicht initialisiert wurde.
     * Das wird benoetigt, wenn zB beim ersten Aufruf der Detailseite
     * eine Karte aus dem Ausland geladen wird, fuer die wir keine GEO Daten haben
     * und dementsprechend nur das Default-Bild laden.
     * Wird Anschließend ein Angebote mit GEO Koordinaten aufgerufen muss natuerlich
     * die Karte erstmals aufgebaut werden.
     */
    initMapIfNotDone() {
      if (!this.initialized) {
        this.initialized = true;
        let mapInitialized = false;
        this.visibilitySubscription = interval(1000).pipe(map(() => this.geoisMap.nativeElement.offsetWidth > 0), distinctUntilChanged(), filter(visible => !!visible)).subscribe(() => {
          if (!mapInitialized) {
            mapInitialized = true;
            // Map darf erst initialisiert werden, wenn sie sichtbar ist;
            // sonst wird ihre Breite falsch berechnet.
            this.loadMapInitially();
            this.visibilitySubscription.unsubscribe();
          }
        });
      }
    }
    ngOnDestroy() {
      if (this.visibilitySubscription != null) {
        this.visibilitySubscription.unsubscribe();
      }
    }
    loadMapInitially() {
      try {
        // setDefaultOptions({ url: this.config.geoisScriptUrl });
        const options = {
          url: this.config.geoisScriptUrl
        };
        setTimeout(() => {
          loadCss(this.config.geoisStylesheetUrl);
          loadModules(['esri/map', 'esri/layers/ArcGISTiledMapServiceLayer', 'esri/geometry/Point', 'esri/symbol', 'esri/InfoTemplate', 'esri/graphic'], options).then(([Map, Layer, Point, symbol, InfoTemplate, Graphic]) => {
            // Zu diesem Zeitpunkt darf das DIV geoisMap nicht display:none sein! Sonst wird die Breite der Karte falsch
            // berechnet.
            this.map = new Map('geoisMap', {
              logo: false,
              showAttribution: true,
              autoResize: true
            });
            this.map.on('load', () => {
              this.map.infoWindow.resize(200, 200);
              this.map.infoWindow.anchor = 'bottom';
              this.map.disableScrollWheelZoom();
              this.map.graphics.on('click', evt => {
                evt.stopPropagation();
                let g = evt.graphic;
                this.map.infoWindow.setContent(g.getContent());
                this.map.infoWindow.setTitle(g.getTitle());
                // Explizit die Koords der Grafik verwenden!
                this.map.infoWindow.show(this.map.toScreen(g.geometry));
              });
              this.update = () => {
                this.errorMessage = ERROR_MESSAGE_NOT_AVAILABLE;
                this.doShowDummyMap();
                this.map.infoWindow.hide();
                this.geocodeService.getCoordinates(this.street, this.zipCode, this.city).subscribe(coords => {
                  this.loggingService.trace(coords);
                  const point = new Point({
                    x: coords.x,
                    y: coords.y,
                    spatialReference: {
                      wkid: 25832
                    }
                  });
                  this.map.centerAndZoom(point, 12); // max zoom
                  const pictureMarkerSymbol = new symbol.PictureMarkerSymbol('assets/images/map-marker-35x35.png', 35, 35);
                  const attributes = {
                    Street: this.street,
                    City: this.city,
                    PLZ: this.zipCode
                  };
                  const infoTemplate = new InfoTemplate(this.title, `${this.street}</br>${this.zipCode} ${this.city}`);
                  this.doShowGeoisMap();
                  this.map.graphics.clear(); // alte marker entfernen
                  this.map.graphics.add(new Graphic(point, pictureMarkerSymbol, attributes, infoTemplate));
                  this.changeDetectorRef.detectChanges();
                  this.onResize();
                }, error => {
                  this.loggingService.debug('ERROR_MESSAGE_NOT_AVAILABLE');
                  this.errorMessage = ERROR_MESSAGE_NOT_AVAILABLE;
                  this.doShowError();
                  this.loggingService.error('Fehler: ' + error);
                });
              };
              this.update();
            });
            this.doShowGeoisMap();
            // komisches verhalten: das erste Erzeugen des Layers scheitert (ohne Rückmeldung)...
            let baseMapLayer = new Layer(this.config.geoisImageServer);
            setTimeout(() => {
              // ...wenn wir danach kurz warten, klappt das zweite Erzeugen aber problemlos
              baseMapLayer = new Layer(this.config.geoisImageServer);
              this.map.addLayer(baseMapLayer);
            }, 500);
          });
        }, 500);
      } catch (err) {
        this.loggingService.error(err);
        this.doShowError();
        this.mapError.emit(true);
      }
    }
    doShowDummyMap() {
      this.state = 'dummy';
      this.changeDetectorRef.detectChanges();
    }
    doShowGeoisMap() {
      this.loggingService.debug('doShowGeoisMap');
      this.state = 'map';
      this.changeDetectorRef.detectChanges();
    }
    doShowError() {
      this.state = 'error';
      this.changeDetectorRef.detectChanges();
    }
    get showDummyMap() {
      return this.state === 'dummy' || this.state === 'error' || this.state === 'loading';
    }
    get showGeoisMap() {
      return this.state === 'map' || this.state === 'loading';
    }
    get showError() {
      return this.state === 'error';
    }
    onResize() {
      if (this.geoisMap?.nativeElement) {
        this.geoisMap.nativeElement.style.height = window.innerWidth <= MAX_WIDTH_PHABLET ? '300px' : '400px';
      }
    }
    static {
      this.ɵfac = function GeoisMapComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GeoisMapComponent)(i0.ɵɵdirectiveInject(GeocodeService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(LoggingService), i0.ɵɵdirectiveInject(GEOIS_CONFIG));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: GeoisMapComponent,
        selectors: [["ba-bub-geois-map"]],
        viewQuery: function GeoisMapComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c31, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.geoisMap = _t.first);
          }
        },
        hostBindings: function GeoisMapComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("resize", function GeoisMapComponent_resize_HostBindingHandler() {
              return ctx.onResize();
            }, false, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          blurWithMessage: "blurWithMessage",
          title: "title",
          street: "street",
          zipCode: "zipCode",
          city: "city"
        },
        outputs: {
          mapError: "mapError"
        },
        features: [i0.ɵɵProvidersFeature([GeocodeService]), i0.ɵɵNgOnChangesFeature],
        decls: 7,
        vars: 11,
        consts: [["geoisMap", ""], ["id", "geoisMap", 2, "width", "100%"], [1, "dummy_container"], [1, "placeholder"], ["alt", "Karte wird geladen...", "src", "assets/images/map-default-blur.png", 1, "placeholder-img"], [1, "error"]],
        template: function GeoisMapComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 1, 0);
            i0.ɵɵelementStart(2, "div", 2)(3, "div", 3);
            i0.ɵɵelement(4, "img", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 5);
            i0.ɵɵtext(6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("display", ctx.showGeoisMap ? "block" : "none");
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("display", ctx.showDummyMap ? "block" : "none");
            i0.ɵɵclassProp("placeholder-small-img", ctx.showError);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("ba-loading", !ctx.showError);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("display", ctx.showError ? "block" : "none");
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.errorMessage);
          }
        },
        styles: ["img.placeholder{width:100%}g>image~path{stroke:transparent}.esriPopupWrapper .maximize,.esriPopupWrapper .actionList{display:none}.dummy_container{position:relative;text-align:center;width:100%;height:400px;overflow:hidden}.dummy_container .error{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.placeholder-img{height:400px;width:100%;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}@media (max-width: 479px){.placeholder-img{height:300px}}.placeholder-small-img{transform-origin:left top;animation:scale .75s ease-in-out forwards}@keyframes scale{to{height:200px}}\n"],
        encapsulation: 2
      });
    }
  }
  return GeoisMapComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GeoisModule = /*#__PURE__*/(() => {
  class GeoisModule {
    static {
      this.ɵfac = function GeoisModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GeoisModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: GeoisModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [LoggingService, provideHttpClient(withInterceptorsFromDi())],
        imports: [CommonModule]
      });
    }
  }
  return GeoisModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let KontaktAvatarComponent = /*#__PURE__*/(() => {
  class KontaktAvatarComponent {
    static {
      this.ɵfac = function KontaktAvatarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || KontaktAvatarComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: KontaktAvatarComponent,
        selectors: [["ba-bub-kontakt-avatar"]],
        decls: 7,
        vars: 0,
        consts: [["data-name", "Ebene 1", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 329.4 361.9"], ["d", "M593.3,793.9c2.6-1,4.8-3.1,6.6-6.2a24.2,24.2,0,0,0,0-14.1c-23.9-1.7-44-8.3-60.4-20-5.2-3.7-7.2-7.8-6.2-12.5-5.5,7.7-11.9,12.8-19.1,15.3a59.3,59.3,0,0,1-33.9,1.2,46.2,46.2,0,0,0,1.4,10.7,60.7,60.7,0,0,1,1.6,10.6,65.9,65.9,0,0,1-.4,10.4,82.5,82.5,0,0,0-.4,8.5,58.5,58.5,0,0,0,3.4,16.3,53.8,53.8,0,0,0,6.3,12.7c3.2,4.9,6.8,10.6,10.7,17.1a51.7,51.7,0,0,0,9.3,11.1c4.5,3.8,9.1,6,13.9,6.6.8,1.4,1.2,4.7,1.4,9.6q1.8,9.8,9.3,14.7c5,3.4,11,4,18,1.9a91.8,91.8,0,0,0,35.6-20.4c6.7-5.5,10.7-11.2,12.3-17.3a122.8,122.8,0,0,1-4.4-12.5C594.6,824.6,592.9,810,593.3,793.9Z", "transform", "translate(-407.7 -678.7)", "fill", "#fff"], ["d", "M593.2,800.5c0-2.2,0-4.3.1-6.6a10.2,10.2,0,0,1-2.9.7c.9,6-.1,12.9-3,21s-8.1,16.2-15.8,24.9-15.2,14.7-22.5,18a40.4,40.4,0,0,1-23,3.1c.8,1.4,1.2,4.7,1.4,9.6a21.9,21.9,0,0,0,2.6,7.3,52.9,52.9,0,0,0,27.9-9.8c13.3-9.2,22.6-20,27.7-32.4A98,98,0,0,0,593.2,800.5Z", "transform", "translate(-407.7 -678.7)", "fill", "#e2e6e9"], ["d", "M622.7,749.9c-.5-10.7-3.3-21.9-8.3-33.5s-11.9-20.6-20.8-26.6-21.5-10-36.6-11.1q-52.2.3-71.3,22.9a55.1,55.1,0,0,0-12.2,27.3,71.3,71.3,0,0,0,.5,25.7,13.2,13.2,0,0,0,6.3,3,59.3,59.3,0,0,0,33.9-1.2c7.2-2.5,13.6-7.6,19.1-15.3-1,4.7,1,8.8,6.2,12.5,16.4,11.7,36.5,18.3,60.4,20a24.2,24.2,0,0,1,0,14.1c-1.8,3.1-4,5.2-6.6,6.2-.4,16.1,1.3,30.7,5,43.7,4-1.8,6.8-3.9,8.5-6.4a37.6,37.6,0,0,0,4.6-9.9c3-9.5,5.9-23.4,8.9-41.9C622.3,767.3,623.1,757.4,622.7,749.9Z", "transform", "translate(-407.7 -678.7)", "fill", "#5a5368"], ["d", "M602.7,850.1c-1.6,6.1-5.6,11.8-12.3,17.3a91.8,91.8,0,0,1-35.6,20.4c-7,2.1-13,1.5-18-1.9s-8.1-8.2-9.3-14.7a91.8,91.8,0,0,0-8.8,3.1,67.6,67.6,0,0,0-10,5.1,44.9,44.9,0,0,0-11,10.9c-2.7,1.5-6.3,3.8-10.8,6.6-8.8,5.8-17.7,11.8-26.5,18s-20.2,23.9-30.7,50.3a441.1,441.1,0,0,0-22,74.6l329.4.8c-.6-10.2-3.7-26.9-9.4-50s-9.8-37.6-13.3-45.3c-4.8-10.5-9.5-18.8-14.2-24.9-6.6-8.7-14.1-14.7-22.7-18-6.9-2.7-16.8-7.5-29.7-14.3s-20-10.9-24.7-14c-.6-.4-1.5-1.8-2.8-4.4l-4-7.8C612.1,854.7,607.6,850.7,602.7,850.1Z", "transform", "translate(-407.7 -678.7)", "fill", "#5a5368"]],
        template: function KontaktAvatarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(0, "svg", 0)(1, "title");
            i0.ɵɵtext(2, "Unisex_Avatar_01");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(3, "path", 1)(4, "path", 2)(5, "path", 3)(6, "path", 4);
            i0.ɵɵelementEnd();
          }
        },
        encapsulation: 2
      });
    }
  }
  return KontaktAvatarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let KontaktSliderKachelComponent = /*#__PURE__*/(() => {
  class KontaktSliderKachelComponent {
    static {
      this.ɵfac = function KontaktSliderKachelComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || KontaktSliderKachelComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: KontaktSliderKachelComponent,
        selectors: [["ba-bub-kontakt-slider-kachel"]],
        inputs: {
          person: "person"
        },
        decls: 15,
        vars: 10,
        consts: [[1, "ba-image"], [1, "kontakt-person"], [1, "avatar"], ["aria-hidden", "true", 1, "avatar-svg"], [1, "person-name"], ["class", "person-funktionen", 4, "ngIf"], ["class", "person-telefon", 4, "ngIf"], ["class", "person-e-mail", 4, "ngIf"], ["aria-hidden", "true", 1, "ba-caption", "d-none"], [1, "person-funktionen"], [4, "ngFor", "ngForOf"], [1, "person-telefon"], [1, "person-e-mail"]],
        template: function KontaktSliderKachelComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵelement(3, "ba-bub-kontakt-avatar", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "dl")(5, "div", 4)(6, "dt");
            i0.ɵɵtext(7, "Name");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "dd");
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(10, KontaktSliderKachelComponent_div_10_Template, 5, 1, "div", 5)(11, KontaktSliderKachelComponent_div_11_Template, 5, 2, "div", 6)(12, KontaktSliderKachelComponent_div_12_Template, 5, 1, "div", 7);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(13, "div", 8);
            i0.ɵɵtext(14);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵattribute("id", "person-" + ctx.person.id);
            i0.ɵɵadvance(8);
            i0.ɵɵtextInterpolate3(" ", ctx.person.titel, " ", ctx.person.vorname, " ", ctx.person.nachname, " ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (ctx.person.rollen == null ? null : ctx.person.rollen.length) > 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.person.telefonVorwahl);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.person.email);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate3(" Kontaktperson ", ctx.person.titel, " ", ctx.person.vorname, " ", ctx.person.nachname, "\n");
          }
        },
        dependencies: [KontaktAvatarComponent, NgIf, NgFor],
        styles: [".avatar[_ngcontent-%COMP%]{background-color:#f9fbfc;padding:15px;height:210px;width:150px;display:flex;align-items:center;margin-top:4px}.avatar[_ngcontent-%COMP%]   .avatar-svg[_ngcontent-%COMP%]{width:100%}@media (max-width: 575.98px){.avatar[_ngcontent-%COMP%]{display:none}}.kontakt-person[_ngcontent-%COMP%]{display:grid;grid-template-columns:min-content auto;gap:2rem}@media (max-width: 575.98px){.kontakt-person[_ngcontent-%COMP%]{grid-template-columns:auto}}.kontakt-person[_ngcontent-%COMP%]   .person-funktionen[_ngcontent-%COMP%]   dd[_ngcontent-%COMP%]   span[_ngcontent-%COMP%] + span[_ngcontent-%COMP%]:before{content:\", \"}.ba-image[_ngcontent-%COMP%]{height:250px}.keywords[_ngcontent-%COMP%]{margin-bottom:0}.keywords[_ngcontent-%COMP%]   dd[_ngcontent-%COMP%]{margin-bottom:.5rem}.keywords[_ngcontent-%COMP%]   dd.simple-chip-wrapper[_ngcontent-%COMP%]{margin:3px 0 5px}.keywords[_ngcontent-%COMP%]   dd[_ngcontent-%COMP%]:last-child{margin-bottom:0}.keywords[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{margin-bottom:1rem}.keywords[_ngcontent-%COMP%]   div[_ngcontent-%COMP%] > dd[_ngcontent-%COMP%]{margin-bottom:0}.keywords[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:last-child{margin-bottom:0}\n\n\n\n\n\n\n\n\n\n"]
      });
    }
  }
  return KontaktSliderKachelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// Vgl. DPL-3 Datei: source/js/_slider.js
// declare global {
//   interface Window {
//     dpl: {
//       imageSlider: {
//         init: () => void;
//       };
//     };
//   }
// }
let KontaktSliderComponent = /*#__PURE__*/(() => {
  class KontaktSliderComponent {
    constructor(changeDetectorRef) {
      this.changeDetectorRef = changeDetectorRef;
      this.ansprechpartner = [];
    }
    ngOnChanges() {
      // Falls bereits initialisiert, stoße Reinitialisierung an.
      if (this.sliderViewContainer) {
        this.resetSlider();
      }
    }
    /**
     * Entfernt Slider komplett, da das dynamische Austauschen der Slides
     * vom BaSlider nicht unterstützt wird. Danach wird der Slider wieder
     * eingefügt und initialisiert.
     */
    resetSlider() {
      this.removeSlider();
      this.initSlider();
    }
    removeSlider() {
      this.sliderViewContainer.clear();
    }
    ngAfterViewInit() {
      // sliderViewContainer ist er in diesem Lifecycle verfügbar.
      this.initSlider();
    }
    initSlider() {
      this.sliderViewContainer.createEmbeddedView(this.sliderTemplate);
      // Notwendig ansonsten Fehler NG0100 ExpressionChangedAfterItHasBeenCheckedError
      this.changeDetectorRef.detectChanges();
      // @ts-ignore
      window.dpl.imageSlider.init();
    }
    static {
      this.ɵfac = function KontaktSliderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || KontaktSliderComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: KontaktSliderComponent,
        selectors: [["ba-bub-kontakt-slider"]],
        viewQuery: function KontaktSliderComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c14, 5, ViewContainerRef);
            i0.ɵɵviewQuery(_c15, 5, TemplateRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sliderViewContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sliderTemplate = _t.first);
          }
        },
        inputs: {
          ansprechpartner: "ansprechpartner"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 4,
        vars: 0,
        consts: [["sliderViewContainer", ""], ["sliderTemplate", ""], ["aria-label", "Slider mit Ansprechpartner", "role", "application", "id", "kontaktpersonen-slider", "class", "ba-slider", "data-prev-text", "vorherige Kontaktperson", "data-next-text", "n\xE4chste Kontaktperson", "data-index-text", "Kontaktperson {1} von {2}", "data-current-text", "aktiv", 4, "ngIf"], [3, "person", 4, "ngIf"], ["id", "keine-kontaktpersonen-hinweise", 4, "ngIf"], ["aria-label", "Slider mit Ansprechpartner", "role", "application", "id", "kontaktpersonen-slider", "data-prev-text", "vorherige Kontaktperson", "data-next-text", "n\xE4chste Kontaktperson", "data-index-text", "Kontaktperson {1} von {2}", "data-current-text", "aktiv", 1, "ba-slider"], [1, "ba-slide-track"], ["class", "ba-slide", 4, "ngFor", "ngForOf"], [1, "ba-slide"], [3, "person"], ["id", "keine-kontaktpersonen-hinweise"]],
        template: function KontaktSliderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementContainer(0, null, 0);
            i0.ɵɵtemplate(2, KontaktSliderComponent_ng_template_2_Template, 3, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
        },
        dependencies: [NgIf, NgFor, KontaktSliderKachelComponent],
        styles: ["@media print{ba-bub-kontakt-slider .ba-slider-dots,ba-bub-kontakt-slider .ba-slider-prev-next{display:none!important}}ba-bub-kontakt-slider .ba-slide{padding-left:65px}ba-bub-kontakt-slider .ba-slide .ba-layout-tile{margin-bottom:0}ba-bub-kontakt-slider .ba-slider{height:285px;margin-bottom:0}ba-bub-kontakt-slider .ba-slider .ba-slide-prev:before,ba-bub-kontakt-slider .ba-slider .ba-slide-next:before{background-color:#00000014}\n"],
        encapsulation: 2
      });
    }
  }
  return KontaktSliderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let KontaktSliderModule = /*#__PURE__*/(() => {
  class KontaktSliderModule {
    static {
      this.ɵfac = function KontaktSliderModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || KontaktSliderModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: KontaktSliderModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return KontaktSliderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FacettenSlideInComponent = /*#__PURE__*/(() => {
  class FacettenSlideInComponent {
    constructor() {
      /**
       * ID des Slide-Ins. Default: facetten-mobile
       */
      this.id = 'facetten-mobile';
      /**
       * ID des Slide-Ins. Default: facetten-mobile
       */
      this.title = 'Filtern / Sortieren';
      /**
       * Status-Flag, ob gerade die Ergebnisliste neu geladen wird
       */
      this.loading = false;
      /**
       * Event wird ausgelöst, wenn alle Filter zurückgesetzt werden sollen
       */
      this.resetAllFilters = new EventEmitter();
    }
    /**
     * Schließt das Slide-In, falls es noch geöffnet wird,
     * bevor alle Angular-Referenzen darauf zerstört werden.
     */
    ngOnDestroy() {
      this.closeFacettenSlideOut();
    }
    // Ruft Bootstrap auf, um das Slide-In der Facetten zu schließen.
    closeFacettenSlideOut() {
      // @ts-ignore
      const bootstrap = window.dpl.bs;
      // https://getbootstrap.com/docs/5.0/components/modal/#via-javascript
      const modal = bootstrap.Modal.getInstance(this.modal.nativeElement);
      modal?.hide();
    }
    static {
      this.ɵfac = function FacettenSlideInComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FacettenSlideInComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FacettenSlideInComponent,
        selectors: [["ba-bub-facetten-slide-in"]],
        viewQuery: function FacettenSlideInComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c32, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modal = _t.first);
          }
        },
        inputs: {
          id: "id",
          title: "title",
          anzahlSuchergebnis: "anzahlSuchergebnis",
          loading: "loading"
        },
        outputs: {
          resetAllFilters: "resetAllFilters"
        },
        ngContentSelectors: _c0,
        decls: 20,
        vars: 14,
        consts: [["modal", ""], ["tabindex", "-1", "role", "dialog", 1, "modal", "fade", "ba-left"], [1, "modal-dialog", "modal-dialog-scrollable", "modal-dialog-centered"], [1, "modal-content"], [1, "modal-header", "p-2"], [1, "modal-title", "m-0", "px-0", "fs-4", "text-center", 3, "id"], ["type", "button", "data-bs-dismiss", "modal", "aria-label", "Schlie\xDFen", "id", "button_schliessen", 1, "close", "ba-modal-close"], ["id", "modal_body", 1, "modal-body"], [1, "modal-footer", "d-block", "p-2"], [1, "sticky-buttons", "d-flex", "flex-wrap", "gap-3"], ["type", "button", "id", "button_filter_loeschen", 1, "ba-btn", "ba-btn-tertiary", "ba-btn-block", "w-auto", 3, "click"], ["type", "button", "aria-label", "Zeige Suchergebnisse an", "data-bs-toggle", "modal", "data-bs-target", "#facetten-mobile", "id", "button_zeige_suchergebnisse", 1, "ba-btn", "ba-btn-primary", "ba-btn-block", "w-auto", 3, "ngClass"]],
        template: function FacettenSlideInComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1, 0)(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "h1", 5);
            i0.ɵɵtext(6);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(7, "button", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 7);
            i0.ɵɵprojection(9);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 8)(11, "div", 9)(12, "button", 10);
            i0.ɵɵlistener("click", function FacettenSlideInComponent_Template_button_click_12_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.resetAllFilters.emit());
            });
            i0.ɵɵelementStart(13, "span");
            i0.ɵɵtext(14, "Filter l\xF6schen");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(15, "button", 11)(16, "span");
            i0.ɵɵtext(17);
            i0.ɵɵpipe(18, "number");
            i0.ɵɵpipe(19, "i18nPlural");
            i0.ɵɵelementEnd()()()()()()();
          }
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id)("aria-labelledby", ctx.id + "-modal-title");
            i0.ɵɵadvance(5);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-modal-title");
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.title);
            i0.ɵɵadvance(9);
            i0.ɵɵproperty("ngClass", ctx.loading ? "ba-loading ba-loading-inverted ba-loading-small" : "faded-out");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(18, 8, ctx.anzahlSuchergebnis), " ", i0.ɵɵpipeBind2(19, 10, ctx.anzahlSuchergebnis, i0.ɵɵpureFunction0(13, _c33)), " ");
          }
        },
        dependencies: [NgClass, DecimalPipe, I18nPluralPipe],
        styles: [".modal.ba-left[_ngcontent-%COMP%]   .modal-body[_ngcontent-%COMP%], .modal.ba-right[_ngcontent-%COMP%]   .modal-body[_ngcontent-%COMP%]{position:static;padding:10px;bottom:0;background-color:#f9fbfc}.modal.ba-left[_ngcontent-%COMP%]   .modal-dialog[_ngcontent-%COMP%], .modal.ba-right[_ngcontent-%COMP%]   .modal-dialog[_ngcontent-%COMP%]{min-width:300px;max-width:420px}.modal.ba-left[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%], .modal.ba-right[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%]{position:relative;background-color:#fff;border-bottom:1px solid #DDE3E8}.modal.ba-left[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%]   .ba-modal-close[_ngcontent-%COMP%], .modal.ba-right[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%]   .ba-modal-close[_ngcontent-%COMP%]{top:10px}.modal.ba-left[_ngcontent-%COMP%]   .modal-footer[_ngcontent-%COMP%], .modal.ba-right[_ngcontent-%COMP%]   .modal-footer[_ngcontent-%COMP%]{background-color:#fff;border-top:1px solid #DDE3E8}.modal-content[_ngcontent-%COMP%]{position:static;display:grid;grid-template-columns:1fr;grid-template-rows:auto 1fr auto}.sticky-buttons[_ngcontent-%COMP%]   .ba-btn[_ngcontent-%COMP%]{min-width:min-content;margin:0}.sticky-buttons[_ngcontent-%COMP%]   .ba-btn.ba-btn-tertiary[_ngcontent-%COMP%]{flex:1.2 0;order:unset}.sticky-buttons[_ngcontent-%COMP%]   .ba-btn.ba-btn-primary[_ngcontent-%COMP%]{flex:2 0}\n\n\n\n\n\n\n\n\n\n"]
      });
    }
  }
  return FacettenSlideInComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FacettenSlideInModule = /*#__PURE__*/(() => {
  class FacettenSlideInModule {
    static {
      this.ɵfac = function FacettenSlideInModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FacettenSlideInModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: FacettenSlideInModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return FacettenSlideInModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ResponsiveKontextinfoHeaderComponent = /*#__PURE__*/(() => {
  class ResponsiveKontextinfoHeaderComponent {
    constructor() {
      this.sources = [];
      this.withAddOn = false;
    }
    static {
      this.ɵfac = function ResponsiveKontextinfoHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ResponsiveKontextinfoHeaderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ResponsiveKontextinfoHeaderComponent,
        selectors: [["ba-bub-responsive-kontextinfo-header"]],
        inputs: {
          breadcrumbs: "breadcrumbs",
          headline: "headline",
          sources: "sources",
          withAddOn: "withAddOn",
          baKontexinfoHeaderCss: "baKontexinfoHeaderCss"
        },
        decls: 10,
        vars: 15,
        consts: [["id", "kontextinfo-header", 3, "ngClass"], [1, "ba-header-image", "d-print-none"], [1, "ba-responsive-picture"], [4, "ngFor", "ngForOf"], ["id", "kontextinfo-header-image", "alt", "", 3, "src"], [1, "ba-content-wrap"], ["id", "kontextinfo-header-breadcrumb", "class", "ba-breadcrumb", "aria-label", "Du befindest Dich hier:", 4, "ngIf"], [1, "ba-overlay"], ["id", "ueberschrift", 3, "innerHtml"], ["id", "kontextinfo-header-subheadline", 3, "innerHtml", 4, "ngIf"], ["id", "kontextinfo-header-breadcrumb", "aria-label", "Du befindest Dich hier:", 1, "ba-breadcrumb"], [4, "ngIf"], [3, "routerLink", "queryParams", "trackEvent"], [1, "sr-only"], ["id", "kontextinfo-header-subheadline", 3, "innerHtml"]],
        template: function ResponsiveKontextinfoHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "header", 0)(1, "div", 1)(2, "picture", 2);
            i0.ɵɵtemplate(3, ResponsiveKontextinfoHeaderComponent_source_3_Template, 1, 3, "source", 3);
            i0.ɵɵelement(4, "img", 4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 5);
            i0.ɵɵtemplate(6, ResponsiveKontextinfoHeaderComponent_nav_6_Template, 4, 2, "nav", 6);
            i0.ɵɵelementStart(7, "div", 7);
            i0.ɵɵelement(8, "h1", 8);
            i0.ɵɵtemplate(9, ResponsiveKontextinfoHeaderComponent_p_9_Template, 1, 1, "p", 9);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("ba-content-header ba-with-overlay ba-full-width ba-with-image ", ctx.baKontexinfoHeaderCss, "");
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c34, ctx.withAddOn));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.sources);
            i0.ɵɵadvance();
            i0.ɵɵproperty("src", ctx.sources[0].src, i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.breadcrumbs);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("background-color", ctx.headline.backgroundColor)("color", ctx.headline.textColor);
            i0.ɵɵadvance();
            i0.ɵɵproperty("innerHtml", ctx.headline.title, i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.headline.subtitle);
          }
        },
        dependencies: [NgClass, NgFor, NgIf, RouterLink, TrackEventDirective],
        styles: ["@media print{header[_ngcontent-%COMP%]{padding:0!important;margin:0!important;margin-top:1rem!important;margin-bottom:1rem!important}header[_ngcontent-%COMP%]   .ba-overlay[_ngcontent-%COMP%]{padding:0!important;margin:0!important}.ba-pull-header[_ngcontent-%COMP%]{margin:0!important}}.ba-breadcrumb[_ngcontent-%COMP%]   ol[_ngcontent-%COMP%]:has(li:only-child){padding-left:0}.ba-breadcrumb[_ngcontent-%COMP%]   ol[_ngcontent-%COMP%]:has(li:only-child):before{content:none}.ba-breadcrumb[_ngcontent-%COMP%]   ol[_ngcontent-%COMP%]:has(li:only-child):after{content:none}"]
      });
    }
  }
  return ResponsiveKontextinfoHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ResponsiveKontextinfoHeaderModule = /*#__PURE__*/(() => {
  class ResponsiveKontextinfoHeaderModule {
    static {
      this.ɵfac = function ResponsiveKontextinfoHeaderModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ResponsiveKontextinfoHeaderModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ResponsiveKontextinfoHeaderModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, RouterModule]
      });
    }
  }
  return ResponsiveKontextinfoHeaderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var ViewMode = /*#__PURE__*/function (ViewMode) {
  ViewMode["PHONE"] = "PHONE";
  ViewMode["PHABLET"] = "PHABLET";
  ViewMode["TABLET"] = "TABLET";
  ViewMode["DESKTOP"] = "DESKTOP";
  ViewMode["LARGE_DESKTOP"] = "LARGE_DESKTOP";
  return ViewMode;
}(ViewMode || {});
/**
 * Responsive Design unterstützender Service,
 * der abhängig von der aktuellen Viewport-Breite und den Pixel-Breakpoints der DPL
 * die Device-Kategorie entsprechend nach PDS
 * https://web.dev.ocp.webapp.idst.ibaintern.de/design/pds3/develop/#/201535451/270462891
 * ermittelt.
 *
 * PHONE < PHABLET < TABLET < DESKTOP < LARGE_DESKTOP
 *
 * Beschreibung aus Demo-APP:
 * @example
 * Der Screen-Size-Service kann eingebunden werden,
 * um die Displaygröße als Observable zu erhalten, um die Breakpoints nicht selbst setzen zu müssen.
 *
 * Verfügbare Streams:
 * onlyPhone$ - Viewport-Breite < 576px
 * onlyPhablet$ - Viewport-Breite 576px - 767px
 * onlyTablet$ - Viewport-Breite 768px - 991px
 * onlyDesktop$ - Viewport-Breite 992px - 1279px
 * onlyLargeDesktop$ - Viewport-Breite >= 1280px
 *
 * Alternativ können die Hilfsfunktionen inRange$(...), rangeFrom$(...) und rangeTo$(...)
 * genutzt werde, um Spannen zwischen, von bzw. bis einer bestimmten Kategorie
 * zu erfassen. Die Grenzen sind dabei immer inklusiv zu verstehen.
 */
class ScreenSizeService {
  constructor() {
    this.ngUnsubscribe = new Subject();
    /**
     * exponiert identifizierten ViewMode
     */
    this.viewMode$ = fromEvent(window, 'resize').pipe(map(event => event.target.innerWidth), startWith(window.innerWidth), map(width => {
      for (const mode in ScreenSizeService.MAX_WIDTH_BY_MODE) {
        if (width <= ScreenSizeService.MAX_WIDTH_BY_MODE[mode]) {
          return mode;
        }
      }
      return ViewMode.LARGE_DESKTOP;
    }), shareReplay(1), takeUntil(this.ngUnsubscribe));
    /**
     * true, gdw. ViewPort nicht mehr DPL-Breakpoint für Smartphones
     */
    this.onlyPhone$ = this.viewMode$.pipe(map(mode => mode === ViewMode.PHONE));
    /**
     * true, gdw. ViewPort breiter als Smartphones und nicht mehr als DPL-Breakpoint für Phablets (Phone-Tablet-Hybride)
     */
    this.onlyPhablet$ = this.viewMode$.pipe(map(mode => mode === ViewMode.PHABLET));
    /**
     * true, gdw. ViewPort breiter als Phablet und nicht mehr als DPL-Breakpoint für Tablet
     */
    this.onlyTablet$ = this.viewMode$.pipe(map(mode => mode === ViewMode.TABLET));
    /**
     * true, gdw. ViewPort breiter als Tablet-DPL-Breakpoint
     */
    this.onlyDesktop$ = this.viewMode$.pipe(map(mode => mode === ViewMode.DESKTOP));
    /**
     * true, gdw. ViewPort breiter als Desktop-DPL-Breakpoint
     */
    this.onlyLargeDesktop$ = this.viewMode$.pipe(map(mode => mode === ViewMode.LARGE_DESKTOP));
  }
  static {
    this.MAX_WIDTH_PHONE = 575.9;
  }
  static {
    this.MAX_WIDTH_PHABLET = 767.9;
  }
  static {
    this.MAX_WIDTH_TABLET = 991.9;
  }
  static {
    this.MAX_WIDTH_DESKTOP = 1279.9;
  }
  static {
    this.MAX_WIDTH_BY_MODE = {
      [ViewMode.PHONE]: ScreenSizeService.MAX_WIDTH_PHONE,
      [ViewMode.PHABLET]: ScreenSizeService.MAX_WIDTH_PHABLET,
      [ViewMode.TABLET]: ScreenSizeService.MAX_WIDTH_TABLET,
      [ViewMode.DESKTOP]: ScreenSizeService.MAX_WIDTH_DESKTOP,
      [ViewMode.LARGE_DESKTOP]: Number.MAX_VALUE
    };
  }
  static {
    this.MIN_WIDTH_BY_MODE = {
      [ViewMode.PHONE]: 0,
      [ViewMode.PHABLET]: ScreenSizeService.MAX_WIDTH_PHONE,
      [ViewMode.TABLET]: ScreenSizeService.MAX_WIDTH_PHABLET,
      [ViewMode.DESKTOP]: ScreenSizeService.MAX_WIDTH_TABLET,
      [ViewMode.LARGE_DESKTOP]: ScreenSizeService.MAX_WIDTH_DESKTOP
    };
  }
  /**
   * Diese Hilfsfunktion liefert ein Observable, das genau dann wahr enthält,
   * wenn die Breite des Viewports zwischen unterer und oberer Grenze fällt.
   * Die Grenzen sind dabei inklusive.
   *
   * Beispiel:
   * inRange$(ViewMode.TABLET, ViewMode.LARGE_DESKTOP) ist wahr, wenn
   * die Mindestbreite für Tablet erreicht ist und die Maximalbreite für
   * Large Desktop nicht überschritten wurde, welche Number.MAX_VALUE ist,
   * also nicht überschritten werden kann.
   *
   * @param lowerBound ViewMode, untere Grenze, inklusive
   * @param upperBound ViewMode, obere Grenze, inklusive
   */
  inRange$(lowerBound, upperBound) {
    return fromEvent(window, 'resize').pipe(map(event => event.target.innerWidth), startWith(window.innerWidth), map(width => {
      return ScreenSizeService.MIN_WIDTH_BY_MODE[lowerBound] < width && width <= ScreenSizeService.MAX_WIDTH_BY_MODE[upperBound];
    }), shareReplay(1), takeUntil(this.ngUnsubscribe));
  }
  /**
   * Diese Hilfsfunktion liefert ein Observable, das genau dann wahr enthält,
   * wenn die Breite des Viewports über der unteren Grenze liegt.
   * Die Grenze ist dabei inklusive.
   *
   * Beispiel:
   * rangeFrom$(ViewMode.TABLET) ist wahr,
   * wenn die Mindestbreite für Tablet erreicht ist.
   * Entspricht dem CSS-Klassen-Infix "md" in Bootstrap-5.
   *
   * @param lowerBound ViewMode, untere Grenze, inklusive
   */
  rangeFrom$(lowerBound) {
    return this.inRange$(lowerBound, ViewMode.LARGE_DESKTOP);
  }
  /**
   * Diese Hilfsfunktion liefert ein Observable, das genau dann wahr enthält,
   * wenn die Breite des Viewports unter der oberen Grenze liegt.
   * Die Grenze ist dabei inklusive.
   *
   * Beispiel:
   * rangeTo$(ViewMode.TABLET) ist wahr, wenn
   * die Maximalbreite für Tablet nicht überschritten wurde.
   *
   * @param upperBound ViewMode, obere Grenze, inklusive
   */
  rangeTo$(upperBound) {
    return this.inRange$(ViewMode.PHONE, upperBound);
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  static {
    this.ɵfac = function ScreenSizeService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ScreenSizeService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ScreenSizeService,
      factory: ScreenSizeService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MapComponent = /*#__PURE__*/(() => {
  class MapComponent {
    constructor(geocodeService, loggingService, screenSizeService, config, location, changeDetector) {
      this.geocodeService = geocodeService;
      this.loggingService = loggingService;
      this.screenSizeService = screenSizeService;
      this.config = config;
      this.location = location;
      this.changeDetector = changeDetector;
      this.controlsDisabled = false;
      this.addHomeControl = false;
      this.mapError = new EventEmitter();
      this.geoIsError = '';
      this.isPhablet$ = this.screenSizeService.rangeTo$(ViewMode.PHABLET);
      this.showMap = false;
      /**
       * Updates the map with the current location
       */
      this.updateMap = () => {
        if (!!this.mapView && !!this.street && !!this.zipCode && !!this.city) {
          this.geoIsError = '';
          this.showMap = false;
          this.changeDetector.detectChanges();
          this.geocodeService.getCoordinates(this.street, this.zipCode, this.city).subscribe({
            next: coords => {
              const point = new this.PointClass({
                x: Number(coords.x),
                y: Number(coords.y),
                spatialReference: {
                  wkid: 25832
                }
              });
              const viewPoint = new this.ViewPointClass({
                targetGeometry: point,
                scale: 7000
              });
              const pictureMarkerSymbol = new this.PictureMarkerSymbolClass({
                url: this.location.prepareExternalUrl('assets/images/map-marker-35x35.png'),
                width: 35,
                height: 35
              });
              const infoTemplate = new this.PopupTemplateClass({
                title: this.title,
                content: `${this.street}</br>${this.zipCode} ${this.city}`,
                actions: [],
                // To Remove the ZoomTo Button
                overwriteActions: true
              });
              let graphic = new this.GraphicClass({
                geometry: point,
                symbol: pictureMarkerSymbol,
                popupTemplate: infoTemplate
              });
              this.mapView.graphics.removeAll();
              this.mapView.graphics.add(graphic);
              this.mapView.goTo({
                target: graphic,
                scale: 7000
              });
              if (this.homeWidget) {
                this.mapView.ui.remove(this.homeWidget);
              }
              this.homeWidget = new this.HomeClass({
                view: this.mapView,
                viewpoint: viewPoint,
                visible: false
              });
              this.mapView.ui.add(this.homeWidget, 'top-left');
              this.showMap = true;
              this.changeDetector.detectChanges();
              if (!this.controlsDisabled) {
                this.enableControls();
              }
            },
            error: error => {
              this.handleError(error);
            }
          });
        }
      };
      this.getMapFocusElement = () => {
        return this.geoisMap?.nativeElement.querySelector('[role="application"]');
      };
    }
    async ngOnChanges(changes) {
      if (changes.title || changes.street || changes.zipCode || changes.city) {
        this.updateMap();
      }
      if (changes.controlsDisabled && changes.controlsDisabled.currentValue != changes.controlsDisabled.previousValue) {
        if (changes.controlsDisabled.currentValue === false) {
          this.enableControls();
        } else {
          this.disableControls();
        }
      }
    }
    ngAfterViewInit() {
      this.loadMapInitially();
    }
    /**
     * Initializes the ArcGis Map.
     */
    loadMapInitially() {
      esri.setDefaultOptions({
        url: this.config.geoisScriptUrl
      });
      esri.loadCss(this.config.geoisStylesheetUrl);
      esri.loadModules(['esri/Map', 'esri/PopupTemplate', 'esri/Graphic', 'esri/symbols/PictureMarkerSymbol', 'esri/geometry/Point', 'esri/views/MapView', 'esri/layers/ImageryLayer', 'esri/widgets/Home', 'esri/Viewpoint']).then(([Map, PopupTemplate, Graphic, PictureMarkerSymbol, Point, MapView, ImageryLayer, Home, Viewpoint]) => {
        this.PopupTemplateClass = PopupTemplate;
        this.GraphicClass = Graphic;
        this.PictureMarkerSymbolClass = PictureMarkerSymbol;
        this.PointClass = Point;
        this.HomeClass = Home;
        this.ViewPointClass = Viewpoint;
        const layer = new ImageryLayer({
          url: this.config.geoisImageServer
        });
        this.map = new Map({
          layers: [layer]
        });
        this.mapView = new MapView({
          container: this.geoisMapId,
          map: this.map,
          ui: {
            components: []
          },
          constraints: {
            minScale: 1500,
            maxScale: 6000000
          }
        });
        this.mapView.when(() => {
          this.getMapFocusElement()?.setAttribute('aria-label', 'Kartendarstellung des Veranstaltungsortes');
          this.updateMap();
        });
      }, error => {
        this.handleError(error);
      });
    }
    handleError(error) {
      this.loggingService.debug('ERROR_MESSAGE_NOT_AVAILABLE');
      this.loggingService.error('Fehler: ' + error);
      this.geoIsError = 'Kartenansicht aktuell nicht verfügbar. Bitte später erneut versuchen...';
      this.showMap = false;
      this.mapError.emit();
      this.changeDetector.detectChanges();
    }
    disableControls() {
      if (this.mapView) {
        this.mapView.ui.components = [];
        if (this.homeWidget) {
          this.homeWidget.visible = false;
        }
      }
      const mapElement = this.getMapFocusElement();
      mapElement?.setAttribute('tabindex', '-1');
    }
    enableControls() {
      if (this.mapView) {
        this.mapView.ui.components = ['attribution', 'zoom'];
        if (this.addHomeControl && this.homeWidget) {
          this.homeWidget.visible = true;
        }
      }
      const mapElement = this.getMapFocusElement();
      mapElement?.setAttribute('tabindex', '0');
    }
    get isMapVisible() {
      return this.showMap && !this.blurWithMessage;
    }
    get errorMessage() {
      return this.blurWithMessage ? this.blurWithMessage : this.geoIsError;
    }
    get geoisMapId() {
      return `geoisMap_${this.id ? this.id : 'default'}`;
    }
    static {
      this.ɵfac = function MapComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MapComponent)(i0.ɵɵdirectiveInject(GeocodeService), i0.ɵɵdirectiveInject(LoggingService), i0.ɵɵdirectiveInject(ScreenSizeService), i0.ɵɵdirectiveInject(GEOIS_CONFIG), i0.ɵɵdirectiveInject(i1$3.Location), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MapComponent,
        selectors: [["ba-bub-map"]],
        viewQuery: function MapComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c31, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.geoisMap = _t.first);
          }
        },
        inputs: {
          blurWithMessage: "blurWithMessage",
          id: "id",
          title: "title",
          street: "street",
          zipCode: "zipCode",
          city: "city",
          controlsDisabled: "controlsDisabled",
          addHomeControl: "addHomeControl"
        },
        outputs: {
          mapError: "mapError"
        },
        features: [i0.ɵɵProvidersFeature([GeocodeService]), i0.ɵɵNgOnChangesFeature],
        decls: 6,
        vars: 6,
        consts: [["geoisMap", ""], [1, "fake-encapsulation"], [1, "geois-map", 3, "id"], [1, "dummy_container-wrapper", 3, "height"], [1, "dummy_container-wrapper"], [1, "dummy_container"], [1, "placeholder"], ["alt", "Karte wird geladen...", "src", "assets/images/map-default-blur.png", 1, "placeholder-img"], [1, "error"]],
        template: function MapComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1)(1, "div");
            i0.ɵɵpipe(2, "async");
            i0.ɵɵelement(3, "div", 2, 0);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, MapComponent_Conditional_5_Template, 6, 11, "div", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("height", ctx.isMapVisible === true ? i0.ɵɵpipeBind1(2, 4, ctx.isPhablet$) ? 300 : 400 : 1, "px");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("id", ctx.geoisMapId);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(!ctx.isMapVisible ? 5 : -1);
          }
        },
        dependencies: [CommonModule, i1$3.AsyncPipe],
        styles: [".fake-encapsulation{position:relative}.fake-encapsulation .geois-map{width:100%;height:100%}.fake-encapsulation .map-loading:before{position:absolute;inset:0;margin:0;transition:opacity 1s;background:#fff9;background-size:100%;content:\"\";opacity:1;z-index:100000}.fake-encapsulation .map-loading:after{display:block;position:absolute;top:50%;left:50%;width:50px;height:50px;margin:0;transform:translate(-50%,-50%);transition:opacity 1s;border:5px solid rgba(0,0,0,0);border-bottom-style:dashed;border-radius:50%;background:none #0000;background-image:url(data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%22100%22%20height%3D%22100%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%3E%3CanimateTransform%20attributeName%3D%22transform%22%20type%3D%22rotate%22%20values%3D%220%2050%2050%3B%20275%2050%2050%22%20begin%3D%220s%22%20dur%3D%221.5s%22%20fill%3D%22freeze%22%20repeatCount%3D%22indefinite%22%2F%3E%3Ccircle%20fill%3D%22none%22%20stroke%3D%22black%22%20stroke-width%3D%2210%22%20stroke-linecap%3D%22square%22%20cx%3D%2250%22%20cy%3D%2250%22%20r%3D%2244%22%20stroke-dasharray%3D%22274%22%20stroke-dashoffset%3D%22610%22%3E%3CanimateTransform%20attributeName%3D%22transform%22%20type%3D%22rotate%22%20values%3D%220%2050%2050%3B%20135%2050%2050%3B%20450%2050%2050%22%20begin%3D%220s%22%20dur%3D%221.5s%22%20fill%3D%22freeze%22%20repeatCount%3D%22indefinite%22%2F%3E%3Canimate%20attributeName%3D%22stroke-dashoffset%22%20values%3D%22274%3B%2068.57%3B%20274%22%20begin%3D%220s%22%20dur%3D%221.5s%22%20fill%3D%22freeze%22%20repeatCount%3D%22indefinite%22%2F%3E%3C%2Fcircle%3E%3C%2Fg%3E%3C%2Fsvg%3E)!important;background-repeat:no-repeat;background-position:center center;background-size:50px 50px;content:\"\";opacity:.9;z-index:100001;stroke:#000}.fake-encapsulation .esri-popup calcite-action:is([title=Ausblenden],[title=Andocken]){display:none}.fake-encapsulation .esri-popup .header-content,.fake-encapsulation .esri-popup .header-action{height:50px}.fake-encapsulation .esri-popup .header-content{padding-block:0}.fake-encapsulation .dummy_container-wrapper{position:relative}.fake-encapsulation .dummy_container-wrapper .dummy_container{position:absolute;top:0;text-align:center;width:100%;overflow:hidden}.fake-encapsulation .dummy_container-wrapper .dummy_container .error{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.fake-encapsulation .placeholder-img{height:400px;width:100%;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}@media (max-width: 479px){.fake-encapsulation .placeholder-img{height:300px}}.fake-encapsulation .placeholder-small-img{transform-origin:left top;animation:scale .75s ease-in-out forwards}@keyframes scale{to{height:200px}}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return MapComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AnwendungsbausteineModule = /*#__PURE__*/(() => {
  class AnwendungsbausteineModule {
    static {
      this.ɵfac = function AnwendungsbausteineModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AnwendungsbausteineModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AnwendungsbausteineModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [AnbieterFilterModule, AnsichtSwitchModule, CheckboxListeModule, CommonModule, FacetteModule, FeedbackModule, KachelModule, KarteModule, KontextinfoHeaderModule, ResponsiveKontextinfoHeaderModule, PaginierungModule, PaginierungDplModule, SuchUmkreisSliderModule, TagcloudModule, DetailNavigationModule, FilterChipListeModule, CollapsibleFacetteModule, GeoisModule, MapComponent, KontaktSliderModule, FacettenSlideInModule, AnbieterFilterModule, AnsichtSwitchModule, CheckboxListeModule, FacetteModule, FeedbackModule, KachelModule, KarteModule, KontextinfoHeaderModule, ResponsiveKontextinfoHeaderModule, PaginierungModule, PaginierungDplModule, SuchUmkreisSliderModule, TagcloudModule, DetailNavigationModule, FilterChipListeModule, CollapsibleFacetteModule, GeoisModule, KontaktSliderModule, FacettenSlideInModule, OiamModule]
      });
    }
  }
  return AnwendungsbausteineModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InfosysbubNgLibModule = /*#__PURE__*/(() => {
  class InfosysbubNgLibModule {
    static {
      this.ɵfac = function InfosysbubNgLibModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InfosysbubNgLibModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: InfosysbubNgLibModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, UiComponentsModule, MainLayoutModule, CoreModule, AnwendungsbausteineModule, PipesModule, UiComponentsModule, MainLayoutModule, CoreModule, AnwendungsbausteineModule, PipesModule]
      });
    }
  }
  return InfosysbubNgLibModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// Interface für aktive Filter, die im FilterChip angezeigt werden

// Directive für swipe Gesten auf Mobilgeräten
let SwipeDirective = /*#__PURE__*/(() => {
  class SwipeDirective {
    constructor() {
      this.leftSwipe = new EventEmitter();
      this.rightSwipe = new EventEmitter();
      this.swipeCoord = [0, 0];
      this.swipeTime = new Date().getTime();
    }
    onSwipeStart($event) {
      this.swipe($event, 'start');
    }
    onSwipeEnd($event) {
      this.swipe($event, 'end');
    }
    swipe(event, when) {
      const coord = [event.changedTouches[0].clientX, event.changedTouches[0].clientY];
      const time = new Date().getTime();
      if (when === 'start') {
        this.swipeCoord = coord;
        this.swipeTime = time;
      } else if (when === 'end') {
        const direction = [coord[0] - this.swipeCoord[0], coord[1] - this.swipeCoord[1]];
        const duration = time - this.swipeTime;
        if (duration < 1000 &&
        // Maximal 1 Sekunde
        Math.abs(direction[0]) > 30 &&
        // Mindestens 30px geswiped
        Math.abs(direction[0]) > Math.abs(direction[1] * 3) // Prüfe dass horizontal und nicht vertikal geswiped wurde
        ) {
          if (direction[0] < 0) {
            this.leftSwipe.emit();
          } else {
            this.rightSwipe.emit();
          }
        }
      }
    }
    static {
      this.ɵfac = function SwipeDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SwipeDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: SwipeDirective,
        selectors: [["", "swipe", ""]],
        hostBindings: function SwipeDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("touchstart", function SwipeDirective_touchstart_HostBindingHandler($event) {
              return ctx.onSwipeStart($event);
            })("touchend", function SwipeDirective_touchend_HostBindingHandler($event) {
              return ctx.onSwipeEnd($event);
            });
          }
        },
        outputs: {
          leftSwipe: "leftSwipe",
          rightSwipe: "rightSwipe"
        }
      });
    }
  }
  return SwipeDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Trackt das Auswählen aller Links, die einen neuen Tab öffnen.
 */
let TrackOutLinkDirective = /*#__PURE__*/(() => {
  class TrackOutLinkDirective {
    constructor(elem, trackingService) {
      this.elem = elem;
      this.trackingService = trackingService;
    }
    trackClick() {
      const nativeElement = this.elem.nativeElement;
      this.trackingService.trackOutlink(nativeElement.href);
    }
    static {
      this.ɵfac = function TrackOutLinkDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrackOutLinkDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(TrackingService));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TrackOutLinkDirective,
        selectors: [["a", "target", "_blank"]],
        hostBindings: function TrackOutLinkDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function TrackOutLinkDirective_click_HostBindingHandler() {
              return ctx.trackClick();
            });
          }
        }
      });
    }
  }
  return TrackOutLinkDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const ANWENDUNGSTITEL = new InjectionToken('anwendungstitel');
/**
 * Baut den Seitentitel rekursiv aufsteigend anhand des Title-Attributs in der Router-Config auf
 * und hängt ein Suffix mit Anwendungsnamen und "Bundesagentur für Arbeit" an.
 */
let InfosysbubTitleStrategy = /*#__PURE__*/(() => {
  class InfosysbubTitleStrategy extends DefaultTitleStrategy {
    constructor(title, anwendungstitel) {
      super(title);
      this.title = title;
      this.anwendungstitel = anwendungstitel;
    }
    /**
     * Konkateniert kaskadieren die Page-Titel, die an den Routen annotiert wird.
     *
     * Beispiel:
     *
     * const routes: Routes = [
     *   {
     *     path: 'doku',
     *     component: DocumentationComponent,
     *     title: 'Dokumentation',
     *     children: [
     *       {
     *         path: 'karte',
     *         component: KarteTestComponent,
     *         title: 'Karte Component'
     *       },
     *       {
     *         path: 'locale-module',
     *         component: LocaleModuleDocComponent,
     *         title: 'Local Module'
     *       }
     *     ]
     *   }
     * ];
     *
     * Würde den Titel "Karte Component - Dokumentation - Demo App - Bundesagentur für Arbeit"
     * erzeugen, wenn als ANWENDUNGSTITEL "Demo App" provided wurde.
     *
     * Inspiriert von https://github.com/angular/angular/blob/main/packages/router/src/page_title_strategy.ts#L46-L54
     */
    buildTitle(snapshot) {
      let pageTitle = `${this.anwendungstitel} | Bundesagentur für Arbeit`;
      let route = snapshot.root;
      while (route) {
        const resolvedTitleForRoute = this.getResolvedTitleForRoute(route);
        if (resolvedTitleForRoute) {
          pageTitle = `${resolvedTitleForRoute} | ${pageTitle}`;
        }
        route = route.firstChild;
      }
      return pageTitle;
    }
    static {
      this.ɵfac = function InfosysbubTitleStrategy_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InfosysbubTitleStrategy)(i0.ɵɵinject(i1$1.Title), i0.ɵɵinject(ANWENDUNGSTITEL));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: InfosysbubTitleStrategy,
        factory: InfosysbubTitleStrategy.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return InfosysbubTitleStrategy;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Http-Interceptor, der nach dem Deployment eines neuen Artefaktes dafür sorgt,
 * dass bereits gecachete REST-Abfragen verworfen werden.
 */
class CacheBustingInterceptor {
  static {
    this.cacheBustHash = CacheBustingInterceptor.getBuildHash();
  }
  /**
   * Implementierung aus #STUDISU-333
   * Liest den HASH aus den Namen der main.js aus,
   * die von der Angular-CLI erzeugt wurde.
   *
   * @return Hash des Angular-CLI-Kompilats oder 'no-cache-busting'
   */
  static getBuildHash() {
    // dynamically substitute cacheBust read from config
    // this had be done before with webpack plugins on buildtime
    // now we go at runtime to read the filehash of our main.js
    // which is set by angular-cli at buildtime
    // (at least for production builds, where output hashing is active)
    // therefore get script-tag from DOM whose src contains main
    const allScripts = Array.from(document.querySelectorAll('script'));
    const filePath = allScripts.find(script => script.src.includes('main'))?.src;
    if (!filePath) {
      return 'no-cache-busting';
    }
    // search for a hash like main.HASH.js
    const searchStrMain = '/main.';
    const main = filePath.lastIndexOf(searchStrMain);
    const mainEnd = main + searchStrMain.length;
    const js = filePath.lastIndexOf('.js');
    if (main && js && mainEnd < js) {
      return filePath.substring(mainEnd, js);
    } else {
      return 'no-cache-busting';
    }
  }
  intercept(request, next) {
    if (CacheBustingInterceptor.cacheBustHash === 'no-cache-busting') {
      return next.handle(request);
    }
    // Wurde an die URL manuell Parametern angehängt?
    // Sollte so nicht mehr genutzt werden, sondern Parameter sollten via request.params mitgegeben werden.
    const paramsManuallyAdded = request.url.includes('?');
    if (paramsManuallyAdded) {
      console.warn('URLs mit manuell angefügten Parametern werden nicht unterstützt!');
      return next.handle(request);
    }
    return next.handle(request.clone({
      params: request.params.append('cb', CacheBustingInterceptor.cacheBustHash)
    }));
  }
  static {
    this.ɵfac = function CacheBustingInterceptor_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CacheBustingInterceptor)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CacheBustingInterceptor,
      factory: CacheBustingInterceptor.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Funktion zur Rückgabe des Providers für den CacheBustingInterceptor.
 *
 * Diese wird für die Applikationen ab Angular 17 ohne Module verwende, die mit
 * der Moduleeinbildung nichts anfangen können.
 *
 * @return Array mit den Provider-Angaben für den CacheBustingInterceptor.
 */
function provideCacheBustingInterceptor() {
  return [{
    provide: HTTP_INTERCEPTORS,
    useClass: CacheBustingInterceptor,
    multi: true
  }];
}
/**
 * Enthält einen Http-Interceptor fürs Cache-Busting.
 */
let CacheBustingModule = /*#__PURE__*/(() => {
  class CacheBustingModule {
    static {
      this.ɵfac = function CacheBustingModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CacheBustingModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CacheBustingModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: provideCacheBustingInterceptor(),
        imports: [CommonModule]
      });
    }
  }
  return CacheBustingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @see DPL 3 Interaktionsdesign https://web.dev.ocp.webapp.idst.ibaintern.de/design/pds3/develop/#/212093132
 * Animationsarten A: Ausdrucksstark
 */
const longAnimation = '240ms ease-in-out';
/**
 * @see DPL 3 Interaktionsdesign https://web.dev.ocp.webapp.idst.ibaintern.de/design/pds3/develop/#/212093132
 * Animationsarten N: Nutzbringend
 */
const shortAnimation = '80ms ease-in-out';
/**
 * Laut W3C-Spec können Animationen nur auf Elemente mit Display Block angewendet werden.
 * Insbesondere eigene Elemente müssen entsprechend gestylt werden.
 */
const prepareComponentAnimation = [style({
  display: 'block'
})];
/**
 * Laut W3C-Spec können Animationen nur auf Elemente mit Display Block angewendet werden.
 * Insbesondere eigene Elemente müssen entsprechend gestylt werden.
 * Diese Query wendet dieses Styling auf alle eingehenden und verlassenden Elemente an.
 */
const prepareComponentAnimationQuery = query(':enter, :leave', prepareComponentAnimation, {
  optional: true
});
/**
 * Angedeutetes Wischen nach nach links:
 * - eingehende Elemente faden von rechts ein
 * - verlassende Elemente faden nach links aus
 */
const swipeLeft = [prepareComponentAnimationQuery, group([query(':leave', [style({
  transform: 'translateX(0)',
  position: 'absolute',
  width: '100%'
}), animate(longAnimation, style({
  opacity: 0,
  transform: 'translateX(-24px)'
}))], {
  optional: true
}), query(':enter', [style({
  opacity: 0,
  transform: 'translateX(24px)'
}), animate(longAnimation, style({
  opacity: 1,
  transform: 'translateX(0)'
}))], {
  optional: true
})])];
/**
 * Angedeutetes Wischen nach rechts:
 * - eingehende Elemente faden von links ein
 * - verlassende Elemente faden nach rechts aus
 */
const swipeRight = [query(':enter, :leave', prepareComponentAnimation, {
  optional: true
}), group([query(':leave', [style({
  transform: 'translateX(0)',
  position: 'absolute',
  width: '100%'
}), animate(longAnimation, style({
  opacity: 0,
  transform: 'translateX(24px)'
}))], {
  optional: true
}), query(':enter', [style({
  opacity: 0,
  transform: 'translateX(-24px)'
}), animate(longAnimation, style({
  opacity: 1,
  transform: 'translateX(0)'
}))], {
  optional: true
})])];
/**
 * Angedeutetes Wischen nach nach links innerhalb eines Flex-Containers:
 * - eingehende Elemente faden von rechts ein
 * - verlassende Elemente faden nach links aus
 */
const swipeLeftInFlexContainer = [query(':enter, :leave', [style({
  width: '100%',
  flexShrink: 0
})], {
  optional: true
}), group([query(':leave', [style({
  transform: 'translateX(0)',
  width: '100%'
}), animate(longAnimation, style({
  opacity: 0,
  transform: 'translateX(-24px)'
}))], {
  optional: true
}), query(':enter', [style({
  opacity: 0,
  position: 'relative',
  top: 0,
  left: '-100%',
  transform: 'translateX(24px)'
}), animate(longAnimation, style({
  opacity: 1,
  transform: 'translateX(0)'
}))], {
  optional: true
})])];
/**
 * Angedeutetes Wischen nach rechts innerhalb eines Flex-Containers:
 * - eingehende Elemente faden von links ein
 * - verlassende Elemente faden nach rechts aus
 */
const swipeRightInFlexContainer = [query(':enter, :leave', [style({
  width: '100%',
  flexShrink: 0
})], {
  optional: true
}), group([query(':leave', [style({
  transform: 'translateX(0)'
}), animate(longAnimation, style({
  opacity: 0,
  transform: 'translateX(24px)'
}))], {
  optional: true
}), query(':enter', [style({
  opacity: 0,
  position: 'relative',
  top: 0,
  left: '-100%',
  transform: 'translateX(-24px)'
}), animate(longAnimation, style({
  opacity: 1,
  transform: 'translateX(0)'
}))], {
  optional: true
})])];
/**
 * Angedeutetes Wischen nach nach links innerhalb eines Flex-Containers:
 * - eingehende Elemente werden nicht animiert
 * - verlassende Elemente faden nach links aus
 */
const fastSwipeLeftInFlexContainer = [query(':enter, :leave', [style({
  width: '100%',
  flexShrink: 0
})], {
  optional: true
}), query(':leave', [style({
  transform: 'translateX(0)',
  width: '100%'
}), animate(longAnimation, style({
  opacity: 0,
  transform: 'translateX(-24px)'
}))], {
  optional: true
})];
/**
 * Angedeutetes Wischen nach rechts innerhalb eines Flex-Containers:
 * - eingehende Elemente werden nicht animiert
 * - verlassende Elemente faden nach rechts aus
 */
const fastSwipeRightInFlexContainer = [query(':enter, :leave', [style({
  width: '100%',
  flexShrink: 0
})], {
  optional: true
}), query(':leave', [style({
  transform: 'translateX(0)'
}), animate(longAnimation, style({
  opacity: 0,
  transform: 'translateX(24px)'
}))], {
  optional: true
})];
/**
 * Vollständige Bewegung nach links:
 * - eingehende Elemente fliegen von rechts ein
 * - verlassende Elemente fliegen nach links aus
 */
const slideLeft = [prepareComponentAnimationQuery, group([query(':leave', [style({
  transform: 'translateX(0)',
  position: 'absolute',
  width: '100%'
}), animate(longAnimation, style({
  opacity: 0,
  transform: 'translateX(-110%)'
}))], {
  optional: true
}), query(':enter', [style({
  opacity: 0,
  transform: 'translateX(110%)'
}), animate(longAnimation, style({
  opacity: 1,
  transform: 'translateX(0)'
}))], {
  optional: true
})])];
/**
 * Vollständige Bewegung nach rechts:
 * - eingehende Elemente fliegen von links ein
 * - verlassende Elemente fliegen nach rechts aus
 */
const slideRight = [query(':enter, :leave', [style({
  display: 'block'
})], {
  optional: true
}), group([query(':leave', [style({
  transform: 'translateX(0)',
  position: 'absolute',
  width: '100%'
}), animate(longAnimation, style({
  opacity: 0,
  transform: 'translateX(110%)'
}))], {
  optional: true
}), query(':enter', [style({
  opacity: 0,
  transform: 'translateX(-110%)'
}), animate(longAnimation, style({
  opacity: 1,
  transform: 'translateX(0)'
}))], {
  optional: true
})])];
/**
 * Zoomt heraus: Element verkleinert sich horizontal wie vertikal und faded dabei aus.
 */
const zoomOutAnimationSteps = [style({
  height: '*',
  transform: 'scale(1)'
}), animate(longAnimation, style({
  opacity: 0,
  transform: 'scale(0.5)',
  height: '0px'
}))];
/**
 * Zoomt aus verlassenden Elemente heraus.
 */
const swapScaleLeave = query(':leave', zoomOutAnimationSteps, {
  optional: true
});
/**
 * Zoomt hinein: Element vergrößert sich horizontal wie vertikal und faded dabei ein.
 */
const zoomInAnimationSteps = [style({
  height: '0px',
  opacity: 0,
  transform: 'scale(0.5)'
}), animate(longAnimation, style({
  opacity: 1,
  transform: 'scale(1)',
  height: '*'
}))];
/**
 * Zoomt in eingehende Elemente hinein.
 */
const swapScaleEnter = query(':enter', zoomInAnimationSteps, {
  optional: true
});
/**
 * Zoom-Animation für eingehende und verlassende Elemente
 */
const swapScaling = [query(':enter, :leave', [style({
  display: 'block'
})]), group([swapScaleLeave, swapScaleEnter])];
/**
 *
 */
const shuffleVertically = [query(':enter, :leave', [style({
  display: 'block'
})], {
  optional: true
}), group([query(':leave', [style({
  transform: 'translateY(0)',
  position: 'absolute',
  width: '100%'
}), animate(longAnimation, style({
  opacity: 0,
  transform: 'translateY(24px)'
}))], {
  optional: true
}), query(':enter', [style({
  opacity: 0,
  transform: 'translateY(24px)'
}), animate(longAnimation, style({
  opacity: 1,
  transform: 'translateY(0)'
}))], {
  optional: true
})])];
/**
 *
 */
const shuffleHorizontally = [query(':enter, :leave', [style({
  display: 'block'
})], {
  optional: true
}), group([query(':leave', [style({
  transform: 'translateX(0)',
  position: 'absolute',
  width: '100%'
}), animate(longAnimation, style({
  opacity: 0,
  transform: 'translateX(24px)'
}))], {
  optional: true
}), query(':enter', [style({
  opacity: 0,
  transform: 'translateX(24px)'
}), animate(longAnimation, style({
  opacity: 1,
  transform: 'translateX(0)'
}))], {
  optional: true
})])];

/*
 * Public API Surface of infosysbub-ng-lib-dpl3
 */
/*
 * Import aller Module der ngLib
 * */

/**
 * Generated bundle index. Do not edit.
 */

export { ANWENDUNGSTITEL, AccordionComponent, AccordionModule, AnbieterFilterComponent, AnbieterFilterConfiguration, AnbieterFilterConfigurationService, AnbieterFilterModule, AnsichtSwitchComponent, AnsichtSwitchModule, AnsichtsTypen, AnwendungsbausteineModule, BildSliderComponent, BildSliderModule, BookmarkComponent, BookmarkIconComponent, BookmarkIconModule, BookmarkModule, CacheBustingModule, CheckChipComponent, CheckboxComponent, CheckboxListeComponent, CheckboxListeModule, CheckboxModule, ChipComponent, ChipsModule, CollapseComponent, CollapseModule, CollapsibleFacetteComponent, CollapsibleFacetteModule, CoreModule, DetailNavigationComponent, DetailNavigationModule, DistanzChipComponent, DropdownComponent, DropdownModule, DurationPipe, Error404Component, Error404Module, FacetteComponent, FacetteModule, FacettenSlideInComponent, FacettenSlideInModule, FeedbackComponent, FeedbackModule, FilterChipComponent, FilterChipListeComponent, FilterChipListeModule, FlyoutComponent, FooterComponent, GEOIS_CONFIG, GeoisMapComponent, GeoisModule, HeaderComponent, HilfeInfoCollapseComponent, InfosysbubNgLibModule, InfosysbubTitleStrategy, InputrangeComponent, InputrangeModule, KachelComponent, KachelModule, KarteComponent, KarteModule, KontaktSliderComponent, KontaktSliderModule, KontextinfoHeaderComponent, KontextinfoHeaderModule, LIVE_ANNOUNCER_ELEMENT_TOKEN, LIVE_ANNOUNCER_PROVIDER, LIVE_ANNOUNCER_PROVIDER_FACTORY, LiveAnnouncer, LoadSpinnerComponent, LoadSpinnerModule, LoggingService, MainLayoutComponent, MainLayoutModule, MapComponent, MinimalCoreModule, ModalModule, ModalPopupComponent, NoReferrerDirective, OiamComponent, OiamModule, OnChange, PaginierungComponent, PaginierungDplComponent, PaginierungDplModule, PaginierungModule, PipesModule, Platform, RegionKurz, RegionLang, Regionenliste, ResponsiveKontextinfoHeaderComponent, ResponsiveKontextinfoHeaderModule, ScreenSizeService, SelectedSuggestion, SlideInComponent, SuchUmkreisSliderComponent, SuchUmkreisSliderModule, SuchergebnisEmptyStateComponent, SuchergebnisEmptyStateModule, Suggestion, SwipeDirective, SwitchComponent, SwitchModule, TagcloudComponent, TagcloudModule, TooltipDirective, TooltipModule, TrackEventDirective, TrackOutLinkDirective, TrackingService, TruncatePipe, TypeaheadComponent, TypeaheadModule, UiComponentsModule, ViewMode, XapikeyModule, ersteKategorieMitValiderAnzahlAnEintraegen, fastSwipeLeftInFlexContainer, fastSwipeRightInFlexContainer, hatValideAnzahlAnEintraegen, kuerzeHtml, longAnimation, ordneStringInBuchstabenKategorie, prepareComponentAnimation, prepareComponentAnimationQuery, provideCacheBustingInterceptor, provideXapikeyInterceptor, shortAnimation, shuffleHorizontally, shuffleVertically, slideLeft, slideRight, swapScaleEnter, swapScaleLeave, swapScaling, swipeLeft, swipeLeftInFlexContainer, swipeRight, swipeRightInFlexContainer, trackByItemKey, zoomInAnimationSteps, zoomOutAnimationSteps };
